{
  "level": "mt03c",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt03c",
    "objects": "AREAS.E3:mt03c.e3",
    "mesh": "TREES.E3:mt03c.e3"
  },
  "spawn_point": {
    "position": [
      -508.12658014623406,
      -2436.6179720522923,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -508.12658014623406,
      -2336.6179720522923,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6860.8203125,
      -4608.44384765625,
      -300.0
    ],
    "bbox_max": [
      2016.71826171875,
      7450.0,
      1819.7926025390625
    ],
    "vertex_count": 2692,
    "vertices": [
      [
        -1289.92431640625,
        1685.8206787109375,
        -300.0
      ],
      [
        -2776.024658203125,
        1147.0701904296875,
        -300.0
      ],
      [
        -2000.0,
        3469.92919921875,
        150.0
      ],
      [
        -2000.0,
        6457.123046875,
        150.0
      ],
      [
        -6821.484375,
        2758.39404296875,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        150.0
      ],
      [
        -4221.82275390625,
        2193.126708984375,
        150.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        150.0
      ],
      [
        -2000.0,
        7012.392578125,
        150.0
      ],
      [
        -2000.0,
        7012.392578125,
        -22.699951171875
      ],
      [
        -3989.468505859375,
        2110.39697265625,
        -300.0
      ],
      [
        -2613.806396484375,
        3353.8779296875,
        0.0
      ],
      [
        -2000.0,
        3419.642822265625,
        0.0
      ],
      [
        -2000.0,
        3469.92919921875,
        150.0
      ],
      [
        -4088.928466796875,
        2100.0,
        0.0
      ],
      [
        -3988.3173828125,
        2100.0,
        -300.0
      ],
      [
        -4221.82275390625,
        2193.126708984375,
        150.0
      ],
      [
        -4088.928466796875,
        2100.0,
        0.0
      ],
      [
        -4211.51220703125,
        2100.0,
        150.0
      ],
      [
        -6860.8203125,
        2699.5234375,
        1640.001220703125
      ],
      [
        -6764.20263671875,
        2844.1220703125,
        1584.5428466796875
      ],
      [
        -6561.474609375,
        2100.0,
        1612.981689453125
      ],
      [
        -5016.3955078125,
        2100.0,
        1045.7587890625
      ],
      [
        -2000.0,
        7012.392578125,
        976.300048828125
      ],
      [
        -4896.1435546875,
        2100.0,
        987.7515258789062
      ],
      [
        -4912.326171875,
        2100.0,
        1007.55322265625
      ],
      [
        -4897.80810546875,
        2100.0,
        1003.6253662109375
      ],
      [
        -4896.1435546875,
        2100.0,
        987.7515258789062
      ],
      [
        -4904.1279296875,
        2100.0,
        1004.5435791015625
      ],
      [
        -3714.02392578125,
        -2323.554931640625,
        1179.126953125
      ],
      [
        -4897.6552734375,
        2100.0,
        1002.1674194335938
      ],
      [
        -2000.0,
        -619.568359375,
        100.0
      ],
      [
        -2000.0,
        594.7691650390625,
        100.0
      ],
      [
        -2000.0,
        1480.2916259765625,
        24.057861328125
      ],
      [
        -2000.0,
        1428.3995361328125,
        -300.0
      ],
      [
        -2796.548095703125,
        1203.6826171875,
        99.99998474121094
      ],
      [
        -2186.04443359375,
        1425.00634765625,
        100.0
      ],
      [
        -2000.0,
        -404.04803466796875,
        100.0
      ],
      [
        -2000.0,
        -406.77117919921875,
        88.22676086425781
      ],
      [
        -2620.045654296875,
        -952.93505859375,
        100.0
      ],
      [
        -2622.662353515625,
        -978.381591796875,
        0.0
      ],
      [
        -2653.8955078125,
        -1075.4200439453125,
        -300.0
      ],
      [
        -2595.50048828125,
        -931.20703125,
        100.0
      ],
      [
        -2622.662353515625,
        -978.381591796875,
        0.0
      ],
      [
        -2000.0,
        -678.2991943359375,
        0.0
      ],
      [
        -2000.0,
        -795.7606811523438,
        -300.0
      ],
      [
        -2000.0,
        -619.568359375,
        100.0
      ],
      [
        -2000.0,
        -678.2991943359375,
        0.0
      ],
      [
        -2350.862548828125,
        -634.7899780273438,
        445.2428894042969
      ],
      [
        -2000.0,
        -362.6867370605469,
        278.82159423828125
      ],
      [
        -2809.60791015625,
        1239.707275390625,
        354.5347595214844
      ],
      [
        -2000.0,
        1569.464599609375,
        580.9298706054688
      ],
      [
        -2000.0,
        -324.193603515625,
        445.2428894042969
      ],
      [
        1720.0,
        -2646.0,
        0.0
      ],
      [
        1720.0,
        -3885.78955078125,
        0.0
      ],
      [
        1844.31591796875,
        -2923.53076171875,
        1342.6407470703125
      ],
      [
        2016.23681640625,
        -3293.19189453125,
        1637.4736328125
      ],
      [
        2016.71826171875,
        -3293.0791015625,
        1653.050537109375
      ],
      [
        2016.6920166015625,
        -3293.0458984375,
        1652.70556640625
      ],
      [
        1890.3787841796875,
        -3002.142578125,
        1684.15185546875
      ],
      [
        1844.31591796875,
        -2923.53076171875,
        1342.6407470703125
      ],
      [
        2015.8232421875,
        -3291.95068359375,
        1641.2861328125
      ],
      [
        2016.23681640625,
        -3293.192138671875,
        1637.4736328125
      ],
      [
        2015.8232421875,
        -3291.95068359375,
        1641.2861328125
      ],
      [
        1805.7742919921875,
        -2832.098876953125,
        1703.96142578125
      ],
      [
        2014.2926025390625,
        -3296.4443359375,
        1634.6939697265625
      ],
      [
        2014.793212890625,
        -3296.4345703125,
        1653.20458984375
      ],
      [
        2014.762939453125,
        -3296.392822265625,
        1652.7911376953125
      ],
      [
        2016.6920166015625,
        -3293.0458984375,
        1652.70556640625
      ],
      [
        2013.76904296875,
        -3295.01806640625,
        1639.190185546875
      ],
      [
        2013.76904296875,
        -3295.01806640625,
        1639.190185546875
      ],
      [
        2014.2926025390625,
        -3296.444580078125,
        1634.694091796875
      ],
      [
        1720.0,
        -3788.61572265625,
        1210.562744140625
      ],
      [
        1720.0,
        -3784.0634765625,
        1094.305908203125
      ],
      [
        1720.0,
        -3788.61572265625,
        1210.562744140625
      ],
      [
        1720.0,
        -3788.75830078125,
        1213.9456787109375
      ],
      [
        1720.0,
        -3810.277587890625,
        1676.798583984375
      ],
      [
        1720.0,
        -3807.822509765625,
        1665.9896240234375
      ],
      [
        2014.7630615234375,
        -3296.392822265625,
        1652.791259765625
      ],
      [
        1720.0,
        -3788.748779296875,
        1213.9671630859375
      ],
      [
        1720.0,
        -3788.75830078125,
        1213.9456787109375
      ],
      [
        2013.9903564453125,
        -3295.621337890625,
        1637.2891845703125
      ],
      [
        1720.0,
        -3806.162109375,
        1658.6788330078125
      ],
      [
        2014.1802978515625,
        -3295.5869140625,
        1644.8177490234375
      ],
      [
        1959.7890625,
        -3375.618408203125,
        1584.114990234375
      ],
      [
        1720.0,
        -3773.997802734375,
        1247.570068359375
      ],
      [
        1720.0,
        -3778.70361328125,
        1537.783935546875
      ],
      [
        1959.7890625,
        -3375.618408203125,
        1584.114990234375
      ],
      [
        1720.0,
        -3733.659423828125,
        1339.4613037109375
      ],
      [
        1720.0,
        -3733.659423828125,
        1339.4613037109375
      ],
      [
        -1169.2957763671875,
        -2040.0,
        0.0
      ],
      [
        -630.9588623046875,
        -2040.0,
        0.0
      ],
      [
        -630.9589233398438,
        -2040.0,
        0.0
      ],
      [
        -299.9998779296875,
        -2040.0,
        0.0
      ],
      [
        200.0,
        7450.0,
        0.0
      ],
      [
        -2000.0,
        7012.392578125,
        0.0
      ],
      [
        -1305.3170166015625,
        1728.280029296875,
        0.0
      ],
      [
        -2000.0,
        1476.4390869140625,
        0.0
      ],
      [
        -270.0,
        7356.51123046875,
        976.300048828125
      ],
      [
        -270.0,
        7356.51123046875,
        0.0
      ],
      [
        -94.98645782470703,
        -2040.0,
        648.947509765625
      ],
      [
        -104.91006469726562,
        -2040.0,
        693.14501953125
      ],
      [
        -88.36563110351562,
        -2040.0,
        757.9679565429688
      ],
      [
        -104.91006469726562,
        -2040.0,
        693.14501953125
      ],
      [
        -88.36563110351562,
        -2040.0,
        757.968017578125
      ],
      [
        -73.74246978759766,
        -2040.0,
        757.9679565429688
      ],
      [
        71.04065704345703,
        -2037.2186279296875,
        772.2144775390625
      ],
      [
        109.02577209472656,
        -2040.0,
        649.1409912109375
      ],
      [
        71.04066467285156,
        -2037.2186279296875,
        772.2144775390625
      ],
      [
        80.18003845214844,
        -2040.0,
        757.9674682617188
      ],
      [
        107.26763916015625,
        -2040.0,
        642.3978271484375
      ],
      [
        5.3979034423828125,
        -2005.0113525390625,
        676.5404052734375
      ],
      [
        109.02577209472656,
        -2040.0,
        649.1409912109375
      ],
      [
        5.3979034423828125,
        -2005.0113525390625,
        676.5404052734375
      ],
      [
        107.26763916015625,
        -2040.0,
        642.3978271484375
      ],
      [
        76.70938873291016,
        -2040.0,
        645.19873046875
      ],
      [
        -118.56556701660156,
        -1950.38720703125,
        813.3817138671875
      ],
      [
        -129.0784454345703,
        -1946.1995849609375,
        862.9803466796875
      ],
      [
        30.361679077148438,
        -2040.0,
        649.4468383789062
      ],
      [
        -97.80717468261719,
        -2033.1204833984375,
        666.0718383789062
      ],
      [
        -98.47842407226562,
        -1969.3336181640625,
        711.3555297851562
      ],
      [
        -98.47842407226562,
        -1969.3336181640625,
        711.3555297851562
      ],
      [
        -98.83558654785156,
        -1969.0758056640625,
        713.1172485351562
      ],
      [
        -118.56555938720703,
        -1950.38720703125,
        813.3817138671875
      ],
      [
        -98.83558654785156,
        -1969.0758056640625,
        713.1172485351562
      ],
      [
        76.70950317382812,
        -2040.0,
        771.060791015625
      ],
      [
        76.70950317382812,
        -2040.0,
        1080.0
      ],
      [
        76.70950317382812,
        -2040.0,
        771.060791015625
      ],
      [
        -175.0777130126953,
        -1927.8765869140625,
        1080.0
      ],
      [
        -270.0,
        4849.71923828125,
        150.0
      ],
      [
        -270.0,
        4972.50830078125,
        150.0
      ],
      [
        -194.8513946533203,
        -1920.0,
        765.0
      ],
      [
        -170.0,
        -1929.899169921875,
        765.0
      ],
      [
        -194.8513946533203,
        -1920.0,
        754.0
      ],
      [
        -184.0,
        -1924.322509765625,
        754.0
      ],
      [
        -270.0,
        -1898.1326904296875,
        855.9585571289062
      ],
      [
        -270.0,
        -1898.1326904296875,
        1080.0
      ],
      [
        -270.0,
        -1916.2109375,
        823.991943359375
      ],
      [
        -270.0,
        -1898.1326904296875,
        855.9585571289062
      ],
      [
        -270.0,
        -1916.2109375,
        823.991943359375
      ],
      [
        -270.0,
        -1978.1456298828125,
        706.3736572265625
      ],
      [
        -270.0,
        -1920.0,
        765.0
      ],
      [
        -270.0,
        -1947.274658203125,
        765.0
      ],
      [
        -245.41355895996094,
        -1948.9671630859375,
        765.0
      ],
      [
        -224.35804748535156,
        -1948.448486328125,
        765.0
      ],
      [
        -170.0,
        -1944.15771484375,
        765.0
      ],
      [
        -195.0,
        -1979.0,
        707.2994384765625
      ],
      [
        -195.0,
        -1987.0,
        693.255859375
      ],
      [
        -195.0,
        -1987.0,
        693.255859375
      ],
      [
        -187.0,
        -1987.0,
        692.1471557617188
      ],
      [
        -195.0,
        -1920.0,
        754.0
      ],
      [
        -195.0,
        -1952.397216796875,
        754.0
      ],
      [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      [
        -198.0,
        -1952.634033203125,
        754.0
      ],
      [
        -198.0,
        -1952.634033203125,
        754.0
      ],
      [
        -198.0,
        -1946.367919921875,
        765.0
      ],
      [
        -270.0,
        -2010.7760009765625,
        656.7780151367188
      ],
      [
        -270.0,
        -2000.6131591796875,
        671.2200317382812
      ],
      [
        -270.0,
        -1978.1456298828125,
        706.3736572265625
      ],
      [
        -270.0,
        -2000.6131591796875,
        671.219970703125
      ],
      [
        -270.0,
        -1949.5728759765625,
        765.0
      ],
      [
        -261.9692077636719,
        -2019.27587890625,
        645.87548828125
      ],
      [
        -270.0,
        -2018.4642333984375,
        645.8526000976562
      ],
      [
        -270.0,
        -1952.0511474609375,
        765.0
      ],
      [
        -270.0,
        -2018.4642333984375,
        645.8526000976562
      ],
      [
        -261.9692077636719,
        -2019.27587890625,
        645.87548828125
      ],
      [
        -270.0,
        -2019.9259033203125,
        645.8472900390625
      ],
      [
        -98.47756958007812,
        -1969.414794921875,
        711.2978515625
      ],
      [
        -195.0,
        -1987.0,
        700.3240966796875
      ],
      [
        -195.0,
        -1980.299072265625,
        705.0189819335938
      ],
      [
        -195.0,
        -1987.0,
        700.3240966796875
      ],
      [
        -187.0,
        -1987.0,
        700.22021484375
      ],
      [
        -107.29669189453125,
        -2040.0,
        660.5897827148438
      ],
      [
        -186.19125366210938,
        -2040.0,
        640.130615234375
      ],
      [
        -227.65122985839844,
        -2040.0,
        645.9105834960938
      ],
      [
        -270.0,
        -2040.0,
        645.774169921875
      ],
      [
        -270.0,
        -2032.0,
        765.0
      ],
      [
        -270.0,
        -2032.0,
        765.0
      ],
      [
        -270.0,
        -2032.0,
        770.0
      ],
      [
        -195.0,
        -1987.0,
        754.0
      ],
      [
        -184.0,
        -1987.0,
        754.0
      ],
      [
        -195.0,
        -1952.397216796875,
        754.0
      ],
      [
        -198.0,
        -1987.0,
        754.0
      ],
      [
        -270.0,
        7356.51123046875,
        150.0
      ],
      [
        -2000.0,
        7012.392578125,
        150.0
      ],
      [
        -2000.0,
        3453.1669921875,
        100.0
      ],
      [
        -1259.1229248046875,
        3532.546630859375,
        100.0
      ],
      [
        -1310.4478759765625,
        1742.4332275390625,
        100.0
      ],
      [
        -2000.0,
        1492.4522705078125,
        100.0
      ],
      [
        -1791.55712890625,
        -219.5267333984375,
        100.0
      ],
      [
        -2000.0,
        -404.04803466796875,
        100.0
      ],
      [
        -1313.0133056640625,
        1749.509765625,
        150.0
      ],
      [
        -2000.0,
        1500.4588623046875,
        150.0
      ],
      [
        -1797.296875,
        -213.04283142089844,
        150.0
      ],
      [
        -2000.0,
        -392.48309326171875,
        150.0
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        892.0023193359375
      ],
      [
        -433.48736572265625,
        -1935.8033447265625,
        912.0
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        892.0023193359375
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        872.4356079101562
      ],
      [
        -433.6494445800781,
        -1935.6546630859375,
        766.0
      ],
      [
        -321.2057189941406,
        -1858.298095703125,
        975.0
      ],
      [
        -327.9764709472656,
        -1862.9718017578125,
        941.5552368164062
      ],
      [
        -433.48736572265625,
        -1935.8033447265625,
        912.0
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      [
        -431.22930908203125,
        -1934.768798828125,
        1080.0
      ],
      [
        -434.07379150390625,
        -1936.41796875,
        960.5042114257812
      ],
      [
        -434.07379150390625,
        -1936.41796875,
        960.5042114257812
      ],
      [
        -321.9030456542969,
        -1859.9444580078125,
        975.0
      ],
      [
        -329.1273193359375,
        -1864.783935546875,
        938.8794555664062
      ],
      [
        -433.45745849609375,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -433.427001953125,
        -1935.858642578125,
        912.0
      ],
      [
        -433.45745849609375,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      [
        -421.8410339355469,
        -1928.0,
        930.0
      ],
      [
        -433.427001953125,
        -1935.858642578125,
        912.0
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      [
        -332.8520812988281,
        -1885.7939453125,
        975.0
      ],
      [
        -341.40447998046875,
        -1884.114990234375,
        910.334716796875
      ],
      [
        -340.5271911621094,
        -1903.9140625,
        975.0
      ],
      [
        -340.66888427734375,
        -1903.9371337890625,
        974.0792236328125
      ],
      [
        -430.0,
        -1939.0,
        836.4242553710938
      ],
      [
        -433.5278625488281,
        -1935.76611328125,
        845.7947387695312
      ],
      [
        -430.0,
        -1939.0,
        836.4242553710938
      ],
      [
        -422.5,
        -1939.0,
        832.452392578125
      ],
      [
        -300.0,
        -1939.0,
        765.0
      ],
      [
        -295.13226318359375,
        -1939.0,
        765.0
      ],
      [
        -270.0,
        -1933.2628173828125,
        765.0
      ],
      [
        -300.0,
        -1939.0,
        765.0
      ],
      [
        -300.0,
        -1937.9560546875,
        770.0
      ],
      [
        -300.0,
        -1939.0,
        767.5780029296875
      ],
      [
        -286.0,
        -1939.0,
        754.0
      ],
      [
        -274.3614196777344,
        -1939.0,
        754.0
      ],
      [
        -272.0,
        -1938.4609375,
        754.0
      ],
      [
        -286.0,
        -1939.0,
        754.0
      ],
      [
        -286.0,
        -1936.915283203125,
        765.0
      ],
      [
        -286.0,
        -1939.0,
        760.1636352539062
      ],
      [
        -422.5,
        -1945.875,
        766.0
      ],
      [
        -422.5,
        -1939.0,
        832.452392578125
      ],
      [
        -422.5,
        -1945.875,
        816.5028076171875
      ],
      [
        -369.377197265625,
        -1950.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1953.6666259765625,
        778.7999267578125
      ],
      [
        -408.3056640625,
        -1958.886474609375,
        778.7999267578125
      ],
      [
        -417.9999694824219,
        -1950.0,
        778.7999267578125
      ],
      [
        -417.9999694824219,
        -1950.0,
        804.5499267578125
      ],
      [
        -414.0,
        -1950.0,
        802.4315795898438
      ],
      [
        -414.0,
        -1950.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1953.6666259765625,
        778.7999267578125
      ],
      [
        -414.0,
        -1950.0,
        802.4317016601562
      ],
      [
        -414.0,
        -1953.6666259765625,
        793.92529296875
      ],
      [
        -283.0,
        -1979.0,
        665.7776489257812
      ],
      [
        -283.0,
        -1987.0,
        647.2184448242188
      ],
      [
        -283.0,
        -1987.0,
        647.2184448242188
      ],
      [
        -275.0,
        -1987.0,
        642.9817504882812
      ],
      [
        -283.0,
        -1940.9720458984375,
        754.0
      ],
      [
        -283.0,
        -1939.0,
        754.0
      ],
      [
        -417.9999694824219,
        -1950.0,
        766.0
      ],
      [
        -286.0,
        -1941.6568603515625,
        754.0
      ],
      [
        -286.0,
        -1941.6568603515625,
        754.0
      ],
      [
        -300.0,
        -1940.1112060546875,
        765.0
      ],
      [
        -300.0,
        -1940.1112060546875,
        765.0
      ],
      [
        -422.5,
        -1950.0,
        806.93310546875
      ],
      [
        -422.5,
        -1950.0,
        806.93310546875
      ],
      [
        -414.0,
        -1960.1864013671875,
        778.7999267578125
      ],
      [
        -414.0,
        -1960.1864013671875,
        778.7999267578125
      ],
      [
        -483.21807861328125,
        -2040.0,
        719.4412231445312
      ],
      [
        -503.4736328125,
        -2040.0,
        745.6981811523438
      ],
      [
        -414.0,
        -1972.0,
        788.1213989257812
      ],
      [
        -414.0,
        -1950.0,
        833.3430786132812
      ],
      [
        -406.8780822753906,
        -1972.0,
        778.7999267578125
      ],
      [
        -401.2017822265625,
        -1968.8211669921875,
        778.7999267578125
      ],
      [
        -370.3376159667969,
        -1950.21923828125,
        778.7999267578125
      ],
      [
        -406.8780822753906,
        -1972.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1972.0,
        788.1213989257812
      ],
      [
        -422.5,
        -1939.0,
        862.8703002929688
      ],
      [
        -422.5,
        -1950.0,
        842.9549560546875
      ],
      [
        -422.5,
        -1950.0,
        842.9549560546875
      ],
      [
        -414.0,
        -1950.0,
        833.3430786132812
      ],
      [
        -430.0,
        -1939.0,
        871.35107421875
      ],
      [
        -433.4741516113281,
        -1935.8153076171875,
        881.0454711914062
      ],
      [
        -430.0,
        -1939.0,
        871.35107421875
      ],
      [
        -422.5,
        -1939.0,
        862.8703002929688
      ],
      [
        -396.4644775390625,
        -1935.34716796875,
        841.7379760742188
      ],
      [
        -414.0011291503906,
        -1944.9122314453125,
        843.802490234375
      ],
      [
        -379.3594665527344,
        -1926.0169677734375,
        839.725341796875
      ],
      [
        -382.8941345214844,
        -1927.9453125,
        840.140625
      ],
      [
        -414.0011291503906,
        -1944.9122314453125,
        843.802490234375
      ],
      [
        -430.0,
        -1939.0,
        871.6712036132812
      ],
      [
        -422.5,
        -1939.0,
        863.5264282226562
      ],
      [
        -430.0,
        -1939.0,
        871.6712036132812
      ],
      [
        -433.47406005859375,
        -1935.8154296875,
        881.0971069335938
      ],
      [
        -422.5,
        -1939.0,
        863.5264282226562
      ],
      [
        -422.5,
        -1942.0531005859375,
        858.1068115234375
      ],
      [
        -422.5,
        -1945.1715087890625,
        851.6968383789062
      ],
      [
        -422.5,
        -1949.5487060546875,
        844.8013916015625
      ],
      [
        -422.5,
        -1950.0,
        843.8737182617188
      ],
      [
        -422.5,
        -1950.0,
        843.8737182617188
      ],
      [
        -422.5,
        -1939.0,
        866.4844360351562
      ],
      [
        -430.0,
        -1939.0,
        875.7760620117188
      ],
      [
        -433.4656982421875,
        -1935.8231201171875,
        886.599853515625
      ],
      [
        -430.0,
        -1939.0,
        875.7760620117188
      ],
      [
        -422.5,
        -1939.0,
        866.4844360351562
      ],
      [
        -433.3038330078125,
        -1935.9715576171875,
        886.0942993164062
      ],
      [
        -435.841552734375,
        -1937.4427490234375,
        886.2142333984375
      ],
      [
        -414.0,
        -1950.0,
        839.5381469726562
      ],
      [
        -366.15057373046875,
        -1939.505859375,
        801.4368286132812
      ],
      [
        -373.7198791503906,
        -1942.5079345703125,
        804.3275146484375
      ],
      [
        -369.0,
        -1950.787353515625,
        778.7999267578125
      ],
      [
        -422.5,
        -1939.0,
        876.37158203125
      ],
      [
        -422.5,
        -1950.0,
        850.6632080078125
      ],
      [
        -422.5,
        -1950.0,
        850.6632080078125
      ],
      [
        -414.0,
        -1950.0,
        839.5380859375
      ],
      [
        -430.0,
        -1939.0,
        886.1878662109375
      ],
      [
        -422.5,
        -1939.0,
        876.37158203125
      ],
      [
        -431.6847839355469,
        -1937.45556640625,
        892.0023193359375
      ],
      [
        -433.44818115234375,
        -1935.8392333984375,
        898.088134765625
      ],
      [
        -431.6847839355469,
        -1937.45556640625,
        892.0023193359375
      ],
      [
        -430.0,
        -1939.0,
        886.1878662109375
      ],
      [
        -433.3038330078125,
        -1935.9715576171875,
        897.5899658203125
      ],
      [
        -435.5733337402344,
        -1937.2872314453125,
        897.4856567382812
      ],
      [
        -482.6417236328125,
        -2040.0,
        719.0380249023438
      ],
      [
        -483.21807861328125,
        -2040.0,
        719.4412231445312
      ],
      [
        -283.0,
        -1987.0,
        687.8589477539062
      ],
      [
        -275.0,
        -1987.0,
        688.9048461914062
      ],
      [
        -283.0,
        -1979.0,
        703.0516967773438
      ],
      [
        -283.0,
        -1987.0,
        687.8589477539062
      ],
      [
        -283.0,
        -1946.379638671875,
        765.0
      ],
      [
        -270.0,
        -1947.2745361328125,
        765.0
      ],
      [
        -283.0,
        -1936.23046875,
        765.0
      ],
      [
        -283.0,
        -1952.172119140625,
        754.0
      ],
      [
        -272.0,
        -1952.9293212890625,
        754.0
      ],
      [
        -283.0,
        -1940.9720458984375,
        754.0
      ],
      [
        -300.0,
        -1945.20947265625,
        765.0
      ],
      [
        -300.0,
        -1945.20947265625,
        765.0
      ],
      [
        -300.0,
        -1942.57666015625,
        770.0
      ],
      [
        -286.0,
        -1951.965576171875,
        754.0
      ],
      [
        -286.0,
        -1946.1732177734375,
        765.0
      ],
      [
        -286.0,
        -1951.965576171875,
        754.0
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.089599609375
      ],
      [
        -419.5531921386719,
        -1928.0,
        930.0
      ],
      [
        -433.3038024902344,
        -1935.9715576171875,
        897.5899047851562
      ],
      [
        -433.3038635253906,
        -1935.9715576171875,
        912.0
      ],
      [
        -433.3038635253906,
        -1935.9715576171875,
        912.0
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.089599609375
      ],
      [
        -404.59893798828125,
        -1972.0,
        778.7999267578125
      ],
      [
        -375.3878479003906,
        -1957.9090576171875,
        778.7999267578125
      ],
      [
        -369.0,
        -1954.001220703125,
        778.7999267578125
      ],
      [
        -404.59893798828125,
        -1972.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1954.82763671875,
        778.7999267578125
      ],
      [
        -456.49090576171875,
        -2040.0,
        699.1410522460938
      ],
      [
        -394.842529296875,
        -2040.0,
        657.894775390625
      ],
      [
        -414.0,
        -1939.0,
        912.0
      ],
      [
        -414.0,
        -1928.0,
        930.0
      ],
      [
        -414.0,
        -1939.0,
        904.0
      ],
      [
        -414.0,
        -1939.0,
        894.0
      ],
      [
        -414.0,
        -1939.0,
        904.0
      ],
      [
        -414.0,
        -1939.0,
        912.0
      ],
      [
        -300.0,
        -1972.0,
        765.0
      ],
      [
        -270.0,
        -1972.0,
        765.0
      ],
      [
        -349.0,
        -1972.0,
        778.7999267578125
      ],
      [
        -300.0,
        -1972.0,
        765.0
      ],
      [
        -300.0,
        -1972.0,
        770.0
      ],
      [
        -286.0,
        -1972.0,
        754.0
      ],
      [
        -286.0,
        -1972.0,
        765.0
      ],
      [
        -286.0,
        -1972.0,
        754.0
      ],
      [
        -272.0,
        -1972.0,
        754.0
      ],
      [
        -334.4937744140625,
        -1972.0,
        709.7407836914062
      ],
      [
        -330.7213439941406,
        -1972.0,
        710.1063232421875
      ],
      [
        -334.4937744140625,
        -1972.0,
        709.7407836914062
      ],
      [
        -335.0843811035156,
        -1972.0,
        710.0416259765625
      ],
      [
        -422.5,
        -1939.0,
        912.0
      ],
      [
        -422.5,
        -1929.7083740234375,
        927.2045288085938
      ],
      [
        -422.5,
        -1939.0,
        908.25
      ],
      [
        -422.5,
        -1939.0,
        908.25
      ],
      [
        -422.5,
        -1939.0,
        912.0
      ],
      [
        -364.47003173828125,
        -2040.0,
        642.4253540039062
      ],
      [
        -394.842529296875,
        -2040.0,
        657.894775390625
      ],
      [
        -283.0,
        -1979.0,
        703.777099609375
      ],
      [
        -283.0,
        -1987.0,
        691.2600708007812
      ],
      [
        -283.0,
        -1987.0,
        691.2600708007812
      ],
      [
        -275.0,
        -1987.0,
        692.035400390625
      ],
      [
        -300.0,
        -1987.0,
        768.5
      ],
      [
        -283.0,
        -1987.0,
        754.0
      ],
      [
        -272.0,
        -1987.0,
        754.0
      ],
      [
        -283.0,
        -1972.0,
        754.0
      ],
      [
        -286.0,
        -1987.0,
        754.0
      ],
      [
        -286.0,
        -1987.0,
        765.0
      ],
      [
        -286.0,
        -1987.0,
        754.0
      ],
      [
        -364.47003173828125,
        -2040.0,
        642.4253540039062
      ],
      [
        -320.5353698730469,
        -2040.0,
        644.4969482421875
      ],
      [
        -281.07293701171875,
        -2040.0,
        645.7384643554688
      ],
      [
        -270.0,
        -2017.276123046875,
        647.5409545898438
      ],
      [
        -281.07293701171875,
        -2040.0,
        645.7384643554688
      ],
      [
        -294.20599365234375,
        -2040.0,
        645.7384643554688
      ],
      [
        -303.6571044921875,
        -2040.0,
        645.7384643554688
      ],
      [
        -320.5353698730469,
        -2040.0,
        644.4969482421875
      ],
      [
        -303.6571044921875,
        -2040.0,
        645.7384643554688
      ],
      [
        -456.49090576171875,
        -2040.0,
        699.1410522460938
      ],
      [
        -471.18353271484375,
        -2040.0,
        711.021728515625
      ],
      [
        -471.18353271484375,
        -2040.0,
        711.021728515625
      ],
      [
        -636.3113403320312,
        -2040.0,
        809.5067749023438
      ],
      [
        -739.34326171875,
        -2040.0,
        714.0588989257812
      ],
      [
        -986.1747436523438,
        -2040.0,
        194.07044982910156
      ],
      [
        -962.92822265625,
        -2040.0,
        345.2850646972656
      ],
      [
        -573.24951171875,
        -2040.0,
        836.1474609375
      ],
      [
        -573.24951171875,
        -2040.0,
        836.1474609375
      ],
      [
        -636.3113403320312,
        -2040.0,
        809.5067749023438
      ],
      [
        -1014.864501953125,
        -2040.0,
        150.4525146484375
      ],
      [
        -1002.93603515625,
        -2040.0,
        162.31973266601562
      ],
      [
        -1002.93603515625,
        -2040.0,
        162.31973266601562
      ],
      [
        -986.1747436523438,
        -2040.0,
        194.07044982910156
      ],
      [
        -1030.2423095703125,
        -2040.0,
        174.0879364013672
      ],
      [
        -1014.864501953125,
        -2040.0,
        150.4525146484375
      ],
      [
        -1036.3642578125,
        -2040.0,
        291.7461853027344
      ],
      [
        -1034.701171875,
        -2040.0,
        270.75787353515625
      ],
      [
        -1032.6046142578125,
        -2040.0,
        235.4507293701172
      ],
      [
        -1030.2423095703125,
        -2040.0,
        174.0879364013672
      ],
      [
        -1034.701171875,
        -2040.0,
        270.7579040527344
      ],
      [
        -1032.6046142578125,
        -2040.0,
        235.4507293701172
      ],
      [
        980.0,
        -3071.217529296875,
        0.0
      ],
      [
        1720.0,
        -2859.02587890625,
        0.0
      ],
      [
        1252.9140625,
        -4306.80322265625,
        1328.073974609375
      ],
      [
        1252.9140625,
        -4306.80322265625,
        1328.073974609375
      ],
      [
        1269.7293701171875,
        -4287.13525390625,
        1358.498291015625
      ],
      [
        1636.295166015625,
        -3859.893310546875,
        1338.7508544921875
      ],
      [
        1654.0455322265625,
        -3839.280517578125,
        1303.609619140625
      ],
      [
        1496.001220703125,
        -4022.9189453125,
        1568.7076416015625
      ],
      [
        1383.4677734375,
        -4154.1025390625,
        1564.286376953125
      ],
      [
        1720.0,
        -3788.748779296875,
        1213.9671630859375
      ],
      [
        1664.4010009765625,
        -3827.30908203125,
        1258.5145263671875
      ],
      [
        1720.0,
        -3774.750732421875,
        1245.8548583984375
      ],
      [
        1675.307373046875,
        -3814.589599609375,
        1261.5203857421875
      ],
      [
        1496.001220703125,
        -4022.9189453125,
        1568.7076416015625
      ],
      [
        1515.475830078125,
        -4000.1982421875,
        1577.9471435546875
      ],
      [
        1654.0455322265625,
        -3839.280517578125,
        1303.609619140625
      ],
      [
        1720.0,
        -3762.04638671875,
        1464.4447021484375
      ],
      [
        1720.0,
        -3762.466796875,
        1273.837890625
      ],
      [
        1636.295166015625,
        -3859.893310546875,
        1338.7509765625
      ],
      [
        1543.9287109375,
        -3967.00244140625,
        1591.4461669921875
      ],
      [
        1543.9287109375,
        -3967.00244140625,
        1591.4461669921875
      ],
      [
        1373.6865234375,
        -4165.5048828125,
        1563.902099609375
      ],
      [
        1269.7293701171875,
        -4287.13525390625,
        1358.498291015625
      ],
      [
        1373.6865234375,
        -4165.5048828125,
        1563.902099609375
      ],
      [
        1043.638916015625,
        -4549.7880859375,
        1761.0576171875
      ],
      [
        1338.2362060546875,
        -4206.98193359375,
        1493.8575439453125
      ],
      [
        1665.5118408203125,
        -3826.013671875,
        1258.8206787109375
      ],
      [
        1002.5,
        -4587.4716796875,
        1763.7958984375
      ],
      [
        1002.5,
        -4598.142578125,
        1579.215576171875
      ],
      [
        1002.5,
        -4055.781005859375,
        1269.789306640625
      ],
      [
        1002.5,
        -4040.350341796875,
        1267.0811767578125
      ],
      [
        980.0,
        -4608.08154296875,
        1765.2935791015625
      ],
      [
        980.0,
        -4608.44384765625,
        1759.030517578125
      ],
      [
        980.0,
        -3982.5,
        1350.0
      ],
      [
        980.0,
        -3982.5,
        1259.772705078125
      ],
      [
        980.0,
        -4081.5126953125,
        1269.789306640625
      ],
      [
        980.0,
        -4025.304443359375,
        1259.924560546875
      ],
      [
        1658.3779296875,
        -3595.599609375,
        103.99835205078125
      ],
      [
        1659.89404296875,
        -3591.999267578125,
        77.56491088867188
      ],
      [
        1321.096923828125,
        -3443.970947265625,
        0.0
      ],
      [
        1312.45263671875,
        -3441.354736328125,
        0.0
      ],
      [
        1270.669189453125,
        -3428.708984375,
        0.0
      ],
      [
        680.0000610351562,
        -4449.17431640625,
        0.0
      ],
      [
        680.0,
        -4318.5712890625,
        0.0
      ],
      [
        680.0,
        -4318.5712890625,
        0.0
      ],
      [
        680.0,
        -3157.2412109375,
        0.0
      ],
      [
        862.7425537109375,
        -3984.127685546875,
        1146.84814453125
      ],
      [
        794.4974975585938,
        -4249.6728515625,
        1225.27978515625
      ],
      [
        970.7195434570312,
        -4019.098388671875,
        1256.97265625
      ],
      [
        867.5,
        -3975.0,
        1146.2098388671875
      ],
      [
        892.5,
        -3975.0,
        1167.5401611328125
      ],
      [
        867.5,
        -3975.0,
        1146.2098388671875
      ],
      [
        867.5,
        -4000.0,
        1159.0758056640625
      ],
      [
        863.2664184570312,
        -3982.2509765625,
        1147.759033203125
      ],
      [
        862.7425537109375,
        -3984.127685546875,
        1146.84814453125
      ],
      [
        867.5,
        -3975.0,
        1158.026611328125
      ],
      [
        892.5,
        -3975.0,
        1233.533935546875
      ],
      [
        892.201904296875,
        -3975.0,
        1233.47412109375
      ],
      [
        892.5,
        -3982.5,
        1234.8502197265625
      ],
      [
        951.0032348632812,
        -3982.5,
        1246.5924072265625
      ],
      [
        867.5,
        -3982.5,
        1160.7808837890625
      ],
      [
        867.5,
        -4000.0,
        1167.20751953125
      ],
      [
        867.5,
        -3982.5,
        1150.069580078125
      ],
      [
        867.5,
        -3975.0,
        1158.026611328125
      ],
      [
        919.0609130859375,
        -3804.191650390625,
        1252.7838134765625
      ],
      [
        905.3211059570312,
        -3982.5,
        1237.423583984375
      ],
      [
        980.0,
        -3982.5,
        1273.15771484375
      ],
      [
        929.451416015625,
        -3982.5,
        1350.0
      ],
      [
        892.5,
        -3982.5,
        1237.1387939453125
      ],
      [
        892.5,
        -3975.0,
        1234.3846435546875
      ],
      [
        867.5,
        -3975.0,
        1229.2340087890625
      ],
      [
        867.5,
        -3989.234130859375,
        1362.5
      ],
      [
        915.0795288085938,
        -3798.05029296875,
        1251.1812744140625
      ],
      [
        881.81298828125,
        -3921.060791015625,
        1229.2020263671875
      ],
      [
        867.5,
        -3980.053955078125,
        1159.8829345703125
      ],
      [
        867.5,
        -3977.258544921875,
        1164.296875
      ],
      [
        884.5675048828125,
        -3958.58740234375,
        1228.671142578125
      ],
      [
        884.5675048828125,
        -3958.58740234375,
        1228.671142578125
      ],
      [
        867.5,
        -3977.258544921875,
        1164.296875
      ],
      [
        867.5,
        -3968.694091796875,
        1170.1976318359375
      ],
      [
        878.0281982421875,
        -3934.9013671875,
        1225.254638671875
      ],
      [
        881.0777587890625,
        -3944.73388671875,
        1227.683837890625
      ],
      [
        881.81298828125,
        -3921.060791015625,
        1229.2020263671875
      ],
      [
        880.21240234375,
        -3926.341552734375,
        1222.173583984375
      ],
      [
        867.5,
        -3975.0,
        1162.65966796875
      ],
      [
        877.2379760742188,
        -3975.0,
        1187.76953125
      ],
      [
        867.5,
        -3975.0,
        1165.85302734375
      ],
      [
        869.563720703125,
        -3975.0,
        1172.0814208984375
      ],
      [
        867.5,
        -3975.0,
        1167.8626708984375
      ],
      [
        867.5,
        -3975.0,
        1219.695556640625
      ],
      [
        891.4415283203125,
        -3975.0,
        1231.1517333984375
      ],
      [
        871.2774047851562,
        -3975.0,
        1362.5
      ],
      [
        867.5,
        -3975.0,
        1229.2340087890625
      ],
      [
        919.5,
        -3786.072509765625,
        1295.0
      ],
      [
        900.0145263671875,
        -3859.5,
        1295.0
      ],
      [
        906.0759887695312,
        -3840.5,
        1330.9654541015625
      ],
      [
        903.9447021484375,
        -3848.26318359375,
        1328.4556884765625
      ],
      [
        903.9447021484375,
        -3848.26318359375,
        1328.4556884765625
      ],
      [
        901.3875732421875,
        -3858.121337890625,
        1330.5355224609375
      ],
      [
        909.7762451171875,
        -3827.7490234375,
        1342.130859375
      ],
      [
        906.0759887695312,
        -3840.5,
        1330.9654541015625
      ],
      [
        901.3875732421875,
        -3858.121337890625,
        1330.5355224609375
      ],
      [
        898.512939453125,
        -3869.61572265625,
        1336.7344970703125
      ],
      [
        863.4521484375,
        -3981.686767578125,
        1149.0294189453125
      ],
      [
        863.2664184570312,
        -3982.2509765625,
        1147.759033203125
      ],
      [
        863.4521484375,
        -3981.686767578125,
        1149.0294189453125
      ],
      [
        793.9007568359375,
        -4250.03759765625,
        1224.9583740234375
      ],
      [
        914.6360473632812,
        -3797.3662109375,
        1251.0028076171875
      ],
      [
        881.541015625,
        -3919.9189453125,
        1229.128173828125
      ],
      [
        877.7193603515625,
        -3933.905517578125,
        1225.0086669921875
      ],
      [
        881.541015625,
        -3919.9189453125,
        1229.128173828125
      ],
      [
        879.9046020507812,
        -3925.34375,
        1221.927978515625
      ],
      [
        863.1806640625,
        -3982.55810546875,
        1147.6099853515625
      ],
      [
        867.5,
        -3975.0,
        1249.570556640625
      ],
      [
        867.5,
        -3986.7265625,
        1362.5
      ],
      [
        870.6091918945312,
        -3975.0,
        1362.5
      ],
      [
        867.5,
        -3975.0,
        1249.570556640625
      ],
      [
        919.5,
        -3783.589599609375,
        1295.0
      ],
      [
        899.3736572265625,
        -3859.5,
        1295.0
      ],
      [
        908.8073120117188,
        -3828.57763671875,
        1339.858642578125
      ],
      [
        905.3595581054688,
        -3840.5,
        1329.4444580078125
      ],
      [
        900.9735107421875,
        -3857.002197265625,
        1329.051513671875
      ],
      [
        897.6475830078125,
        -3870.290283203125,
        1336.2144775390625
      ],
      [
        903.3675537109375,
        -3847.76953125,
        1327.1021728515625
      ],
      [
        900.9735107421875,
        -3857.002197265625,
        1329.051513671875
      ],
      [
        905.3595581054688,
        -3840.5,
        1329.4444580078125
      ],
      [
        903.3675537109375,
        -3847.76953125,
        1327.1021728515625
      ],
      [
        867.5,
        -3975.0,
        1302.96923828125
      ],
      [
        867.5,
        -3978.600830078125,
        1362.5
      ],
      [
        868.5252685546875,
        -3975.0,
        1362.5
      ],
      [
        867.5,
        -3975.0,
        1302.96923828125
      ],
      [
        830.0,
        -3717.5,
        1207.4354248046875
      ],
      [
        830.0,
        -3742.5,
        1193.7001953125
      ],
      [
        872.5,
        -3831.5,
        1229.15869140625
      ],
      [
        869.5,
        -3831.5,
        1227.72314453125
      ],
      [
        869.5,
        -3831.5,
        1227.72314453125
      ],
      [
        869.5,
        -3834.5,
        1227.5753173828125
      ],
      [
        869.5,
        -3854.5,
        1226.58984375
      ],
      [
        869.5,
        -3857.5,
        1226.4420166015625
      ],
      [
        872.5,
        -3854.5,
        1228.025390625
      ],
      [
        869.5,
        -3854.5,
        1226.5899658203125
      ],
      [
        830.0,
        -3717.5,
        1214.439453125
      ],
      [
        830.0,
        -3741.96728515625,
        1213.23388671875
      ],
      [
        830.0,
        -3742.5,
        1212.8668212890625
      ],
      [
        830.0,
        -3742.5,
        1213.2076416015625
      ],
      [
        867.5,
        -3975.0,
        1327.3516845703125
      ],
      [
        867.5,
        -3976.133056640625,
        1321.7015380859375
      ],
      [
        870.972900390625,
        -3808.16943359375,
        1319.7017822265625
      ],
      [
        870.2852783203125,
        -3821.986328125,
        1312.1380615234375
      ],
      [
        871.01953125,
        -3872.706298828125,
        1320.21484375
      ],
      [
        870.32470703125,
        -3858.756591796875,
        1312.572021484375
      ],
      [
        870.2059936523438,
        -3856.372802734375,
        1311.2659912109375
      ],
      [
        870.2852783203125,
        -3859.013916015625,
        1312.1380615234375
      ],
      [
        875.9066772460938,
        -3852.15087890625,
        1310.021484375
      ],
      [
        870.2852783203125,
        -3821.986328125,
        1312.1380615234375
      ],
      [
        869.9841918945312,
        -3832.017822265625,
        1308.82568359375
      ],
      [
        869.9841918945312,
        -3848.982421875,
        1308.82568359375
      ],
      [
        869.8992309570312,
        -3840.5,
        1307.891357421875
      ],
      [
        869.9841918945312,
        -3848.982421875,
        1308.82568359375
      ],
      [
        869.9841918945312,
        -3832.017822265625,
        1308.82568359375
      ],
      [
        869.8992309570312,
        -3840.5,
        1307.891357421875
      ],
      [
        867.5,
        -3975.0,
        1327.3516845703125
      ],
      [
        868.3547973632812,
        -3975.0,
        1352.6033935546875
      ],
      [
        867.5,
        -3810.87646484375,
        1317.614990234375
      ],
      [
        867.5,
        -3819.91357421875,
        1312.7493896484375
      ],
      [
        867.5,
        -3869.962890625,
        1318.10009765625
      ],
      [
        867.5,
        -3860.857666015625,
        1313.193603515625
      ],
      [
        867.5,
        -3858.377197265625,
        1311.85693359375
      ],
      [
        867.5,
        -3861.08642578125,
        1312.7493896484375
      ],
      [
        870.2059936523438,
        -3856.372802734375,
        1311.2659912109375
      ],
      [
        867.5,
        -3819.91357421875,
        1312.7493896484375
      ],
      [
        867.5,
        -3831.180908203125,
        1309.03759765625
      ],
      [
        867.5,
        -3795.24609375,
        1338.5040283203125
      ],
      [
        867.5,
        -3786.752685546875,
        1333.1954345703125
      ],
      [
        867.5,
        -3840.5,
        1308.006591796875
      ],
      [
        867.5,
        -3849.8193359375,
        1309.03759765625
      ],
      [
        867.5,
        -3831.180908203125,
        1309.03759765625
      ],
      [
        867.5,
        -3840.5,
        1308.006591796875
      ],
      [
        867.5,
        -3849.8193359375,
        1309.03759765625
      ],
      [
        869.5,
        -3854.0,
        1292.0
      ],
      [
        869.5,
        -3854.0,
        1295.0
      ],
      [
        869.5,
        -3831.0,
        1292.0
      ],
      [
        869.5,
        -3831.0,
        1295.0
      ],
      [
        868.3492431640625,
        -3975.0,
        1362.5
      ],
      [
        867.5,
        -3975.0,
        1336.2237548828125
      ],
      [
        867.5,
        -3975.0,
        1336.2237548828125
      ],
      [
        867.5,
        -3976.526123046875,
        1328.19873046875
      ],
      [
        787.322265625,
        -3664.83544921875,
        486.5341491699219
      ],
      [
        -132.7933349609375,
        -3390.305908203125,
        0.0
      ],
      [
        106.4583740234375,
        -3321.701416015625,
        0.0
      ],
      [
        106.4583740234375,
        -3321.70166015625,
        0.0
      ],
      [
        503.552734375,
        -3730.059326171875,
        11.74609375
      ],
      [
        504.1846923828125,
        -3729.798583984375,
        0.0
      ],
      [
        566.8375854492188,
        -3934.084716796875,
        1819.7926025390625
      ],
      [
        567.0928955078125,
        -3931.114501953125,
        1789.7890625
      ],
      [
        427.0243225097656,
        -3811.61572265625,
        1771.95361328125
      ],
      [
        372.3069152832031,
        -3796.810546875,
        1698.721435546875
      ],
      [
        426.9814453125,
        -3811.85205078125,
        1774.5174560546875
      ],
      [
        269.3843994140625,
        -3786.52392578125,
        1746.7979736328125
      ],
      [
        372.3069152832031,
        -3796.810546875,
        1698.721435546875
      ],
      [
        427.0243225097656,
        -3811.61572265625,
        1771.95361328125
      ],
      [
        431.4538269042969,
        -3806.322265625,
        1687.03955078125
      ],
      [
        350.990234375,
        -3780.25,
        1519.1739501953125
      ],
      [
        350.990234375,
        -3780.25,
        1519.1739501953125
      ],
      [
        305.2799377441406,
        -3778.67431640625,
        1609.0145263671875
      ],
      [
        222.45388793945312,
        -3769.860107421875,
        1642.0294189453125
      ],
      [
        305.2799377441406,
        -3778.67431640625,
        1609.0145263671875
      ],
      [
        59.025657653808594,
        -3335.302490234375,
        1455.1270751953125
      ],
      [
        70.72618103027344,
        -3331.947509765625,
        1112.677001953125
      ],
      [
        40.58837890625,
        -3340.589111328125,
        1629.9017333984375
      ],
      [
        51.478782653808594,
        -3337.46630859375,
        1535.99658203125
      ],
      [
        59.025657653808594,
        -3335.302490234375,
        1455.1270751953125
      ],
      [
        51.478790283203125,
        -3337.46630859375,
        1535.99658203125
      ],
      [
        534.474365234375,
        -3248.261962890625,
        1155.389404296875
      ],
      [
        498.8936462402344,
        -3233.130126953125,
        1095.7650146484375
      ],
      [
        470.009521484375,
        -3217.454833984375,
        1048.0806884765625
      ],
      [
        494.55560302734375,
        -3229.383056640625,
        1093.1484375
      ],
      [
        468.7945251464844,
        -3217.80322265625,
        1051.5068359375
      ],
      [
        494.55560302734375,
        -3229.383056640625,
        1093.1484375
      ],
      [
        498.8936462402344,
        -3233.130126953125,
        1095.7650146484375
      ],
      [
        260.17779541015625,
        -3277.623046875,
        290.81121826171875
      ],
      [
        217.87071228027344,
        -3289.75439453125,
        99.0547103881836
      ],
      [
        191.07476806640625,
        -3297.438232421875,
        0.0
      ],
      [
        217.8707275390625,
        -3289.754638671875,
        99.05470275878906
      ],
      [
        265.89044189453125,
        -3275.98486328125,
        511.052001953125
      ],
      [
        272.2877502441406,
        -3274.150634765625,
        740.441650390625
      ],
      [
        272.2877502441406,
        -3274.150634765625,
        740.441650390625
      ],
      [
        288.7086486816406,
        -3269.442138671875,
        952.2669677734375
      ],
      [
        325.7543640136719,
        -3258.8193359375,
        1078.021240234375
      ],
      [
        288.7086486816406,
        -3269.442138671875,
        952.2669677734375
      ],
      [
        325.75433349609375,
        -3258.8193359375,
        1078.021240234375
      ],
      [
        422.0525817871094,
        -3231.206298828125,
        1183.3170166015625
      ],
      [
        422.0525817871094,
        -3231.206298828125,
        1183.3170166015625
      ],
      [
        475.89849853515625,
        -3299.09814453125,
        1286.029296875
      ],
      [
        474.0192565917969,
        -3298.414306640625,
        1283.331298828125
      ],
      [
        473.3350524902344,
        -3300.29345703125,
        1283.468505859375
      ],
      [
        474.0192565917969,
        -3298.414306640625,
        1283.331298828125
      ],
      [
        484.7911376953125,
        -3274.666259765625,
        1284.2423095703125
      ],
      [
        482.91168212890625,
        -3273.982177734375,
        1281.5438232421875
      ],
      [
        482.2276916503906,
        -3275.861572265625,
        1281.6815185546875
      ],
      [
        482.91168212890625,
        -3273.982177734375,
        1281.5438232421875
      ],
      [
        474.01983642578125,
        -3298.41455078125,
        1323.5
      ],
      [
        472.6517639160156,
        -3302.17333984375,
        1323.5
      ],
      [
        482.9465026855469,
        -3301.66259765625,
        1323.5
      ],
      [
        481.54376220703125,
        -3277.740966796875,
        1323.5
      ],
      [
        491.83868408203125,
        -3277.231689453125,
        1323.5
      ],
      [
        482.91168212890625,
        -3273.982177734375,
        1323.5
      ],
      [
        474.7038269042969,
        -3296.53515625,
        1323.5
      ],
      [
        474.7038269042969,
        -3296.53515625,
        1325.0
      ],
      [
        474.7038269042969,
        -3296.53515625,
        1323.5
      ],
      [
        483.5956726074219,
        -3272.102783203125,
        1323.5
      ],
      [
        483.5956726074219,
        -3272.102783203125,
        1325.0
      ],
      [
        483.5956726074219,
        -3272.102783203125,
        1323.5
      ],
      [
        -471.43853759765625,
        -2949.135009765625,
        0.0
      ],
      [
        -182.02957153320312,
        -2820.28173828125,
        0.0
      ],
      [
        -182.02969360351562,
        -2820.28173828125,
        0.0
      ],
      [
        817.5167846679688,
        -2375.255126953125,
        0.0
      ],
      [
        -893.66162109375,
        -3137.120849609375,
        838.5628051757812
      ],
      [
        -835.3902587890625,
        -3111.1767578125,
        865.5540771484375
      ],
      [
        19.489643096923828,
        -3270.4326171875,
        1444.5465087890625
      ],
      [
        29.435382843017578,
        -3272.546630859375,
        1229.5478515625
      ],
      [
        -1115.741943359375,
        -3379.651123046875,
        901.18310546875
      ],
      [
        -922.2028198242188,
        -3149.828369140625,
        825.3421020507812
      ],
      [
        -892.20703125,
        -3136.473388671875,
        816.1241455078125
      ],
      [
        19.489643096923828,
        -3270.4326171875,
        1444.5465087890625
      ],
      [
        5.555870056152344,
        -3267.470947265625,
        1554.2142333984375
      ],
      [
        -2.5234222412109375,
        -3265.75341796875,
        1605.5548095703125
      ],
      [
        5.5558624267578125,
        -3267.470947265625,
        1554.2142333984375
      ],
      [
        -975.439453125,
        -3173.53076171875,
        838.225341796875
      ],
      [
        -951.7387084960938,
        -3162.978759765625,
        834.2861328125
      ],
      [
        -950.7990112304688,
        -3162.560302734375,
        834.1299438476562
      ],
      [
        -893.66162109375,
        -3137.120849609375,
        838.5628051757812
      ],
      [
        -950.7990112304688,
        -3162.560302734375,
        834.1299438476562
      ],
      [
        -950.7990112304688,
        -3162.560302734375,
        834.1299438476562
      ],
      [
        -42.06678009033203,
        -3172.2548828125,
        1444.156494140625
      ],
      [
        -57.122589111328125,
        -3161.155517578125,
        1429.8426513671875
      ],
      [
        -39.56816482543945,
        -3173.531982421875,
        1428.741455078125
      ],
      [
        -39.40976333618164,
        -3173.50634765625,
        1424.409423828125
      ],
      [
        -42.06678009033203,
        -3172.2548828125,
        1444.156494140625
      ],
      [
        -39.56816482543945,
        -3173.531982421875,
        1428.741455078125
      ],
      [
        177.8013916015625,
        -3281.84326171875,
        0.0
      ],
      [
        196.6639404296875,
        -3295.83544921875,
        20.66110610961914
      ],
      [
        -246.2593994140625,
        -3025.329345703125,
        1363.6708984375
      ],
      [
        -57.122589111328125,
        -3161.155517578125,
        1429.8426513671875
      ],
      [
        -246.2593994140625,
        -3025.329345703125,
        1363.6708984375
      ],
      [
        -301.69952392578125,
        -2988.336181640625,
        1433.0771484375
      ],
      [
        -266.6356506347656,
        -3006.173095703125,
        1367.7857666015625
      ],
      [
        -254.36074829101562,
        -3019.923583984375,
        1373.81298828125
      ],
      [
        -266.6356506347656,
        -3006.173095703125,
        1367.7857666015625
      ],
      [
        -352.0573425292969,
        -2913.139892578125,
        1383.4918212890625
      ],
      [
        -360.6915283203125,
        -2905.960205078125,
        1433.338623046875
      ],
      [
        -352.0573425292969,
        -2913.139892578125,
        1383.4918212890625
      ],
      [
        -327.6908264160156,
        -2936.516357421875,
        1315.572998046875
      ],
      [
        -265.533935546875,
        -3007.09814453125,
        1367.1375732421875
      ],
      [
        -327.6908264160156,
        -2936.516357421875,
        1315.572998046875
      ],
      [
        -253.673583984375,
        -3020.382080078125,
        1372.9527587890625
      ],
      [
        -265.533935546875,
        -3007.09814453125,
        1367.1375732421875
      ],
      [
        -331.9208984375,
        -2931.7841796875,
        1313.62060546875
      ],
      [
        -331.9208984375,
        -2931.7841796875,
        1313.62060546875
      ],
      [
        -352.1159362792969,
        -2912.790283203125,
        1383.0391845703125
      ],
      [
        -360.88519287109375,
        -2905.47607421875,
        1433.607177734375
      ],
      [
        -352.1159362792969,
        -2912.790283203125,
        1383.0391845703125
      ],
      [
        -295.45245361328125,
        -2913.558837890625,
        39.06966018676758
      ],
      [
        -295.45245361328125,
        -2913.558837890625,
        39.069671630859375
      ],
      [
        -295.1515197753906,
        -2912.103515625,
        0.0
      ],
      [
        -40.67903137207031,
        -3172.964111328125,
        1435.5948486328125
      ],
      [
        -257.665283203125,
        -3015.9111328125,
        1370.99560546875
      ],
      [
        -230.99546813964844,
        -3014.874755859375,
        707.8347778320312
      ],
      [
        -257.69537353515625,
        -3015.87744140625,
        1370.9808349609375
      ],
      [
        -329.5851745605469,
        -2885.977783203125,
        670.6998901367188
      ],
      [
        -319.76470947265625,
        -2881.60546875,
        324.57611083984375
      ],
      [
        -339.4705810546875,
        -2912.31396484375,
        1312.0963134765625
      ],
      [
        -319.76470947265625,
        -2881.60546875,
        324.57611083984375
      ],
      [
        -312.6351013183594,
        -2878.43115234375,
        0.0
      ],
      [
        -339.4705810546875,
        -2912.31396484375,
        1312.0963134765625
      ],
      [
        -354.7329406738281,
        -2897.17431640625,
        1362.815673828125
      ],
      [
        -347.9726257324219,
        -2894.16455078125,
        1318.76904296875
      ],
      [
        -362.7738952636719,
        -2900.75439453125,
        1436.2266845703125
      ],
      [
        -354.7329406738281,
        -2897.17431640625,
        1362.815673828125
      ],
      [
        629.46337890625,
        -3072.419677734375,
        0.0
      ],
      [
        623.2100830078125,
        -3081.6552734375,
        62.479888916015625
      ],
      [
        600.8919067382812,
        -3129.21435546875,
        373.4314270019531
      ],
      [
        623.2100830078125,
        -3081.6552734375,
        62.479896545410156
      ],
      [
        259.686279296875,
        -3277.763916015625,
        288.5833740234375
      ],
      [
        99.39129638671875,
        -3108.955322265625,
        204.25372314453125
      ],
      [
        76.22080993652344,
        -3085.625732421875,
        163.80921936035156
      ],
      [
        94.6696548461914,
        -3103.98291015625,
        201.7694549560547
      ],
      [
        95.31218719482422,
        -3104.622314453125,
        203.09152221679688
      ],
      [
        99.39128875732422,
        -3108.955322265625,
        204.25372314453125
      ],
      [
        95.31218719482422,
        -3104.622314453125,
        203.09152221679688
      ],
      [
        225.11087036132812,
        -3287.67822265625,
        131.87069702148438
      ],
      [
        199.54443359375,
        -3261.78857421875,
        115.3267822265625
      ],
      [
        94.6696548461914,
        -3103.98291015625,
        201.7694549560547
      ],
      [
        41.913944244384766,
        -3102.16455078125,
        13.32565689086914
      ],
      [
        36.13882064819336,
        -3097.333251953125,
        0.0
      ],
      [
        67.61579895019531,
        -3123.666015625,
        72.63072204589844
      ],
      [
        199.5435791015625,
        -3261.787353515625,
        115.32754516601562
      ],
      [
        67.61579132080078,
        -3123.666015625,
        72.63072204589844
      ],
      [
        -346.7237243652344,
        -2893.6083984375,
        1310.6319580078125
      ],
      [
        -337.2969055175781,
        -2889.4111328125,
        997.9078369140625
      ],
      [
        -337.2969055175781,
        -2889.4111328125,
        997.9077758789062
      ],
      [
        -329.5851745605469,
        -2885.977783203125,
        670.6998901367188
      ],
      [
        -346.7237243652344,
        -2893.6083984375,
        1310.6319580078125
      ],
      [
        -280.0,
        -2649.999755859375,
        0.0
      ],
      [
        -280.0,
        -2863.901123046875,
        0.0
      ],
      [
        -280.0,
        -2650.0,
        0.0
      ],
      [
        -279.99993896484375,
        -2046.0,
        0.0
      ],
      [
        -142.0,
        -2663.0,
        904.0472412109375
      ],
      [
        -142.0,
        -2665.0,
        910.7396240234375
      ],
      [
        -142.0,
        -2663.0,
        904.0472412109375
      ],
      [
        -140.0,
        -2663.0,
        905.9403076171875
      ],
      [
        -142.0,
        -2672.5,
        918.5
      ],
      [
        -138.0,
        -2666.18798828125,
        918.5
      ],
      [
        -142.0,
        -2667.319580078125,
        918.5
      ],
      [
        -144.0,
        -2667.88525390625,
        918.5
      ],
      [
        -144.0,
        -2667.88525390625,
        918.5
      ],
      [
        -144.0,
        -2668.33349609375,
        920.0
      ],
      [
        -169.5,
        -2665.086669921875,
        885.0
      ],
      [
        -168.53497314453125,
        -2665.534912109375,
        887.4125366210938
      ],
      [
        -168.0,
        -2663.0,
        904.0755615234375
      ],
      [
        -168.0,
        -2665.0,
        916.7216186523438
      ],
      [
        -168.0,
        -2663.0,
        904.0755615234375
      ],
      [
        -166.0,
        -2663.0,
        905.9432983398438
      ],
      [
        -142.0,
        -2667.319580078125,
        918.5
      ],
      [
        -138.0,
        -2663.0,
        918.5
      ],
      [
        -142.0,
        -2663.0,
        918.5
      ],
      [
        -164.0,
        -2664.690185546875,
        918.5
      ],
      [
        -168.0,
        -2665.28125,
        918.5
      ],
      [
        -168.0,
        -2672.5,
        918.5
      ],
      [
        -144.0,
        -2663.0,
        918.5
      ],
      [
        -144.0,
        -2663.0,
        918.5
      ],
      [
        -144.0,
        -2663.0,
        920.0
      ],
      [
        -144.0,
        -2661.736083984375,
        918.5
      ],
      [
        -138.0,
        -2660.849853515625,
        918.5
      ],
      [
        -144.0,
        -2661.736083984375,
        918.5
      ],
      [
        -144.0,
        -2661.973388671875,
        920.0
      ],
      [
        -168.0,
        -2662.5,
        887.5
      ],
      [
        -168.0,
        -2661.5,
        885.0
      ],
      [
        -170.0,
        -2665.57666015625,
        918.5
      ],
      [
        -170.0,
        -2665.57666015625,
        918.5
      ],
      [
        -170.0,
        -2665.81396484375,
        920.0
      ],
      [
        -280.0,
        -2668.909423828125,
        885.4474487304688
      ],
      [
        -280.0,
        -2657.304443359375,
        801.344482421875
      ],
      [
        -280.0,
        -2656.94873046875,
        798.7672729492188
      ],
      [
        -280.0,
        -2648.321533203125,
        731.131591796875
      ],
      [
        -280.0,
        -2632.418212890625,
        86.79737091064453
      ],
      [
        -280.0,
        -2651.806884765625,
        761.5028686523438
      ],
      [
        -280.0,
        -2651.806884765625,
        761.5028686523438
      ],
      [
        -280.0,
        -2648.321533203125,
        731.131591796875
      ],
      [
        -280.0,
        -2482.281982421875,
        505.02899169921875
      ],
      [
        -280.0,
        -2499.09228515625,
        115.6485595703125
      ],
      [
        -280.0,
        -2441.731689453125,
        970.539306640625
      ],
      [
        -280.0,
        -2476.800537109375,
        631.989990234375
      ],
      [
        -65.38192749023438,
        -2204.348876953125,
        855.09765625
      ],
      [
        -125.29585266113281,
        -2597.9091796875,
        142.70672607421875
      ],
      [
        -158.05810546875,
        -2581.8466796875,
        24.302167892456055
      ],
      [
        -280.0,
        -2501.82470703125,
        31.725990295410156
      ],
      [
        -280.0,
        -2499.09228515625,
        115.64855194091797
      ],
      [
        -189.5,
        -2504.836181640625,
        780.0
      ],
      [
        -162.0,
        -2518.013916015625,
        780.0
      ],
      [
        -145.0,
        -2239.39990234375,
        861.0
      ],
      [
        -125.63127136230469,
        -2221.324462890625,
        861.0
      ],
      [
        -145.0,
        -2226.23486328125,
        861.0
      ],
      [
        -122.04180908203125,
        -2208.415771484375,
        819.3709106445312
      ],
      [
        -145.0,
        -2214.13623046875,
        819.024658203125
      ],
      [
        -145.0,
        -2219.5,
        818.7000122070312
      ],
      [
        -189.5,
        -2504.836181640625,
        780.0
      ],
      [
        -189.5,
        -2504.577392578125,
        782.5
      ],
      [
        -178.07568359375,
        -2239.39990234375,
        861.0
      ],
      [
        -174.511474609375,
        -2233.716796875,
        861.0
      ],
      [
        -166.52584838867188,
        -2219.5,
        818.7000122070312
      ],
      [
        -164.0,
        -2513.32666015625,
        816.0
      ],
      [
        -169.8990020751953,
        -2510.5,
        816.0
      ],
      [
        -188.042724609375,
        -2505.275634765625,
        782.5
      ],
      [
        -188.042724609375,
        -2504.861083984375,
        786.5
      ],
      [
        -188.300048828125,
        -2504.73779296875,
        786.5
      ],
      [
        -188.300048828125,
        -2504.68603515625,
        787.0
      ],
      [
        -229.0,
        -2461.5,
        780.0
      ],
      [
        -229.0,
        -2484.14697265625,
        797.0
      ],
      [
        -229.0,
        -2485.907958984375,
        780.0
      ],
      [
        -226.5,
        -2485.344970703125,
        797.0
      ],
      [
        -226.5,
        -2484.619873046875,
        804.0
      ],
      [
        -168.86631774902344,
        -2575.91064453125,
        0.0
      ],
      [
        -158.05810546875,
        -2581.8466796875,
        24.302162170410156
      ],
      [
        -203.04644775390625,
        -2498.5,
        778.5
      ],
      [
        -193.73773193359375,
        -2502.960693359375,
        778.5
      ],
      [
        -229.0,
        -2486.063232421875,
        778.5
      ],
      [
        -203.0464630126953,
        -2498.5,
        778.5
      ],
      [
        -229.0,
        -2486.063232421875,
        778.5
      ],
      [
        -200.5,
        -2500.451416015625,
        771.4423828125
      ],
      [
        -197.5,
        -2501.7939453125,
        772.3593139648438
      ],
      [
        -220.5,
        -2491.500732421875,
        765.3291015625
      ],
      [
        -217.5,
        -2492.843505859375,
        766.2462158203125
      ],
      [
        -219.27052307128906,
        -2490.915283203125,
        776.6690673828125
      ],
      [
        -214.84860229492188,
        -2493.0,
        777.0
      ],
      [
        -219.27052307128906,
        -2490.915283203125,
        776.6690673828125
      ],
      [
        -219.30735778808594,
        -2490.7080078125,
        778.5
      ],
      [
        -201.0,
        -2498.5,
        777.8729858398438
      ],
      [
        -197.0,
        -2498.5,
        777.8729858398438
      ],
      [
        -201.0,
        -2498.5,
        777.8729858398438
      ],
      [
        -201.0,
        -2499.480712890625,
        778.5
      ],
      [
        -201.0,
        -2499.52880859375,
        778.0363159179688
      ],
      [
        -220.5,
        -2491.060546875,
        769.5775146484375
      ],
      [
        -220.5,
        -2491.500732421875,
        765.3291015625
      ],
      [
        -200.5,
        -2500.185302734375,
        774.0122680664062
      ],
      [
        -200.5,
        -2499.9794921875,
        776.0
      ],
      [
        -201.0,
        -2499.73974609375,
        776.0
      ],
      [
        -280.0,
        -2501.824462890625,
        31.725988388061523
      ],
      [
        -280.0,
        -2502.831787109375,
        29.026920318603516
      ],
      [
        119.41747283935547,
        -2124.32177734375,
        739.994140625
      ],
      [
        82.40275573730469,
        -2042.7933349609375,
        642.696533203125
      ],
      [
        76.70938873291016,
        -2040.0,
        645.19873046875
      ],
      [
        -122.41246795654297,
        -2206.403564453125,
        819.49267578125
      ],
      [
        -184.58523559570312,
        -2215.1083984375,
        818.9658203125
      ],
      [
        -187.47689819335938,
        -2219.5,
        818.7000122070312
      ],
      [
        -126.89228057861328,
        -2214.045166015625,
        861.0
      ],
      [
        -165.60885620117188,
        -2219.521240234375,
        861.0
      ],
      [
        -97.62342834472656,
        -2050.576416015625,
        653.67919921875
      ],
      [
        -97.73475646972656,
        -2040.0,
        661.1878051757812
      ],
      [
        -108.52902221679688,
        -2049.560791015625,
        652.0034790039062
      ],
      [
        -113.6387939453125,
        -2040.0,
        658.9451293945312
      ],
      [
        -110.26805877685547,
        -2063.052490234375,
        639.8867797851562
      ],
      [
        -138.13999938964844,
        -2064.75,
        631.1911010742188
      ],
      [
        -172.86427307128906,
        -2046.8643798828125,
        637.6512451171875
      ],
      [
        -164.34634399414062,
        -2040.0,
        645.7954711914062
      ],
      [
        -162.45565795898438,
        -2181.5,
        821.0
      ],
      [
        -166.02816772460938,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -166.02816772460938,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -145.49356079101562,
        -2187.44677734375,
        861.0
      ],
      [
        -124.73332977294922,
        -2181.5,
        861.0
      ],
      [
        -128.75,
        -2181.5,
        861.0
      ],
      [
        -123.87754821777344,
        -2181.5,
        861.0
      ],
      [
        -124.73332977294922,
        -2181.5,
        861.0
      ],
      [
        -139.69480895996094,
        -2181.5,
        865.0
      ],
      [
        -141.76400756835938,
        -2181.5,
        861.0
      ],
      [
        -128.75,
        -2181.5,
        861.0
      ],
      [
        -140.26210021972656,
        -2179.60009765625,
        861.5999755859375
      ],
      [
        -140.847412109375,
        -2180.03857421875,
        861.0
      ],
      [
        -134.0,
        -2180.03857421875,
        861.0
      ],
      [
        -139.53794860839844,
        -2179.60009765625,
        863.0
      ],
      [
        -140.26210021972656,
        -2179.60009765625,
        861.5999755859375
      ],
      [
        -160.38650512695312,
        -2181.5,
        825.0
      ],
      [
        -162.45565795898438,
        -2181.5,
        821.0
      ],
      [
        -143.83319091796875,
        -2181.5,
        857.0
      ],
      [
        -147.56275939941406,
        -2187.44677734375,
        857.0
      ],
      [
        -143.83319091796875,
        -2181.5,
        857.0
      ],
      [
        -142.79855346679688,
        -2181.5,
        859.0
      ],
      [
        -280.0,
        -2441.731689453125,
        970.539306640625
      ],
      [
        -280.0,
        -2302.680419921875,
        914.57568359375
      ],
      [
        -271.1961669921875,
        -2186.925537109375,
        861.0
      ],
      [
        -270.1224365234375,
        -2181.5,
        861.0
      ],
      [
        -277.6429138183594,
        -2219.5,
        861.0
      ],
      [
        -271.1961669921875,
        -2186.925537109375,
        861.0
      ],
      [
        -277.4501953125,
        -2218.526123046875,
        861.0
      ],
      [
        -280.0,
        -2221.244384765625,
        864.3377685546875
      ],
      [
        -280.0,
        -2219.5703125,
        861.0
      ],
      [
        -271.68597412109375,
        -2186.925537109375,
        857.0
      ],
      [
        -270.61224365234375,
        -2181.5,
        857.0
      ],
      [
        -278.1327209472656,
        -2219.5,
        857.0
      ],
      [
        -271.68597412109375,
        -2186.925537109375,
        857.0
      ],
      [
        -277.5511474609375,
        -2216.561279296875,
        857.0
      ],
      [
        -280.0,
        -2217.564208984375,
        857.0
      ],
      [
        -280.0,
        -2219.5,
        841.750732421875
      ],
      [
        -280.0,
        -2216.49951171875,
        836.9013061523438
      ],
      [
        -280.0,
        -2216.49951171875,
        836.9013061523438
      ],
      [
        -280.0,
        -2219.5,
        834.86962890625
      ],
      [
        -278.34173583984375,
        -2197.676025390625,
        820.0210571289062
      ],
      [
        -280.0,
        -2209.36181640625,
        840.6448364257812
      ],
      [
        -280.0,
        -2205.35400390625,
        833.1509399414062
      ],
      [
        -280.0,
        -2198.250732421875,
        819.9862670898438
      ],
      [
        -280.0,
        -2205.35400390625,
        833.1509399414062
      ],
      [
        -280.0,
        -2209.36181640625,
        840.6448364257812
      ],
      [
        -267.6521301269531,
        -2181.5,
        799.795166015625
      ],
      [
        -280.0,
        -2189.98046875,
        804.6587524414062
      ],
      [
        -280.0,
        -2181.5,
        790.450439453125
      ],
      [
        -256.7187194824219,
        -2181.5,
        808.6917114257812
      ],
      [
        -267.6521301269531,
        -2181.5,
        799.795166015625
      ],
      [
        -280.0,
        -2189.98046875,
        804.6587524414062
      ],
      [
        -248.08619689941406,
        -2181.5,
        815.7967529296875
      ],
      [
        -256.7187194824219,
        -2181.5,
        808.6917114257812
      ],
      [
        -280.0,
        -2148.38671875,
        739.6044921875
      ],
      [
        -280.0,
        -2153.10009765625,
        746.711181640625
      ],
      [
        -243.68463134765625,
        -2066.32080078125,
        645.7630615234375
      ],
      [
        -248.41612243652344,
        -2068.887451171875,
        645.7384643554688
      ],
      [
        -250.85545349121094,
        -2070.218994140625,
        645.7384643554688
      ],
      [
        -248.41612243652344,
        -2068.887451171875,
        645.7384643554688
      ],
      [
        -280.0,
        -2153.10009765625,
        746.711181640625
      ],
      [
        -280.0,
        -2177.109130859375,
        783.0938720703125
      ],
      [
        -280.0,
        -2040.9490966796875,
        645.7384643554688
      ],
      [
        -280.0,
        -2040.0,
        645.741943359375
      ],
      [
        -280.0,
        -2067.0478515625,
        645.7384643554688
      ],
      [
        -280.0,
        -2040.9490966796875,
        645.7384643554688
      ],
      [
        -280.0,
        -2177.109130859375,
        783.0938720703125
      ],
      [
        -168.0,
        -2511.409912109375,
        816.0
      ],
      [
        -168.0,
        -2527.5,
        816.0
      ],
      [
        -229.0,
        -2485.907958984375,
        780.0
      ],
      [
        -229.0,
        -2498.5,
        780.0
      ],
      [
        -188.042724609375,
        -2522.5,
        789.2999877929688
      ],
      [
        -188.042724609375,
        -2522.5,
        782.5
      ],
      [
        -188.300048828125,
        -2522.5,
        789.2999877929688
      ],
      [
        -188.300048828125,
        -2522.5,
        782.5
      ],
      [
        -229.0,
        -2498.5,
        789.0
      ],
      [
        -226.810791015625,
        -2500.689208984375,
        780.0
      ],
      [
        -219.0,
        -2508.5,
        780.0
      ],
      [
        -229.0,
        -2498.5,
        780.0
      ],
      [
        -226.810791015625,
        -2500.689208984375,
        780.0
      ],
      [
        -280.0,
        -2482.281982421875,
        505.02899169921875
      ],
      [
        -280.0,
        -2478.0947265625,
        619.495361328125
      ],
      [
        -280.0,
        -2478.0947265625,
        619.495361328125
      ],
      [
        -280.0,
        -2587.04541015625,
        0.0
      ],
      [
        -280.0,
        -2632.418212890625,
        86.79737091064453
      ],
      [
        -280.0,
        -2512.26806640625,
        3.7401342391967773
      ],
      [
        -280.0,
        -2515.038330078125,
        0.0
      ],
      [
        -280.0,
        -2512.26806640625,
        3.740133762359619
      ],
      [
        -1086.8209228515625,
        -2147.4443359375,
        0.0
      ],
      [
        -523.60009765625,
        -2226.599609375,
        0.0
      ],
      [
        -523.6001586914062,
        -2226.599609375,
        0.0
      ],
      [
        -279.9999694824219,
        -2260.83544921875,
        0.0
      ],
      [
        -854.4132080078125,
        -2180.10693359375,
        1118.8780517578125
      ],
      [
        -841.965576171875,
        -2181.8564453125,
        765.5958862304688
      ],
      [
        -855.5603637695312,
        -2179.94580078125,
        1148.8271484375
      ],
      [
        -854.4132080078125,
        -2180.10693359375,
        1118.8780517578125
      ],
      [
        -829.9765014648438,
        -2163.21533203125,
        0.0
      ],
      [
        -809.9580688476562,
        -2186.354736328125,
        0.0
      ],
      [
        -823.1215209960938,
        -2184.5048828125,
        296.2656555175781
      ],
      [
        -842.2705688476562,
        -2165.90673828125,
        374.65692138671875
      ],
      [
        -839.6445922851562,
        -2182.1826171875,
        707.8184814453125
      ],
      [
        -842.6279907226562,
        -2166.107421875,
        392.2167663574219
      ],
      [
        -827.633544921875,
        -2183.87060546875,
        424.899169921875
      ],
      [
        -827.633544921875,
        -2183.87060546875,
        424.899169921875
      ],
      [
        -842.6279907226562,
        -2166.107421875,
        392.2167663574219
      ],
      [
        -842.2705688476562,
        -2165.90673828125,
        374.65692138671875
      ],
      [
        -823.1215209960938,
        -2184.5048828125,
        296.2656555175781
      ],
      [
        -841.965576171875,
        -2181.8564453125,
        765.5958862304688
      ],
      [
        -839.6445922851562,
        -2182.1826171875,
        707.8184814453125
      ],
      [
        -854.0363159179688,
        -2168.380126953125,
        730.94091796875
      ],
      [
        -854.0363159179688,
        -2168.380126953125,
        730.94091796875
      ],
      [
        -854.02099609375,
        -2168.478759765625,
        732.7373046875
      ],
      [
        -974.577392578125,
        -2120.9970703125,
        622.5990600585938
      ],
      [
        -970.6127319335938,
        -2114.774169921875,
        487.23077392578125
      ],
      [
        -980.2942504882812,
        -2113.5029296875,
        591.9867553710938
      ],
      [
        -970.6127319335938,
        -2114.774169921875,
        487.23077392578125
      ],
      [
        -950.1731567382812,
        -2098.053955078125,
        0.0
      ],
      [
        -1026.597900390625,
        -2040.0,
        168.48663330078125
      ],
      [
        -929.723388671875,
        -2055.64697265625,
        171.35107421875
      ],
      [
        -948.3048706054688,
        -2042.9688720703125,
        366.4222717285156
      ],
      [
        -927.1856689453125,
        -2057.93994140625,
        157.1575164794922
      ],
      [
        -929.723388671875,
        -2055.64697265625,
        171.35107421875
      ],
      [
        -912.9092407226562,
        -2070.868896484375,
        77.95028686523438
      ],
      [
        -927.1856689453125,
        -2057.93994140625,
        157.1575164794922
      ],
      [
        -895.0585327148438,
        -2087.986083984375,
        0.0
      ],
      [
        -909.219970703125,
        -2074.339599609375,
        60.35429000854492
      ],
      [
        -909.219970703125,
        -2074.339599609375,
        60.35429000854492
      ],
      [
        -912.9092407226562,
        -2070.868896484375,
        77.95028686523438
      ],
      [
        -670.4060668945312,
        -2133.73095703125,
        744.58544921875
      ],
      [
        -310.461181640625,
        -2256.554443359375,
        874.0912475585938
      ],
      [
        -478.5008544921875,
        -2232.937744140625,
        695.9130249023438
      ],
      [
        -390.7621765136719,
        -2160.501220703125,
        667.9999389648438
      ],
      [
        -398.73809814453125,
        -2148.240966796875,
        639.9999389648438
      ],
      [
        -310.4612121582031,
        -2256.554443359375,
        874.0912475585938
      ],
      [
        -291.2613830566406,
        -2259.252685546875,
        888.99365234375
      ],
      [
        -336.4956359863281,
        -2138.847412109375,
        671.9999389648438
      ],
      [
        -337.4930114746094,
        -2137.05517578125,
        667.9999389648438
      ],
      [
        -336.6002502441406,
        -2138.659423828125,
        671.9999389648438
      ],
      [
        -337.60186767578125,
        -2136.859619140625,
        667.9999389648438
      ],
      [
        -337.6197204589844,
        -2136.82763671875,
        671.9999389648438
      ],
      [
        -338.6816101074219,
        -2134.919677734375,
        667.9999389648438
      ],
      [
        -295.6277770996094,
        -2134.03662109375,
        705.1061401367188
      ],
      [
        -337.9849548339844,
        -2136.17138671875,
        671.9999389648438
      ],
      [
        -338.9958801269531,
        -2134.35498046875,
        667.9999389648438
      ],
      [
        -294.1380310058594,
        -2133.71728515625,
        705.8507690429688
      ],
      [
        -295.6277770996094,
        -2134.03662109375,
        705.1061401367188
      ],
      [
        -370.0525817871094,
        -2143.47509765625,
        669.841796875
      ],
      [
        -361.6012878417969,
        -2140.760498046875,
        671.0531616210938
      ],
      [
        -392.8360595703125,
        -2157.313232421875,
        667.9999389648438
      ],
      [
        -401.4259338378906,
        -2144.109375,
        639.9999389648438
      ],
      [
        -339.98016357421875,
        -2132.58642578125,
        671.9999389648438
      ],
      [
        -342.2251281738281,
        -2128.552734375,
        667.9999389648438
      ],
      [
        -337.551025390625,
        -2107.583984375,
        648.5309448242188
      ],
      [
        -338.2642822265625,
        -2106.3486328125,
        645.9999389648438
      ],
      [
        -348.8781433105469,
        -2148.298828125,
        683.38916015625
      ],
      [
        -349.0511474609375,
        -2140.843505859375,
        676.5722045898438
      ],
      [
        -349.0511474609375,
        -2140.843505859375,
        676.5722045898438
      ],
      [
        -361.6012878417969,
        -2140.760498046875,
        671.0531616210938
      ],
      [
        -340.4855041503906,
        -2131.678466796875,
        671.9999389648438
      ],
      [
        -342.4285888671875,
        -2128.187255859375,
        667.9999389648438
      ],
      [
        -363.3562927246094,
        -2137.917236328125,
        668.1739501953125
      ],
      [
        -359.68548583984375,
        -2135.369873046875,
        668.0
      ],
      [
        -362.8344421386719,
        -2137.531005859375,
        668.1134033203125
      ],
      [
        -341.3185119628906,
        -2130.181640625,
        671.9999389648438
      ],
      [
        -343.9417419433594,
        -2125.468505859375,
        667.9999389648438
      ],
      [
        -363.3562927246094,
        -2137.917236328125,
        668.1739501953125
      ],
      [
        -362.8344421386719,
        -2137.531005859375,
        668.1134033203125
      ],
      [
        -320.1700744628906,
        -2105.479736328125,
        662.465576171875
      ],
      [
        -301.4779357910156,
        -2092.2255859375,
        661.1591796875
      ],
      [
        -343.05560302734375,
        -2127.060546875,
        671.9999389648438
      ],
      [
        -344.1531677246094,
        -2125.088623046875,
        667.9999389648438
      ],
      [
        -519.0640258789062,
        -2202.210693359375,
        639.28125
      ],
      [
        -392.9285583496094,
        -2150.499755859375,
        667.9998779296875
      ],
      [
        -395.288330078125,
        -2153.543701171875,
        667.9999389648438
      ],
      [
        -405.737060546875,
        -2137.482421875,
        648.943115234375
      ],
      [
        -405.737060546875,
        -2137.482421875,
        648.943115234375
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.6473388671875
      ],
      [
        -337.551025390625,
        -2107.583984375,
        651.483642578125
      ],
      [
        -340.2927551269531,
        -2102.835205078125,
        645.9999389648438
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.6473388671875
      ],
      [
        -404.5238342285156,
        -2127.01123046875,
        639.9999389648438
      ],
      [
        -396.0443115234375,
        -2152.381591796875,
        667.9999389648438
      ],
      [
        -405.737060546875,
        -2137.482421875,
        649.1535034179688
      ],
      [
        -392.0724792480469,
        -2119.150146484375,
        640.0
      ],
      [
        -375.8053283691406,
        -2109.32568359375,
        640.0
      ],
      [
        -391.3579406738281,
        -2119.943115234375,
        641.11181640625
      ],
      [
        -375.3231506347656,
        -2110.685302734375,
        641.4992065429688
      ],
      [
        -405.737060546875,
        -2137.482421875,
        649.1535034179688
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.7142333984375
      ],
      [
        -337.551025390625,
        -2107.583984375,
        652.8601684570312
      ],
      [
        -341.5163879394531,
        -2100.7158203125,
        645.9999389648438
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.7142333984375
      ],
      [
        -405.2586669921875,
        -2127.96875,
        640.547119140625
      ],
      [
        -405.2586364746094,
        -2127.968505859375,
        640.7760620117188
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        641.343017578125
      ],
      [
        -359.4485778808594,
        -2101.52001953125,
        639.9999389648438
      ],
      [
        -359.4485778808594,
        -2101.52001953125,
        640.4400024414062
      ],
      [
        -375.3231506347656,
        -2110.685302734375,
        641.4992065429688
      ],
      [
        -375.8053283691406,
        -2109.32568359375,
        640.0
      ],
      [
        -359.25421142578125,
        -2100.88525390625,
        639.9999389648438
      ],
      [
        -404.03619384765625,
        -2126.375732421875,
        639.9999389648438
      ],
      [
        -329.4201354980469,
        -2095.0888671875,
        652.5116577148438
      ],
      [
        -299.10333251953125,
        -2076.334716796875,
        652.1083374023438
      ],
      [
        -292.9984436035156,
        -2065.633544921875,
        645.7384643554688
      ],
      [
        -280.0,
        -2057.783203125,
        645.7384643554688
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        642.8467407226562
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.0137329101562
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.0137329101562
      ],
      [
        -358.6785583496094,
        -2098.98193359375,
        639.9999389648438
      ],
      [
        -337.551025390625,
        -2107.583984375,
        657.2886962890625
      ],
      [
        -343.8673400878906,
        -2096.643798828125,
        645.9999389648438
      ],
      [
        -340.7268371582031,
        -2102.083251953125,
        652.6621704101562
      ],
      [
        -337.551025390625,
        -2107.583984375,
        659.3994140625
      ],
      [
        -344.00396728515625,
        -2125.356689453125,
        671.9999389648438
      ],
      [
        -345.8387756347656,
        -2122.06005859375,
        667.9999389648438
      ],
      [
        -519.0640258789062,
        -2202.210693359375,
        639.28125
      ],
      [
        -513.1192626953125,
        -2191.465087890625,
        639.28125
      ],
      [
        -383.08306884765625,
        -2106.674072265625,
        639.28125
      ],
      [
        -330.7853088378906,
        -2093.555419921875,
        651.0426025390625
      ],
      [
        -299.01641845703125,
        -2075.753173828125,
        651.7770385742188
      ],
      [
        -376.68212890625,
        -2107.806884765625,
        639.9999389648438
      ],
      [
        -380.38275146484375,
        -2110.05224609375,
        639.9999389648438
      ],
      [
        -391.15643310546875,
        -2119.826904296875,
        642.2750854492188
      ],
      [
        -375.48980712890625,
        -2110.781494140625,
        642.598876953125
      ],
      [
        -293.59466552734375,
        -2065.568603515625,
        645.7384643554688
      ],
      [
        -280.0,
        -2057.586181640625,
        645.7384643554688
      ],
      [
        -406.1957702636719,
        -2133.9990234375,
        645.7384643554688
      ],
      [
        -406.736328125,
        -2129.89404296875,
        642.7066650390625
      ],
      [
        -406.21026611328125,
        -2133.888916015625,
        645.7384643554688
      ],
      [
        -406.736328125,
        -2129.89404296875,
        642.7066650390625
      ],
      [
        -405.2586364746094,
        -2127.968505859375,
        640.7760620117188
      ],
      [
        -405.2587890625,
        -2127.96875,
        641.983642578125
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        643.6758422851562
      ],
      [
        -359.4485168457031,
        -2101.52001953125,
        641.8824462890625
      ],
      [
        -359.4485168457031,
        -2101.52001953125,
        642.9303588867188
      ],
      [
        -343.5585632324219,
        -2097.1787109375,
        646.655029296875
      ],
      [
        -343.95709228515625,
        -2096.48828125,
        645.9999389648438
      ],
      [
        -406.1461181640625,
        -2134.3759765625,
        646.1080932617188
      ],
      [
        -376.2414855957031,
        -2108.90625,
        640.9603881835938
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.1424560546875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        640.4264526367188
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.62548828125
      ],
      [
        -402.07666015625,
        -2123.822265625,
        640.4264526367188
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.4857177734375
      ],
      [
        -375.48980712890625,
        -2110.781494140625,
        642.598876953125
      ],
      [
        -376.2414855957031,
        -2108.90625,
        640.9603881835938
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.4857177734375
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        639.9999389648438
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.3223266601562
      ],
      [
        -359.0480651855469,
        -2097.34765625,
        639.9999389648438
      ],
      [
        -358.8332824707031,
        -2098.297607421875,
        640.9281616210938
      ],
      [
        -376.68212890625,
        -2107.806884765625,
        639.9999389648438
      ],
      [
        -376.241455078125,
        -2108.90625,
        640.96044921875
      ],
      [
        -391.008544921875,
        -2119.741455078125,
        643.1288452148438
      ],
      [
        -375.5898742675781,
        -2110.83935546875,
        643.2592163085938
      ],
      [
        -340.7268371582031,
        -2102.083251953125,
        652.6621704101562
      ],
      [
        -344.4078063964844,
        -2095.707763671875,
        645.9999389648438
      ],
      [
        -342.0165710449219,
        -2099.849609375,
        650.783447265625
      ],
      [
        -405.737060546875,
        -2137.482421875,
        650.5148315429688
      ],
      [
        -406.736328125,
        -2129.89404296875,
        643.92041015625
      ],
      [
        -405.9733581542969,
        -2135.68798828125,
        649.3043823242188
      ],
      [
        -403.50347900390625,
        -2140.915771484375,
        653.4964599609375
      ],
      [
        -405.737060546875,
        -2137.482421875,
        650.5148315429688
      ],
      [
        -406.736328125,
        -2129.89404296875,
        643.92041015625
      ],
      [
        -405.2587890625,
        -2127.96875,
        641.983642578125
      ],
      [
        -405.2587890625,
        -2127.96875,
        643.008056640625
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        644.3175659179688
      ],
      [
        -359.4485168457031,
        -2101.52001953125,
        642.9303588867188
      ],
      [
        -359.44854736328125,
        -2101.52001953125,
        643.3959350585938
      ],
      [
        -376.2871398925781,
        -2108.9326171875,
        641.2615966796875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.3364868164062
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.043212890625
      ],
      [
        -392.3555908203125,
        -2118.209716796875,
        641.1255493164062
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.043212890625
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.6097412109375
      ],
      [
        -375.5898742675781,
        -2110.83935546875,
        643.2592163085938
      ],
      [
        -376.2871398925781,
        -2108.9326171875,
        641.2615966796875
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.6097412109375
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.3223266601562
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.4099731445312
      ],
      [
        -378.97265625,
        -2109.19677734375,
        639.9999389648438
      ],
      [
        -379.2862243652344,
        -2109.23095703125,
        639.9999389648438
      ],
      [
        -376.72735595703125,
        -2107.728515625,
        639.9999389648438
      ],
      [
        -379.2862243652344,
        -2109.23095703125,
        639.9999389648438
      ],
      [
        -376.72735595703125,
        -2107.728515625,
        639.9999389648438
      ],
      [
        -396.3149719238281,
        -2151.965576171875,
        667.9999389648438
      ],
      [
        -405.737060546875,
        -2137.482421875,
        650.9717407226562
      ],
      [
        -397.22943115234375,
        -2150.559814453125,
        666.560302734375
      ],
      [
        -405.737060546875,
        -2137.482421875,
        650.9717407226562
      ],
      [
        -337.551025390625,
        -2107.583984375,
        659.7164306640625
      ],
      [
        -396.4437561035156,
        -2151.767578125,
        667.9999389648438
      ],
      [
        -383.08306884765625,
        -2106.674072265625,
        639.28125
      ],
      [
        -342.99169921875,
        -2083.39306640625,
        642.1755981445312
      ],
      [
        -293.63909912109375,
        -2054.734375,
        645.7384643554688
      ],
      [
        -280.0,
        -2045.6334228515625,
        645.7384643554688
      ],
      [
        -287.8267517089844,
        -2062.181884765625,
        645.7384643554688
      ],
      [
        -336.96319580078125,
        -2079.83544921875,
        642.5633544921875
      ],
      [
        -342.99169921875,
        -2083.39306640625,
        642.1755981445312
      ],
      [
        -358.8597106933594,
        -2098.180908203125,
        640.8139038085938
      ],
      [
        -360.1973571777344,
        -2092.264892578125,
        639.9999389648438
      ],
      [
        -359.9736022949219,
        -2093.25439453125,
        640.9495239257812
      ],
      [
        -336.96319580078125,
        -2079.83544921875,
        642.5633544921875
      ],
      [
        -332.9053955078125,
        -2077.535888671875,
        642.9036865234375
      ],
      [
        -299.1072082519531,
        -2058.383056640625,
        645.7384643554688
      ],
      [
        -299.1072082519531,
        -2058.383056640625,
        645.7384643554688
      ],
      [
        -342.0165710449219,
        -2099.849609375,
        650.783447265625
      ],
      [
        -345.3001403808594,
        -2094.162109375,
        645.9999389648438
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.9988403320312
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        645.025390625
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        642.8890991210938
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        642.8890991210938
      ],
      [
        -358.7217712402344,
        -2098.791015625,
        641.4099731445312
      ],
      [
        -358.7217712402344,
        -2098.791015625,
        642.7213745117188
      ],
      [
        -359.23504638671875,
        -2096.52099609375,
        640.859619140625
      ],
      [
        -390.697265625,
        -2119.561767578125,
        644.9259033203125
      ],
      [
        -375.8705139160156,
        -2111.001220703125,
        645.1109008789062
      ],
      [
        -405.9733581542969,
        -2135.68798828125,
        649.3043823242188
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.3958740234375
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.3958740234375
      ],
      [
        -405.2587890625,
        -2127.96875,
        643.008056640625
      ],
      [
        -405.2589111328125,
        -2127.96875,
        644.6988525390625
      ],
      [
        -405.7652893066406,
        -2128.628662109375,
        644.96728515625
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        645.9818725585938
      ],
      [
        -359.44854736328125,
        -2101.52001953125,
        644.2982788085938
      ],
      [
        -359.4485778808594,
        -2101.52001953125,
        645.3162231445312
      ],
      [
        -376.6501770019531,
        -2109.142333984375,
        643.6571044921875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        643.772216796875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        643.0117797851562
      ],
      [
        -391.9501953125,
        -2117.975830078125,
        643.4659423828125
      ],
      [
        -396.8337707519531,
        -2120.795166015625,
        643.4049072265625
      ],
      [
        -402.07666015625,
        -2123.822265625,
        643.0117797851562
      ],
      [
        -375.8705139160156,
        -2111.001220703125,
        645.1109008789062
      ],
      [
        -376.6501770019531,
        -2109.142333984375,
        643.6571044921875
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        644.0260620117188
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        644.0260620117188
      ],
      [
        -358.7217712402344,
        -2098.791015625,
        642.7213745117188
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        643.8809204101562
      ],
      [
        -359.6673278808594,
        -2094.609130859375,
        640.9122314453125
      ],
      [
        -397.2310485839844,
        -2150.557373046875,
        667.9999389648438
      ],
      [
        -405.737060546875,
        -2137.482421875,
        652.365234375
      ],
      [
        -338.2374572753906,
        -2106.39501953125,
        663.9999389648438
      ],
      [
        -346.551025390625,
        -2091.995361328125,
        647.3677978515625
      ],
      [
        -390.5455017089844,
        -2119.47412109375,
        645.8020629882812
      ],
      [
        -376.1389465332031,
        -2111.15625,
        646.8821411132812
      ],
      [
        -405.737060546875,
        -2137.482421875,
        652.365234375
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.4821166992188
      ],
      [
        -346.2439880371094,
        -2121.33203125,
        671.9999389648438
      ],
      [
        -348.19085693359375,
        -2117.833984375,
        667.9999389648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9978637695312
      ],
      [
        -359.4485778808594,
        -2101.52001953125,
        645.3162231445312
      ],
      [
        -359.4485778808594,
        -2101.52001953125,
        648.1336059570312
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.4821166992188
      ],
      [
        -376.8392028808594,
        -2109.25146484375,
        644.9042358398438
      ],
      [
        -367.435791015625,
        -2103.822265625,
        645.6092529296875
      ],
      [
        -391.8966369628906,
        -2117.94482421875,
        643.7750854492188
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        646.4585571289062
      ],
      [
        -376.1389465332031,
        -2111.15625,
        646.8821411132812
      ],
      [
        -376.8392028808594,
        -2109.25146484375,
        644.9042358398438
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        646.4585571289062
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        643.8809204101562
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        646.2623291015625
      ],
      [
        -482.16583251953125,
        -2135.513671875,
        639.28125
      ],
      [
        -493.8836669921875,
        -2156.69482421875,
        639.28125
      ],
      [
        -460.35186767578125,
        -2096.0830078125,
        639.28125
      ],
      [
        -482.16583251953125,
        -2135.513671875,
        639.28125
      ],
      [
        -493.8836669921875,
        -2156.69482421875,
        639.28125
      ],
      [
        -294.20599365234375,
        -2040.0,
        645.7384643554688
      ],
      [
        -287.59991455078125,
        -2050.70458984375,
        645.7384643554688
      ],
      [
        -360.30859375,
        -2091.77294921875,
        640.9903564453125
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      [
        -359.9736022949219,
        -2093.254638671875,
        640.9495849609375
      ],
      [
        -360.30859375,
        -2091.77294921875,
        640.9903564453125
      ],
      [
        -360.30859375,
        -2091.77294921875,
        641.115234375
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.4136962890625
      ],
      [
        -359.9416198730469,
        -2093.39599609375,
        641.0853271484375
      ],
      [
        -360.30859375,
        -2091.77294921875,
        641.115234375
      ],
      [
        -425.5252685546875,
        -2058.641845703125,
        653.1666870117188
      ],
      [
        -460.35186767578125,
        -2096.0830078125,
        639.28125
      ],
      [
        -425.5252685546875,
        -2058.641845703125,
        653.1666870117188
      ],
      [
        -404.1064758300781,
        -2040.0,
        664.0928955078125
      ],
      [
        -357.70416259765625,
        -2087.4541015625,
        659.9999389648438
      ],
      [
        -750.164306640625,
        -2046.3411865234375,
        702.8358764648438
      ],
      [
        -621.1246948242188,
        -2040.0,
        815.9224243164062
      ],
      [
        -665.9322509765625,
        -2136.1591796875,
        743.8489379882812
      ],
      [
        -670.4060668945312,
        -2133.73095703125,
        744.58544921875
      ],
      [
        -463.440673828125,
        -2101.666259765625,
        639.28125
      ],
      [
        -583.7952270507812,
        -2184.9345703125,
        639.2813110351562
      ],
      [
        -665.2572021484375,
        -2136.525634765625,
        743.73779296875
      ],
      [
        -665.2572021484375,
        -2136.525634765625,
        743.73779296875
      ],
      [
        -547.0039672851562,
        -2204.625,
        639.28125
      ],
      [
        -532.1075439453125,
        -2212.597412109375,
        639.28125
      ],
      [
        -583.7952880859375,
        -2184.9345703125,
        639.2813110351562
      ],
      [
        -547.0039672851562,
        -2204.625,
        639.28125
      ],
      [
        -479.2474365234375,
        -2232.832763671875,
        695.3135375976562
      ],
      [
        -494.63037109375,
        -2230.6708984375,
        682.3578491210938
      ],
      [
        -532.1075439453125,
        -2212.597412109375,
        639.28125
      ],
      [
        -478.6838684082031,
        -2232.912109375,
        695.7410278320312
      ],
      [
        -479.2474365234375,
        -2232.832763671875,
        695.3135375976562
      ],
      [
        -478.6838684082031,
        -2232.912109375,
        695.7410278320312
      ],
      [
        -478.5008544921875,
        -2232.937744140625,
        695.9130249023438
      ],
      [
        -709.2534790039062,
        -2113.703857421875,
        728.0035400390625
      ],
      [
        -709.2535400390625,
        -2113.703857421875,
        728.0035400390625
      ],
      [
        -793.6016235351562,
        -2071.79541015625,
        657.7850341796875
      ],
      [
        -664.2880859375,
        -2141.871337890625,
        723.4580078125
      ],
      [
        -584.1629638671875,
        -2185.19921875,
        639.2813110351562
      ],
      [
        -652.0050659179688,
        -2148.140869140625,
        723.0947265625
      ],
      [
        -652.0050659179688,
        -2148.140869140625,
        723.0947265625
      ],
      [
        -664.2880859375,
        -2141.871337890625,
        723.4580688476562
      ],
      [
        -584.1630249023438,
        -2185.19921875,
        639.2813110351562
      ],
      [
        -566.179443359375,
        -2194.3623046875,
        639.2813110351562
      ],
      [
        -645.1852416992188,
        -2209.51220703125,
        339.9388122558594
      ],
      [
        -642.7560424804688,
        -2209.853515625,
        395.9699401855469
      ],
      [
        -602.43359375,
        -2192.60791015625,
        641.6248779296875
      ],
      [
        -604.6768188476562,
        -2194.20947265625,
        630.2252807617188
      ],
      [
        -594.0823974609375,
        -2199.5419921875,
        630.2252807617188
      ],
      [
        -604.6768188476562,
        -2194.20947265625,
        630.2252807617188
      ],
      [
        -598.218994140625,
        -2195.29052734375,
        639.2813110351562
      ],
      [
        -598.2291870117188,
        -2195.2744140625,
        639.3268432617188
      ],
      [
        -599.2575073242188,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -602.43359375,
        -2192.60791015625,
        641.6248779296875
      ],
      [
        -599.2575073242188,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -599.7045288085938,
        -2193.9814453125,
        641.6248779296875
      ],
      [
        -534.6232299804688,
        -2225.050537109375,
        648.6753540039062
      ],
      [
        -544.3950805664062,
        -2222.38232421875,
        639.28125
      ],
      [
        -553.4985961914062,
        -2217.800048828125,
        639.28125
      ],
      [
        -544.3950805664062,
        -2222.38232421875,
        639.28125
      ],
      [
        -553.4985961914062,
        -2217.800048828125,
        639.28125
      ],
      [
        -598.7432250976562,
        -2194.46533203125,
        641.6248779296875
      ],
      [
        -598.7432250976562,
        -2194.46533203125,
        641.6248779296875
      ],
      [
        -598.2819213867188,
        -2216.103759765625,
        587.4226684570312
      ],
      [
        -578.4766845703125,
        -2218.88720703125,
        639.28125
      ],
      [
        -555.6181640625,
        -2222.099853515625,
        639.28125
      ],
      [
        -545.7772827148438,
        -2223.48291015625,
        639.28125
      ],
      [
        -578.4766845703125,
        -2218.88720703125,
        639.28125
      ],
      [
        -555.6181640625,
        -2222.099853515625,
        639.28125
      ],
      [
        -578.3451538085938,
        -2218.90576171875,
        630.2252807617188
      ],
      [
        -600.3375854492188,
        -2196.3935546875,
        630.2252807617188
      ],
      [
        -581.9351196289062,
        -2218.401123046875,
        630.2252807617188
      ],
      [
        -545.7772827148438,
        -2223.48291015625,
        639.28125
      ],
      [
        -598.2819213867188,
        -2216.103759765625,
        587.4226684570312
      ],
      [
        -607.9061889648438,
        -2214.751220703125,
        564.9820556640625
      ],
      [
        -612.2839965820312,
        -2205.430908203125,
        639.2813110351562
      ],
      [
        -578.486328125,
        -2218.885986328125,
        639.28125
      ],
      [
        -603.4556884765625,
        -2215.376708984375,
        639.2813110351562
      ],
      [
        -615.72021484375,
        -2202.09423828125,
        630.2252807617188
      ],
      [
        -603.9982299804688,
        -2215.300537109375,
        630.2252807617188
      ],
      [
        -615.4296875,
        -2201.886962890625,
        639.2813110351562
      ],
      [
        -615.72021484375,
        -2202.09423828125,
        630.2252807617188
      ],
      [
        -602.894775390625,
        -2192.937255859375,
        639.2813110351562
      ],
      [
        -612.2088623046875,
        -2205.376953125,
        641.6248779296875
      ],
      [
        -612.2839965820312,
        -2205.430908203125,
        639.2813110351562
      ],
      [
        -615.3544921875,
        -2201.833251953125,
        641.6248779296875
      ],
      [
        -612.2088623046875,
        -2205.376953125,
        641.6248779296875
      ],
      [
        -615.3544921875,
        -2201.833251953125,
        641.6248779296875
      ],
      [
        -627.8792724609375,
        -2211.9443359375,
        471.1322021484375
      ],
      [
        -642.7560424804688,
        -2209.853515625,
        395.9699401855469
      ],
      [
        -627.8792724609375,
        -2211.9443359375,
        471.1322021484375
      ],
      [
        -610.0732421875,
        -2214.44677734375,
        559.9291381835938
      ],
      [
        -610.0732421875,
        -2214.44677734375,
        559.9291381835938
      ],
      [
        -629.2466430664062,
        -2211.751953125,
        630.2252807617188
      ],
      [
        -629.2466430664062,
        -2211.751953125,
        641.6248779296875
      ],
      [
        -629.2466430664062,
        -2211.751953125,
        630.2252807617188
      ],
      [
        -622.4407958984375,
        -2212.70849609375,
        639.2813110351562
      ],
      [
        -629.2466430664062,
        -2211.751953125,
        641.6248779296875
      ],
      [
        -622.4407958984375,
        -2212.70849609375,
        641.6248779296875
      ],
      [
        -622.4407958984375,
        -2212.70849609375,
        641.6248779296875
      ],
      [
        -622.4407958984375,
        -2212.70849609375,
        639.2813110351562
      ],
      [
        -645.1852416992188,
        -2209.51220703125,
        339.9388122558594
      ],
      [
        -671.0499267578125,
        -2205.877197265625,
        28.868404388427734
      ],
      [
        -929.6712646484375,
        -2055.694091796875,
        171.05938720703125
      ],
      [
        -681.166015625,
        -2169.79150390625,
        60.62879943847656
      ],
      [
        -679.6759643554688,
        -2204.664794921875,
        0.0
      ],
      [
        -671.0499267578125,
        -2205.877197265625,
        28.868404388427734
      ],
      [
        -892.0865478515625,
        -3076.67138671875,
        824.6702270507812
      ],
      [
        -905.2670288085938,
        -3073.869873046875,
        812.7454833984375
      ],
      [
        -947.423095703125,
        -3064.909423828125,
        812.885009765625
      ],
      [
        -954.8323364257812,
        -3063.33447265625,
        821.918701171875
      ],
      [
        -583.5014038085938,
        -2544.535400390625,
        740.6970825195312
      ],
      [
        -574.3484497070312,
        -2554.2509765625,
        446.5647277832031
      ],
      [
        -517.8585205078125,
        -2705.55859375,
        497.7949523925781
      ],
      [
        -525.963623046875,
        -2701.2490234375,
        845.9915771484375
      ],
      [
        -583.5014038085938,
        -2544.535400390625,
        740.6970825195312
      ],
      [
        -611.6629028320312,
        -2514.64306640625,
        1169.573974609375
      ],
      [
        -539.7568969726562,
        -2693.9150390625,
        1366.9058837890625
      ],
      [
        -525.963623046875,
        -2701.2490234375,
        845.9915771484375
      ],
      [
        -539.7568969726562,
        -2693.9150390625,
        1366.9058837890625
      ],
      [
        -546.2139282226562,
        -2690.481689453125,
        1429.120361328125
      ],
      [
        -621.5278930664062,
        -2504.171630859375,
        1316.36279296875
      ],
      [
        -611.6629028320312,
        -2514.64306640625,
        1169.573974609375
      ],
      [
        -556.47802734375,
        -2685.024169921875,
        1480.5965576171875
      ],
      [
        -546.2139282226562,
        -2690.481689453125,
        1429.120361328125
      ],
      [
        -665.8518676757812,
        -2457.123291015625,
        1480.5965576171875
      ],
      [
        -643.080078125,
        -2481.294677734375,
        1406.9556884765625
      ],
      [
        -643.080078125,
        -2481.294677734375,
        1406.9556884765625
      ],
      [
        -621.5278930664062,
        -2504.171630859375,
        1316.36279296875
      ],
      [
        -783.0198974609375,
        -2332.75390625,
        671.9031982421875
      ],
      [
        -780.5735473632812,
        -2335.3505859375,
        674.7783813476562
      ],
      [
        -783.0198974609375,
        -2332.75390625,
        671.9031982421875
      ],
      [
        -782.8914794921875,
        -2332.89013671875,
        669.7511596679688
      ],
      [
        -883.9695434570312,
        -2510.893798828125,
        695.8771362304688
      ],
      [
        -900.268310546875,
        -2502.2275390625,
        675.9594116210938
      ],
      [
        -904.4310913085938,
        -2500.01416015625,
        668.8807983398438
      ],
      [
        -900.268310546875,
        -2502.2275390625,
        675.9594116210938
      ],
      [
        -883.9695434570312,
        -2510.893798828125,
        695.8771362304688
      ],
      [
        -880.8256225585938,
        -2512.5654296875,
        696.2402954101562
      ],
      [
        -904.4310913085938,
        -2500.01416015625,
        668.8807983398438
      ],
      [
        -904.178466796875,
        -2500.1484375,
        667.9860229492188
      ],
      [
        -772.9179077148438,
        -2343.4765625,
        686.7938232421875
      ],
      [
        -754.6390380859375,
        -2362.87890625,
        687.0128784179688
      ],
      [
        -879.661376953125,
        -2513.1845703125,
        696.3748168945312
      ],
      [
        -858.8065795898438,
        -2524.273193359375,
        695.8198852539062
      ],
      [
        -879.661376953125,
        -2513.1845703125,
        696.3748168945312
      ],
      [
        -858.8065795898438,
        -2524.273193359375,
        695.8198852539062
      ],
      [
        -854.71240234375,
        -2526.4501953125,
        690.4739990234375
      ],
      [
        -747.6953735351562,
        -2370.24951171875,
        687.0174560546875
      ],
      [
        -754.6390380859375,
        -2362.87890625,
        687.0128784179688
      ],
      [
        -772.9179077148438,
        -2343.4765625,
        686.7938232421875
      ],
      [
        -773.8707885742188,
        -2342.465087890625,
        684.7185668945312
      ],
      [
        -747.6953735351562,
        -2370.24951171875,
        687.0174560546875
      ],
      [
        -746.6306762695312,
        -2371.379638671875,
        684.9544067382812
      ],
      [
        -851.6050415039062,
        -2512.331787109375,
        690.0169067382812
      ],
      [
        -851.725830078125,
        -2512.525634765625,
        690.0234375
      ],
      [
        -854.6571655273438,
        -2526.4794921875,
        690.40185546875
      ],
      [
        -851.725830078125,
        -2512.525634765625,
        690.0234375
      ],
      [
        -851.6050415039062,
        -2512.331787109375,
        690.0169067382812
      ],
      [
        -743.874755859375,
        -2374.304931640625,
        679.6140747070312
      ],
      [
        -743.874755859375,
        -2374.304931640625,
        679.6140747070312
      ],
      [
        -735.9410400390625,
        -2382.726318359375,
        672.4468994140625
      ],
      [
        -842.8680419921875,
        -2532.747802734375,
        675.0084838867188
      ],
      [
        -838.7605590820312,
        -2534.931640625,
        669.04052734375
      ],
      [
        -842.8680419921875,
        -2532.747802734375,
        675.0084838867188
      ],
      [
        -838.7605590820312,
        -2534.931640625,
        669.04052734375
      ],
      [
        -839.5821533203125,
        -2534.494873046875,
        666.0324096679688
      ],
      [
        -737.33447265625,
        -2381.247314453125,
        666.9407348632812
      ],
      [
        -735.9410400390625,
        -2382.726318359375,
        672.4468994140625
      ],
      [
        -746.7591552734375,
        -2390.28076171875,
        660.59375
      ],
      [
        -737.8631591796875,
        -2380.68603515625,
        664.8515014648438
      ],
      [
        -737.4252319335938,
        -2381.15087890625,
        656.7145385742188
      ],
      [
        -737.8631591796875,
        -2380.68603515625,
        664.8515014648438
      ],
      [
        -746.7591552734375,
        -2390.28076171875,
        660.59375
      ],
      [
        -749.5479736328125,
        -2393.28857421875,
        659.2589721679688
      ],
      [
        -737.2938842773438,
        -2381.290283203125,
        654.2742919921875
      ],
      [
        -749.5479736328125,
        -2393.28857421875,
        659.2589721679688
      ],
      [
        -739.329833984375,
        -2379.129150390625,
        639.6727294921875
      ],
      [
        -747.7177124023438,
        -2370.225830078125,
        639.6663818359375
      ],
      [
        -739.329833984375,
        -2379.129150390625,
        639.6727294921875
      ],
      [
        -736.8543701171875,
        -2381.7568359375,
        646.1090698242188
      ],
      [
        -846.969482421875,
        -2530.56689453125,
        643.8728637695312
      ],
      [
        -840.2496948242188,
        -2534.139892578125,
        663.588134765625
      ],
      [
        -846.969482421875,
        -2530.56689453125,
        643.8728637695312
      ],
      [
        -847.32568359375,
        -2530.37744140625,
        643.8756713867188
      ],
      [
        -840.2496948242188,
        -2534.139892578125,
        663.588134765625
      ],
      [
        -736.8543701171875,
        -2381.7568359375,
        646.1090698242188
      ],
      [
        -847.4234619140625,
        -2530.325439453125,
        643.8764038085938
      ],
      [
        -777.5018310546875,
        -2338.611083984375,
        639.6258544921875
      ],
      [
        -764.7413330078125,
        -2352.15576171875,
        639.6535034179688
      ],
      [
        -764.7413330078125,
        -2352.15576171875,
        639.6535034179688
      ],
      [
        -780.0750122070312,
        -2335.879638671875,
        646.8973999023438
      ],
      [
        -781.9783935546875,
        -2333.859375,
        654.4479370117188
      ],
      [
        -775.9280395507812,
        -2340.281494140625,
        680.2382202148438
      ],
      [
        -775.9280395507812,
        -2340.281494140625,
        680.2382202148438
      ],
      [
        -782.6444702148438,
        -2333.15234375,
        665.61083984375
      ],
      [
        -781.9783935546875,
        -2333.859375,
        654.4479370117188
      ],
      [
        -777.5018310546875,
        -2338.611083984375,
        639.6258544921875
      ],
      [
        -780.0750122070312,
        -2335.879638671875,
        646.8973999023438
      ],
      [
        -885.7332153320312,
        -2509.9560546875,
        644.1735229492188
      ],
      [
        -885.7332153320312,
        -2509.9560546875,
        644.1735229492188
      ],
      [
        -896.2223510742188,
        -2504.37890625,
        643.792724609375
      ],
      [
        -896.2223510742188,
        -2504.37890625,
        643.792724609375
      ],
      [
        -896.3795776367188,
        -2504.29541015625,
        644.2561645507812
      ],
      [
        -902.9319458007812,
        -2500.811279296875,
        663.5715942382812
      ],
      [
        -902.9319458007812,
        -2500.811279296875,
        663.5715942382812
      ],
      [
        -544.0863037109375,
        -2586.373046875,
        0.0
      ],
      [
        -491.5693359375,
        -2719.536865234375,
        0.0
      ],
      [
        -498.2544860839844,
        -2715.982177734375,
        134.7078857421875
      ],
      [
        -572.501953125,
        -2556.2109375,
        421.2178955078125
      ],
      [
        -572.501953125,
        -2556.2109375,
        421.2178649902344
      ],
      [
        -498.2544860839844,
        -2715.982177734375,
        134.70785522460938
      ],
      [
        -517.8585205078125,
        -2705.55859375,
        497.7949523925781
      ],
      [
        -574.3484497070312,
        -2554.2509765625,
        446.5647277832031
      ],
      [
        -562.9622192382812,
        -2541.47509765625,
        29.808334350585938
      ],
      [
        -552.3164672851562,
        -2577.636962890625,
        121.99911499023438
      ],
      [
        -567.82470703125,
        -2532.732666015625,
        0.0
      ],
      [
        -562.9622192382812,
        -2541.47509765625,
        29.808349609375
      ],
      [
        -473.75244140625,
        -2373.2626953125,
        56.81050491333008
      ],
      [
        -393.79583740234375,
        -2413.92529296875,
        383.8636779785156
      ],
      [
        -280.0,
        -2456.75244140625,
        825.5303955078125
      ],
      [
        -280.0,
        -2476.800537109375,
        631.98974609375
      ],
      [
        -311.01348876953125,
        -2453.052978515625,
        717.7733764648438
      ],
      [
        -393.79583740234375,
        -2413.92529296875,
        383.8636474609375
      ],
      [
        -392.693603515625,
        -2414.40576171875,
        388.24566650390625
      ],
      [
        -392.0885314941406,
        -2414.696044921875,
        390.6929626464844
      ],
      [
        -391.46820068359375,
        -2415.062744140625,
        393.3116455078125
      ],
      [
        -392.693603515625,
        -2414.40576171875,
        388.24566650390625
      ],
      [
        -392.0885314941406,
        -2414.696044921875,
        390.6929626464844
      ],
      [
        -280.0,
        -2502.831787109375,
        29.026920318603516
      ],
      [
        -356.43310546875,
        -2454.134521484375,
        12.780550956726074
      ],
      [
        -446.3771057128906,
        -2396.077880859375,
        11.056449890136719
      ],
      [
        -481.1627197265625,
        -2372.709716796875,
        31.58688735961914
      ],
      [
        -473.75244140625,
        -2373.2626953125,
        56.81050491333008
      ],
      [
        -393.83563232421875,
        -2430.022705078125,
        11.349940299987793
      ],
      [
        -446.3771057128906,
        -2396.077880859375,
        11.056450843811035
      ],
      [
        -393.83563232421875,
        -2430.022705078125,
        11.349940299987793
      ],
      [
        -356.43310546875,
        -2454.134521484375,
        12.78055191040039
      ],
      [
        -391.1797790527344,
        -2415.2333984375,
        394.5291748046875
      ],
      [
        -315.125,
        -2452.5625,
        703.4877319335938
      ],
      [
        -315.125,
        -2452.5625,
        703.48779296875
      ],
      [
        -391.1797790527344,
        -2415.2333984375,
        394.5291748046875
      ],
      [
        -491.74896240234375,
        -2374.730712890625,
        0.0
      ],
      [
        -488.6003723144531,
        -2372.154541015625,
        6.270025253295898
      ],
      [
        -488.6003723144531,
        -2372.154541015625,
        6.27002477645874
      ],
      [
        -554.801025390625,
        -2569.197265625,
        100.48339080810547
      ],
      [
        -698.2745361328125,
        -2408.3671875,
        1479.6412353515625
      ],
      [
        -714.7828369140625,
        -2350.402587890625,
        639.3530883789062
      ],
      [
        -714.501953125,
        -2350.786376953125,
        639.3538208007812
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.3803100585938
      ],
      [
        -758.4019775390625,
        -2314.277587890625,
        639.3778686523438
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.3803100585938
      ],
      [
        -574.4654541015625,
        -2554.126708984375,
        450.3244934082031
      ],
      [
        -758.4019775390625,
        -2314.277587890625,
        639.3778686523438
      ],
      [
        -777.5082397460938,
        -2338.604248046875,
        639.6439208984375
      ],
      [
        -758.4041137695312,
        -2314.276123046875,
        639.3829345703125
      ],
      [
        -754.6053466796875,
        -2319.914306640625,
        686.6563720703125
      ],
      [
        -711.3695678710938,
        -2355.322998046875,
        648.9346923828125
      ],
      [
        -738.39111328125,
        -2380.125732421875,
        674.6602783203125
      ],
      [
        -752.0667724609375,
        -2365.609375,
        687.0145874023438
      ],
      [
        -714.501953125,
        -2350.786376953125,
        639.3538208007812
      ],
      [
        -711.3695678710938,
        -2355.322998046875,
        648.9346923828125
      ],
      [
        -763.1380615234375,
        -2310.982666015625,
        651.2776489257812
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -754.98779296875,
        -2319.55615234375,
        685.8677978515625
      ],
      [
        -754.6053466796875,
        -2319.914306640625,
        686.6563720703125
      ],
      [
        -754.98779296875,
        -2319.55615234375,
        685.8677978515625
      ],
      [
        -762.50537109375,
        -2311.39697265625,
        649.1970825195312
      ],
      [
        -762.50537109375,
        -2311.39697265625,
        649.1970825195312
      ],
      [
        -763.1380615234375,
        -2310.982666015625,
        651.2776489257812
      ],
      [
        -636.65966796875,
        -2481.19091796875,
        1302.6832275390625
      ],
      [
        -637.385986328125,
        -2487.3388671875,
        1383.0211181640625
      ],
      [
        -729.6845703125,
        -2337.88671875,
        930.5068359375
      ],
      [
        -770.8285522460938,
        -2309.6298828125,
        1413.108642578125
      ],
      [
        -760.3702392578125,
        -2307.621826171875,
        650.8118896484375
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -752.9869384765625,
        -2315.81494140625,
        685.6275634765625
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -752.5239868164062,
        -2317.117431640625,
        686.5301513671875
      ],
      [
        -752.4957885742188,
        -2317.2001953125,
        686.6405639648438
      ],
      [
        -752.5239868164062,
        -2317.117431640625,
        686.5301513671875
      ],
      [
        -752.4957885742188,
        -2317.2001953125,
        686.6405639648438
      ],
      [
        -754.2664184570312,
        -2320.1953125,
        686.6597900390625
      ],
      [
        -752.467041015625,
        -2317.27783203125,
        686.6412963867188
      ],
      [
        -756.310791015625,
        -2311.613525390625,
        639.3507080078125
      ],
      [
        -760.0313720703125,
        -2307.949462890625,
        649.5208740234375
      ],
      [
        -750.1141967773438,
        -2323.63623046875,
        686.7015380859375
      ],
      [
        -749.9871826171875,
        -2321.246826171875,
        639.3771362304688
      ],
      [
        -753.7207641601562,
        -2314.28271484375,
        639.3557739257812
      ],
      [
        -751.8521728515625,
        -2316.20849609375,
        639.3568115234375
      ],
      [
        -756.310791015625,
        -2311.613525390625,
        639.3507080078125
      ],
      [
        -753.7207641601562,
        -2314.28271484375,
        639.3557739257812
      ],
      [
        -760.0313720703125,
        -2307.949462890625,
        649.5208740234375
      ],
      [
        -760.3702392578125,
        -2307.621826171875,
        650.8118896484375
      ],
      [
        -757.4647827148438,
        -2322.21044921875,
        1342.038330078125
      ],
      [
        -734.536865234375,
        -2347.26708984375,
        1427.1378173828125
      ],
      [
        -729.0033569335938,
        -2352.36328125,
        1390.960205078125
      ],
      [
        -729.0033569335938,
        -2352.36328125,
        1390.960205078125
      ],
      [
        -724.2160034179688,
        -2356.54248046875,
        1345.99072265625
      ],
      [
        -749.2044067382812,
        -2332.04296875,
        1420.7086181640625
      ],
      [
        -757.4647827148438,
        -2322.21044921875,
        1342.038330078125
      ],
      [
        -734.5928344726562,
        -2333.996337890625,
        639.3665771484375
      ],
      [
        -729.6845703125,
        -2337.88671875,
        930.5068359375
      ],
      [
        -741.8724365234375,
        -2326.51611328125,
        1126.518798828125
      ],
      [
        -774.5051879882812,
        -2299.141845703125,
        1403.4530029296875
      ],
      [
        -742.3391723632812,
        -2328.641357421875,
        1229.1416015625
      ],
      [
        -741.8724365234375,
        -2326.51611328125,
        1126.5186767578125
      ],
      [
        -737.9234008789062,
        -2338.639892578125,
        1376.481201171875
      ],
      [
        -742.3391723632812,
        -2328.641357421875,
        1229.1416015625
      ],
      [
        -737.9234008789062,
        -2338.639892578125,
        1376.481201171875
      ],
      [
        -827.1680908203125,
        -2208.307861328125,
        1063.4324951171875
      ],
      [
        -834.5745849609375,
        -2190.76513671875,
        787.61962890625
      ],
      [
        -769.68017578125,
        -2285.218505859375,
        1003.4500732421875
      ],
      [
        -765.195068359375,
        -2286.757080078125,
        833.05029296875
      ],
      [
        -774.9254150390625,
        -2297.943115234375,
        1402.349365234375
      ],
      [
        -781.3870239257812,
        -2279.51025390625,
        1385.3797607421875
      ],
      [
        -778.74169921875,
        -2280.03857421875,
        1270.7828369140625
      ],
      [
        -819.005859375,
        -2224.935791015625,
        1266.92626953125
      ],
      [
        -827.1680908203125,
        -2208.307861328125,
        1063.4324951171875
      ],
      [
        -757.1022338867188,
        -2302.95263671875,
        655.3712768554688
      ],
      [
        -770.0616455078125,
        -2280.2109375,
        836.8131103515625
      ],
      [
        -768.2567138671875,
        -2282.130859375,
        816.547119140625
      ],
      [
        -756.84716796875,
        -2303.34375,
        650.2191162109375
      ],
      [
        -757.1022338867188,
        -2302.95263671875,
        655.3712768554688
      ],
      [
        -759.273681640625,
        -2308.695556640625,
        647.44970703125
      ],
      [
        -756.8021240234375,
        -2303.44970703125,
        649.943603515625
      ],
      [
        -756.6925048828125,
        -2303.717529296875,
        649.4515380859375
      ],
      [
        -756.8021240234375,
        -2303.44970703125,
        649.943603515625
      ],
      [
        -756.84716796875,
        -2303.34375,
        650.2191162109375
      ],
      [
        -761.9382934570312,
        -2306.4140625,
        675.1514892578125
      ],
      [
        -753.0465087890625,
        -2315.6474609375,
        685.5114135742188
      ],
      [
        -768.7003173828125,
        -2282.0419921875,
        835.7605590820312
      ],
      [
        -770.0616455078125,
        -2280.2109375,
        836.8131713867188
      ],
      [
        -753.0465087890625,
        -2315.6474609375,
        685.5114135742188
      ],
      [
        -752.9869384765625,
        -2315.81494140625,
        685.6275634765625
      ],
      [
        -754.4367065429688,
        -2309.22607421875,
        639.3263549804688
      ],
      [
        -751.85205078125,
        -2316.208740234375,
        639.3568725585938
      ],
      [
        -753.2120971679688,
        -2312.534423828125,
        639.342041015625
      ],
      [
        -754.4367065429688,
        -2309.22607421875,
        639.3263549804688
      ],
      [
        -753.2120971679688,
        -2312.534423828125,
        639.342041015625
      ],
      [
        -778.74169921875,
        -2280.03857421875,
        1270.7828369140625
      ],
      [
        -769.68017578125,
        -2285.218505859375,
        1003.4500732421875
      ],
      [
        -765.195068359375,
        -2286.757080078125,
        833.05029296875
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -763.294189453125,
        -2287.4091796875,
        760.8275146484375
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -756.6925048828125,
        -2303.717529296875,
        649.4515380859375
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -750.8490600585938,
        -2317.242431640625,
        639.357421875
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -763.2392578125,
        -2287.467529296875,
        760.2109985351562
      ],
      [
        -757.6132202148438,
        -2294.22802734375,
        634.0616455078125
      ],
      [
        -763.2392578125,
        -2287.467529296875,
        760.2110595703125
      ],
      [
        -761.055908203125,
        -2288.817626953125,
        699.5869750976562
      ],
      [
        -757.6132202148438,
        -2294.22802734375,
        634.0616455078125
      ],
      [
        -753.3262329101562,
        -2300.94140625,
        637.1533813476562
      ],
      [
        -753.871826171875,
        -2300.73193359375,
        638.5557861328125
      ],
      [
        -753.5899047851562,
        -2300.53076171875,
        630.2252807617188
      ],
      [
        -753.5890502929688,
        -2300.530029296875,
        636.9639892578125
      ],
      [
        -752.82275390625,
        -2301.795166015625,
        630.2252807617188
      ],
      [
        -752.8037109375,
        -2301.761962890625,
        630.2252807617188
      ],
      [
        -753.5899047851562,
        -2300.53076171875,
        630.2252807617188
      ],
      [
        -753.8310546875,
        -2300.702880859375,
        641.6248779296875
      ],
      [
        -753.5885620117188,
        -2300.52978515625,
        640.6307373046875
      ],
      [
        -753.6727294921875,
        -2301.012451171875,
        639.2813110351562
      ],
      [
        -753.8582153320312,
        -2300.75,
        641.6248779296875
      ],
      [
        -753.8310546875,
        -2300.702880859375,
        641.6248779296875
      ],
      [
        -753.8582153320312,
        -2300.75,
        641.6248779296875
      ],
      [
        -750.7191162109375,
        -2305.024169921875,
        639.28125
      ],
      [
        -729.5591430664062,
        -2338.1650390625,
        639.3631591796875
      ],
      [
        -750.894287109375,
        -2304.749755859375,
        639.28125
      ],
      [
        -750.7191162109375,
        -2305.024169921875,
        639.28125
      ],
      [
        -750.8925170898438,
        -2304.75341796875,
        636.568603515625
      ],
      [
        -751.0501708984375,
        -2304.505859375,
        638.7948608398438
      ],
      [
        -751.0501708984375,
        -2304.505859375,
        638.7948608398438
      ],
      [
        -753.7503662109375,
        -2301.1484375,
        639.27490234375
      ],
      [
        -752.7094116210938,
        -2301.90966796875,
        630.2252807617188
      ],
      [
        -750.8165283203125,
        -2304.8720703125,
        637.5436401367188
      ],
      [
        -750.8925170898438,
        -2304.75341796875,
        636.568603515625
      ],
      [
        -750.7191162109375,
        -2305.024169921875,
        639.28125
      ],
      [
        -750.8165283203125,
        -2304.8720703125,
        637.5436401367188
      ],
      [
        -753.5884399414062,
        -2300.52978515625,
        641.6248779296875
      ],
      [
        -750.8939819335938,
        -2304.74951171875,
        641.6248779296875
      ],
      [
        -750.8939819335938,
        -2304.74951171875,
        641.6248779296875
      ],
      [
        -750.894287109375,
        -2304.749755859375,
        639.28125
      ],
      [
        -753.5884399414062,
        -2300.52978515625,
        641.6248779296875
      ],
      [
        -834.5745849609375,
        -2190.76513671875,
        787.61962890625
      ],
      [
        -837.9896850585938,
        -2183.86328125,
        704.5289916992188
      ],
      [
        -837.9896850585938,
        -2183.86328125,
        704.5289916992188
      ],
      [
        -838.8136596679688,
        -2182.29931640625,
        688.246337890625
      ],
      [
        -746.9037475585938,
        -2302.17822265625,
        477.8255615234375
      ],
      [
        -753.1447143554688,
        -2297.6806640625,
        627.4076538085938
      ],
      [
        -758.4227294921875,
        -2290.446044921875,
        626.472900390625
      ],
      [
        -753.1447143554688,
        -2297.6806640625,
        627.4076538085938
      ],
      [
        -758.4227294921875,
        -2290.446044921875,
        626.472900390625
      ],
      [
        -753.5890502929688,
        -2300.5302734375,
        636.9641723632812
      ],
      [
        -752.491455078125,
        -2299.74658203125,
        630.2252807617188
      ],
      [
        -752.5074462890625,
        -2299.758056640625,
        630.8737182617188
      ],
      [
        -751.1507568359375,
        -2303.486083984375,
        630.2252807617188
      ],
      [
        -752.491455078125,
        -2299.74658203125,
        630.2252807617188
      ],
      [
        -752.772216796875,
        -2299.947021484375,
        641.6248779296875
      ],
      [
        -752.772216796875,
        -2299.947021484375,
        641.6248779296875
      ],
      [
        -751.250732421875,
        -2304.190673828125,
        641.6248779296875
      ],
      [
        -743.664794921875,
        -2308.582275390625,
        551.3611450195312
      ],
      [
        -746.9037475585938,
        -2302.17822265625,
        477.8255615234375
      ],
      [
        -739.7911987304688,
        -2316.24072265625,
        639.2871704101562
      ],
      [
        -750.6803588867188,
        -2305.0849609375,
        639.2813720703125
      ],
      [
        -742.0280151367188,
        -2313.185302734375,
        639.28125
      ],
      [
        -743.664794921875,
        -2308.582275390625,
        551.361083984375
      ],
      [
        -742.0280151367188,
        -2313.185302734375,
        639.28125
      ],
      [
        -742.673583984375,
        -2312.059814453125,
        630.2252807617188
      ],
      [
        -751.9638061523438,
        -2299.369873046875,
        630.2252807617188
      ],
      [
        -752.1113891601562,
        -2299.47509765625,
        641.6248779296875
      ],
      [
        -751.9638061523438,
        -2299.369873046875,
        630.2252807617188
      ],
      [
        -749.1293334960938,
        -2303.485107421875,
        639.28125
      ],
      [
        -742.0280151367188,
        -2313.185302734375,
        639.28125
      ],
      [
        -752.1113891601562,
        -2299.47509765625,
        641.6248779296875
      ],
      [
        -749.1597900390625,
        -2303.507080078125,
        641.6248779296875
      ],
      [
        -749.1597900390625,
        -2303.507080078125,
        641.6248779296875
      ],
      [
        -749.1293334960938,
        -2303.485107421875,
        639.28125
      ],
      [
        -577.6831665039062,
        -2543.928466796875,
        429.817626953125
      ],
      [
        -555.198486328125,
        -2567.84716796875,
        97.04133605957031
      ],
      [
        -582.0225219726562,
        -2537.216796875,
        421.6952819824219
      ],
      [
        -577.6831665039062,
        -2543.928466796875,
        429.817626953125
      ],
      [
        -582.0225219726562,
        -2537.216796875,
        421.6952819824219
      ],
      [
        -737.3385620117188,
        -2296.00341796875,
        97.15826416015625
      ],
      [
        -759.3041381835938,
        -2277.610107421875,
        593.9218139648438
      ],
      [
        -788.6555786132812,
        -2262.2900390625,
        1364.9808349609375
      ],
      [
        -781.0297241210938,
        -2256.065185546875,
        969.5377807617188
      ],
      [
        -779.3583374023438,
        -2260.81689453125,
        1047.4464111328125
      ],
      [
        -762.060302734375,
        -2273.45166015625,
        592.3736572265625
      ],
      [
        -774.703369140625,
        -2264.43212890625,
        932.4213256835938
      ],
      [
        -781.0297241210938,
        -2256.065185546875,
        969.5377807617188
      ],
      [
        -781.328125,
        -2254.9462890625,
        946.2839965820312
      ],
      [
        -774.703369140625,
        -2264.43212890625,
        932.4212646484375
      ],
      [
        -775.706787109375,
        -2263.271728515625,
        944.0613403320312
      ],
      [
        -775.0945434570312,
        -2264.1533203125,
        942.94921875
      ],
      [
        -775.706787109375,
        -2263.271728515625,
        944.0614013671875
      ],
      [
        -765.8814697265625,
        -2285.833740234375,
        833.5809936523438
      ],
      [
        -781.328125,
        -2254.9462890625,
        946.2839965820312
      ],
      [
        -795.1062622070312,
        -2227.4150390625,
        619.2904052734375
      ],
      [
        -784.2650756835938,
        -2246.868408203125,
        818.7529296875
      ],
      [
        -823.192138671875,
        -2184.494873046875,
        298.278076171875
      ],
      [
        -796.3873291015625,
        -2210.4697265625,
        186.8227081298828
      ],
      [
        -794.0770874023438,
        -2218.97607421875,
        361.432373046875
      ],
      [
        -809.0655517578125,
        -2202.36474609375,
        362.4170227050781
      ],
      [
        -798.9852294921875,
        -2205.023193359375,
        132.6617889404297
      ],
      [
        -796.3873291015625,
        -2210.4697265625,
        186.8227081298828
      ],
      [
        -823.0145263671875,
        -2184.52001953125,
        293.85711669921875
      ],
      [
        -816.2205200195312,
        -2189.5185546875,
        230.58316040039062
      ],
      [
        -795.1062622070312,
        -2227.4150390625,
        619.2904052734375
      ],
      [
        -829.6610717773438,
        -2183.585693359375,
        472.6568908691406
      ],
      [
        -825.479736328125,
        -2184.17333984375,
        363.49530029296875
      ],
      [
        -821.5480346679688,
        -2184.72607421875,
        260.85125732421875
      ],
      [
        -774.8352661132812,
        -2266.859619140625,
        971.2859497070312
      ],
      [
        -775.4022827148438,
        -2264.129638671875,
        957.9810180664062
      ],
      [
        -774.989501953125,
        -2264.3046875,
        942.7584228515625
      ],
      [
        -774.8352661132812,
        -2266.859619140625,
        971.2859497070312
      ],
      [
        -773.3426513671875,
        -2283.125,
        1111.500732421875
      ],
      [
        -774.989501953125,
        -2264.3046875,
        942.7584228515625
      ],
      [
        -759.3041381835938,
        -2277.610107421875,
        593.9218139648438
      ],
      [
        -762.060302734375,
        -2273.45166015625,
        592.3736572265625
      ],
      [
        -805.3485717773438,
        -2191.682861328125,
        0.0
      ],
      [
        -789.132080078125,
        -2233.482421875,
        607.4157104492188
      ],
      [
        -809.0655517578125,
        -2202.36474609375,
        362.4170227050781
      ],
      [
        -793.1044921875,
        -2222.556884765625,
        434.93841552734375
      ],
      [
        -789.132080078125,
        -2233.482421875,
        607.4157104492188
      ],
      [
        -792.2159423828125,
        -2225.82861328125,
        502.0966491699219
      ],
      [
        -792.2159423828125,
        -2225.82861328125,
        502.09661865234375
      ],
      [
        -729.47509765625,
        -2315.94384765625,
        380.36639404296875
      ],
      [
        -737.3385620117188,
        -2296.00341796875,
        97.15827941894531
      ],
      [
        -706.5855102539062,
        -2373.9873046875,
        1204.7161865234375
      ],
      [
        -725.6580200195312,
        -2344.184814453125,
        960.1473388671875
      ],
      [
        -710.0498657226562,
        -2375.04443359375,
        1314.4796142578125
      ],
      [
        -706.0453491210938,
        -2375.35693359375,
        1224.163330078125
      ],
      [
        -710.5647583007812,
        -2352.470947265625,
        666.98779296875
      ],
      [
        -722.285400390625,
        -2334.175537109375,
        639.29638671875
      ],
      [
        -712.6063842773438,
        -2348.62255859375,
        639.3294677734375
      ],
      [
        -739.791259765625,
        -2316.24072265625,
        639.2871704101562
      ],
      [
        -709.56298828125,
        -2353.44921875,
        649.135009765625
      ],
      [
        -710.5647583007812,
        -2352.470947265625,
        666.98779296875
      ],
      [
        -712.6063842773438,
        -2348.62255859375,
        639.3294677734375
      ],
      [
        -709.56298828125,
        -2353.44921875,
        649.135009765625
      ],
      [
        -779.0325927734375,
        -2261.742919921875,
        1062.6295166015625
      ],
      [
        -779.0325927734375,
        -2261.742919921875,
        1062.6295166015625
      ],
      [
        -775.6288452148438,
        -2264.033447265625,
        966.3346557617188
      ],
      [
        -775.6288452148438,
        -2264.033447265625,
        966.3346557617188
      ],
      [
        -732.7147216796875,
        -2333.08203125,
        1138.8880615234375
      ],
      [
        -732.7147216796875,
        -2333.08203125,
        1138.8880615234375
      ],
      [
        -733.7012329101562,
        -2332.134033203125,
        1156.989013671875
      ],
      [
        -733.44970703125,
        -2333.139892578125,
        1178.7537841796875
      ],
      [
        -733.7510986328125,
        -2332.292724609375,
        1165.0408935546875
      ],
      [
        -733.44970703125,
        -2333.139892578125,
        1178.7537841796875
      ],
      [
        -733.7510986328125,
        -2332.292724609375,
        1165.0408935546875
      ],
      [
        -733.7012329101562,
        -2332.134033203125,
        1156.989013671875
      ],
      [
        -726.7146606445312,
        -2327.564453125,
        639.28125
      ],
      [
        -729.47509765625,
        -2315.94384765625,
        380.36639404296875
      ],
      [
        -726.7146606445312,
        -2327.564453125,
        639.28125
      ],
      [
        -739.8632202148438,
        -2314.902099609375,
        630.2252807617188
      ],
      [
        -724.8484497070312,
        -2330.087646484375,
        630.2252807617188
      ],
      [
        -726.811279296875,
        -2327.158203125,
        630.2252807617188
      ],
      [
        -747.5438842773438,
        -2296.214111328125,
        630.2252807617188
      ],
      [
        -744.8853759765625,
        -2300.444091796875,
        639.28125
      ],
      [
        -726.7146606445312,
        -2327.564453125,
        639.28125
      ],
      [
        -752.0810546875,
        -2299.453369140625,
        639.28125
      ],
      [
        -747.5438842773438,
        -2296.214111328125,
        630.2252807617188
      ],
      [
        -747.662841796875,
        -2296.298828125,
        639.28125
      ],
      [
        -747.693603515625,
        -2296.32080078125,
        641.6248779296875
      ],
      [
        -744.9161376953125,
        -2300.46630859375,
        641.6248779296875
      ],
      [
        -747.693603515625,
        -2296.32080078125,
        641.6248779296875
      ],
      [
        -744.9161376953125,
        -2300.46630859375,
        641.6248779296875
      ],
      [
        -744.8853759765625,
        -2300.444091796875,
        639.28125
      ],
      [
        -776.7902221679688,
        -2260.416015625,
        959.8062133789062
      ],
      [
        -775.7855834960938,
        -2262.257568359375,
        948.6776123046875
      ],
      [
        -775.7855834960938,
        -2262.257568359375,
        948.6776123046875
      ],
      [
        -776.3511352539062,
        -2261.33837890625,
        956.3025512695312
      ],
      [
        -775.8807983398438,
        -2262.30322265625,
        952.2825927734375
      ],
      [
        -776.3511352539062,
        -2261.33837890625,
        956.3025512695312
      ],
      [
        -775.0945434570312,
        -2264.1533203125,
        942.94921875
      ],
      [
        -775.7078247070312,
        -2262.657958984375,
        950.8040161132812
      ],
      [
        -775.4022827148438,
        -2264.129638671875,
        957.9810180664062
      ],
      [
        -775.7078247070312,
        -2262.657958984375,
        950.8040161132812
      ],
      [
        -779.3583374023438,
        -2260.81689453125,
        1047.4464111328125
      ],
      [
        -776.8268432617188,
        -2260.41552734375,
        960.9846801757812
      ],
      [
        -776.8268432617188,
        -2260.41552734375,
        960.9846801757812
      ],
      [
        -776.7902221679688,
        -2260.416015625,
        959.8062133789062
      ],
      [
        -775.8807983398438,
        -2262.30322265625,
        952.2825927734375
      ],
      [
        -737.0079345703125,
        -2296.841796875,
        109.06561279296875
      ],
      [
        -778.8005981445312,
        -2261.899169921875,
        1056.065673828125
      ],
      [
        -705.9177856445312,
        -2349.2333984375,
        630.2252807617188
      ],
      [
        -708.6976318359375,
        -2344.16650390625,
        630.2252807617188
      ],
      [
        -726.811279296875,
        -2327.158203125,
        630.2252807617188
      ],
      [
        -715.55029296875,
        -2359.94921875,
        1195.7457275390625
      ],
      [
        -720.0554809570312,
        -2352.895751953125,
        1186.4080810546875
      ],
      [
        -721.0748901367188,
        -2351.30419921875,
        1168.2125244140625
      ],
      [
        -713.7638549804688,
        -2362.74951171875,
        1186.6314697265625
      ],
      [
        -715.1890869140625,
        -2361.270751953125,
        1209.011962890625
      ],
      [
        -720.7378540039062,
        -2352.72265625,
        1199.8175048828125
      ],
      [
        -720.0554809570312,
        -2352.895751953125,
        1186.4080810546875
      ],
      [
        -715.55029296875,
        -2359.94921875,
        1195.7457275390625
      ],
      [
        -738.5347900390625,
        -2289.78173828125,
        630.2252807617188
      ],
      [
        -736.3060913085938,
        -2294.296875,
        639.28125
      ],
      [
        -747.662841796875,
        -2296.298828125,
        639.28125
      ],
      [
        -738.5347900390625,
        -2289.78173828125,
        630.2252807617188
      ],
      [
        -738.7133178710938,
        -2289.9091796875,
        639.28125
      ],
      [
        -738.759521484375,
        -2289.942138671875,
        641.6248779296875
      ],
      [
        -736.3521728515625,
        -2294.329833984375,
        641.6248779296875
      ],
      [
        -738.759521484375,
        -2289.942138671875,
        641.6248779296875
      ],
      [
        -736.3521728515625,
        -2294.329833984375,
        641.6248779296875
      ],
      [
        -736.3060913085938,
        -2294.296875,
        639.28125
      ],
      [
        -558.191650390625,
        -2557.679931640625,
        71.12109375
      ],
      [
        -576.5865478515625,
        -2545.094970703125,
        413.58770751953125
      ],
      [
        -650.1622924804688,
        -2228.74755859375,
        191.8474884033203
      ],
      [
        -666.1176147460938,
        -2223.4716796875,
        13.3828706741333
      ],
      [
        -537.5596923828125,
        -2295.1669921875,
        671.6787109375
      ],
      [
        -556.5177612304688,
        -2291.06005859375,
        401.86346435546875
      ],
      [
        -547.3446655273438,
        -2285.270751953125,
        656.66552734375
      ],
      [
        -547.3446655273438,
        -2285.270751953125,
        656.66552734375
      ],
      [
        -570.9049682617188,
        -2242.13525390625,
        610.0081787109375
      ],
      [
        -621.3937377929688,
        -2212.855712890625,
        503.47503662109375
      ],
      [
        -610.9713745117188,
        -2214.320556640625,
        555.4501953125
      ],
      [
        -608.0498046875,
        -2217.2685546875,
        559.9291381835938
      ],
      [
        -570.9049682617188,
        -2242.13525390625,
        610.0081787109375
      ],
      [
        -608.0498046875,
        -2217.2685546875,
        559.9291381835938
      ],
      [
        -650.1622924804688,
        -2228.74755859375,
        191.8474884033203
      ],
      [
        -621.9354248046875,
        -2242.64111328125,
        385.76458740234375
      ],
      [
        -598.3650512695312,
        -2257.63134765625,
        457.1606140136719
      ],
      [
        -621.9354248046875,
        -2242.64111328125,
        385.76458740234375
      ],
      [
        -598.3650512695312,
        -2257.63134765625,
        457.1606140136719
      ],
      [
        -556.5177612304688,
        -2291.06005859375,
        401.86346435546875
      ],
      [
        -638.9112548828125,
        -2210.393798828125,
        415.3950500488281
      ],
      [
        -567.03173828125,
        -2239.724365234375,
        624.5343627929688
      ],
      [
        -563.072509765625,
        -2243.481689453125,
        630.2252807617188
      ],
      [
        -560.1396484375,
        -2241.306640625,
        631.389892578125
      ],
      [
        -563.072509765625,
        -2243.481689453125,
        630.2252807617188
      ],
      [
        -560.8627319335938,
        -2240.4169921875,
        630.2252807617188
      ],
      [
        -567.03173828125,
        -2239.724365234375,
        624.5343627929688
      ],
      [
        -601.2230224609375,
        -2215.6904296875,
        580.5648803710938
      ],
      [
        -564.2896118164062,
        -2244.38427734375,
        630.2252807617188
      ],
      [
        -561.3180541992188,
        -2242.1806640625,
        641.6248779296875
      ],
      [
        -564.2896118164062,
        -2244.38427734375,
        630.2252807617188
      ],
      [
        -566.7360229492188,
        -2233.190185546875,
        630.2252807617188
      ],
      [
        -561.3347778320312,
        -2239.679443359375,
        641.6248779296875
      ],
      [
        -561.3347778320312,
        -2239.679443359375,
        641.6248779296875
      ],
      [
        -561.3180541992188,
        -2242.1806640625,
        641.6248779296875
      ],
      [
        -561.7347412109375,
        -2240.273681640625,
        641.6248779296875
      ],
      [
        -565.5144653320312,
        -2238.779541015625,
        630.2252807617188
      ],
      [
        -568.2611694335938,
        -2231.3134765625,
        630.2252807617188
      ],
      [
        -569.9207153320312,
        -2232.635009765625,
        630.2252807617188
      ],
      [
        -593.981689453125,
        -2216.7080078125,
        598.6825561523438
      ],
      [
        -569.2437744140625,
        -2233.5791015625,
        630.2252807617188
      ],
      [
        -569.9882202148438,
        -2232.688720703125,
        630.2252807617188
      ],
      [
        -585.956298828125,
        -2260.451904296875,
        630.2252807617188
      ],
      [
        -585.8543090820312,
        -2260.376220703125,
        634.2875366210938
      ],
      [
        -564.7127075195312,
        -2244.697998046875,
        641.6248779296875
      ],
      [
        -585.956298828125,
        -2260.451904296875,
        630.2252807617188
      ],
      [
        -576.6520385742188,
        -2237.995361328125,
        630.2252807617188
      ],
      [
        -589.819091796875,
        -2257.55712890625,
        630.2252807617188
      ],
      [
        -564.7127075195312,
        -2244.697998046875,
        641.6248779296875
      ],
      [
        -588.8173217773438,
        -2217.433837890625,
        612.2050170898438
      ],
      [
        -553.1201782226562,
        -2222.450927734375,
        639.28125
      ],
      [
        -570.3907470703125,
        -2228.693115234375,
        630.2252807617188
      ],
      [
        -571.7012329101562,
        -2230.64013671875,
        630.2252807617188
      ],
      [
        -569.9880981445312,
        -2232.688720703125,
        630.2252807617188
      ],
      [
        -620.2957153320312,
        -2213.010009765625,
        639.2813110351562
      ],
      [
        -590.0313720703125,
        -2257.05908203125,
        639.28125
      ],
      [
        -610.1602172851562,
        -2241.975341796875,
        639.28125
      ],
      [
        -621.0487670898438,
        -2212.904052734375,
        630.2252807617188
      ],
      [
        -610.9699096679688,
        -2241.70751953125,
        630.2252807617188
      ],
      [
        -571.7012329101562,
        -2230.64013671875,
        630.2252807617188
      ],
      [
        -581.9352416992188,
        -2218.401123046875,
        630.2252807617188
      ],
      [
        -585.7289428710938,
        -2260.283203125,
        639.28125
      ],
      [
        -571.465576171875,
        -2249.705810546875,
        639.28125
      ],
      [
        -589.9722900390625,
        -2257.015625,
        641.6248779296875
      ],
      [
        -590.0313720703125,
        -2257.05908203125,
        639.28125
      ],
      [
        -589.9722900390625,
        -2257.015625,
        641.6248779296875
      ],
      [
        -585.6701049804688,
        -2260.239501953125,
        641.6248779296875
      ],
      [
        -585.6701049804688,
        -2260.239501953125,
        641.6248779296875
      ],
      [
        -631.4694213867188,
        -2213.339111328125,
        630.2252807617188
      ],
      [
        -619.3198852539062,
        -2235.450439453125,
        630.2252807617188
      ],
      [
        -628.907470703125,
        -2217.342041015625,
        639.2813110351562
      ],
      [
        -619.0206298828125,
        -2235.335693359375,
        639.28125
      ],
      [
        -631.2091674804688,
        -2213.153076171875,
        639.28125
      ],
      [
        -631.4694213867188,
        -2213.339111328125,
        630.2252807617188
      ],
      [
        -629.2466430664062,
        -2211.751953125,
        639.28125
      ],
      [
        -631.141845703125,
        -2213.10498046875,
        641.6248779296875
      ],
      [
        -628.8401489257812,
        -2217.2939453125,
        641.6248779296875
      ],
      [
        -628.8401489257812,
        -2217.2939453125,
        641.6248779296875
      ],
      [
        -628.907470703125,
        -2217.342041015625,
        639.2813110351562
      ],
      [
        -631.141845703125,
        -2213.10498046875,
        641.6248779296875
      ],
      [
        -671.7844848632812,
        -2219.72607421875,
        0.0
      ],
      [
        -666.1176147460938,
        -2223.4716796875,
        13.382871627807617
      ],
      [
        -640.35791015625,
        -2219.685302734375,
        630.2252807617188
      ],
      [
        -636.1281127929688,
        -2222.515869140625,
        639.2813110351562
      ],
      [
        -640.1262817382812,
        -2219.519775390625,
        639.28125
      ],
      [
        -640.35791015625,
        -2219.685302734375,
        630.2252807617188
      ],
      [
        -631.2091674804688,
        -2213.153076171875,
        639.28125
      ],
      [
        -640.0663452148438,
        -2219.47705078125,
        641.6248779296875
      ],
      [
        -640.0663452148438,
        -2219.47705078125,
        641.6248779296875
      ],
      [
        -636.068115234375,
        -2222.472900390625,
        641.6248779296875
      ],
      [
        -636.068115234375,
        -2222.472900390625,
        641.6248779296875
      ],
      [
        -636.1281127929688,
        -2222.515869140625,
        639.2813110351562
      ],
      [
        -504.2900390625,
        -2353.19775390625,
        71.826416015625
      ],
      [
        -395.4713134765625,
        -2413.0732421875,
        377.01031494140625
      ],
      [
        -504.2900390625,
        -2353.19775390625,
        71.826416015625
      ],
      [
        -479.33441162109375,
        -2372.84619140625,
        37.8101692199707
      ],
      [
        -653.3314208984375,
        -2227.69970703125,
        156.39959716796875
      ],
      [
        -606.9039916992188,
        -2261.97998046875,
        394.9550476074219
      ],
      [
        -606.9039916992188,
        -2261.97998046875,
        394.9550476074219
      ],
      [
        -609.4266357421875,
        -2260.69091796875,
        386.1427917480469
      ],
      [
        -618.7315063476562,
        -2244.6787109375,
        395.4695129394531
      ],
      [
        -596.65380859375,
        -2269.941162109375,
        382.904296875
      ],
      [
        -586.0835571289062,
        -2260.54638671875,
        630.2252807617188
      ],
      [
        -585.8739624023438,
        -2260.390869140625,
        633.505126953125
      ],
      [
        -586.0835571289062,
        -2260.54638671875,
        630.2252807617188
      ],
      [
        -586.3511962890625,
        -2260.156005859375,
        630.2252807617188
      ],
      [
        -738.7133178710938,
        -2289.9091796875,
        639.28125
      ],
      [
        -640.1262817382812,
        -2219.519775390625,
        639.28125
      ],
      [
        -918.32568359375,
        -2575.4931640625,
        717.738525390625
      ],
      [
        -941.46484375,
        -2571.4130859375,
        685.9884033203125
      ],
      [
        -915.2291870117188,
        -2576.0390625,
        725.8607788085938
      ],
      [
        -918.32568359375,
        -2575.4931640625,
        717.738525390625
      ],
      [
        -915.2291870117188,
        -2576.0390625,
        725.8607788085938
      ],
      [
        -912.1072998046875,
        -2576.589599609375,
        726.27099609375
      ],
      [
        -941.46484375,
        -2571.4130859375,
        685.9884033203125
      ],
      [
        -940.4493408203125,
        -2571.592041015625,
        684.4713134765625
      ],
      [
        -910.4232788085938,
        -2576.886474609375,
        726.4923095703125
      ],
      [
        -846.3800048828125,
        -2530.88037109375,
        645.6022338867188
      ],
      [
        -910.0775756835938,
        -2576.947509765625,
        726.5377197265625
      ],
      [
        -860.8630981445312,
        -2585.62548828125,
        684.910888671875
      ],
      [
        -884.07763671875,
        -2581.53173828125,
        717.5496826171875
      ],
      [
        -888.8445434570312,
        -2580.69140625,
        726.1139526367188
      ],
      [
        -884.07763671875,
        -2581.53173828125,
        717.5496826171875
      ],
      [
        -888.8445434570312,
        -2580.69140625,
        726.1139526367188
      ],
      [
        -890.2044067382812,
        -2580.45166015625,
        726.163818359375
      ],
      [
        -894.9523315429688,
        -2579.614501953125,
        726.3378295898438
      ],
      [
        -860.8630981445312,
        -2585.62548828125,
        684.910888671875
      ],
      [
        -861.900634765625,
        -2585.442626953125,
        682.1506958007812
      ],
      [
        -938.7445068359375,
        -2571.892578125,
        681.924560546875
      ],
      [
        -907.9686279296875,
        -2577.3193359375,
        726.8148803710938
      ],
      [
        -907.9686279296875,
        -2577.3193359375,
        726.8148803710938
      ],
      [
        -870.6910400390625,
        -2583.89208984375,
        654.4735717773438
      ],
      [
        -862.2821655273438,
        -2585.375244140625,
        681.1356811523438
      ],
      [
        -862.2821655273438,
        -2585.375244140625,
        681.1356811523438
      ],
      [
        -870.6910400390625,
        -2583.89208984375,
        654.4735717773438
      ],
      [
        -873.16162109375,
        -2583.45654296875,
        654.5232543945312
      ],
      [
        -916.9639282226562,
        -2575.733154296875,
        655.4043579101562
      ],
      [
        -929.5636596679688,
        -2573.511474609375,
        655.013916015625
      ],
      [
        -916.9639282226562,
        -2575.733154296875,
        655.4043579101562
      ],
      [
        -929.5636596679688,
        -2573.511474609375,
        655.013916015625
      ],
      [
        -929.7709350585938,
        -2573.474853515625,
        655.6619262695312
      ],
      [
        -937.6468505859375,
        -2572.086181640625,
        680.2847900390625
      ],
      [
        -937.6468505859375,
        -2572.086181640625,
        680.2847900390625
      ],
      [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      [
        -985.4205932617188,
        -2640.0,
        705.8635864257812
      ],
      [
        -985.4205932617188,
        -2640.0,
        705.8635864257812
      ],
      [
        -940.1668701171875,
        -2580.30615234375,
        678.852294921875
      ],
      [
        -984.8797607421875,
        -2640.0,
        705.1128540039062
      ],
      [
        -940.1668701171875,
        -2580.30615234375,
        678.852294921875
      ],
      [
        -935.3463134765625,
        -2572.491943359375,
        673.092529296875
      ],
      [
        -957.8712158203125,
        -2640.0,
        666.6993408203125
      ],
      [
        -881.5084838867188,
        -2640.0,
        666.6993408203125
      ],
      [
        -878.090576171875,
        -2640.0,
        666.505859375
      ],
      [
        -881.5084838867188,
        -2640.0,
        666.6993408203125
      ],
      [
        -878.090576171875,
        -2640.0,
        666.505859375
      ],
      [
        -869.9378662109375,
        -2584.02490234375,
        656.8616333007812
      ],
      [
        -878.0274047851562,
        -2640.0,
        666.6993408203125
      ],
      [
        -958.4671630859375,
        -2640.0,
        668.449462890625
      ],
      [
        -957.8712158203125,
        -2640.0,
        666.6993408203125
      ],
      [
        -958.4671630859375,
        -2640.0,
        668.449462890625
      ],
      [
        -882.9166870117188,
        -2640.0,
        742.6649169921875
      ],
      [
        -864.775634765625,
        -2640.0,
        708.57958984375
      ],
      [
        -862.9345092773438,
        -2640.0,
        705.8839111328125
      ],
      [
        -864.775634765625,
        -2640.0,
        708.57958984375
      ],
      [
        -882.9166870117188,
        -2640.0,
        742.6649169921875
      ],
      [
        -895.7581787109375,
        -2640.0,
        767.9290771484375
      ],
      [
        -895.7581787109375,
        -2640.0,
        767.9290771484375
      ],
      [
        -897.95458984375,
        -2640.0,
        770.9197387695312
      ],
      [
        -862.90673828125,
        -2587.63671875,
        680.6214599609375
      ],
      [
        -862.9345092773438,
        -2640.0,
        705.8839111328125
      ],
      [
        -863.10595703125,
        -2640.0,
        705.4423828125
      ],
      [
        -862.83447265625,
        -2585.27783203125,
        679.3844604492188
      ],
      [
        -862.90673828125,
        -2587.63671875,
        680.6214599609375
      ],
      [
        -877.3690185546875,
        -2640.0,
        668.7150268554688
      ],
      [
        -877.3690185546875,
        -2640.0,
        668.7150268554688
      ],
      [
        -898.71923828125,
        -2640.0,
        771.9608154296875
      ],
      [
        -952.3094482421875,
        -2640.0,
        771.9608154296875
      ],
      [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      [
        -952.3094482421875,
        -2640.0,
        771.9608154296875
      ],
      [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      [
        -898.71923828125,
        -2640.0,
        771.9608154296875
      ],
      [
        -977.0639038085938,
        -2859.5,
        761.111083984375
      ],
      [
        -959.8472290039062,
        -2859.5,
        761.111083984375
      ],
      [
        -903.5572509765625,
        -2859.5,
        761.111083984375
      ],
      [
        -878.493408203125,
        -2859.5,
        761.111083984375
      ],
      [
        -959.8472290039062,
        -2859.5,
        761.111083984375
      ],
      [
        -941.3390502929688,
        -2859.5,
        761.111083984375
      ],
      [
        -903.5572509765625,
        -2859.5,
        761.111083984375
      ],
      [
        -941.3390502929688,
        -2859.5,
        761.111083984375
      ],
      [
        -336.5840759277344,
        -2859.5,
        522.09130859375
      ],
      [
        -322.4647216796875,
        -2859.5,
        0.0
      ],
      [
        -341.2353820800781,
        -2859.5,
        658.3660888671875
      ],
      [
        -336.5840759277344,
        -2859.5,
        522.0913696289062
      ],
      [
        -966.0363159179688,
        -2920.0,
        788.0
      ],
      [
        -877.9636840820312,
        -2920.0,
        788.0
      ],
      [
        -906.0615234375,
        -2930.0,
        790.5328369140625
      ],
      [
        -933.5289916992188,
        -2930.0,
        790.5328369140625
      ],
      [
        -940.072265625,
        -2930.0,
        790.5327758789062
      ],
      [
        -939.038330078125,
        -2930.0,
        790.4069213867188
      ],
      [
        -933.5289916992188,
        -2930.0,
        790.5328369140625
      ],
      [
        -939.038330078125,
        -2930.0,
        790.4069213867188
      ],
      [
        -939.1234741210938,
        -2930.0,
        790.5327758789062
      ],
      [
        -941.6363525390625,
        -2930.0,
        792.4444580078125
      ],
      [
        -940.416259765625,
        -2930.0,
        792.4444580078125
      ],
      [
        -906.0615234375,
        -2930.0,
        790.5328369140625
      ],
      [
        -904.2719116210938,
        -2930.0,
        792.4444580078125
      ],
      [
        -344.1455078125,
        -2859.5,
        761.1112060546875
      ],
      [
        -341.2353820800781,
        -2859.5,
        658.3660888671875
      ],
      [
        -332.004638671875,
        -2887.054931640625,
        773.3578491210938
      ],
      [
        -932.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -932.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -358.3706359863281,
        -2859.5,
        1263.345458984375
      ],
      [
        -359.94940185546875,
        -2859.5,
        1307.9615478515625
      ],
      [
        -358.3706359863281,
        -2859.5,
        1263.345458984375
      ],
      [
        -376.8299865722656,
        -2859.5,
        1439.6474609375
      ],
      [
        -361.046630859375,
        -2859.5,
        1314.0255126953125
      ],
      [
        -871.1350708007812,
        -2920.0,
        801.7215576171875
      ],
      [
        -887.615478515625,
        -2920.0,
        825.2523803710938
      ],
      [
        -902.0224609375,
        -2920.0,
        845.8228759765625
      ],
      [
        -887.615478515625,
        -2920.0,
        825.2523803710938
      ],
      [
        -914.6135864257812,
        -2920.0,
        863.8005981445312
      ],
      [
        -902.0224609375,
        -2920.0,
        845.8228759765625
      ],
      [
        -376.8299865722656,
        -2859.5,
        1439.6474609375
      ],
      [
        -380.5986633300781,
        -2859.5,
        1457.741455078125
      ],
      [
        -869.7720336914062,
        -2859.5,
        790.45849609375
      ],
      [
        -871.22314453125,
        -2859.5,
        792.14794921875
      ],
      [
        -381.02655029296875,
        -2859.5,
        1459.052734375
      ],
      [
        -380.5986633300781,
        -2859.5,
        1457.741455078125
      ],
      [
        -869.7720336914062,
        -2859.5,
        790.45849609375
      ],
      [
        -869.8526611328125,
        -2859.5,
        790.1911010742188
      ],
      [
        -890.6571655273438,
        -2930.0,
        792.7325439453125
      ],
      [
        -883.2512817382812,
        -2930.0,
        818.8846435546875
      ],
      [
        -886.1357421875,
        -2920.0,
        800.3511962890625
      ],
      [
        -889.6334228515625,
        -2920.0,
        788.0
      ],
      [
        -881.5404052734375,
        -2920.0,
        816.5783081054688
      ],
      [
        -886.1357421875,
        -2920.0,
        800.3511962890625
      ],
      [
        -871.61669921875,
        -2859.5,
        784.3419189453125
      ],
      [
        -890.6571655273438,
        -2930.0,
        792.7325439453125
      ],
      [
        -891.4382934570312,
        -2930.0,
        792.7470703125
      ],
      [
        -883.2512817382812,
        -2930.0,
        818.8846435546875
      ],
      [
        -883.5030517578125,
        -2930.0,
        820.7681884765625
      ],
      [
        -877.9344482421875,
        -2859.5,
        763.3938598632812
      ],
      [
        -877.9344482421875,
        -2859.5,
        763.3938598632812
      ],
      [
        -878.493408203125,
        -2859.5,
        761.111083984375
      ],
      [
        -889.6818237304688,
        -2920.0,
        788.0
      ],
      [
        -888.9674072265625,
        -2920.0,
        790.3518676757812
      ],
      [
        -883.9012451171875,
        -2920.0,
        819.9491577148438
      ],
      [
        -888.56396484375,
        -2920.0,
        824.670166015625
      ],
      [
        -904.548583984375,
        -2920.0,
        840.8545532226562
      ],
      [
        -888.56396484375,
        -2920.0,
        824.670166015625
      ],
      [
        -927.2113037109375,
        -2920.0,
        863.8005981445312
      ],
      [
        -904.548583984375,
        -2920.0,
        840.8545532226562
      ],
      [
        -883.5282592773438,
        -2930.0,
        820.9566040039062
      ],
      [
        -932.0,
        -2863.125,
        833.59375
      ],
      [
        -932.0,
        -2925.0,
        844.0625
      ],
      [
        -914.0,
        -2859.5,
        832.9804077148438
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -914.0,
        -2920.0,
        843.216552734375
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -932.0,
        -2920.0,
        863.8005981445312
      ],
      [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      [
        -914.0,
        -2920.0,
        843.2164916992188
      ],
      [
        -914.0,
        -2920.0,
        850.4241333007812
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -932.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -906.88134765625,
        -2920.0,
        843.2164916992188
      ],
      [
        -914.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -932.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -932.0,
        -2930.0,
        838.0
      ],
      [
        -914.0,
        -2930.0,
        838.0
      ],
      [
        -914.0,
        -2920.0,
        838.0
      ],
      [
        -932.0,
        -2920.0,
        838.0
      ],
      [
        -932.0,
        -2920.0,
        838.0
      ],
      [
        -914.0,
        -2920.0,
        838.0
      ],
      [
        -914.0,
        -2920.0,
        843.2164916992188
      ],
      [
        -892.25634765625,
        -2863.125,
        822.7603759765625
      ],
      [
        -871.8587036132812,
        -2859.5,
        792.8878784179688
      ],
      [
        -891.8325805664062,
        -2859.5,
        821.4066772460938
      ],
      [
        -871.8587036132812,
        -2859.5,
        792.8878784179688
      ],
      [
        -894.0,
        -2923.890625,
        789.7291870117188
      ],
      [
        -894.0,
        -2930.0,
        792.794677734375
      ],
      [
        -903.77392578125,
        -2930.0,
        792.9763793945312
      ],
      [
        -903.77392578125,
        -2930.0,
        792.9763793945312
      ],
      [
        -932.0,
        -2863.125,
        833.59375
      ],
      [
        -914.0,
        -2863.125,
        833.59375
      ],
      [
        -914.0,
        -2859.5,
        832.5732421875
      ],
      [
        -932.0,
        -2859.5,
        832.5732421875
      ],
      [
        -899.6533813476562,
        -2859.5,
        832.5732421875
      ],
      [
        -906.3441162109375,
        -2859.5,
        832.5732421875
      ],
      [
        -906.3441162109375,
        -2859.5,
        832.5732421875
      ],
      [
        -899.6533813476562,
        -2859.5,
        832.5732421875
      ],
      [
        -359.94940185546875,
        -2859.5,
        1307.9615478515625
      ],
      [
        -361.046630859375,
        -2859.5,
        1314.0255126953125
      ],
      [
        -972.8826293945312,
        -2920.0,
        805.2472534179688
      ],
      [
        -957.2628784179688,
        -2920.0,
        825.7915649414062
      ],
      [
        -957.2628784179688,
        -2920.0,
        825.7915649414062
      ],
      [
        -941.999755859375,
        -2920.0,
        845.86669921875
      ],
      [
        -941.999755859375,
        -2920.0,
        845.86669921875
      ],
      [
        -932.0,
        -2920.0,
        859.0191040039062
      ],
      [
        -985.7762451171875,
        -2859.5,
        790.45849609375
      ],
      [
        -985.7095336914062,
        -2859.5,
        790.23095703125
      ],
      [
        -985.7762451171875,
        -2859.5,
        790.45849609375
      ],
      [
        -984.927490234375,
        -2859.5,
        791.2595825195312
      ],
      [
        -956.1746826171875,
        -2920.0,
        788.0
      ],
      [
        -959.533203125,
        -2920.0,
        799.8598022460938
      ],
      [
        -959.533203125,
        -2920.0,
        799.8598022460938
      ],
      [
        -964.2676391601562,
        -2920.0,
        816.578369140625
      ],
      [
        -952.7792358398438,
        -2930.0,
        792.8374633789062
      ],
      [
        -954.5962524414062,
        -2930.0,
        792.7979125976562
      ],
      [
        -983.5852661132812,
        -2859.5,
        782.986328125
      ],
      [
        -977.84033203125,
        -2859.5,
        763.3938598632812
      ],
      [
        -956.147705078125,
        -2920.0,
        788.0
      ],
      [
        -956.8422241210938,
        -2920.0,
        790.3572998046875
      ],
      [
        -977.0639038085938,
        -2859.5,
        761.111083984375
      ],
      [
        -977.84033203125,
        -2859.5,
        763.3938598632812
      ],
      [
        -956.4358520507812,
        -2920.0,
        825.2838745117188
      ],
      [
        -961.7053833007812,
        -2920.0,
        819.948486328125
      ],
      [
        -956.4358520507812,
        -2920.0,
        825.2838745117188
      ],
      [
        -939.9971923828125,
        -2920.0,
        841.927978515625
      ],
      [
        -939.9971923828125,
        -2920.0,
        841.927978515625
      ],
      [
        -932.0,
        -2920.0,
        850.0250854492188
      ],
      [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      [
        -938.7245483398438,
        -2920.0,
        843.216552734375
      ],
      [
        -953.0294189453125,
        -2859.5,
        832.5732421875
      ],
      [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      [
        -950.0,
        -2930.0,
        792.89794921875
      ],
      [
        -950.0,
        -2923.65380859375,
        789.6239013671875
      ],
      [
        -942.1470947265625,
        -2930.0,
        793.0687255859375
      ],
      [
        -940.857421875,
        -2930.0,
        793.0968017578125
      ],
      [
        -940.857421875,
        -2930.0,
        793.0968017578125
      ],
      [
        -943.8286743164062,
        -2859.5,
        832.5732421875
      ],
      [
        -953.0294189453125,
        -2859.5,
        832.5732421875
      ],
      [
        -943.8286743164062,
        -2859.5,
        832.5732421875
      ],
      [
        -970.0,
        -2712.0,
        720.0
      ],
      [
        -970.0,
        -2712.0,
        670.0
      ],
      [
        -980.0,
        -2712.0,
        720.0
      ],
      [
        -970.0,
        -2712.0,
        720.0
      ],
      [
        -990.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -970.0,
        -2677.65380859375,
        680.2904663085938
      ],
      [
        -970.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -994.123291015625,
        -2682.291259765625,
        694.1002197265625
      ],
      [
        -1007.907958984375,
        -2697.0,
        720.0
      ],
      [
        -1007.4884643554688,
        -2695.500244140625,
        720.0
      ],
      [
        -1007.907958984375,
        -2697.0,
        720.0
      ],
      [
        -1007.45263671875,
        -2700.84130859375,
        720.0
      ],
      [
        -1006.3765869140625,
        -2710.0,
        720.0
      ],
      [
        -1007.45263671875,
        -2700.84130859375,
        720.0
      ],
      [
        -981.5535278320312,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -994.123291015625,
        -2682.291259765625,
        694.1002197265625
      ],
      [
        -990.0,
        -2710.0,
        748.4310302734375
      ],
      [
        -972.8922729492188,
        -2710.0,
        748.4310302734375
      ],
      [
        -1020.0,
        -2710.0,
        748.4310302734375
      ],
      [
        -990.0,
        -2710.0,
        748.4310302734375
      ],
      [
        -972.8922729492188,
        -2710.0,
        748.4310302734375
      ],
      [
        -980.0,
        -2712.0,
        720.0
      ],
      [
        -971.9118041992188,
        -2712.0,
        752.3527221679688
      ],
      [
        -1011.9400024414062,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -1000.169921875,
        -2710.0,
        748.4310913085938
      ],
      [
        -1011.9400024414062,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -1010.0033569335938,
        -2698.625732421875,
        726.1282958984375
      ],
      [
        -1009.0059204101562,
        -2697.0,
        722.940673828125
      ],
      [
        -1010.0033569335938,
        -2698.625732421875,
        726.1282958984375
      ],
      [
        -1009.0059204101562,
        -2697.0,
        722.940673828125
      ],
      [
        -897.6017456054688,
        -2712.0,
        695.5555419921875
      ],
      [
        -896.08935546875,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -870.4964599609375,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -865.0618896484375,
        -2712.0,
        695.5555419921875
      ],
      [
        -968.076904296875,
        -2674.54345703125,
        678.9081420898438
      ],
      [
        -951.5470581054688,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -949.479736328125,
        -2712.0,
        695.5555419921875
      ],
      [
        -896.08935546875,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -897.6017456054688,
        -2712.0,
        695.5555419921875
      ],
      [
        -949.479736328125,
        -2712.0,
        695.5555419921875
      ],
      [
        -951.5470581054688,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -894.0,
        -2712.0,
        670.0
      ],
      [
        -894.0,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -894.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -515.4536743164062,
        -2712.0,
        499.9759216308594
      ],
      [
        -505.7439270019531,
        -2712.0,
        273.41998291015625
      ],
      [
        -515.4536743164062,
        -2712.0,
        499.9759216308594
      ],
      [
        -519.0872802734375,
        -2712.0,
        695.5555419921875
      ],
      [
        -522.370361328125,
        -2703.15966796875,
        691.62646484375
      ],
      [
        -894.0,
        -2712.0,
        720.0
      ],
      [
        -520.1425170898438,
        -2712.0,
        752.3527221679688
      ],
      [
        -523.3565063476562,
        -2702.63525390625,
        733.9903564453125
      ],
      [
        -877.0875244140625,
        -2712.0,
        720.0
      ],
      [
        -885.9562377929688,
        -2712.0,
        720.0
      ],
      [
        -870.0,
        -2712.0,
        720.0
      ],
      [
        -877.0875244140625,
        -2712.0,
        720.0
      ],
      [
        -894.0,
        -2712.0,
        720.0
      ],
      [
        -885.9562377929688,
        -2712.0,
        720.0
      ],
      [
        -856.3112182617188,
        -2697.0,
        720.0
      ],
      [
        -864.9321899414062,
        -2682.35205078125,
        694.219482421875
      ],
      [
        -856.40234375,
        -2695.500244140625,
        720.0
      ],
      [
        -864.9321899414062,
        -2682.35205078125,
        694.219482421875
      ],
      [
        -870.4964599609375,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -872.3709716796875,
        -2712.0,
        752.3528442382812
      ],
      [
        -872.3709716796875,
        -2712.0,
        720.0
      ],
      [
        -868.5,
        -2700.0,
        728.8235473632812
      ],
      [
        -865.2177734375,
        -2712.0,
        752.3527221679688
      ],
      [
        -853.125,
        -2712.0,
        735.8872680664062
      ],
      [
        -853.125,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -868.5,
        -2700.0,
        728.8235473632812
      ],
      [
        -855.4293823242188,
        -2697.0,
        722.940673828125
      ],
      [
        -856.3504028320312,
        -2696.355224609375,
        720.0
      ],
      [
        -855.9296264648438,
        -2696.22900390625,
        721.4287109375
      ],
      [
        -533.1121826171875,
        -2712.0,
        1370.0621337890625
      ],
      [
        -521.2469482421875,
        -2712.0,
        811.7999267578125
      ],
      [
        -521.2469482421875,
        -2712.0,
        811.7999267578125
      ],
      [
        -546.9571533203125,
        -2712.0,
        1480.5965576171875
      ],
      [
        -537.3478393554688,
        -2712.0,
        1421.2711181640625
      ],
      [
        -533.1121826171875,
        -2712.0,
        1370.0621337890625
      ],
      [
        -537.3478393554688,
        -2712.0,
        1421.2711181640625
      ],
      [
        -932.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -932.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -932.0,
        -2641.0,
        714.6666870117188
      ],
      [
        -932.0,
        -2641.0,
        748.0
      ],
      [
        -932.0,
        -2641.0,
        668.0
      ],
      [
        -932.0,
        -2641.0,
        714.6666870117188
      ],
      [
        -858.5,
        -2641.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        757.0
      ],
      [
        -932.0,
        -2641.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        748.0
      ],
      [
        -932.0,
        -2645.0,
        667.578125
      ],
      [
        -932.0,
        -2641.0,
        666.8751220703125
      ],
      [
        -880.956787109375,
        -2641.0,
        666.8751220703125
      ],
      [
        -895.098388671875,
        -2647.400634765625,
        668.0
      ],
      [
        -932.0,
        -2650.0,
        668.0
      ],
      [
        -932.0,
        -2647.400634765625,
        668.0
      ],
      [
        -875.80322265625,
        -2650.0,
        668.0
      ],
      [
        -876.2950439453125,
        -2645.0,
        667.578125
      ],
      [
        -875.9871215820312,
        -2647.400390625,
        668.0
      ],
      [
        -878.2224731445312,
        -2641.0,
        666.7203369140625
      ],
      [
        -880.956787109375,
        -2641.0,
        666.8751220703125
      ],
      [
        -878.2224731445312,
        -2641.0,
        666.7203369140625
      ],
      [
        -878.1719360351562,
        -2641.0,
        666.8751220703125
      ],
      [
        -895.098388671875,
        -2647.400634765625,
        668.0
      ],
      [
        -894.743408203125,
        -2650.0,
        668.4568481445312
      ],
      [
        -875.6536865234375,
        -2650.0,
        668.4568481445312
      ],
      [
        -862.1634521484375,
        -2650.0,
        710.0059814453125
      ],
      [
        -878.9583740234375,
        -2641.0,
        735.6944580078125
      ],
      [
        -889.7877807617188,
        -2641.0,
        757.0
      ],
      [
        -886.0501098632812,
        -2650.0,
        757.0
      ],
      [
        -878.9583740234375,
        -2641.0,
        735.6944580078125
      ],
      [
        -864.4454956054688,
        -2641.0,
        708.4261474609375
      ],
      [
        -862.9725952148438,
        -2641.0,
        706.2696533203125
      ],
      [
        -864.4454956054688,
        -2641.0,
        708.4261474609375
      ],
      [
        -863.1098022460938,
        -2641.0,
        705.9163208007812
      ],
      [
        -862.9725952148438,
        -2641.0,
        706.2696533203125
      ],
      [
        -863.4183959960938,
        -2641.0,
        705.1217041015625
      ],
      [
        -877.6452026367188,
        -2641.0,
        668.4876708984375
      ],
      [
        -863.366943359375,
        -2650.0,
        705.992919921875
      ],
      [
        -862.1634521484375,
        -2650.0,
        710.0059814453125
      ],
      [
        -863.366943359375,
        -2650.0,
        705.992919921875
      ],
      [
        -877.6452026367188,
        -2641.0,
        668.4876708984375
      ],
      [
        -932.0,
        -2641.0,
        748.0
      ],
      [
        -932.0,
        -2650.0,
        748.0
      ],
      [
        -895.098388671875,
        -2641.0,
        748.0
      ],
      [
        -895.098388671875,
        -2641.0,
        668.0
      ],
      [
        -932.0,
        -2641.0,
        668.0
      ],
      [
        -876.0,
        -2641.0,
        692.579833984375
      ],
      [
        -876.0,
        -2641.0,
        725.420166015625
      ],
      [
        -895.098388671875,
        -2641.0,
        668.0
      ],
      [
        -876.0,
        -2641.0,
        692.579833984375
      ],
      [
        -895.098388671875,
        -2641.0,
        748.0
      ],
      [
        -876.0,
        -2641.0,
        725.420166015625
      ],
      [
        -860.2403564453125,
        -2660.0,
        714.3930053710938
      ],
      [
        -883.2678833007812,
        -2656.699462890625,
        757.0
      ],
      [
        -880.7991943359375,
        -2660.0,
        754.8399047851562
      ],
      [
        -863.8507690429688,
        -2660.0,
        702.353759765625
      ],
      [
        -873.6409912109375,
        -2660.0,
        672.4444580078125
      ],
      [
        -914.0,
        -2660.0,
        754.0
      ],
      [
        -932.0,
        -2660.0,
        754.0
      ],
      [
        -860.2403564453125,
        -2660.0,
        714.3930053710938
      ],
      [
        -863.8507690429688,
        -2660.0,
        702.353759765625
      ],
      [
        -914.0,
        -2660.0,
        750.0
      ],
      [
        -914.0,
        -2660.0,
        754.0
      ],
      [
        -880.7991943359375,
        -2660.0,
        754.8399047851562
      ],
      [
        -883.2678833007812,
        -2656.699462890625,
        757.0
      ],
      [
        -882.3856201171875,
        -2660.0,
        757.0
      ],
      [
        -898.5655517578125,
        -2660.0,
        779.0304565429688
      ],
      [
        -898.7115478515625,
        -2641.0,
        772.3142700195312
      ],
      [
        -932.0,
        -2641.0,
        772.3142700195312
      ],
      [
        -932.0,
        -2660.0,
        779.0304565429688
      ],
      [
        -927.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -921.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -915.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -909.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -921.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -921.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -927.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -921.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -915.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -895.01025390625,
        -2641.0,
        767.2745971679688
      ],
      [
        -898.7115478515625,
        -2641.0,
        772.3142700195312
      ],
      [
        -898.5655517578125,
        -2660.0,
        779.0304565429688
      ],
      [
        -895.01025390625,
        -2641.0,
        767.2745971679688
      ],
      [
        -932.0,
        -2640.0,
        757.0
      ],
      [
        -932.0,
        -2640.0,
        666.6993408203125
      ],
      [
        -878.0274047851562,
        -2640.0,
        666.6993408203125
      ],
      [
        -878.1719360351562,
        -2641.0,
        666.8751220703125
      ],
      [
        -932.0,
        -2640.0,
        668.0
      ],
      [
        -932.0,
        -2640.0,
        748.0
      ],
      [
        -885.6284790039062,
        -2640.0,
        748.0
      ],
      [
        -890.2030639648438,
        -2640.0,
        757.0
      ],
      [
        -889.7877807617188,
        -2641.0,
        757.0
      ],
      [
        -885.213134765625,
        -2641.0,
        748.0
      ],
      [
        -932.0,
        -2640.0,
        771.9608154296875
      ],
      [
        -853.5,
        -2695.5,
        730.5896606445312
      ],
      [
        -868.5,
        -2700.0,
        752.6513061523438
      ],
      [
        -872.3709716796875,
        -2712.0,
        792.0
      ],
      [
        -872.3709716796875,
        -2712.0,
        762.2891845703125
      ],
      [
        -868.5,
        -2700.0,
        752.6513061523438
      ],
      [
        -890.8987426757812,
        -2712.0,
        787.3197021484375
      ],
      [
        -858.5,
        -2697.0,
        737.9435424804688
      ],
      [
        -868.5,
        -2700.0,
        752.6119384765625
      ],
      [
        -872.3709716796875,
        -2712.0,
        762.09228515625
      ],
      [
        -868.5,
        -2700.0,
        752.6119384765625
      ],
      [
        -853.5,
        -2695.5,
        730.1375122070312
      ],
      [
        -854.1096801757812,
        -2695.682861328125,
        731.486328125
      ],
      [
        -932.0,
        -2697.0,
        792.109375
      ],
      [
        -853.5,
        -2695.5,
        729.67822265625
      ],
      [
        -855.9295654296875,
        -2696.228759765625,
        721.4291381835938
      ],
      [
        -914.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -932.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -914.0,
        -2668.288818359375,
        750.0
      ],
      [
        -914.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -914.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -897.8980712890625,
        -2712.0,
        795.4685668945312
      ],
      [
        -932.0,
        -2697.0,
        792.109375
      ],
      [
        -932.0,
        -2712.0,
        795.468505859375
      ],
      [
        -897.8980712890625,
        -2712.0,
        795.468505859375
      ],
      [
        -890.8987426757812,
        -2712.0,
        787.3197021484375
      ],
      [
        -991.0,
        -2641.0,
        757.0
      ],
      [
        -932.0,
        -2641.0,
        757.0
      ],
      [
        -972.3472290039062,
        -2641.0,
        735.4166259765625
      ],
      [
        -990.860595703125,
        -2650.0,
        709.5540771484375
      ],
      [
        -967.8666381835938,
        -2650.0,
        757.0
      ],
      [
        -961.88720703125,
        -2641.0,
        757.0
      ],
      [
        -965.4456787109375,
        -2650.0,
        668.0
      ],
      [
        -989.3621826171875,
        -2650.0,
        705.541015625
      ],
      [
        -986.0614624023438,
        -2641.0,
        706.1533813476562
      ],
      [
        -958.7737426757812,
        -2641.0,
        668.2752075195312
      ],
      [
        -958.2969970703125,
        -2641.0,
        666.8751220703125
      ],
      [
        -957.76513671875,
        -2641.0,
        666.8751220703125
      ],
      [
        -958.2969970703125,
        -2641.0,
        666.8751220703125
      ],
      [
        -958.7737426757812,
        -2641.0,
        668.2752075195312
      ],
      [
        -972.0,
        -2641.0,
        692.579833984375
      ],
      [
        -972.0,
        -2641.0,
        725.420166015625
      ],
      [
        -972.3472290039062,
        -2641.0,
        735.4166259765625
      ],
      [
        -984.5794067382812,
        -2641.0,
        707.9124755859375
      ],
      [
        -984.5794067382812,
        -2641.0,
        707.9124755859375
      ],
      [
        -986.0614624023438,
        -2641.0,
        706.1533813476562
      ],
      [
        -989.3621826171875,
        -2650.0,
        705.541015625
      ],
      [
        -990.860595703125,
        -2650.0,
        709.5540771484375
      ],
      [
        -952.901611328125,
        -2641.0,
        668.0
      ],
      [
        -972.0,
        -2641.0,
        692.579833984375
      ],
      [
        -952.5738525390625,
        -2645.0,
        667.578125
      ],
      [
        -952.0276489257812,
        -2641.0,
        666.8751220703125
      ],
      [
        -972.0,
        -2641.0,
        725.420166015625
      ],
      [
        -952.901611328125,
        -2641.0,
        748.0
      ],
      [
        -952.901611328125,
        -2641.0,
        668.0
      ],
      [
        -932.0,
        -2641.0,
        668.0
      ],
      [
        -932.0,
        -2641.0,
        666.8751220703125
      ],
      [
        -952.901611328125,
        -2641.0,
        748.0
      ],
      [
        -932.0,
        -2641.0,
        748.0
      ],
      [
        -995.3317260742188,
        -2660.0,
        714.0372314453125
      ],
      [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      [
        -972.317626953125,
        -2656.699462890625,
        757.0
      ],
      [
        -972.0087280273438,
        -2660.0,
        672.4444580078125
      ],
      [
        -990.8366088867188,
        -2660.0,
        701.9979858398438
      ],
      [
        -990.8366088867188,
        -2660.0,
        701.9979858398438
      ],
      [
        -995.3317260742188,
        -2660.0,
        714.0372314453125
      ],
      [
        -972.317626953125,
        -2656.699462890625,
        757.0
      ],
      [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      [
        -973.61962890625,
        -2660.0,
        757.0
      ],
      [
        -953.8565673828125,
        -2660.0,
        779.0304565429688
      ],
      [
        -952.3867797851562,
        -2641.0,
        772.3142700195312
      ],
      [
        -956.9077758789062,
        -2641.0,
        767.2745971679688
      ],
      [
        -952.3867797851562,
        -2641.0,
        772.3142700195312
      ],
      [
        -953.8565673828125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2641.0,
        772.3142700195312
      ],
      [
        -940.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -934.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -940.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -934.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -934.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -934.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -956.9077758789062,
        -2641.0,
        767.2745971679688
      ],
      [
        -957.2064208984375,
        -2640.0,
        666.6993408203125
      ],
      [
        -957.76513671875,
        -2641.0,
        666.8751220703125
      ],
      [
        -972.0,
        -2640.914794921875,
        736.01611328125
      ],
      [
        -972.0,
        -2641.0,
        736.1331176757812
      ],
      [
        -951.8910522460938,
        -2640.0,
        666.6993408203125
      ],
      [
        -952.0276489257812,
        -2641.0,
        666.8751220703125
      ],
      [
        -961.88720703125,
        -2641.0,
        757.0
      ],
      [
        -961.2227783203125,
        -2640.0,
        757.0
      ],
      [
        -990.6512451171875,
        -2710.0,
        760.0
      ],
      [
        -1001.029541015625,
        -2710.0,
        748.4310302734375
      ],
      [
        -990.4483642578125,
        -2712.0,
        760.0
      ],
      [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      [
        -989.7916870117188,
        -2710.0,
        760.0
      ],
      [
        -990.0,
        -2710.0,
        759.7677612304688
      ],
      [
        -1000.169921875,
        -2710.0,
        748.4310302734375
      ],
      [
        -990.0,
        -2710.0,
        759.7677612304688
      ],
      [
        -957.3062744140625,
        -2712.0,
        795.468505859375
      ],
      [
        -970.0,
        -2712.0,
        780.0
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -970.0,
        -2712.0,
        782.79443359375
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -957.3062744140625,
        -2712.0,
        795.4685668945312
      ],
      [
        -957.2279663085938,
        -2710.0,
        795.0206909179688
      ],
      [
        -964.7109375,
        -2710.0,
        787.9583129882812
      ],
      [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      [
        -349.5162048339844,
        -2845.801025390625,
        718.0
      ],
      [
        -349.8541259765625,
        -2845.6787109375,
        718.0
      ],
      [
        -349.05755615234375,
        -2845.966796875,
        718.0
      ],
      [
        -349.05755615234375,
        -2845.966796875,
        718.0
      ],
      [
        -342.9244384765625,
        -2859.5,
        718.0
      ],
      [
        -508.307373046875,
        -2741.493896484375,
        718.0
      ],
      [
        -519.5042724609375,
        -2712.0,
        718.0
      ],
      [
        -485.8497314453125,
        -2802.005615234375,
        718.0
      ],
      [
        -508.307373046875,
        -2741.493896484375,
        718.0
      ],
      [
        -485.264404296875,
        -2802.19140625,
        718.0
      ],
      [
        -485.8497314453125,
        -2802.005615234375,
        718.0
      ],
      [
        -361.2165222167969,
        -2841.567626953125,
        718.0
      ],
      [
        -361.2165222167969,
        -2841.567626953125,
        718.0
      ],
      [
        -873.5,
        -2712.0,
        695.5555419921875
      ],
      [
        -863.1127319335938,
        -2762.5,
        718.0
      ],
      [
        -873.5,
        -2762.5,
        718.0
      ],
      [
        -871.5,
        -2830.819580078125,
        748.3642578125
      ],
      [
        -873.5,
        -2839.021728515625,
        752.0096435546875
      ],
      [
        -871.5,
        -2762.5,
        718.0
      ],
      [
        -871.5,
        -2781.199951171875,
        720.0
      ],
      [
        -873.5,
        -2775.0,
        723.555419921875
      ],
      [
        -871.5,
        -2781.199951171875,
        726.3109741210938
      ],
      [
        -873.5,
        -2854.677490234375,
        794.2353515625
      ],
      [
        -871.5,
        -2859.5,
        792.4702758789062
      ],
      [
        -871.5,
        -2788.75,
        784.2052612304688
      ],
      [
        -873.5,
        -2788.75,
        786.5337524414062
      ],
      [
        -873.5,
        -2775.0,
        784.9275512695312
      ],
      [
        -871.5,
        -2781.199951171875,
        792.0
      ],
      [
        -871.5,
        -2781.199951171875,
        783.3233032226562
      ],
      [
        -873.5,
        -2859.5,
        795.2313232421875
      ],
      [
        -873.5,
        -2854.677490234375,
        794.2353515625
      ],
      [
        -873.5,
        -2747.351318359375,
        776.0315551757812
      ],
      [
        -871.5,
        -2751.4150390625,
        774.7340087890625
      ],
      [
        -871.5,
        -2712.0,
        760.906494140625
      ],
      [
        -872.3709106445312,
        -2712.0,
        762.0923461914062
      ],
      [
        -873.5,
        -2715.5,
        764.8575439453125
      ],
      [
        -871.5,
        -2781.199951171875,
        782.2899780273438
      ],
      [
        -871.5,
        -2751.4150390625,
        774.7340087890625
      ],
      [
        -873.5,
        -2747.351318359375,
        776.0315551757812
      ],
      [
        -873.5,
        -2775.000244140625,
        783.045654296875
      ],
      [
        -873.5,
        -2754.5,
        721.0
      ],
      [
        -873.5,
        -2754.5,
        735.0
      ],
      [
        -871.5,
        -2713.5,
        720.0
      ],
      [
        -872.5,
        -2714.5,
        720.0
      ],
      [
        -872.5,
        -2712.400146484375,
        720.0
      ],
      [
        -872.3709106445312,
        -2712.0,
        720.0
      ],
      [
        -871.5,
        -2712.0,
        720.0
      ],
      [
        -871.5,
        -2859.5,
        784.7289428710938
      ],
      [
        -873.5,
        -2859.5,
        778.097412109375
      ],
      [
        -873.5,
        -2846.85400390625,
        763.2899169921875
      ],
      [
        -871.5,
        -2841.150634765625,
        763.2430419921875
      ],
      [
        -871.5,
        -2841.150634765625,
        763.2430419921875
      ],
      [
        -873.5,
        -2846.85400390625,
        763.2899169921875
      ],
      [
        -873.5,
        -2839.021728515625,
        752.0096435546875
      ],
      [
        -871.5,
        -2830.819580078125,
        748.3642578125
      ],
      [
        -873.5,
        -2788.75,
        786.5337524414062
      ],
      [
        -871.5,
        -2788.75,
        784.2052612304688
      ],
      [
        -873.5,
        -2712.0,
        763.6296997070312
      ],
      [
        -873.5,
        -2712.0,
        720.0
      ],
      [
        -359.81793212890625,
        -2859.5,
        1304.246337890625
      ],
      [
        -512.7351684570312,
        -2808.96240234375,
        1480.5965576171875
      ],
      [
        -514.8211669921875,
        -2803.052001953125,
        1480.5965576171875
      ],
      [
        -514.8677978515625,
        -2802.919921875,
        1480.5965576171875
      ],
      [
        -868.5,
        -2790.5,
        780.9170532226562
      ],
      [
        -871.5,
        -2781.199951171875,
        783.3233032226562
      ],
      [
        -862.2526245117188,
        -2784.78515625,
        727.904541015625
      ],
      [
        -871.5,
        -2826.99072265625,
        746.6625366210938
      ],
      [
        -868.5,
        -2790.5,
        730.4443359375
      ],
      [
        -871.5,
        -2781.199951171875,
        726.3109741210938
      ],
      [
        -869.0645141601562,
        -2788.75,
        781.3698120117188
      ],
      [
        -871.5,
        -2781.199951171875,
        782.2899780273438
      ],
      [
        -970.0,
        -2788.75,
        803.5133056640625
      ],
      [
        -970.0,
        -2718.603271484375,
        785.2112426757812
      ],
      [
        -1038.2408447265625,
        -2774.0,
        735.2599487304688
      ],
      [
        -1045.0,
        -2774.0,
        728.8806762695312
      ],
      [
        -1036.3973388671875,
        -2774.0,
        737.0
      ],
      [
        -1038.2408447265625,
        -2774.0,
        735.2599487304688
      ],
      [
        -1036.3973388671875,
        -2774.0,
        737.0
      ],
      [
        -1012.02734375,
        -2774.0,
        760.0
      ],
      [
        -1016.8873901367188,
        -2770.5,
        754.5
      ],
      [
        -1018.5,
        -2770.5,
        752.97802734375
      ],
      [
        -970.0,
        -2718.603271484375,
        785.2112426757812
      ],
      [
        -970.0,
        -2712.0,
        782.79443359375
      ],
      [
        -1032.8116455078125,
        -2774.0,
        735.46875
      ],
      [
        -1045.0,
        -2774.0,
        721.8819580078125
      ],
      [
        -1031.4378662109375,
        -2774.0,
        737.0
      ],
      [
        -1032.8116455078125,
        -2774.0,
        735.46875
      ],
      [
        -1031.4378662109375,
        -2774.0,
        737.0
      ],
      [
        -1010.80517578125,
        -2774.0,
        760.0
      ],
      [
        -1014.5899047851562,
        -2770.5,
        754.5
      ],
      [
        -1018.5,
        -2770.5,
        750.14111328125
      ],
      [
        -1008.0,
        -2765.456298828125,
        760.0
      ],
      [
        -1008.0,
        -2764.024169921875,
        759.475830078125
      ],
      [
        -970.0,
        -2788.75,
        803.5133056640625
      ],
      [
        -970.0,
        -2818.693115234375,
        804.289794921875
      ],
      [
        -970.0,
        -2818.693115234375,
        804.289794921875
      ],
      [
        -970.0,
        -2859.5,
        810.2523193359375
      ],
      [
        -1012.725341796875,
        -2774.0,
        736.2413330078125
      ],
      [
        -1007.9630737304688,
        -2774.0,
        720.0
      ],
      [
        -1012.9478759765625,
        -2774.0,
        737.0
      ],
      [
        -1012.725341796875,
        -2774.0,
        736.2413330078125
      ],
      [
        -1012.9478759765625,
        -2774.0,
        737.0
      ],
      [
        -1017.502685546875,
        -2774.0,
        752.5339965820312
      ],
      [
        -1018.5,
        -2770.5,
        749.953369140625
      ],
      [
        -1011.3297729492188,
        -2770.5,
        725.5
      ],
      [
        -1009.5757446289062,
        -2774.0,
        725.5
      ],
      [
        -1020.0,
        -2770.5,
        725.5
      ],
      [
        -1011.3297119140625,
        -2770.5,
        725.5
      ],
      [
        -1008.0,
        -2774.0,
        720.1260986328125
      ],
      [
        -1008.0,
        -2773.92626953125,
        720.0
      ],
      [
        -1012.0814208984375,
        -2769.0,
        725.5
      ],
      [
        -1013.224853515625,
        -2763.5,
        720.0
      ],
      [
        -1012.0814208984375,
        -2769.0,
        725.5
      ],
      [
        -1018.1138916015625,
        -2770.5,
        750.571533203125
      ],
      [
        -1009.5856323242188,
        -2770.5,
        725.5
      ],
      [
        -1011.5,
        -2774.0,
        736.2884521484375
      ],
      [
        -1005.9593505859375,
        -2774.0,
        720.0
      ],
      [
        -1011.7420654296875,
        -2774.0,
        737.0
      ],
      [
        -1011.5,
        -2774.0,
        736.2884521484375
      ],
      [
        -1011.7420654296875,
        -2774.0,
        737.0
      ],
      [
        -1017.1570434570312,
        -2774.0,
        752.9193115234375
      ],
      [
        -1008.0,
        -2773.66162109375,
        725.5
      ],
      [
        -1008.0,
        -2770.5,
        720.8386840820312
      ],
      [
        -1008.0,
        -2770.5,
        720.0
      ],
      [
        -1011.3297119140625,
        -2770.5,
        725.5
      ],
      [
        -1009.5856323242188,
        -2770.5,
        725.5
      ],
      [
        -1008.0,
        -2773.66162109375,
        725.5
      ],
      [
        -1009.5,
        -2774.0,
        730.4086303710938
      ],
      [
        -1009.5,
        -2770.670654296875,
        725.5
      ],
      [
        -1010.3379516601562,
        -2769.0,
        725.5
      ],
      [
        -1011.225341796875,
        -2763.5,
        720.0
      ],
      [
        -1010.3379516601562,
        -2769.0,
        725.5
      ],
      [
        -1008.0,
        -2769.93115234375,
        720.0
      ],
      [
        -970.0,
        -2831.384521484375,
        748.6153564453125
      ],
      [
        -970.0,
        -2859.5,
        761.111083984375
      ],
      [
        -970.0,
        -2831.384521484375,
        748.6153564453125
      ],
      [
        -990.0,
        -2767.0,
        720.0
      ],
      [
        -970.0,
        -2767.0,
        720.0
      ],
      [
        -1007.0177001953125,
        -2774.0,
        723.1112670898438
      ],
      [
        -993.0,
        -2774.0,
        723.111328125
      ],
      [
        -978.9999389648438,
        -2776.0,
        724.000244140625
      ],
      [
        -979.22216796875,
        -2774.0,
        723.111328125
      ],
      [
        -980.0,
        -2774.0,
        720.0
      ],
      [
        -980.0,
        -2766.99951171875,
        720.0
      ],
      [
        -1008.0,
        -2766.999755859375,
        720.0
      ],
      [
        -1008.0,
        -2771.196044921875,
        721.864990234375
      ],
      [
        -1009.5,
        -2770.670654296875,
        725.5
      ],
      [
        -1009.5856323242188,
        -2770.5,
        725.5
      ],
      [
        -1009.5,
        -2770.5,
        725.5
      ],
      [
        -1008.0,
        -2770.5,
        760.0
      ],
      [
        -1008.0,
        -2770.5,
        754.5
      ],
      [
        -1008.0,
        -2770.5,
        725.5
      ],
      [
        -1008.0,
        -2770.5,
        721.5556640625
      ],
      [
        -1008.0,
        -2770.5,
        725.5
      ],
      [
        -1008.0,
        -2766.0,
        760.0
      ],
      [
        -1008.0,
        -2766.0,
        757.5
      ],
      [
        -1008.0,
        -2766.0,
        722.5
      ],
      [
        -1008.0,
        -2766.0,
        720.0
      ],
      [
        -1010.8219604492188,
        -2766.0,
        722.5
      ],
      [
        -1008.0,
        -2766.0,
        722.5
      ],
      [
        -970.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -894.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -894.0,
        -2767.0,
        720.0
      ],
      [
        -894.0,
        -2767.0,
        720.0
      ],
      [
        -880.5184326171875,
        -2766.999755859375,
        720.0
      ],
      [
        -887.5,
        -2766.999755859375,
        720.0
      ],
      [
        -885.3666381835938,
        -2775.0,
        723.5556030273438
      ],
      [
        -894.0,
        -2788.75,
        810.4005737304688
      ],
      [
        -894.0,
        -2712.0,
        790.9302978515625
      ],
      [
        -894.0,
        -2859.5,
        824.5013427734375
      ],
      [
        -894.0,
        -2794.44287109375,
        811.0656127929688
      ],
      [
        -894.0,
        -2794.44287109375,
        811.0656127929688
      ],
      [
        -894.0,
        -2788.75,
        810.4005737304688
      ],
      [
        -884.5225219726562,
        -2724.955322265625,
        783.182861328125
      ],
      [
        -873.5,
        -2719.897216796875,
        766.4002075195312
      ],
      [
        -878.5,
        -2727.294921875,
        720.0
      ],
      [
        -878.5,
        -2712.0,
        720.0
      ],
      [
        -878.5,
        -2727.294921875,
        720.0
      ],
      [
        -878.5,
        -2762.8076171875,
        720.0
      ],
      [
        -878.5,
        -2715.5,
        720.0
      ],
      [
        -878.5,
        -2754.5,
        720.0
      ],
      [
        -932.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        812.65625
      ],
      [
        -932.0,
        -2712.0,
        795.468505859375
      ],
      [
        -914.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2854.642578125,
        831.205810546875
      ],
      [
        -932.0,
        -2859.5,
        832.5732421875
      ],
      [
        -932.0,
        -2854.642578125,
        831.205810546875
      ],
      [
        -932.0,
        -2836.284423828125,
        826.0377197265625
      ],
      [
        -932.0,
        -2836.284423828125,
        826.0377197265625
      ],
      [
        -932.0,
        -2788.75,
        812.65625
      ],
      [
        -928.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -918.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -918.0,
        -2853.0,
        830.743408203125
      ],
      [
        -918.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -928.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -928.0,
        -2853.0,
        830.743408203125
      ],
      [
        -919.0,
        -2844.0,
        828.2097778320312
      ],
      [
        -919.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -927.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -927.0,
        -2844.0,
        828.2097778320312
      ],
      [
        -919.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -927.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -944.0224609375,
        -2978.0,
        801.9602661132812
      ],
      [
        -912.0682983398438,
        -2978.0,
        802.6903076171875
      ],
      [
        -906.3569946289062,
        -2978.0,
        802.6903076171875
      ],
      [
        -912.0682983398438,
        -2978.0,
        802.6903076171875
      ],
      [
        -906.3569946289062,
        -2978.0,
        802.6903076171875
      ],
      [
        -905.461181640625,
        -2930.0,
        791.174072265625
      ],
      [
        -906.232177734375,
        -2978.0,
        802.8236694335938
      ],
      [
        -954.572998046875,
        -2978.0,
        817.5613403320312
      ],
      [
        -956.2754516601562,
        -2978.0,
        817.5243530273438
      ],
      [
        -891.4109497070312,
        -2978.0,
        816.8317260742188
      ],
      [
        -893.0887451171875,
        -2978.0,
        816.8629150390625
      ],
      [
        -944.0224609375,
        -2978.0,
        801.9602661132812
      ],
      [
        -954.572998046875,
        -2978.0,
        817.5613403320312
      ],
      [
        -893.0887451171875,
        -2978.0,
        816.8629150390625
      ],
      [
        -891.4109497070312,
        -2978.0,
        816.8317260742188
      ],
      [
        -890.2422485351562,
        -2930.0,
        794.19775390625
      ],
      [
        -890.8115234375,
        -2978.0,
        818.9483642578125
      ],
      [
        -890.463623046875,
        -2978.0,
        820.1769409179688
      ],
      [
        -890.463623046875,
        -2978.0,
        820.1769409179688
      ],
      [
        -892.9408569335938,
        -2978.0,
        838.7080078125
      ],
      [
        -892.9408569335938,
        -2978.0,
        838.7080078125
      ],
      [
        -893.0785522460938,
        -2978.0,
        841.7567138671875
      ],
      [
        -893.3917236328125,
        -2978.0,
        842.0806884765625
      ],
      [
        -893.377685546875,
        -2978.0,
        842.0687866210938
      ],
      [
        -893.0785522460938,
        -2978.0,
        841.7567138671875
      ],
      [
        -893.377685546875,
        -2978.0,
        842.0687866210938
      ],
      [
        -914.2279052734375,
        -2978.0,
        859.777587890625
      ],
      [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      [
        -934.7142944335938,
        -2978.0,
        859.526611328125
      ],
      [
        -957.5886840820312,
        -2978.0,
        841.4196166992188
      ],
      [
        -957.2632446289062,
        -2978.0,
        836.5609130859375
      ],
      [
        -891.6133422851562,
        -2978.0,
        828.77734375
      ],
      [
        -892.01171875,
        -2978.0,
        816.8428955078125
      ],
      [
        -893.0757446289062,
        -2978.058349609375,
        816.8919677734375
      ],
      [
        -893.0757446289062,
        -2978.058349609375,
        816.8919677734375
      ],
      [
        -891.8243408203125,
        -2980.69091796875,
        818.189697265625
      ],
      [
        -909.0305786132812,
        -2978.0,
        802.6903076171875
      ],
      [
        -946.2026977539062,
        -2978.0,
        805.1842041015625
      ],
      [
        -956.2836303710938,
        -2978.23388671875,
        817.6448364257812
      ],
      [
        -956.2008666992188,
        -2978.0,
        817.5260009765625
      ],
      [
        -943.5988159179688,
        -2978.0,
        801.969970703125
      ],
      [
        -943.3382568359375,
        -2978.0,
        801.9759521484375
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -7500.0,
        -4840.0,
        -400.0
      ],
      "bbox_max": [
        2500.0,
        7450.0,
        2300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33702352643013,
        -0.9296524524688721,
        0.14886711537837982
      ],
      "plane_d": 2046.6221923828125,
      "bbox_min": [
        -2776.024658203125,
        1138.48779296875,
        -360.6396484375
      ],
      "bbox_max": [
        -1286.81298828125,
        1685.8206787109375,
        -300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -6971.595703125,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        7012.392578125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6821.484375,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        7012.392578125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        7012.392578125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4221.82275390625,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        7012.392578125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895066857337952,
        -0.7432910799980164,
        0.3162282407283783
      ],
      "plane_d": 4052.218017578125,
      "bbox_min": [
        -4100.0,
        2110.39697265625,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        7012.392578125,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2708.39404296875,
        6871.484375,
        -22.699951171875
      ],
      "bbox_max": [
        -2000.0,
        7012.392578125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -2669.724609375,
        3350.0,
        0.0
      ],
      "bbox_max": [
        -2613.806396484375,
        3398.1728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -4221.82275390625,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        3469.92919921875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -4221.82275390625,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3988.3173828125,
        2200.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -4221.82275390625,
        2100.0,
        0.0
      ],
      "bbox_max": [
        -4088.928466796875,
        2200.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -6971.595703125,
        2100.0,
        150.0
      ],
      "bbox_max": [
        -2000.0,
        7012.392578125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6971.595703125,
        2100.0,
        150.0
      ],
      "bbox_max": [
        -2000.0,
        7012.392578125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        2699.5234375,
        1584.5428466796875
      ],
      "bbox_max": [
        -6764.20263671875,
        2921.382080078125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -6860.8203125,
        2100.0,
        150.0
      ],
      "bbox_max": [
        -2000.0,
        7012.392578125,
        1640.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2708.39404296875,
        6871.484375,
        150.0
      ],
      "bbox_max": [
        -2000.0,
        7012.392578125,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -5016.3955078125,
        2100.0,
        150.0
      ],
      "bbox_max": [
        -4211.51220703125,
        2193.126708984375,
        1045.7587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -5016.3955078125,
        2100.0,
        1000.0
      ],
      "bbox_max": [
        -4912.15185546875,
        2154.178466796875,
        1045.7587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600968956947327,
        0.260924369096756,
        0.10065929591655731
      ],
      "plane_d": 4053.40478515625,
      "bbox_min": [
        -4912.326171875,
        2100.0,
        987.7515258789062
      ],
      "bbox_max": [
        -4896.1435546875,
        2154.178466796875,
        1007.55322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -4912.326171875,
        2100.0,
        1000.0
      ],
      "bbox_max": [
        -4904.1279296875,
        2154.178466796875,
        1007.55322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6561.474609375,
        -2619.10009765625,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        2100.0,
        1612.981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600968956947327,
        0.260924369096756,
        0.10065929591655731
      ],
      "plane_d": 4053.40478515625,
      "bbox_min": [
        -4897.6552734375,
        -2323.554931640625,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        2100.0,
        1179.126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -4088.928466796875,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3509.2900390625,
        2100.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        -2906.989501953125,
        -1095.0159912109375,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        1480.2916259765625,
        445.2428894042969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33702352643013,
        -0.9296524524688721,
        0.14886711537837982
      ],
      "plane_d": 2046.6221923828125,
      "bbox_min": [
        -2827.890380859375,
        -1095.0159912109375,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        1480.2916259765625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1034676656126976,
        -0.8884226083755493,
        0.44721338152885437
      ],
      "plane_d": -1140.5770263671875,
      "bbox_min": [
        -2749.31689453125,
        -978.381591796875,
        0.0
      ],
      "bbox_max": [
        -2595.50048828125,
        -917.86865234375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4976885914802551,
        -0.8076545596122742,
        0.31622782349586487
      ],
      "plane_d": 447.54583740234375,
      "bbox_min": [
        -2653.8955078125,
        -1095.0159912109375,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        -619.568359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4692252576351166,
        -0.76146399974823,
        0.4472138583660126
      ],
      "plane_d": 421.9500732421875,
      "bbox_min": [
        -2653.8955078125,
        -1095.0159912109375,
        -300.0
      ],
      "bbox_max": [
        -2000.0,
        -619.568359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10974399000406265,
        -0.9423143267631531,
        0.3162277042865753
      ],
      "plane_d": -1209.764404296875,
      "bbox_min": [
        -2653.8955078125,
        -1095.0159912109375,
        -300.0
      ],
      "bbox_max": [
        -2485.635009765625,
        -931.20703125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1034676656126976,
        -0.8884226083755493,
        0.44721338152885437
      ],
      "plane_d": -1140.5770263671875,
      "bbox_min": [
        -2622.662353515625,
        -991.6719970703125,
        0.0
      ],
      "bbox_max": [
        -2508.544921875,
        -931.20703125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6531122922897339,
        -0.7377828359603882,
        0.17064858973026276
      ],
      "plane_d": 991.0599365234375,
      "bbox_min": [
        -2809.60791015625,
        -952.93505859375,
        99.99998474121094
      ],
      "bbox_max": [
        -2000.0,
        1425.00634765625,
        445.2428894042969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33702352643013,
        -0.9296524524688721,
        0.14886711537837982
      ],
      "plane_d": 2046.6221923828125,
      "bbox_min": [
        -2809.60791015625,
        1203.6826171875,
        99.99998474121094
      ],
      "bbox_max": [
        -2186.04443359375,
        1425.00634765625,
        354.5347595214844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600968956947327,
        0.260924369096756,
        0.10065929591655731
      ],
      "plane_d": 4053.40478515625,
      "bbox_min": [
        -4897.80810546875,
        -2329.13720703125,
        24.057861328125
      ],
      "bbox_max": [
        -2000.0,
        2100.0,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33702352643013,
        -0.9296524524688721,
        0.14886711537837982
      ],
      "plane_d": 2046.6221923828125,
      "bbox_min": [
        -2821.223876953125,
        -634.7899780273438,
        24.057861328125
      ],
      "bbox_max": [
        -2000.0,
        1569.464599609375,
        580.9298706054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6531122922897339,
        -0.7377828359603882,
        0.17064858973026276
      ],
      "plane_d": 991.0599365234375,
      "bbox_min": [
        -2350.862548828125,
        -634.7899780273438,
        278.82159423828125
      ],
      "bbox_max": [
        -2000.0,
        -324.193603515625,
        445.2428894042969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        1720.0,
        -3885.78955078125,
        0.0
      ],
      "bbox_max": [
        2500.0,
        -2646.0,
        1717.0206298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155784845352173,
        -0.4009268581867218,
        0.03120390884578228
      ],
      "plane_d": 474.5984191894531,
      "bbox_min": [
        1720.0,
        -3810.277587890625,
        0.0
      ],
      "bbox_max": [
        2026.580078125,
        -2720.0,
        1717.0206298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9081138372421265,
        -0.4138675034046173,
        0.0635838732123375
      ],
      "plane_d": 379.5241394042969,
      "bbox_min": [
        1844.31591796875,
        -3297.8095703125,
        1156.7398681640625
      ],
      "bbox_max": [
        2026.580078125,
        -2923.53076171875,
        1684.15185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659723997116089,
        0.49964767694473267,
        0.02107161097228527
      ],
      "plane_d": 3356.937255859375,
      "bbox_min": [
        1844.31591796875,
        -3297.8095703125,
        1156.7398681640625
      ],
      "bbox_max": [
        2026.580078125,
        -2923.53076171875,
        1684.15185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        2016.6920166015625,
        -3293.0791015625,
        1652.26123046875
      ],
      "bbox_max": [
        2026.580078125,
        -3275.88916015625,
        1653.050537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8943387866020203,
        -0.44703900814056396,
        0.017724694684147835
      ],
      "plane_d": 318.7131652832031,
      "bbox_min": [
        1844.31591796875,
        -3293.192138671875,
        1342.6407470703125
      ],
      "bbox_max": [
        2026.580078125,
        -2923.53076171875,
        1684.15185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        2015.8232421875,
        -3293.192138671875,
        1637.4736328125
      ],
      "bbox_max": [
        2026.580078125,
        -3275.88916015625,
        1652.70556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        2015.8232421875,
        -3293.0458984375,
        1641.2861328125
      ],
      "bbox_max": [
        2026.580078125,
        -3275.88916015625,
        1652.70556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        1720.0,
        -3810.277587890625,
        0.0
      ],
      "bbox_max": [
        2016.71826171875,
        -2720.0,
        1717.0206298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9081138372421265,
        -0.4138675034046173,
        0.0635838732123375
      ],
      "plane_d": 379.5241394042969,
      "bbox_min": [
        1754.619140625,
        -3297.8095703125,
        1156.7398681640625
      ],
      "bbox_max": [
        2016.71826171875,
        -2750.126220703125,
        1703.96142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        2014.762939453125,
        -3296.4345703125,
        1652.70556640625
      ],
      "bbox_max": [
        2016.71826171875,
        -3293.0458984375,
        1653.20458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        2013.76904296875,
        -3296.444580078125,
        1634.694091796875
      ],
      "bbox_max": [
        2016.6920166015625,
        -3291.95068359375,
        1652.7911376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        2013.76904296875,
        -3296.444580078125,
        1634.694091796875
      ],
      "bbox_max": [
        2016.23681640625,
        -3291.95068359375,
        1641.2861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8598151206970215,
        0.5105383396148682,
        0.008278584107756615
      ],
      "plane_d": 3395.324462890625,
      "bbox_min": [
        1720.0,
        -3810.277587890625,
        0.0
      ],
      "bbox_max": [
        2014.793212890625,
        -2720.0,
        1717.0206298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660708069801331,
        0.49953848123550415,
        0.019560152664780617
      ],
      "plane_d": 3358.522216796875,
      "bbox_min": [
        1720.0,
        -3810.277587890625,
        567.5963134765625
      ],
      "bbox_max": [
        2014.793212890625,
        -3295.01806640625,
        1676.798583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659723997116089,
        0.49964767694473267,
        0.02107161097228527
      ],
      "plane_d": 3356.937255859375,
      "bbox_min": [
        1720.0,
        -3810.277587890625,
        1156.7398681640625
      ],
      "bbox_max": [
        2014.793212890625,
        -3295.5869140625,
        1676.798583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1720.0,
        -3810.277587890625,
        1652.791259765625
      ],
      "bbox_max": [
        2014.793212890625,
        -3296.392822265625,
        1676.798583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1720.0,
        -3807.822509765625,
        1213.9456787109375
      ],
      "bbox_max": [
        2014.7630615234375,
        -3295.5869140625,
        1665.9896240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1720.0,
        -3807.822509765625,
        1644.8177490234375
      ],
      "bbox_max": [
        2014.7630615234375,
        -3295.5869140625,
        1665.9896240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1720.0,
        -3806.162109375,
        1213.9671630859375
      ],
      "bbox_max": [
        2014.1802978515625,
        -3295.01806640625,
        1658.6788330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8477191925048828,
        0.52967768907547,
        0.02852289006114006
      ],
      "plane_d": 3434.6318359375,
      "bbox_min": [
        1720.0,
        -3778.70361328125,
        0.0
      ],
      "bbox_max": [
        1974.96875,
        -2720.0,
        1717.0206298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1720.0,
        -3778.70361328125,
        0.0
      ],
      "bbox_max": [
        1974.96875,
        -2720.0,
        1717.0206298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8139365315437317,
        0.49027109146118164,
        0.3116752505302429
      ],
      "plane_d": 3230.79345703125,
      "bbox_min": [
        1765.005859375,
        -3659.5888671875,
        0.0
      ],
      "bbox_max": [
        1974.96875,
        -3324.7158203125,
        21.55415916442871
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -2000.0,
        -2040.0,
        -300.0
      ],
      "bbox_max": [
        200.0,
        7450.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2000.0,
        -795.7606811523438,
        -300.0
      ],
      "bbox_max": [
        200.0,
        7450.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33702352643013,
        -0.9296524524688721,
        0.14886711537837982
      ],
      "plane_d": 2046.6221923828125,
      "bbox_min": [
        -2000.0,
        -795.7606811523438,
        -300.0
      ],
      "bbox_max": [
        -1289.92431640625,
        1728.280029296875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4976885914802551,
        -0.8076545596122742,
        0.31622782349586487
      ],
      "plane_d": 447.54583740234375,
      "bbox_min": [
        -2000.0,
        -795.7606811523438,
        -300.0
      ],
      "bbox_max": [
        -1822.041748046875,
        -612.2042846679688,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -270.0,
        -2040.0,
        0.0
      ],
      "bbox_max": [
        200.0,
        7450.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -175.0777130126953,
        -2040.0,
        642.3978271484375
      ],
      "bbox_max": [
        109.02577209472656,
        -1865.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9814715385437012,
        0.1916080117225647
      ],
      "plane_d": -2147.4345703125,
      "bbox_min": [
        -129.0784454345703,
        -2040.0,
        642.3978271484375
      ],
      "bbox_max": [
        109.02577209472656,
        -1946.1995849609375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        -51.42585754394531,
        -2040.0,
        642.3978271484375
      ],
      "bbox_max": [
        109.02577209472656,
        -1977.1312255859375,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -129.0784454345703,
        -2040.0,
        645.19873046875
      ],
      "bbox_max": [
        76.70938873291016,
        -1946.1995849609375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -118.56555938720703,
        -2040.0,
        645.19873046875
      ],
      "bbox_max": [
        76.70938873291016,
        -1950.38720703125,
        813.3817138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -118.56555938720703,
        -2005.0113525390625,
        676.5404052734375
      ],
      "bbox_max": [
        5.3979034423828125,
        -1950.38720703125,
        813.3817138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -118.56555938720703,
        -1977.1312255859375,
        713.1172485351562
      ],
      "bbox_max": [
        -51.42585754394531,
        -1950.38720703125,
        813.3817138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.440481036901474,
        -0.8977619409561157,
        0.0
      ],
      "plane_d": -1797.645263671875,
      "bbox_min": [
        -51.42585754394531,
        -2040.0,
        757.9674682617188
      ],
      "bbox_max": [
        80.18003845214844,
        -1977.1312255859375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -175.0777130126953,
        -1977.1312255859375,
        862.9803466796875
      ],
      "bbox_max": [
        -51.42585754394531,
        -1927.8765869140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -270.0,
        -2040.0,
        150.0
      ],
      "bbox_max": [
        -97.80717468261719,
        4972.50830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -270.0,
        -1929.899169921875,
        150.0
      ],
      "bbox_max": [
        -170.0,
        4972.50830078125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -194.8513946533203,
        -1929.899169921875,
        754.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -194.8513946533203,
        -1924.322509765625,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1926385760307312,
        -0.9812697768211365,
        0.0
      ],
      "plane_d": -1914.5927734375,
      "bbox_min": [
        -270.0,
        -2040.0,
        635.0
      ],
      "bbox_max": [
        -97.80717468261719,
        -1898.1326904296875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -270.0,
        -2040.0,
        635.0
      ],
      "bbox_max": [
        -97.80717468261719,
        -1898.1326904296875,
        855.9585571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02143726870417595,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -270.0,
        -2019.9259033203125,
        635.0
      ],
      "bbox_max": [
        -170.0,
        -1898.1326904296875,
        855.9585571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -270.0,
        -2010.7760009765625,
        635.0
      ],
      "bbox_max": [
        -170.0,
        -1916.2109375,
        823.991943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -270.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -195.0,
        -1952.397216796875,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1952.634033203125,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -198.0,
        -1952.634033203125,
        754.0
      ],
      "bbox_max": [
        -198.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -270.0,
        -2010.7760009765625,
        656.7780151367188
      ],
      "bbox_max": [
        -219.687744140625,
        -1947.274658203125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -270.0,
        -2000.6131591796875,
        671.219970703125
      ],
      "bbox_max": [
        -219.687744140625,
        -1947.274658203125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -270.0,
        -1949.5728759765625,
        765.0
      ],
      "bbox_max": [
        -245.41355895996094,
        -1947.274658203125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -270.0,
        -2019.9259033203125,
        645.8472900390625
      ],
      "bbox_max": [
        -219.687744140625,
        -1948.448486328125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -270.0,
        -2019.9259033203125,
        645.8472900390625
      ],
      "bbox_max": [
        -224.35804748535156,
        -1948.448486328125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -270.0,
        -2019.9259033203125,
        645.8472900390625
      ],
      "bbox_max": [
        -261.9692077636719,
        -2018.4642333984375,
        645.87548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -270.0,
        -2040.0,
        640.130615234375
      ],
      "bbox_max": [
        -97.80717468261719,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -99.61474609375,
        -1969.414794921875,
        711.2978515625
      ],
      "bbox_max": [
        -98.47756958007812,
        -1968.943359375,
        713.1172485351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -99.61474609375,
        -1969.414794921875,
        711.2978515625
      ],
      "bbox_max": [
        -98.47756958007812,
        -1968.943359375,
        711.7363891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -270.0,
        -2040.0,
        640.130615234375
      ],
      "bbox_max": [
        -97.80717468261719,
        -1944.15771484375,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -270.0,
        -2040.0,
        640.130615234375
      ],
      "bbox_max": [
        -97.80717468261719,
        -1968.943359375,
        711.7363891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -195.0,
        -2033.1204833984375,
        666.0718383789062
      ],
      "bbox_max": [
        -97.80717468261719,
        -1968.943359375,
        711.7363891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        692.1471557617188
      ],
      "bbox_max": [
        -187.0,
        -1980.299072265625,
        705.0189819335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        692.1471557617188
      ],
      "bbox_max": [
        -187.0,
        -1987.0,
        700.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -270.0,
        -2040.0,
        640.130615234375
      ],
      "bbox_max": [
        -106.350830078125,
        -1983.23779296875,
        703.2808227539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -270.0,
        -2040.0,
        645.774169921875
      ],
      "bbox_max": [
        -217.74951171875,
        -1983.23779296875,
        703.2808227539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -270.0,
        -2040.0,
        645.774169921875
      ],
      "bbox_max": [
        -217.74951171875,
        -2019.27587890625,
        646.001708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -270.0,
        -2032.0,
        700.22021484375
      ],
      "bbox_max": [
        -170.0,
        -1944.15771484375,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -270.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -180.0,
        -2032.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -198.0,
        -2014.0,
        700.22021484375
      ],
      "bbox_max": [
        -184.0,
        -1946.367919921875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -198.0,
        -2014.0,
        700.22021484375
      ],
      "bbox_max": [
        -184.0,
        -1951.5289306640625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -198.0,
        -1987.0,
        700.3240966796875
      ],
      "bbox_max": [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1952.397216796875,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.41665470600128174,
        -0.9090648293495178
      ],
      "plane_d": -143.7080078125,
      "bbox_min": [
        -198.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1990.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1987.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -2000.0,
        -2040.0,
        0.0
      ],
      "bbox_max": [
        -270.0,
        7356.51123046875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2000.0,
        -678.2991943359375,
        0.0
      ],
      "bbox_max": [
        -270.0,
        7356.51123046875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        -2000.0,
        -678.2991943359375,
        0.0
      ],
      "bbox_max": [
        -1250.0,
        3548.820068359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7399791479110718,
        -0.5024248361587524,
        0.447213739156723
      ],
      "plane_d": 1093.001953125,
      "bbox_min": [
        -2000.0,
        -678.2991943359375,
        0.0
      ],
      "bbox_max": [
        -1250.0,
        3532.546630859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -2000.0,
        -678.2991943359375,
        0.0
      ],
      "bbox_max": [
        -1250.0,
        3532.546630859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6531122922897339,
        -0.7377828359603882,
        0.17064858973026276
      ],
      "plane_d": 991.0599365234375,
      "bbox_min": [
        -2000.0,
        -678.2991943359375,
        0.0
      ],
      "bbox_max": [
        -1790.20556640625,
        -219.5267333984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4692252576351166,
        -0.76146399974823,
        0.4472138583660126
      ],
      "plane_d": 421.9500732421875,
      "bbox_min": [
        -2000.0,
        -678.2991943359375,
        0.0
      ],
      "bbox_max": [
        -1892.740478515625,
        -575.2562866210938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -2000.0,
        -404.04803466796875,
        100.0
      ],
      "bbox_max": [
        -1259.1229248046875,
        3548.820068359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6531122922897339,
        -0.7377828359603882,
        0.17064858973026276
      ],
      "plane_d": 991.0599365234375,
      "bbox_min": [
        -2000.0,
        -404.04803466796875,
        100.0
      ],
      "bbox_max": [
        -1791.55712890625,
        -213.04283142089844,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2000.0,
        -2040.0,
        150.0
      ],
      "bbox_max": [
        -270.0,
        7356.51123046875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33702352643013,
        -0.9296524524688721,
        0.14886711537837982
      ],
      "plane_d": 2046.6221923828125,
      "bbox_min": [
        -2000.0,
        -2040.0,
        150.0
      ],
      "bbox_max": [
        -270.0,
        1810.499755859375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -528.131103515625,
        -2040.0,
        635.0
      ],
      "bbox_max": [
        -270.0,
        -1840.3223876953125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -495.131103515625,
        -1978.3544921875,
        766.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1840.3223876953125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        766.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1840.3223876953125,
        975.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        912.0
      ],
      "bbox_max": [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      "bbox_max": [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        872.4356079101562
      ],
      "bbox_max": [
        -321.2057189941406,
        -1858.298095703125,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        872.4356079101562
      ],
      "bbox_max": [
        -421.8410339355469,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1926385760307312,
        -0.9812697768211365,
        0.0
      ],
      "plane_d": -1914.5927734375,
      "bbox_min": [
        -528.131103515625,
        -2040.0,
        635.0
      ],
      "bbox_max": [
        -270.0,
        -1859.9444580078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9128968119621277,
        0.3866746425628662,
        0.13077570497989655
      ],
      "plane_d": 297.8227844238281,
      "bbox_min": [
        -341.40447998046875,
        -1885.7939453125,
        910.334716796875
      ],
      "bbox_max": [
        -321.9030456542969,
        -1859.9444580078125,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.160947784781456,
        -0.9869629144668579,
        0.0
      ],
      "plane_d": -1824.285400390625,
      "bbox_min": [
        -528.131103515625,
        -2040.0,
        635.0
      ],
      "bbox_max": [
        -270.0,
        -1884.114990234375,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9128968119621277,
        0.3866746425628662,
        0.13077570497989655
      ],
      "plane_d": 297.8227844238281,
      "bbox_min": [
        -348.0,
        -1903.9371337890625,
        895.0
      ],
      "bbox_max": [
        -332.8520812988281,
        -1884.114990234375,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -528.131103515625,
        -2040.0,
        635.0
      ],
      "bbox_max": [
        -270.0,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.6494445800781,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -270.0,
        -1920.0,
        845.7947387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1939.0,
        754.0
      ],
      "bbox_max": [
        -270.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1939.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1939.0,
        754.0
      ],
      "bbox_max": [
        -286.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -274.3614196777344,
        -1939.0,
        832.452392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1953.6666259765625,
        778.7999267578125
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        802.4317016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -417.9999694824219,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -274.3614196777344,
        -1939.0,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -274.3614196777344,
        -1939.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -283.0,
        -1940.9720458984375,
        754.0
      ],
      "bbox_max": [
        -274.3614196777344,
        -1939.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -417.9999694824219,
        -1950.0,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1939.0,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -300.0,
        -1941.6568603515625,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1939.0,
        767.5780029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1941.6568603515625,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1939.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1940.1112060546875,
        765.0
      ],
      "bbox_max": [
        -295.13226318359375,
        -1939.0,
        767.5780029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1940.1112060546875,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1939.0,
        767.5780029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1960.1864013671875,
        766.0
      ],
      "bbox_max": [
        -408.3056640625,
        -1945.875,
        816.5028076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1960.1864013671875,
        766.0
      ],
      "bbox_max": [
        -408.3056640625,
        -1950.0,
        806.93310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1960.1864013671875,
        778.7999267578125
      ],
      "bbox_max": [
        -408.3056640625,
        -1953.6666259765625,
        793.92529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1960.1864013671875,
        778.7999267578125
      ],
      "bbox_max": [
        -408.3056640625,
        -1953.6666259765625,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4577594995498657,
        -0.8173955082893372,
        0.3497438430786133
      ],
      "plane_d": -1698.0321044921875,
      "bbox_min": [
        -528.131103515625,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -528.131103515625,
        -2040.0,
        716.4224243164062
      ],
      "bbox_max": [
        -366.15057373046875,
        -1912.418212890625,
        898.088134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.476491779088974,
        -0.7905871868133545,
        0.3846135139465332
      ],
      "plane_d": -1664.8924560546875,
      "bbox_min": [
        -528.131103515625,
        -2000.3544921875,
        778.7999267578125
      ],
      "bbox_max": [
        -366.15057373046875,
        -1912.418212890625,
        898.088134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47970375418663025,
        -0.768060028553009,
        0.42422646284103394
      ],
      "plane_d": -1652.64599609375,
      "bbox_min": [
        -528.131103515625,
        -2000.3544921875,
        778.7999267578125
      ],
      "bbox_max": [
        -370.3376159667969,
        -1912.418212890625,
        886.599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -433.5278625488281,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -370.3376159667969,
        -1935.76611328125,
        881.0454711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -370.3376159667969,
        -1950.21923828125,
        788.1213989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -406.8780822753906,
        -1972.0,
        788.1213989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -433.5278625488281,
        -1950.0,
        802.4315795898438
      ],
      "bbox_max": [
        -414.0,
        -1935.76611328125,
        881.0454711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        802.4315795898438
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        842.9549560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.5278625488281,
        -1939.0,
        832.452392578125
      ],
      "bbox_max": [
        -422.5,
        -1935.76611328125,
        881.0454711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1939.0,
        832.452392578125
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        871.35107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703570008277893,
        -0.7688688039779663,
        0.433133989572525
      ],
      "plane_d": -1666.133544921875,
      "bbox_min": [
        -435.970703125,
        -1950.0,
        833.3430786132812
      ],
      "bbox_max": [
        -379.3594665527344,
        -1912.418212890625,
        886.599853515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -435.970703125,
        -1950.0,
        833.3430786132812
      ],
      "bbox_max": [
        -414.0,
        -1935.8153076171875,
        881.0971069335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.4741516113281,
        -1939.0,
        871.35107421875
      ],
      "bbox_max": [
        -430.0,
        -1935.8153076171875,
        881.0971069335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1945.1715087890625,
        851.6968383789062
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        863.5264282226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        833.3430786132812
      ],
      "bbox_max": [
        -414.0,
        -1942.0531005859375,
        858.1068115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -435.970703125,
        -1949.5487060546875,
        844.8013916015625
      ],
      "bbox_max": [
        -422.5,
        -1935.8154296875,
        886.599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1939.0,
        863.5264282226562
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        875.7760620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        880.6350708007812
      ],
      "bbox_max": [
        -433.3038330078125,
        -1935.9715576171875,
        886.2142333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -435.841552734375,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -366.15057373046875,
        -1926.0169677734375,
        898.088134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -414.0011291503906,
        -1968.8211669921875,
        778.7999267578125
      ],
      "bbox_max": [
        -366.15057373046875,
        -1926.0169677734375,
        843.802490234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0011291503906,
        -1968.8211669921875,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1944.9122314453125,
        843.802490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -414.0011291503906,
        -1950.0,
        818.3564453125
      ],
      "bbox_max": [
        -398.885498046875,
        -1944.9122314453125,
        843.802490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -435.841552734375,
        -1950.0,
        833.3430786132812
      ],
      "bbox_max": [
        -414.0,
        -1935.8231201171875,
        898.088134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        833.3430786132812
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        850.6632080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -435.841552734375,
        -1939.0,
        866.4844360351562
      ],
      "bbox_max": [
        -422.5,
        -1935.8231201171875,
        898.088134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -435.841552734375,
        -1939.0,
        875.7760620117188
      ],
      "bbox_max": [
        -430.0,
        -1935.8231201171875,
        898.088134765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.841552734375,
        -1937.4427490234375,
        886.0942993164062
      ],
      "bbox_max": [
        -433.3038330078125,
        -1935.9715576171875,
        897.5899658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -483.21807861328125,
        -2040.0,
        716.4224243164062
      ],
      "bbox_max": [
        -468.130615234375,
        -2032.99267578125,
        719.4412231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -300.0,
        -1987.0,
        642.9817504882812
      ],
      "bbox_max": [
        -270.0,
        -1895.00830078125,
        862.176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02143726870417595,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -300.0,
        -1987.0,
        647.2184448242188
      ],
      "bbox_max": [
        -270.0,
        -1895.00830078125,
        862.176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -300.0,
        -1987.0,
        647.2184448242188
      ],
      "bbox_max": [
        -270.0,
        -1933.2628173828125,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -283.0,
        -1952.9293212890625,
        754.0
      ],
      "bbox_max": [
        -270.0,
        -1933.2628173828125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -283.0,
        -1952.9293212890625,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1938.4609375,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1952.172119140625,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1936.23046875,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1945.20947265625,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1937.9560546875,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1952.172119140625,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1936.915283203125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1952.172119140625,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1940.9720458984375,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015454292297363,
        -0.8651313185691833,
        0.0
      ],
      "plane_d": -1457.548095703125,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1903.9140625,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -433.44818115234375,
        -1935.9715576171875,
        897.5899047851562
      ],
      "bbox_max": [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.427001953125,
        -1935.9715576171875,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794841408729553,
        -0.8249640464782715,
        0.4013371765613556
      ],
      "plane_d": -1778.3809814453125,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1903.9140625,
        975.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -414.0,
        -1972.0,
        710.3526000976562
      ],
      "bbox_max": [
        -334.72802734375,
        -1939.505859375,
        804.3275146484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1950.787353515625,
        788.1213989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -404.59893798828125,
        -1972.0,
        788.1213989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -375.3878479003906,
        -1957.9090576171875,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1954.001220703125,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1903.9140625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1903.9140625,
        975.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -433.3038635253906,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -270.0,
        -1903.9140625,
        975.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -414.0,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -270.0,
        -1903.9140625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1938.9998779296875,
      "bbox_min": [
        -414.0,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -270.0,
        -1939.0,
        912.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -404.59893798828125,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -270.0,
        -1942.57666015625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -404.59893798828125,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1942.57666015625,
        778.7999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1942.57666015625,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -335.0843811035156,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -272.0,
        -1946.1732177734375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1972.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1951.965576171875,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -335.0843811035156,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -330.7213439941406,
        -1971.594482421875,
        710.3526000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -335.0843811035156,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -334.4937744140625,
        -1971.594482421875,
        710.3526000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9128968119621277,
        0.3866746425628662,
        0.13077570497989655
      ],
      "plane_d": 297.8227844238281,
      "bbox_min": [
        -340.66888427734375,
        -1904.0469970703125,
        974.0792236328125
      ],
      "bbox_max": [
        -340.5271911621094,
        -1903.9140625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -433.3038635253906,
        -1950.0,
        839.5380859375
      ],
      "bbox_max": [
        -414.0,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -433.3038635253906,
        -1950.0,
        850.6632080078125
      ],
      "bbox_max": [
        -414.0,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -422.5,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -414.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -422.5,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -414.0,
        -1939.0,
        912.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        876.37158203125
      ],
      "bbox_max": [
        -422.5,
        -1929.7083740234375,
        927.2045288085938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -422.5,
        -1929.7083740234375,
        927.2045288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1934.0562744140625,
        920.089599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        687.8589477539062
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        703.777099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        687.8589477539062
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        692.035400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -300.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -270.0,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -300.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -290.0,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -366.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        2.303213477716781e-06,
        -8.291568519780412e-06,
        -1.0
      ],
      "plane_d": 778.7843627929688,
      "bbox_min": [
        -366.0,
        -1987.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.5547002553939819,
        0.0
      ],
      "plane_d": -1398.3994140625,
      "bbox_min": [
        -366.0,
        -1987.0,
        778.7999877929688
      ],
      "bbox_max": [
        -356.0,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 768.4999389648438,
      "bbox_min": [
        -325.0,
        -1987.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -325.0,
      "bbox_min": [
        -325.0,
        -1987.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1972.0,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1978.400146484375,
      "bbox_min": [
        -325.0,
        -1986.60009765625,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1972.0,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1168.1405029296875,
      "bbox_min": [
        -325.0,
        -1978.400146484375,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1972.0,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -324.0,
      "bbox_min": [
        -324.0,
        -1978.400146484375,
        770.0
      ],
      "bbox_max": [
        -324.0,
        -1977.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -324.0,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1985.60009765625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1986.60009765625,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1986.60009765625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 768.4999389648438,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1987.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1634.8309326171875,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1987.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1972.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        691.2600708007812
      ],
      "bbox_max": [
        -272.0,
        -1972.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1972.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1972.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1972.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        642.4253540039062
      ],
      "bbox_max": [
        -270.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -309.987548828125,
        -2040.0,
        645.7384643554688
      ],
      "bbox_max": [
        -270.0,
        -2014.4228515625,
        647.5409545898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -309.987548828125,
        -2040.0,
        645.7384643554688
      ],
      "bbox_max": [
        -281.07293701171875,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        644.4969482421875
      ],
      "bbox_max": [
        -270.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.41665470600128174,
        -0.9090648293495178
      ],
      "plane_d": -143.7080078125,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        644.4969482421875
      ],
      "bbox_max": [
        -272.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1990.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1987.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        644.4969482421875
      ],
      "bbox_max": [
        -294.20599365234375,
        -2014.4228515625,
        719.0380249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -309.987548828125,
        -2040.0,
        645.7384643554688
      ],
      "bbox_max": [
        -294.20599365234375,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        699.1410522460938
      ],
      "bbox_max": [
        -456.49090576171875,
        -2032.99267578125,
        719.0380249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -482.6417236328125,
        -2040.0,
        711.021728515625
      ],
      "bbox_max": [
        -468.130615234375,
        -2032.99267578125,
        719.0380249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6731522679328918,
        -0.137336865067482,
        0.7266392707824707
      ],
      "plane_d": -1296.7210693359375,
      "bbox_min": [
        -1049.821533203125,
        -2040.0,
        150.4525146484375
      ],
      "bbox_max": [
        -503.4736328125,
        -1959.4697265625,
        871.233154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25237345695495605,
        -0.9668518304824829,
        0.03879788890480995
      ],
      "plane_d": -2228.79150390625,
      "bbox_min": [
        -1049.821533203125,
        -2040.0,
        150.4525146484375
      ],
      "bbox_max": [
        -503.4736328125,
        -1959.4697265625,
        871.233154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -636.3113403320312,
        -2040.0,
        745.6981811523438
      ],
      "bbox_max": [
        -503.4736328125,
        -1959.4697265625,
        871.233154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36469170451164246,
        -0.3489462733268738,
        0.8632707595825195
      ],
      "plane_d": -1642.7313232421875,
      "bbox_min": [
        -636.3113403320312,
        -2040.0,
        809.5067749023438
      ],
      "bbox_max": [
        -528.131103515625,
        -1959.4697265625,
        871.233154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16410835087299347,
        -0.9725523591041565,
        0.16495563089847565
      ],
      "plane_d": -2175.37255859375,
      "bbox_min": [
        -1049.821533203125,
        -2040.0,
        150.4525146484375
      ],
      "bbox_max": [
        -986.1747436523438,
        -2022.358642578125,
        291.7461853027344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22133076190948486,
        -0.9681739807128906,
        0.11684101819992065
      ],
      "plane_d": -2216.021240234375,
      "bbox_min": [
        -1049.821533203125,
        -2040.0,
        150.4525146484375
      ],
      "bbox_max": [
        -986.1747436523438,
        -2022.358642578125,
        291.7461853027344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7558661699295044,
        -0.4322206377983093,
        0.49178430438041687
      ],
      "plane_d": -188.6185302734375,
      "bbox_min": [
        -1049.821533203125,
        -2040.0,
        150.4525146484375
      ],
      "bbox_max": [
        -1014.864501953125,
        -2022.358642578125,
        291.7461853027344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762436032295227,
        0.7347268462181091,
        0.053582221269607544
      ],
      "plane_d": 2184.045166015625,
      "bbox_min": [
        -1049.821533203125,
        -2040.0,
        174.0879364013672
      ],
      "bbox_max": [
        -1030.2423095703125,
        -2022.358642578125,
        291.7461853027344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.703201413154602,
        0.7104752063751221,
        0.027071993798017502
      ],
      "plane_d": 2169.124267578125,
      "bbox_min": [
        -1049.821533203125,
        -2040.0,
        174.0879364013672
      ],
      "bbox_max": [
        -1030.2423095703125,
        -2022.358642578125,
        270.7579040527344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6963309645652771,
        0.7165287137031555,
        0.04134921357035637
      ],
      "plane_d": 2171.017333984375,
      "bbox_min": [
        -1049.821533203125,
        -2040.0,
        219.68569946289062
      ],
      "bbox_max": [
        -1032.6046142578125,
        -2022.358642578125,
        270.7579040527344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        980.0,
        -4840.0,
        0.0
      ],
      "bbox_max": [
        1720.0,
        -2859.02587890625,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27419278025627136,
        0.9614750742912292,
        0.01959756575524807
      ],
      "plane_d": 2996.966552734375,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        0.0
      ],
      "bbox_max": [
        1720.0,
        -3443.970947265625,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2924555540084839,
        0.9559801816940308,
        0.023905904963612556
      ],
      "plane_d": 2949.833984375,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        77.56491088867188
      ],
      "bbox_max": [
        1720.0,
        -3498.41943359375,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48610720038414,
        0.8734968304634094,
        0.026513127610087395
      ],
      "plane_d": 2384.339599609375,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        103.99835205078125
      ],
      "bbox_max": [
        1720.0,
        -3498.41943359375,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49489134550094604,
        0.8684111833572388,
        0.03073418140411377
      ],
      "plane_d": 2349.123291015625,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        540.2590942382812
      ],
      "bbox_max": [
        1720.0,
        -3498.41943359375,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589735984802246,
        0.6511198282241821,
        -0.001435855752788484
      ],
      "plane_d": 3757.080322265625,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        869.450927734375
      ],
      "bbox_max": [
        1720.0,
        -3498.41943359375,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7015435695648193,
        0.7094086408615112,
        0.0676460936665535
      ],
      "plane_d": 3858.47607421875,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        1094.305908203125
      ],
      "bbox_max": [
        1720.0,
        -3762.04638671875,
        1761.0576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8785086870193481,
        0.4433222711086273,
        0.17801031470298767
      ],
      "plane_d": 2773.586669921875,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        1094.305908203125
      ],
      "bbox_max": [
        1720.0,
        -3762.04638671875,
        1761.0576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6350630521774292,
        0.762075662612915,
        0.12623634934425354
      ],
      "plane_d": 3811.68212890625,
      "bbox_min": [
        1383.4677734375,
        -4180.0,
        1094.305908203125
      ],
      "bbox_max": [
        1720.0,
        -3762.04638671875,
        1720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7489288449287415,
        0.6362079381942749,
        0.1853240579366684
      ],
      "plane_d": 3389.09228515625,
      "bbox_min": [
        1383.4677734375,
        -4180.0,
        1094.305908203125
      ],
      "bbox_max": [
        1720.0,
        -3774.750732421875,
        1720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660708069801331,
        0.49953848123550415,
        0.019560152664780617
      ],
      "plane_d": 3358.522216796875,
      "bbox_min": [
        1664.4010009765625,
        -3827.30908203125,
        1094.305908203125
      ],
      "bbox_max": [
        1720.0,
        -3774.750732421875,
        1261.5203857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659723997116089,
        0.49964767694473267,
        0.02107161097228527
      ],
      "plane_d": 3356.937255859375,
      "bbox_min": [
        1717.91259765625,
        -3792.250244140625,
        1210.562744140625
      ],
      "bbox_max": [
        1720.0,
        -3788.61572265625,
        1213.9671630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1717.91259765625,
        -3792.250244140625,
        1210.9613037109375
      ],
      "bbox_max": [
        1720.0,
        -3788.748779296875,
        1213.9671630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1664.4010009765625,
        -3827.30908203125,
        1210.9613037109375
      ],
      "bbox_max": [
        1720.0,
        -3774.750732421875,
        1261.5203857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7831375598907471,
        0.5788978934288025,
        0.22709693014621735
      ],
      "plane_d": 3144.185546875,
      "bbox_min": [
        1496.001220703125,
        -4022.9189453125,
        1568.7076416015625
      ],
      "bbox_max": [
        1560.0,
        -3980.0,
        1680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1515.475830078125,
        -4000.1982421875,
        1245.8548583984375
      ],
      "bbox_max": [
        1720.0,
        -3762.04638671875,
        1680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1675.307373046875,
        -3814.589599609375,
        1245.8548583984375
      ],
      "bbox_max": [
        1720.0,
        -3762.466796875,
        1273.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44197332859039307,
        0.8725138306617737,
        0.2082766443490982
      ],
      "plane_d": 3812.1787109375,
      "bbox_min": [
        1515.475830078125,
        -4000.1982421875,
        1338.7509765625
      ],
      "bbox_max": [
        1636.295166015625,
        -3859.893310546875,
        1680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7831375598907471,
        0.5788978934288025,
        0.22709693014621735
      ],
      "plane_d": 3144.185546875,
      "bbox_min": [
        1515.475830078125,
        -4000.1982421875,
        1577.9471435546875
      ],
      "bbox_max": [
        1560.0,
        -3967.00244140625,
        1680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.88088059425354,
        0.43405717611312866,
        0.18879587948322296
      ],
      "plane_d": 2722.86279296875,
      "bbox_min": [
        1269.7293701171875,
        -4287.13525390625,
        1358.498291015625
      ],
      "bbox_max": [
        1400.0,
        -4154.1025390625,
        1720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7489288449287415,
        0.6362079381942749,
        0.1853240579366684
      ],
      "plane_d": 3389.09228515625,
      "bbox_min": [
        1373.6865234375,
        -4180.0,
        1563.902099609375
      ],
      "bbox_max": [
        1400.0,
        -4154.1025390625,
        1720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6763855814933777,
        0.7353199124336243,
        -0.042511679232120514
      ],
      "plane_d": 4126.3173828125,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        1578.7645263671875
      ],
      "bbox_max": [
        1360.0,
        -4260.0,
        1761.0576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7831375598907471,
        0.5788978934288025,
        0.22709693014621735
      ],
      "plane_d": 3144.185546875,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        1050.4578857421875
      ],
      "bbox_max": [
        1720.0,
        -3498.41943359375,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44197332859039307,
        0.8725138306617737,
        0.2082766443490982
      ],
      "plane_d": 3812.1787109375,
      "bbox_min": [
        1199.9169921875,
        -4368.81494140625,
        1220.9613037109375
      ],
      "bbox_max": [
        1720.0,
        -3733.659423828125,
        1591.4461669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.88088059425354,
        0.43405717611312866,
        0.18879587948322296
      ],
      "plane_d": 2722.86279296875,
      "bbox_min": [
        1199.9169921875,
        -4368.81494140625,
        1220.9613037109375
      ],
      "bbox_max": [
        1665.5118408203125,
        -3826.013671875,
        1493.8575439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1651.71337890625,
        -3835.62158203125,
        1258.5145263671875
      ],
      "bbox_max": [
        1665.5118408203125,
        -3826.013671875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8785086870193481,
        0.4433222711086273,
        0.17801031470298767
      ],
      "plane_d": 2773.586669921875,
      "bbox_min": [
        1199.9169921875,
        -4368.81494140625,
        1220.9613037109375
      ],
      "bbox_max": [
        1269.7293701171875,
        -4287.13525390625,
        1358.498291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8635953068733215,
        0.4744468927383423,
        0.17059697210788727
      ],
      "plane_d": 2898.794677734375,
      "bbox_min": [
        1237.76220703125,
        -4313.42529296875,
        1269.789306640625
      ],
      "bbox_max": [
        1269.7293701171875,
        -4287.13525390625,
        1358.498291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1636.295166015625,
        -3859.893310546875,
        1258.8206787109375
      ],
      "bbox_max": [
        1720.0,
        -3733.659423828125,
        1464.4447021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7489288449287415,
        0.6362079381942749,
        0.1853240579366684
      ],
      "plane_d": 3389.09228515625,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        1050.4578857421875
      ],
      "bbox_max": [
        1496.001220703125,
        -3498.41943359375,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.88088059425354,
        0.43405717611312866,
        0.18879587948322296
      ],
      "plane_d": 2722.86279296875,
      "bbox_min": [
        1324.10791015625,
        -4206.98193359375,
        1269.789306640625
      ],
      "bbox_max": [
        1373.6865234375,
        -4138.1943359375,
        1563.902099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4357794523239136,
        0.8783008456230164,
        0.19668203592300415
      ],
      "plane_d": 3390.929931640625,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        1050.4578857421875
      ],
      "bbox_max": [
        1395.755859375,
        -3498.41943359375,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2072485238313675,
        0.7593603134155273,
        0.6167818903923035
      ],
      "plane_d": 2200.4560546875,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        1160.9613037109375
      ],
      "bbox_max": [
        1395.755859375,
        -3498.41943359375,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1002.5,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        1160.9613037109375
      ],
      "bbox_max": [
        1395.755859375,
        -3498.41943359375,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6763855814933777,
        0.7353199124336243,
        -0.042511679232120514
      ],
      "plane_d": 4126.3173828125,
      "bbox_min": [
        1002.5,
        -4598.142578125,
        1160.9613037109375
      ],
      "bbox_max": [
        1395.755859375,
        -3498.41943359375,
        1763.7958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19393526017665863,
        0.1695787012577057,
        0.966246485710144
      ],
      "plane_d": -344.73529052734375,
      "bbox_min": [
        1002.5,
        -4055.781005859375,
        1267.0811767578125
      ],
      "bbox_max": [
        1011.01416015625,
        -4040.350341796875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6763855814933777,
        0.7353199124336243,
        -0.042511679232120514
      ],
      "plane_d": 4126.3173828125,
      "bbox_min": [
        980.0,
        -4608.44384765625,
        1259.772705078125
      ],
      "bbox_max": [
        1002.5,
        -3982.5,
        1765.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        980.0,
        -4081.5126953125,
        1259.772705078125
      ],
      "bbox_max": [
        1002.5,
        -3982.5,
        1350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19393526017665863,
        0.1695787012577057,
        0.966246485710144
      ],
      "plane_d": -344.73529052734375,
      "bbox_min": [
        980.0,
        -4081.5126953125,
        1259.924560546875
      ],
      "bbox_max": [
        1002.5,
        -4025.304443359375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44719284772872925,
        0.8824665546417236,
        0.14584721624851227
      ],
      "plane_d": 2416.2138671875,
      "bbox_min": [
        1410.96142578125,
        -3655.021484375,
        103.99835205078125
      ],
      "bbox_max": [
        1658.3779296875,
        -3528.76806640625,
        540.2590942382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44719284772872925,
        0.8824665546417236,
        0.14584721624851227
      ],
      "plane_d": 2416.2138671875,
      "bbox_min": [
        1410.96142578125,
        -3595.599609375,
        77.56491088867188
      ],
      "bbox_max": [
        1659.89404296875,
        -3528.76806640625,
        458.24737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4219103455543518,
        0.8972445130348206,
        0.13016921281814575
      ],
      "plane_d": 2511.218994140625,
      "bbox_min": [
        1251.11328125,
        -3591.999267578125,
        0.0
      ],
      "bbox_max": [
        1664.3427734375,
        -3443.970947265625,
        458.24737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44719284772872925,
        0.8824665546417236,
        0.14584721624851227
      ],
      "plane_d": 2416.2138671875,
      "bbox_min": [
        1251.11328125,
        -3591.999267578125,
        0.0
      ],
      "bbox_max": [
        1664.3427734375,
        -3443.970947265625,
        458.24737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2870385944843292,
        0.9484124183654785,
        0.13461995124816895
      ],
      "plane_d": 2887.098876953125,
      "bbox_min": [
        1251.11328125,
        -3487.208984375,
        0.0
      ],
      "bbox_max": [
        1463.9609375,
        -3443.970947265625,
        419.9752197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33050447702407837,
        0.9427840113639832,
        0.04387516900897026
      ],
      "plane_d": 3678.2255859375,
      "bbox_min": [
        1000.55810546875,
        -3599.5791015625,
        0.0
      ],
      "bbox_max": [
        1321.096923828125,
        -3421.011474609375,
        1050.4578857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2870385944843292,
        0.9484124183654785,
        0.13461995124816895
      ],
      "plane_d": 2887.098876953125,
      "bbox_min": [
        1251.11328125,
        -3482.402587890625,
        0.0
      ],
      "bbox_max": [
        1321.096923828125,
        -3441.354736328125,
        419.9752197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3277740180492401,
        0.9389278292655945,
        0.10477888584136963
      ],
      "plane_d": 3635.802490234375,
      "bbox_min": [
        1008.86376953125,
        -3567.58056640625,
        0.0
      ],
      "bbox_max": [
        1312.45263671875,
        -3421.011474609375,
        425.44268798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2870385944843292,
        0.9484124183654785,
        0.13461995124816895
      ],
      "plane_d": 2887.098876953125,
      "bbox_min": [
        1251.11328125,
        -3482.402587890625,
        0.0
      ],
      "bbox_max": [
        1312.45263671875,
        -3428.708984375,
        419.9752197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38686707615852356,
        0.9116483330726624,
        0.1386769711971283
      ],
      "plane_d": 3600.500244140625,
      "bbox_min": [
        1025.00244140625,
        -3514.4697265625,
        0.0
      ],
      "bbox_max": [
        1270.669189453125,
        -3421.011474609375,
        419.9752197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2870385944843292,
        0.9484124183654785,
        0.13461995124816895
      ],
      "plane_d": 2887.098876953125,
      "bbox_min": [
        1245.23583984375,
        -3482.402587890625,
        0.0
      ],
      "bbox_max": [
        1270.669189453125,
        -3421.011474609375,
        419.9752197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        680.0,
        -4840.0,
        0.0
      ],
      "bbox_max": [
        980.0,
        -3071.217529296875,
        1765.3458251953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6043979525566101,
        0.36455777287483215,
        0.7083789706230164
      ],
      "plane_d": 1161.4814453125,
      "bbox_min": [
        794.4974975585938,
        -4608.80029296875,
        1130.0
      ],
      "bbox_max": [
        980.0,
        -3786.072509765625,
        1765.3458251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19393526017665863,
        0.1695787012577057,
        0.966246485710144
      ],
      "plane_d": -344.73529052734375,
      "bbox_min": [
        867.5,
        -4199.14404296875,
        1130.0
      ],
      "bbox_max": [
        980.0,
        -3975.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -4000.0,
        1130.0
      ],
      "bbox_max": [
        867.5,
        -3975.0,
        1159.0758056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9442156553268433,
        0.1135261207818985,
        0.3091418147087097
      ],
      "plane_d": 912.37890625,
      "bbox_min": [
        862.7425537109375,
        -4608.80029296875,
        1146.2098388671875
      ],
      "bbox_max": [
        980.0,
        -3786.072509765625,
        1765.3458251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19393526017665863,
        0.1695787012577057,
        0.966246485710144
      ],
      "plane_d": -344.73529052734375,
      "bbox_min": [
        867.5,
        -4199.14404296875,
        1146.2098388671875
      ],
      "bbox_max": [
        980.0,
        -3804.191650390625,
        1350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -4000.0,
        1150.069580078125
      ],
      "bbox_max": [
        867.5,
        -3982.5,
        1167.20751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3982.5,
        1146.2098388671875
      ],
      "bbox_max": [
        867.5,
        -3975.0,
        1160.7808837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43120837211608887,
        -0.0444025956094265,
        0.9011589884757996
      ],
      "plane_d": -901.566650390625,
      "bbox_min": [
        892.201904296875,
        -3982.5,
        1232.1705322265625
      ],
      "bbox_max": [
        980.0,
        -3804.191650390625,
        1350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        905.3211059570312,
        -3982.5,
        1237.423583984375
      ],
      "bbox_max": [
        980.0,
        -3982.5,
        1273.15771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        892.201904296875,
        -3982.5,
        1233.47412109375
      ],
      "bbox_max": [
        980.0,
        -3975.0,
        1350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        892.201904296875,
        -3975.0,
        1233.47412109375
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1234.3846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        863.2664184570312,
        -4608.80029296875,
        1147.759033203125
      ],
      "bbox_max": [
        980.0,
        -3786.072509765625,
        1765.3458251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43120837211608887,
        -0.0444025956094265,
        0.9011589884757996
      ],
      "plane_d": -901.566650390625,
      "bbox_min": [
        867.5,
        -4608.80029296875,
        1158.026611328125
      ],
      "bbox_max": [
        980.0,
        -3786.072509765625,
        1765.3458251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3975.0,
        1158.026611328125
      ],
      "bbox_max": [
        877.2379760742188,
        -3975.0,
        1187.76953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3975.0,
        1162.65966796875
      ],
      "bbox_max": [
        877.2379760742188,
        -3975.0,
        1187.76953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3975.0,
        1165.85302734375
      ],
      "bbox_max": [
        869.563720703125,
        -3975.0,
        1172.0814208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3975.0,
        1167.8626708984375
      ],
      "bbox_max": [
        891.4415283203125,
        -3975.0,
        1231.1517333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -4608.80029296875,
        1219.695556640625
      ],
      "bbox_max": [
        980.0,
        -3786.072509765625,
        1765.3458251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6763855814933777,
        0.7353199124336243,
        -0.042511679232120514
      ],
      "plane_d": 4126.3173828125,
      "bbox_min": [
        979.21533203125,
        -4608.80029296875,
        1759.030517578125
      ],
      "bbox_max": [
        980.0,
        -4608.08154296875,
        1765.3458251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1295.0,
      "bbox_min": [
        881.0777587890625,
        -3966.9541015625,
        1227.683837890625
      ],
      "bbox_max": [
        919.5,
        -3786.072509765625,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8991886973381042,
        0.10993248224258423,
        0.4235263466835022
      ],
      "plane_d": 673.2299194335938,
      "bbox_min": [
        898.512939453125,
        -3869.61572265625,
        1328.4556884765625
      ],
      "bbox_max": [
        912.85107421875,
        -3827.076416015625,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8270716071128845,
        0.3130333423614502,
        0.4668647050857544
      ],
      "plane_d": 1332.052734375,
      "bbox_min": [
        898.512939453125,
        -3869.61572265625,
        1328.4556884765625
      ],
      "bbox_max": [
        912.85107421875,
        -3827.076416015625,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8991838097572327,
        -0.10993055999279022,
        0.4235370457172394
      ],
      "plane_d": -171.17263793945312,
      "bbox_min": [
        898.512939453125,
        -3869.61572265625,
        1330.5355224609375
      ],
      "bbox_max": [
        912.85107421875,
        -3827.076416015625,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6938219666481018,
        0.4684847593307495,
        0.546930730342865
      ],
      "plane_d": 1705.1630859375,
      "bbox_min": [
        898.512939453125,
        -3869.61572265625,
        1330.5355224609375
      ],
      "bbox_max": [
        904.044677734375,
        -3858.121337890625,
        1340.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927715003490448,
        -0.2117890864610672,
        0.30739253759384155
      ],
      "plane_d": -395.4433898925781,
      "bbox_min": [
        881.0777587890625,
        -3966.9541015625,
        1227.683837890625
      ],
      "bbox_max": [
        892.742431640625,
        -3944.73388671875,
        1232.1705322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7380097508430481,
        -0.57009357213974,
        0.36101922392845154
      ],
      "plane_d": -2047.51953125,
      "bbox_min": [
        884.5675048828125,
        -3966.9541015625,
        1228.671142578125
      ],
      "bbox_max": [
        892.742431640625,
        -3957.92822265625,
        1232.1705322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927715003490448,
        -0.2117890864610672,
        0.30739253759384155
      ],
      "plane_d": -395.4433898925781,
      "bbox_min": [
        863.2664184570312,
        -3982.2509765625,
        1147.759033203125
      ],
      "bbox_max": [
        867.5,
        -3968.694091796875,
        1170.1976318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7380097508430481,
        -0.57009357213974,
        0.36101922392845154
      ],
      "plane_d": -2047.51953125,
      "bbox_min": [
        863.2664184570312,
        -3982.2509765625,
        1147.759033203125
      ],
      "bbox_max": [
        867.5,
        -3977.258544921875,
        1164.296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9662607908248901,
        0.2561880648136139,
        0.02660275809466839
      ],
      "plane_d": 1823.3367919921875,
      "bbox_min": [
        742.7138671875,
        -4275.525390625,
        0.0
      ],
      "bbox_max": [
        919.5,
        -3645.51611328125,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6043979525566101,
        0.36455777287483215,
        0.7083789706230164
      ],
      "plane_d": 1161.4814453125,
      "bbox_min": [
        793.9007568359375,
        -4250.03759765625,
        1145.9613037109375
      ],
      "bbox_max": [
        919.5,
        -3783.589599609375,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927715003490448,
        -0.2117890864610672,
        0.30739253759384155
      ],
      "plane_d": -395.4433898925781,
      "bbox_min": [
        862.638671875,
        -3984.127685546875,
        1145.9613037109375
      ],
      "bbox_max": [
        881.81298828125,
        -3919.9189453125,
        1229.2020263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7380097508430481,
        -0.57009357213974,
        0.36101922392845154
      ],
      "plane_d": -2047.51953125,
      "bbox_min": [
        862.638671875,
        -3982.57666015625,
        1145.9613037109375
      ],
      "bbox_max": [
        863.4521484375,
        -3981.686767578125,
        1149.0294189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9442156553268433,
        0.1135261207818985,
        0.3091418147087097
      ],
      "plane_d": 912.37890625,
      "bbox_min": [
        862.638671875,
        -3982.57666015625,
        1145.9613037109375
      ],
      "bbox_max": [
        863.2664184570312,
        -3982.2509765625,
        1147.759033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9442156553268433,
        0.1135261207818985,
        0.3091418147087097
      ],
      "plane_d": 912.37890625,
      "bbox_min": [
        862.638671875,
        -3984.127685546875,
        1145.9613037109375
      ],
      "bbox_max": [
        863.1806640625,
        -3982.55810546875,
        1147.6099853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3989.234130859375,
        1229.2340087890625
      ],
      "bbox_max": [
        919.5,
        -3783.589599609375,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3975.0,
        1229.2340087890625
      ],
      "bbox_max": [
        919.5,
        -3783.589599609375,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1295.0,
      "bbox_min": [
        897.6475830078125,
        -3870.290283203125,
        1295.0
      ],
      "bbox_max": [
        919.5,
        -3783.589599609375,
        1342.130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8991838097572327,
        -0.10993055999279022,
        0.4235370457172394
      ],
      "plane_d": -171.17263793945312,
      "bbox_min": [
        897.6475830078125,
        -3870.290283203125,
        1327.1021728515625
      ],
      "bbox_max": [
        909.7762451171875,
        -3827.7490234375,
        1342.130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6938219666481018,
        0.4684847593307495,
        0.546930730342865
      ],
      "plane_d": 1705.1630859375,
      "bbox_min": [
        897.6475830078125,
        -3870.290283203125,
        1327.1021728515625
      ],
      "bbox_max": [
        906.0759887695312,
        -3840.5,
        1336.7344970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8270716071128845,
        0.3130333423614502,
        0.4668647050857544
      ],
      "plane_d": 1332.052734375,
      "bbox_min": [
        900.9735107421875,
        -3858.121337890625,
        1327.1021728515625
      ],
      "bbox_max": [
        906.0759887695312,
        -3840.5,
        1330.9654541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8991886973381042,
        0.10993248224258423,
        0.4235263466835022
      ],
      "plane_d": 673.2299194335938,
      "bbox_min": [
        903.3675537109375,
        -3848.26318359375,
        1327.1021728515625
      ],
      "bbox_max": [
        906.0759887695312,
        -3840.5,
        1330.9654541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9616368412971497,
        0.2738252878189087,
        0.01656172424554825
      ],
      "plane_d": 1901.0960693359375,
      "bbox_min": [
        742.7138671875,
        -4275.525390625,
        0.0
      ],
      "bbox_max": [
        919.5,
        -3645.51611328125,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6043979525566101,
        0.36455777287483215,
        0.7083789706230164
      ],
      "plane_d": 1161.4814453125,
      "bbox_min": [
        786.47900390625,
        -4254.5751953125,
        1145.9613037109375
      ],
      "bbox_max": [
        870.6091918945312,
        -3975.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3975.0,
        1249.570556640625
      ],
      "bbox_max": [
        870.6091918945312,
        -3975.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853616952896118,
        -0.16747601330280304,
        0.03184564411640167
      ],
      "plane_d": 146.53118896484375,
      "bbox_min": [
        742.7138671875,
        -4275.525390625,
        0.0
      ],
      "bbox_max": [
        919.5,
        -3645.51611328125,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.985414981842041,
        -0.16721226274967194,
        0.03158261999487877
      ],
      "plane_d": 147.77157592773438,
      "bbox_min": [
        787.322265625,
        -3989.190673828125,
        486.5341491699219
      ],
      "bbox_max": [
        919.5,
        -3645.51611328125,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9855049252510071,
        -0.16633452475070953,
        0.0333598256111145
      ],
      "plane_d": 149.46559143066406,
      "bbox_min": [
        798.377197265625,
        -3982.57666015625,
        891.35791015625
      ],
      "bbox_max": [
        919.5,
        -3645.51611328125,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43120837211608887,
        -0.0444025956094265,
        0.9011589884757996
      ],
      "plane_d": -901.566650390625,
      "bbox_min": [
        816.192138671875,
        -3982.57666015625,
        1145.9613037109375
      ],
      "bbox_max": [
        919.5,
        -3645.51611328125,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9144766330718994,
        -0.1948431432247162,
        0.3546387553215027
      ],
      "plane_d": -393.5171813964844,
      "bbox_min": [
        816.192138671875,
        -3982.57666015625,
        1145.9613037109375
      ],
      "bbox_max": [
        881.541015625,
        -3645.51611328125,
        1229.15869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        830.0,
        -3857.5,
        1152.5
      ],
      "bbox_max": [
        872.5,
        -3717.5,
        1229.15869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3831.5,
        1229.15869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3831.5,
        1228.025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.5,
      "bbox_min": [
        869.5,
        -3854.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3854.5,
        1228.025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927715003490448,
        -0.2117890864610672,
        0.30739253759384155
      ],
      "plane_d": -395.4433898925781,
      "bbox_min": [
        829.6383056640625,
        -3982.57666015625,
        1145.9613037109375
      ],
      "bbox_max": [
        877.7193603515625,
        -3717.5,
        1225.0086669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        830.0,
        -3742.5,
        1193.7001953125
      ],
      "bbox_max": [
        830.0,
        -3717.5,
        1214.439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        830.0,
        -3742.5,
        1212.8668212890625
      ],
      "bbox_max": [
        830.0,
        -3741.96728515625,
        1213.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        830.0,
        -3976.133056640625,
        1213.2076416015625
      ],
      "bbox_max": [
        919.5,
        -3717.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1295.0,
      "bbox_min": [
        852.692626953125,
        -3976.133056640625,
        1226.4420166015625
      ],
      "bbox_max": [
        919.5,
        -3779.5,
        1352.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        852.692626953125,
        -3976.133056640625,
        1295.0
      ],
      "bbox_max": [
        908.8073120117188,
        -3779.5,
        1352.6033935546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.33149731159210205,
        0.5522077083587646,
        -0.7649680972099304
      ],
      "plane_d": 2823.57568359375,
      "bbox_min": [
        869.8992309570312,
        -3875.57763671875,
        1307.7818603515625
      ],
      "bbox_max": [
        908.8073120117188,
        -3805.144775390625,
        1339.858642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33128464221954346,
        0.5526131391525269,
        0.7647674679756165
      ],
      "plane_d": 1419.0845947265625,
      "bbox_min": [
        869.8992309570312,
        -3875.57763671875,
        1307.7818603515625
      ],
      "bbox_max": [
        908.8073120117188,
        -3807.8359375,
        1339.858642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5197157859802246,
        0.5526195168495178,
        0.6515422463417053
      ],
      "plane_d": 1735.7353515625,
      "bbox_min": [
        869.8992309570312,
        -3875.57763671875,
        1307.7818603515625
      ],
      "bbox_max": [
        908.8073120117188,
        -3807.8359375,
        1339.858642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3376634418964386,
        -0.03876829519867897,
        -0.9404681324958801
      ],
      "plane_d": 786.5344848632812,
      "bbox_min": [
        869.8992309570312,
        -3872.907470703125,
        1307.7818603515625
      ],
      "bbox_max": [
        908.8073120117188,
        -3807.8359375,
        1339.858642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4715111553668976,
        0.19494082033634186,
        -0.8600437641143799
      ],
      "plane_d": 1459.18994140625,
      "bbox_min": [
        869.8992309570312,
        -3872.907470703125,
        1307.7818603515625
      ],
      "bbox_max": [
        908.8073120117188,
        -3807.8359375,
        1339.858642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15753163397312164,
        0.4681376516819,
        -0.8695003390312195
      ],
      "plane_d": 2793.02294921875,
      "bbox_min": [
        869.8992309570312,
        -3872.907470703125,
        1307.7818603515625
      ],
      "bbox_max": [
        908.8073120117188,
        -3807.8359375,
        1339.858642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6938219666481018,
        0.4684847593307495,
        0.546930730342865
      ],
      "plane_d": 1705.1630859375,
      "bbox_min": [
        869.8992309570312,
        -3872.907470703125,
        1307.7818603515625
      ],
      "bbox_max": [
        908.8073120117188,
        -3821.986328125,
        1339.858642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15717488527297974,
        0.4684818983078003,
        0.8693795204162598
      ],
      "plane_d": 803.4276123046875,
      "bbox_min": [
        869.8992309570312,
        -3872.907470703125,
        1307.7818603515625
      ],
      "bbox_max": [
        908.8073120117188,
        -3821.986328125,
        1339.858642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024375267326831818,
        -0.312801331281662,
        -0.9495057463645935
      ],
      "plane_d": 17.5645751953125,
      "bbox_min": [
        870.2059936523438,
        -3859.013916015625,
        1310.021484375
      ],
      "bbox_max": [
        876.98291015625,
        -3852.15087890625,
        1312.1380615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8270716071128845,
        0.3130333423614502,
        0.4668647050857544
      ],
      "plane_d": 1332.052734375,
      "bbox_min": [
        869.8992309570312,
        -3857.002197265625,
        1307.7818603515625
      ],
      "bbox_max": [
        905.3595581054688,
        -3832.017822265625,
        1329.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024375267326831818,
        -0.312801331281662,
        -0.9495057463645935
      ],
      "plane_d": 17.5645751953125,
      "bbox_min": [
        869.8992309570312,
        -3856.372802734375,
        1307.7818603515625
      ],
      "bbox_max": [
        905.3595581054688,
        -3832.017822265625,
        1329.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04768463224172592,
        0.10984193533658981,
        -0.9928045868873596
      ],
      "plane_d": 1761.809326171875,
      "bbox_min": [
        869.8992309570312,
        -3847.76953125,
        1307.7818603515625
      ],
      "bbox_max": [
        905.3595581054688,
        -3832.017822265625,
        1329.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8991886973381042,
        0.10993248224258423,
        0.4235263466835022
      ],
      "plane_d": 673.2299194335938,
      "bbox_min": [
        903.34375,
        -3847.76953125,
        1327.04638671875
      ],
      "bbox_max": [
        905.3595581054688,
        -3840.5,
        1329.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8571872711181641,
        2.205165628765826e-06,
        -0.5150048732757568
      ],
      "plane_d": 1434.377685546875,
      "bbox_min": [
        884.8291015625,
        -3846.699951171875,
        1310.478271484375
      ],
      "bbox_max": [
        885.998291015625,
        -3840.5,
        1312.42431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3975.0,
        1302.96923828125
      ],
      "bbox_max": [
        872.39990234375,
        -3786.599853515625,
        1352.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15717488527297974,
        0.4684818983078003,
        0.8693795204162598
      ],
      "plane_d": 803.4276123046875,
      "bbox_min": [
        867.5,
        -3872.706298828125,
        1307.891357421875
      ],
      "bbox_max": [
        872.39990234375,
        -3786.599853515625,
        1338.5040283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024375267326831818,
        -0.312801331281662,
        -0.9495057463645935
      ],
      "plane_d": 17.5645751953125,
      "bbox_min": [
        867.5,
        -3861.08642578125,
        1311.2659912109375
      ],
      "bbox_max": [
        870.2852783203125,
        -3856.372802734375,
        1312.7493896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024374594911932945,
        0.3127957284450531,
        -0.9495076537132263
      ],
      "plane_d": 2420.17333984375,
      "bbox_min": [
        867.5,
        -3858.377197265625,
        1307.891357421875
      ],
      "bbox_max": [
        872.39990234375,
        -3786.599853515625,
        1338.5040283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.0861628513557662e-07,
        0.5300033688545227,
        0.8479955792427063
      ],
      "plane_d": 876.44775390625,
      "bbox_min": [
        867.5,
        -3858.377197265625,
        1307.891357421875
      ],
      "bbox_max": [
        872.39990234375,
        -3786.599853515625,
        1338.5040283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04768304154276848,
        -0.10983971506357193,
        -0.9928048849105835
      ],
      "plane_d": 918.1209716796875,
      "bbox_min": [
        867.5,
        -3858.377197265625,
        1307.891357421875
      ],
      "bbox_max": [
        870.2059936523438,
        -3831.180908203125,
        1311.85693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04768463224172592,
        0.10984193533658981,
        -0.9928045868873596
      ],
      "plane_d": 1761.809326171875,
      "bbox_min": [
        867.5,
        -3858.377197265625,
        1307.891357421875
      ],
      "bbox_max": [
        870.2059936523438,
        -3831.180908203125,
        1311.85693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024375267326831818,
        -0.312801331281662,
        -0.9495057463645935
      ],
      "plane_d": 17.5645751953125,
      "bbox_min": [
        867.5,
        -3858.377197265625,
        1308.82568359375
      ],
      "bbox_max": [
        870.2059936523438,
        -3848.982421875,
        1311.85693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04768304154276848,
        -0.10983971506357193,
        -0.9928048849105835
      ],
      "plane_d": 918.1209716796875,
      "bbox_min": [
        852.692626953125,
        -3869.962890625,
        1308.006591796875
      ],
      "bbox_max": [
        867.5,
        -3786.752685546875,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04768463224172592,
        0.10984193533658981,
        -0.9928045868873596
      ],
      "plane_d": 1761.809326171875,
      "bbox_min": [
        852.692626953125,
        -3869.962890625,
        1308.006591796875
      ],
      "bbox_max": [
        867.5,
        -3786.752685546875,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024374594911932945,
        0.3127957284450531,
        -0.9495076537132263
      ],
      "plane_d": 2420.17333984375,
      "bbox_min": [
        854.99951171875,
        -3869.962890625,
        1309.03759765625
      ],
      "bbox_max": [
        867.5,
        -3786.752685546875,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024375267326831818,
        -0.312801331281662,
        -0.9495057463645935
      ],
      "plane_d": 17.5645751953125,
      "bbox_min": [
        854.99951171875,
        -3869.962890625,
        1309.03759765625
      ],
      "bbox_max": [
        867.5,
        -3786.752685546875,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.0861628513557662e-07,
        0.5300033688545227,
        0.8479955792427063
      ],
      "plane_d": 876.44775390625,
      "bbox_min": [
        861.52294921875,
        -3869.962890625,
        1312.7493896484375
      ],
      "bbox_max": [
        867.5,
        -3786.752685546875,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15717488527297974,
        0.4684818983078003,
        0.8693795204162598
      ],
      "plane_d": 803.4276123046875,
      "bbox_min": [
        861.52294921875,
        -3869.962890625,
        1312.7493896484375
      ],
      "bbox_max": [
        867.5,
        -3810.87646484375,
        1318.10009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15753163397312164,
        0.4681376516819,
        -0.8695003390312195
      ],
      "plane_d": 2793.02294921875,
      "bbox_min": [
        861.56884765625,
        -3819.91357421875,
        1312.7493896484375
      ],
      "bbox_max": [
        867.5,
        -3810.87646484375,
        1317.614990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.0,
        -3858.0,
        1226.4420166015625
      ],
      "bbox_max": [
        873.0,
        -3831.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.5,
      "bbox_min": [
        869.5,
        -3854.5,
        1226.5899658203125
      ],
      "bbox_max": [
        873.0,
        -3831.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.5,
      "bbox_min": [
        869.5,
        -3854.0,
        1227.72314453125
      ],
      "bbox_max": [
        873.0,
        -3831.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.0,
      "bbox_min": [
        869.5,
        -3854.0,
        1292.0
      ],
      "bbox_max": [
        873.0,
        -3854.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.0,
      "bbox_min": [
        869.5,
        -3831.0,
        1292.0
      ],
      "bbox_max": [
        873.0,
        -3831.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.0,
      "bbox_min": [
        869.0,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3831.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.0,
      "bbox_min": [
        869.0,
        -3854.0,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3831.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.0,
      "bbox_min": [
        869.0,
        -3831.0,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3831.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3976.526123046875,
        1321.7015380859375
      ],
      "bbox_max": [
        868.5252685546875,
        -3975.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3976.526123046875,
        1321.7015380859375
      ],
      "bbox_max": [
        867.5,
        -3975.0,
        1336.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9816219806671143,
        -0.15174885094165802,
        0.1157173216342926
      ],
      "plane_d": 160.41783142089844,
      "bbox_min": [
        787.322265625,
        -3989.190673828125,
        486.5341491699219
      ],
      "bbox_max": [
        844.33447265625,
        -3664.63330078125,
        544.813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9811185002326965,
        0.1803492158651352,
        0.06986100971698761
      ],
      "plane_d": 1509.7783203125,
      "bbox_min": [
        742.7138671875,
        -4275.525390625,
        0.0
      ],
      "bbox_max": [
        868.3492431640625,
        -3664.83544921875,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9722859859466553,
        -0.2179602086544037,
        0.08457721769809723
      ],
      "plane_d": -94.62902069091797,
      "bbox_min": [
        742.7138671875,
        -4010.265869140625,
        0.0
      ],
      "bbox_max": [
        868.3492431640625,
        -3664.83544921875,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9816219806671143,
        -0.15174885094165802,
        0.1157173216342926
      ],
      "plane_d": 160.41783142089844,
      "bbox_min": [
        742.7138671875,
        -3989.190673828125,
        0.0
      ],
      "bbox_max": [
        844.33447265625,
        -3664.83544921875,
        544.813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3975.0,
        1336.2237548828125
      ],
      "bbox_max": [
        868.3492431640625,
        -3975.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -132.7933349609375,
        -4449.17431640625,
        0.0
      ],
      "bbox_max": [
        680.0000610351562,
        -3157.2412109375,
        1832.32373046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6095805168151855,
        0.7911238670349121,
        0.05034473538398743
      ],
      "plane_d": 2643.3916015625,
      "bbox_min": [
        211.637451171875,
        -4033.44873046875,
        0.0
      ],
      "bbox_max": [
        664.2568359375,
        -3717.37890625,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0567576140165329,
        0.9980700612068176,
        0.025192802771925926
      ],
      "plane_d": 3693.984130859375,
      "bbox_min": [
        211.637451171875,
        -4033.44873046875,
        0.0
      ],
      "bbox_max": [
        664.2568359375,
        -3717.37890625,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12320823967456818,
        0.9910323619842529,
        0.0517178438603878
      ],
      "plane_d": 3629.03662109375,
      "bbox_min": [
        211.637451171875,
        -4033.44873046875,
        789.3822631835938
      ],
      "bbox_max": [
        664.2568359375,
        -3736.21240234375,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6409114003181458,
        0.7633273005485535,
        0.08101856708526611
      ],
      "plane_d": 2492.2646484375,
      "bbox_min": [
        269.3843994140625,
        -4033.44873046875,
        803.0512084960938
      ],
      "bbox_max": [
        664.2568359375,
        -3763.686767578125,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6077371835708618,
        0.7909682989120483,
        0.07088473439216614
      ],
      "plane_d": 2627.199462890625,
      "bbox_min": [
        269.3843994140625,
        -4033.44873046875,
        803.0512084960938
      ],
      "bbox_max": [
        664.2568359375,
        -3763.686767578125,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7833710312843323,
        0.6178421974182129,
        0.06782949715852737
      ],
      "plane_d": 1863.1636962890625,
      "bbox_min": [
        269.3843994140625,
        -4033.44873046875,
        1520.6715087890625
      ],
      "bbox_max": [
        664.2568359375,
        -3786.52392578125,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        269.3843994140625,
        -3811.85205078125,
        1520.6715087890625
      ],
      "bbox_max": [
        440.13232421875,
        -3786.52392578125,
        1774.5174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14199809730052948,
        0.9854755401611328,
        0.09313669055700302
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        269.3843994140625,
        -3811.85205078125,
        1698.721435546875
      ],
      "bbox_max": [
        427.0243225097656,
        -3786.52392578125,
        1774.5174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6327277421951294,
        0.771410346031189,
        0.06768848747015
      ],
      "plane_d": 2549.050537109375,
      "bbox_min": [
        426.9814453125,
        -3934.084716796875,
        1520.6715087890625
      ],
      "bbox_max": [
        569.706298828125,
        -3795.950927734375,
        1819.7926025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        426.9814453125,
        -3934.084716796875,
        1687.03955078125
      ],
      "bbox_max": [
        567.0928955078125,
        -3806.322265625,
        1819.7926025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7833710312843323,
        0.6178421974182129,
        0.06782949715852737
      ],
      "plane_d": 1863.1636962890625,
      "bbox_min": [
        426.9814453125,
        -3934.084716796875,
        1771.95361328125
      ],
      "bbox_max": [
        567.0928955078125,
        -3811.61572265625,
        1819.7926025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14199809730052948,
        0.9854755401611328,
        0.09313669055700302
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        426.9814453125,
        -3812.21435546875,
        1771.95361328125
      ],
      "bbox_max": [
        429.236328125,
        -3811.61572265625,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6415850520133972,
        0.763245701789856,
        0.0763196349143982
      ],
      "plane_d": 2498.803955078125,
      "bbox_min": [
        429.236328125,
        -3906.921142578125,
        1520.6715087890625
      ],
      "bbox_max": [
        569.706298828125,
        -3795.950927734375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        429.236328125,
        -3812.21435546875,
        1520.6715087890625
      ],
      "bbox_max": [
        440.13232421875,
        -3795.950927734375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17268596589565277,
        0.98418790102005,
        0.03941702842712402
      ],
      "plane_d": 3599.98388671875,
      "bbox_min": [
        211.637451171875,
        -3796.810546875,
        789.3822631835938
      ],
      "bbox_max": [
        440.13232421875,
        -3736.21240234375,
        1746.7979736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        211.637451171875,
        -3796.810546875,
        1519.1739501953125
      ],
      "bbox_max": [
        440.13232421875,
        -3769.860107421875,
        1746.7979736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14199809730052948,
        0.9854755401611328,
        0.09313669055700302
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        211.637451171875,
        -3796.810546875,
        1609.0145263671875
      ],
      "bbox_max": [
        372.3069152832031,
        -3769.860107421875,
        1746.7979736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6175416707992554,
        0.7847907543182373,
        0.05240177363157272
      ],
      "plane_d": 2614.06787109375,
      "bbox_min": [
        481.841796875,
        -3831.127197265625,
        0.0
      ],
      "bbox_max": [
        635.6904296875,
        -3729.798583984375,
        803.0512084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0567576140165329,
        0.9980700612068176,
        0.025192802771925926
      ],
      "plane_d": 3693.984130859375,
      "bbox_min": [
        503.552734375,
        -3730.059326171875,
        0.0
      ],
      "bbox_max": [
        507.132080078125,
        -3729.798583984375,
        11.74609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17268596589565277,
        0.98418790102005,
        0.03941702842712402
      ],
      "plane_d": 3599.98388671875,
      "bbox_min": [
        40.58837890625,
        -3780.25,
        0.0
      ],
      "bbox_max": [
        546.996826171875,
        -3217.454833984375,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        236.71875,
        -3780.25,
        1517.2542724609375
      ],
      "bbox_max": [
        350.990234375,
        -3760.123046875,
        1609.0145263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        40.58837890625,
        -3603.74560546875,
        0.0
      ],
      "bbox_max": [
        546.996826171875,
        -3217.454833984375,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8440337181091309,
        0.5237486362457275,
        0.11530200392007828
      ],
      "plane_d": 1527.4400634765625,
      "bbox_min": [
        40.58837890625,
        -3536.330078125,
        1455.1270751953125
      ],
      "bbox_max": [
        176.252197265625,
        -3335.302490234375,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8434123396873474,
        0.5291796922683716,
        0.09286854416131973
      ],
      "plane_d": 1580.055908203125,
      "bbox_min": [
        51.478790283203125,
        -3527.64501953125,
        1455.1270751953125
      ],
      "bbox_max": [
        176.252197265625,
        -3335.302490234375,
        1535.99658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7167351245880127,
        -0.6454834342002869,
        0.2638974189758301
      ],
      "plane_d": -2018.5269775390625,
      "bbox_min": [
        191.07476806640625,
        -3603.74560546875,
        0.0
      ],
      "bbox_max": [
        546.996826171875,
        -3217.454833984375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8040251731872559,
        -0.5580930113792419,
        0.2051236778497696
      ],
      "plane_d": -1666.128173828125,
      "bbox_min": [
        191.07476806640625,
        -3603.74560546875,
        0.0
      ],
      "bbox_max": [
        546.996826171875,
        -3217.454833984375,
        1155.389404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07370751351118088,
        0.9552657604217529,
        0.2864168584346771
      ],
      "plane_d": 2811.425048828125,
      "bbox_min": [
        468.7945251464844,
        -3248.261962890625,
        1048.0806884765625
      ],
      "bbox_max": [
        546.996826171875,
        -3217.454833984375,
        1155.389404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17600783705711365,
        0.971106767654419,
        0.1611611247062683
      ],
      "plane_d": 2872.85693359375,
      "bbox_min": [
        468.7945251464844,
        -3233.130126953125,
        1048.0806884765625
      ],
      "bbox_max": [
        498.8936462402344,
        -3217.454833984375,
        1095.7650146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.58553147315979,
        0.7935402989387512,
        0.1656704992055893
      ],
      "plane_d": 2091.965087890625,
      "bbox_min": [
        494.55560302734375,
        -3233.130126953125,
        1071.7021484375
      ],
      "bbox_max": [
        498.8936462402344,
        -3226.122802734375,
        1095.7650146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589617371559143,
        -0.6175175309181213,
        0.20651651918888092
      ],
      "plane_d": -1886.5819091796875,
      "bbox_min": [
        191.07476806640625,
        -3459.993896484375,
        0.0
      ],
      "bbox_max": [
        384.896240234375,
        -3277.623046875,
        354.4547119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7376764416694641,
        -0.6278554797172546,
        0.24825602769851685
      ],
      "plane_d": -1929.36328125,
      "bbox_min": [
        191.07476806640625,
        -3459.993896484375,
        0.0
      ],
      "bbox_max": [
        329.43017578125,
        -3289.754638671875,
        99.05470275878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047291398048401,
        -0.7089955806732178,
        0.026118943467736244
      ],
      "plane_d": -2155.4189453125,
      "bbox_min": [
        265.89044189453125,
        -3527.64501953125,
        354.4547119140625
      ],
      "bbox_max": [
        534.474365234375,
        -3217.80322265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7023268342018127,
        -0.7113156914710999,
        0.02769298106431961
      ],
      "plane_d": -2165.433837890625,
      "bbox_min": [
        265.89044189453125,
        -3527.64501953125,
        354.4547119140625
      ],
      "bbox_max": [
        534.474365234375,
        -3217.80322265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7313293814659119,
        -0.6815345883369446,
        0.02584567293524742
      ],
      "plane_d": -2051.451904296875,
      "bbox_min": [
        265.89044189453125,
        -3517.91015625,
        354.4547119140625
      ],
      "bbox_max": [
        534.474365234375,
        -3217.80322265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7006473541259766,
        -0.7095324397087097,
        0.07521317899227142
      ],
      "plane_d": -2197.341552734375,
      "bbox_min": [
        272.2877502441406,
        -3517.91015625,
        740.441650390625
      ],
      "bbox_max": [
        534.474365234375,
        -3217.80322265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7064646482467651,
        -0.7041506767272949,
        0.07127003371715546
      ],
      "plane_d": -2172.34130859375,
      "bbox_min": [
        272.2877502441406,
        -3517.91015625,
        740.441650390625
      ],
      "bbox_max": [
        534.474365234375,
        -3217.80322265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7322627902030945,
        -0.6772246956825256,
        0.07181940227746964
      ],
      "plane_d": -2071.12744140625,
      "bbox_min": [
        272.2877502441406,
        -3400.330810546875,
        740.441650390625
      ],
      "bbox_max": [
        534.474365234375,
        -3217.80322265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8246844410896301,
        -0.4889775812625885,
        0.2842473089694977
      ],
      "plane_d": -1631.2696533203125,
      "bbox_min": [
        288.7086486816406,
        -3386.47900390625,
        952.2669677734375
      ],
      "bbox_max": [
        534.474365234375,
        -3217.80322265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7403071522712708,
        0.3129737675189972,
        0.5949727892875671
      ],
      "plane_d": 619.6898193359375,
      "bbox_min": [
        325.75433349609375,
        -3345.48291015625,
        1051.5068359375
      ],
      "bbox_max": [
        534.474365234375,
        -3217.80322265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.58553147315979,
        0.7935402989387512,
        0.1656704992055893
      ],
      "plane_d": 2091.965087890625,
      "bbox_min": [
        422.0525817871094,
        -3300.29345703125,
        1051.5068359375
      ],
      "bbox_max": [
        534.474365234375,
        -3217.80322265625,
        1286.029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17600783705711365,
        0.971106767654419,
        0.1611611247062683
      ],
      "plane_d": 2872.85693359375,
      "bbox_min": [
        422.0525817871094,
        -3300.29345703125,
        1051.5068359375
      ],
      "bbox_max": [
        494.55560302734375,
        -3217.80322265625,
        1286.029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9396525621414185,
        0.34213024377822876,
        0.0
      ],
      "plane_d": 1573.9007568359375,
      "bbox_min": [
        473.3350524902344,
        -3300.29345703125,
        1272.5
      ],
      "bbox_max": [
        474.0192565917969,
        -3298.414306640625,
        1283.468505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3420272767543793,
        0.9396900534629822,
        0.0
      ],
      "plane_d": 2911.359619140625,
      "bbox_min": [
        482.2276916503906,
        -3275.861572265625,
        1272.5
      ],
      "bbox_max": [
        484.7911376953125,
        -3273.982177734375,
        1284.2423095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9397011995315552,
        0.3419966697692871,
        0.0
      ],
      "plane_d": 1573.4837646484375,
      "bbox_min": [
        482.2276916503906,
        -3275.861572265625,
        1272.5
      ],
      "bbox_max": [
        482.91168212890625,
        -3273.982177734375,
        1281.6815185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07370751351118088,
        0.9552657604217529,
        0.2864168584346771
      ],
      "plane_d": 2811.425048828125,
      "bbox_min": [
        498.8936462402344,
        -3283.8076171875,
        1095.7650146484375
      ],
      "bbox_max": [
        534.474365234375,
        -3233.130126953125,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9397011995315552,
        0.3419966697692871,
        0.0
      ],
      "plane_d": 1573.4837646484375,
      "bbox_min": [
        465.60345458984375,
        -3305.422119140625,
        1281.5438232421875
      ],
      "bbox_max": [
        492.5228271484375,
        -3269.537841796875,
        1325.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3420272767543793,
        0.9396900534629822,
        0.0
      ],
      "plane_d": 2911.359619140625,
      "bbox_min": [
        472.6517639160156,
        -3305.422119140625,
        1281.5438232421875
      ],
      "bbox_max": [
        492.5228271484375,
        -3272.102783203125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3419538140296936,
        0.9397167563438416,
        0.0
      ],
      "plane_d": 2937.482421875,
      "bbox_min": [
        472.6517639160156,
        -3305.422119140625,
        1283.331298828125
      ],
      "bbox_max": [
        491.83868408203125,
        -3273.982177734375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        472.6517639160156,
        -3305.422119140625,
        1323.5
      ],
      "bbox_max": [
        482.9465026855469,
        -3298.41455078125,
        1323.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        474.01983642578125,
        -3301.66259765625,
        1323.5
      ],
      "bbox_max": [
        491.83868408203125,
        -3273.982177734375,
        1325.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        482.91168212890625,
        -3277.231689453125,
        1323.5
      ],
      "bbox_max": [
        492.5228271484375,
        -3272.102783203125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3420146107673645,
        0.9396947026252747,
        0.0
      ],
      "plane_d": 2909.381103515625,
      "bbox_min": [
        483.5956726074219,
        -3275.35205078125,
        1323.5
      ],
      "bbox_max": [
        492.5228271484375,
        -3272.102783203125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        465.60345458984375,
        -3302.17333984375,
        1323.5
      ],
      "bbox_max": [
        483.5956726074219,
        -3269.537841796875,
        1325.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.34201404452323914,
        0.9396949410438538,
        0.0
      ],
      "plane_d": 2935.3818359375,
      "bbox_min": [
        465.60345458984375,
        -3299.60791015625,
        1323.5
      ],
      "bbox_max": [
        483.5956726074219,
        -3269.537841796875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9396963119506836,
        0.34201014041900635,
        0.0
      ],
      "plane_d": 1566.025146484375,
      "bbox_min": [
        465.60345458984375,
        -3299.60791015625,
        1323.5
      ],
      "bbox_max": [
        467.655517578125,
        -3293.9697265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3420146107673645,
        0.9396947026252747,
        0.0
      ],
      "plane_d": 2909.381103515625,
      "bbox_min": [
        474.49603271484375,
        -3275.176025390625,
        1323.5
      ],
      "bbox_max": [
        483.5956726074219,
        -3269.537841796875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9396947026252747,
        0.3420146405696869,
        0.0
      ],
      "plane_d": 1566.03955078125,
      "bbox_min": [
        474.49603271484375,
        -3275.176025390625,
        1323.5
      ],
      "bbox_max": [
        476.5481262207031,
        -3269.537841796875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1123.0411376953125,
        -3390.305908203125,
        0.0
      ],
      "bbox_max": [
        1720.0,
        -2375.255126953125,
        1629.9017333984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        -1115.741943359375,
        -3379.651123046875,
        816.1241455078125
      ],
      "bbox_max": [
        70.72618103027344,
        -3136.473388671875,
        1629.9017333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24717621505260468,
        0.11013562232255936,
        0.9626911282539368
      ],
      "plane_d": -219.55609130859375,
      "bbox_min": [
        -1115.741943359375,
        -3379.651123046875,
        816.1241455078125
      ],
      "bbox_max": [
        59.025657653808594,
        -3136.473388671875,
        1629.9017333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8434123396873474,
        0.5291796922683716,
        0.09286854416131973
      ],
      "plane_d": 1580.055908203125,
      "bbox_min": [
        -2.5234222412109375,
        -3340.589111328125,
        1444.5465087890625
      ],
      "bbox_max": [
        59.025657653808594,
        -3265.75341796875,
        1629.9017333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8440337181091309,
        0.5237486362457275,
        0.11530200392007828
      ],
      "plane_d": 1527.4400634765625,
      "bbox_min": [
        -2.5234222412109375,
        -3340.589111328125,
        1535.99658203125
      ],
      "bbox_max": [
        51.478782653808594,
        -3265.75341796875,
        1629.9017333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24717621505260468,
        0.11013562232255936,
        0.9626911282539368
      ],
      "plane_d": -219.55609130859375,
      "bbox_min": [
        -1123.0411376953125,
        -3385.130859375,
        825.3421020507812
      ],
      "bbox_max": [
        -893.66162109375,
        -3137.120849609375,
        903.68408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0647813007235527,
        0.2180229127407074,
        0.9737911820411682
      ],
      "plane_d": -61.163818359375,
      "bbox_min": [
        -991.43603515625,
        -3231.95166015625,
        834.2861328125
      ],
      "bbox_max": [
        -951.7387084960938,
        -3162.978759765625,
        852.3694458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23609928786754608,
        0.3740059733390808,
        0.896870493888855
      ],
      "plane_d": 210.2269287109375,
      "bbox_min": [
        -991.43603515625,
        -3231.95166015625,
        825.3421020507812
      ],
      "bbox_max": [
        -893.66162109375,
        -3137.120849609375,
        852.3694458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24781043827533722,
        0.10794221609830856,
        0.9627764225006104
      ],
      "plane_d": -226.0889892578125,
      "bbox_min": [
        -991.43603515625,
        -3231.95166015625,
        825.3421020507812
      ],
      "bbox_max": [
        -922.2028198242188,
        -3149.828369140625,
        852.3694458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0647813007235527,
        0.2180229127407074,
        0.9737911820411682
      ],
      "plane_d": -61.163818359375,
      "bbox_min": [
        -991.43603515625,
        -3231.95166015625,
        834.1299438476562
      ],
      "bbox_max": [
        -950.7990112304688,
        -3162.560302734375,
        852.3694458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5771116018295288,
        0.8162537217140198,
        0.02592291869223118
      ],
      "plane_d": 2576.205322265625,
      "bbox_min": [
        -362.7738952636719,
        -3297.438232421875,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -2878.43115234375,
        1605.5548095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5382782816886902,
        0.8385637402534485,
        0.08406741917133331
      ],
      "plane_d": 2561.375,
      "bbox_min": [
        -301.69952392578125,
        -3297.438232421875,
        0.0
      ],
      "bbox_max": [
        196.6639404296875,
        -2988.336181640625,
        1605.5548095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        -52.589599609375,
        -3297.438232421875,
        0.0
      ],
      "bbox_max": [
        196.6639404296875,
        -3172.2548828125,
        1605.5548095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8434123396873474,
        0.5291796922683716,
        0.09286854416131973
      ],
      "plane_d": 1580.055908203125,
      "bbox_min": [
        -52.589599609375,
        -3270.4326171875,
        1428.741455078125
      ],
      "bbox_max": [
        19.489643096923828,
        -3172.2548828125,
        1605.5548095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8440337181091309,
        0.5237486362457275,
        0.11530200392007828
      ],
      "plane_d": 1527.4400634765625,
      "bbox_min": [
        -52.589599609375,
        -3267.470947265625,
        1554.2142333984375
      ],
      "bbox_max": [
        5.5558624267578125,
        -3178.84619140625,
        1605.5548095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7376764416694641,
        -0.6278554797172546,
        0.24825602769851685
      ],
      "plane_d": -1929.36328125,
      "bbox_min": [
        177.8013916015625,
        -3297.438232421875,
        0.0
      ],
      "bbox_max": [
        196.6639404296875,
        -3281.84326171875,
        20.66110610961914
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5380130410194397,
        0.8274743556976318,
        0.16071178019046783
      ],
      "plane_d": 2416.71533203125,
      "bbox_min": [
        -301.69952392578125,
        -3161.155517578125,
        1363.6708984375
      ],
      "bbox_max": [
        -57.122589111328125,
        -2988.336181640625,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -301.69952392578125,
        -3031.18994140625,
        1363.6708984375
      ],
      "bbox_max": [
        -246.2593994140625,
        -2988.336181640625,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5808821320533752,
        0.8135150671005249,
        0.027732910588383675
      ],
      "plane_d": 2567.5458984375,
      "bbox_min": [
        -362.7738952636719,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -2878.43115234375,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388664484024048,
        0.6731492280960083,
        0.03076668083667755
      ],
      "plane_d": 2178.357666015625,
      "bbox_min": [
        -362.7738952636719,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -2878.43115234375,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7295700907707214,
        0.6833271980285645,
        0.02813161164522171
      ],
      "plane_d": 2207.02783203125,
      "bbox_min": [
        -360.88519287109375,
        -3020.382080078125,
        0.0
      ],
      "bbox_max": [
        -208.442626953125,
        -2905.47607421875,
        1433.607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -360.88519287109375,
        -3020.382080078125,
        688.5384521484375
      ],
      "bbox_max": [
        -229.613525390625,
        -2905.47607421875,
        1433.607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -360.6915283203125,
        -3019.923583984375,
        1313.6531982421875
      ],
      "bbox_max": [
        -254.36074829101562,
        -2905.960205078125,
        1433.338623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -360.6915283203125,
        -2937.93310546875,
        1383.4918212890625
      ],
      "bbox_max": [
        -347.90234375,
        -2905.960205078125,
        1433.338623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -360.88519287109375,
        -3020.382080078125,
        688.5384521484375
      ],
      "bbox_max": [
        -229.613525390625,
        -2905.47607421875,
        1433.607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -331.759765625,
        -3020.382080078125,
        1313.6531982421875
      ],
      "bbox_max": [
        -253.673583984375,
        -2932.19970703125,
        1373.81298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -266.6356506347656,
        -3020.382080078125,
        1367.1375732421875
      ],
      "bbox_max": [
        -253.673583984375,
        -3006.173095703125,
        1373.81298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -360.88519287109375,
        -2932.19970703125,
        688.5384521484375
      ],
      "bbox_max": [
        -312.7353515625,
        -2905.47607421875,
        1433.607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -360.88519287109375,
        -2932.19970703125,
        1313.62060546875
      ],
      "bbox_max": [
        -331.759765625,
        -2905.47607421875,
        1433.607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -360.88519287109375,
        -2913.139892578125,
        1383.0391845703125
      ],
      "bbox_max": [
        -352.0573425292969,
        -2905.47607421875,
        1433.607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9094638824462891,
        0.4146226942539215,
        0.031041515991091728
      ],
      "plane_d": 1475.5181884765625,
      "bbox_min": [
        -312.7353515625,
        -2924.27294921875,
        0.0
      ],
      "bbox_max": [
        -292.12548828125,
        -2912.103515625,
        688.5384521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -295.45245361328125,
        -2917.931396484375,
        0.0
      ],
      "bbox_max": [
        -292.12548828125,
        -2912.103515625,
        39.069671630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784721970558167,
        0.8153333067893982,
        0.024523697793483734
      ],
      "plane_d": 2574.3935546875,
      "bbox_min": [
        -362.7738952636719,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -2878.43115234375,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5775443315505981,
        0.816006064414978,
        0.024013593792915344
      ],
      "plane_d": 2576.892578125,
      "bbox_min": [
        -257.69537353515625,
        -3173.531982421875,
        699.149169921875
      ],
      "bbox_max": [
        -22.141357421875,
        -3014.874755859375,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5380130410194397,
        0.8274743556976318,
        0.16071178019046783
      ],
      "plane_d": 2416.71533203125,
      "bbox_min": [
        -257.665283203125,
        -3173.531982421875,
        1354.7957763671875
      ],
      "bbox_max": [
        -39.40976333618164,
        -3015.9111328125,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8434123396873474,
        0.5291796922683716,
        0.09286854416131973
      ],
      "plane_d": 1580.055908203125,
      "bbox_min": [
        -40.82177734375,
        -3173.531982421875,
        1424.409423828125
      ],
      "bbox_max": [
        -39.40976333618164,
        -3171.47509765625,
        1435.5948486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        -40.82177734375,
        -3173.531982421875,
        1424.409423828125
      ],
      "bbox_max": [
        -39.40976333618164,
        -3171.47509765625,
        1428.741455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5382782816886902,
        0.8385637402534485,
        0.08406741917133331
      ],
      "plane_d": 2561.375,
      "bbox_min": [
        -257.665283203125,
        -3172.964111328125,
        1354.7957763671875
      ],
      "bbox_max": [
        -40.67903137207031,
        -3015.9111328125,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8434123396873474,
        0.5291796922683716,
        0.09286854416131973
      ],
      "plane_d": 1580.055908203125,
      "bbox_min": [
        -42.06678009033203,
        -3172.964111328125,
        1428.406005859375
      ],
      "bbox_max": [
        -40.67903137207031,
        -3171.47509765625,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -257.665283203125,
        -3025.329345703125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -3015.9111328125,
        1372.9527587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -257.69537353515625,
        -3024.712158203125,
        699.149169921875
      ],
      "bbox_max": [
        -229.613525390625,
        -3014.874755859375,
        1370.99560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -257.69537353515625,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -3015.87744140625,
        1370.99560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -362.7738952636719,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -2878.43115234375,
        1436.2266845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -327.6908264160156,
        -3024.712158203125,
        1315.572998046875
      ],
      "bbox_max": [
        -244.5576171875,
        -2936.516357421875,
        1370.9808349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -265.533935546875,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -3007.09814453125,
        1370.9808349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9094638824462891,
        0.4146226942539215,
        0.031041515991091728
      ],
      "plane_d": 1475.5181884765625,
      "bbox_min": [
        -362.7738952636719,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -2878.43115234375,
        1436.2266845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -362.7738952636719,
        -2931.7841796875,
        0.0
      ],
      "bbox_max": [
        -295.1515197753906,
        -2878.43115234375,
        1436.2266845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -362.7738952636719,
        -2931.7841796875,
        1312.0963134765625
      ],
      "bbox_max": [
        -331.9208984375,
        -2894.16455078125,
        1436.2266845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -362.7738952636719,
        -2912.790283203125,
        1362.815673828125
      ],
      "bbox_max": [
        -352.1159362792969,
        -2897.17431640625,
        1436.2266845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17600783705711365,
        0.971106767654419,
        0.1611611247062683
      ],
      "plane_d": 2872.85693359375,
      "bbox_min": [
        -347.9726257324219,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -2885.977783203125,
        1318.76904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7403071522712708,
        0.3129737675189972,
        0.5949727892875671
      ],
      "plane_d": 619.6898193359375,
      "bbox_min": [
        0.776123046875,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        629.46337890625,
        -3015.99462890625,
        1183.3170166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5805860161781311,
        0.8118429183959961,
        0.0618952140212059
      ],
      "plane_d": 2859.779541015625,
      "bbox_min": [
        0.776123046875,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        629.46337890625,
        -3015.99462890625,
        1078.021240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.520085871219635,
        0.8490864038467407,
        0.0925370380282402
      ],
      "plane_d": 2934.9326171875,
      "bbox_min": [
        500.994140625,
        -3198.260009765625,
        62.479896545410156
      ],
      "bbox_max": [
        623.2100830078125,
        -3081.6552734375,
        470.11712646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8246844410896301,
        -0.4889775812625885,
        0.2842473089694977
      ],
      "plane_d": -1631.2696533203125,
      "bbox_min": [
        0.776123046875,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        325.7543640136719,
        -3015.99462890625,
        1078.021240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7322627902030945,
        -0.6772246956825256,
        0.07181940227746964
      ],
      "plane_d": -2071.12744140625,
      "bbox_min": [
        0.776123046875,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        288.7086486816406,
        -3015.99462890625,
        952.2669677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7313293814659119,
        -0.6815345883369446,
        0.02584567293524742
      ],
      "plane_d": -2051.451904296875,
      "bbox_min": [
        0.776123046875,
        -3287.67822265625,
        0.0
      ],
      "bbox_max": [
        272.2877502441406,
        -3015.99462890625,
        740.441650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589617371559143,
        -0.6175175309181213,
        0.20651651918888092
      ],
      "plane_d": -1886.5819091796875,
      "bbox_min": [
        76.22080993652344,
        -3277.763916015625,
        163.80921936035156
      ],
      "bbox_max": [
        260.17779541015625,
        -3085.625732421875,
        290.81121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        76.22080993652344,
        -3104.03466796875,
        163.80921936035156
      ],
      "bbox_max": [
        96.166748046875,
        -3085.625732421875,
        207.1168212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7376764416694641,
        -0.6278554797172546,
        0.24825602769851685
      ],
      "plane_d": -1929.36328125,
      "bbox_min": [
        94.6696548461914,
        -3108.955322265625,
        201.7694549560547
      ],
      "bbox_max": [
        99.39128875732422,
        -3103.98291015625,
        207.1168212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        94.6696548461914,
        -3104.622314453125,
        201.7694549560547
      ],
      "bbox_max": [
        96.166748046875,
        -3103.98291015625,
        207.1168212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589617371559143,
        -0.6175175309181213,
        0.20651651918888092
      ],
      "plane_d": -1886.5819091796875,
      "bbox_min": [
        0.776123046875,
        -3287.67822265625,
        0.0
      ],
      "bbox_max": [
        259.686279296875,
        -3015.99462890625,
        288.5833740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        0.776123046875,
        -3103.98291015625,
        0.0
      ],
      "bbox_max": [
        94.6696548461914,
        -3015.99462890625,
        201.7694549560547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7376764416694641,
        -0.6278554797172546,
        0.24825602769851685
      ],
      "plane_d": -1929.36328125,
      "bbox_min": [
        41.913944244384766,
        -3261.787353515625,
        13.32565689086914
      ],
      "bbox_max": [
        199.5435791015625,
        -3102.16455078125,
        204.25372314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        41.913944244384766,
        -3123.666015625,
        13.32565689086914
      ],
      "bbox_max": [
        95.31218719482422,
        -3102.16455078125,
        203.09152221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7376764416694641,
        -0.6278554797172546,
        0.24825602769851685
      ],
      "plane_d": -1929.36328125,
      "bbox_min": [
        36.13882064819336,
        -3295.83544921875,
        0.0
      ],
      "bbox_max": [
        225.11087036132812,
        -3097.333251953125,
        131.87069702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        36.13882064819336,
        -3134.26806640625,
        0.0
      ],
      "bbox_max": [
        67.61579132080078,
        -3097.333251953125,
        72.63072204589844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589617371559143,
        -0.6175175309181213,
        0.20651651918888092
      ],
      "plane_d": -1886.5819091796875,
      "bbox_min": [
        199.54443359375,
        -3289.75439453125,
        99.0547103881836
      ],
      "bbox_max": [
        225.11087036132812,
        -3261.78857421875,
        131.87069702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -347.9726257324219,
        -3129.21435546875,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -2885.977783203125,
        1318.76904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -347.9726257324219,
        -2912.31396484375,
        1310.6319580078125
      ],
      "bbox_max": [
        -339.4705810546875,
        -2893.6083984375,
        1318.76904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.520085871219635,
        0.8490864038467407,
        0.0925370380282402
      ],
      "plane_d": 2934.9326171875,
      "bbox_min": [
        600.8919067382812,
        -3129.21435546875,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -3062.634765625,
        373.4314270019531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5805860161781311,
        0.8118429183959961,
        0.0618952140212059
      ],
      "plane_d": 2859.779541015625,
      "bbox_min": [
        623.2100830078125,
        -3081.6552734375,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -3062.634765625,
        62.479888916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -280.0,
        -2863.901123046875,
        0.0
      ],
      "bbox_max": [
        817.5167846679688,
        -2040.0,
        1275.6396484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.256084680557251,
        0.9662680625915527,
        0.027326710522174835
      ],
      "plane_d": 2474.06640625,
      "bbox_min": [
        -280.0,
        -2675.23974609375,
        144.4669647216797
      ],
      "bbox_max": [
        -120.41259765625,
        -2596.432861328125,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26160192489624023,
        0.9247593879699707,
        0.27637779712677
      ],
      "plane_d": 2175.628173828125,
      "bbox_min": [
        -280.0,
        -2675.23974609375,
        749.8496704101562
      ],
      "bbox_max": [
        -126.417724609375,
        -2615.420654296875,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -142.0,
      "bbox_min": [
        -169.5,
        -2672.5,
        885.0
      ],
      "bbox_max": [
        -138.0,
        -2663.0,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2663.0,
      "bbox_min": [
        -142.0,
        -2672.5,
        887.5
      ],
      "bbox_max": [
        -138.0,
        -2663.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -142.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -138.0,
        -2666.18798828125,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -169.5,
        -2672.5,
        885.0
      ],
      "bbox_max": [
        -142.0,
        -2665.086669921875,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        -144.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -144.0,
        -2667.88525390625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -486.05755615234375,
      "bbox_min": [
        -169.5,
        -2666.5,
        885.0
      ],
      "bbox_max": [
        -168.53497314453125,
        -2665.086669921875,
        887.4125366210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14437326788902283,
        0.977375328540802,
        0.1545761078596115
      ],
      "plane_d": 2438.747314453125,
      "bbox_min": [
        -280.0,
        -2675.23974609375,
        749.8496704101562
      ],
      "bbox_max": [
        -132.919921875,
        -2654.277587890625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -168.0,
      "bbox_min": [
        -170.0,
        -2672.5,
        885.0
      ],
      "bbox_max": [
        -138.0,
        -2660.849853515625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2663.0,
      "bbox_min": [
        -168.0,
        -2672.5,
        885.0
      ],
      "bbox_max": [
        -138.0,
        -2660.849853515625,
        920.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -142.0,
      "bbox_min": [
        -168.0,
        -2672.5,
        904.0472412109375
      ],
      "bbox_max": [
        -138.0,
        -2663.0,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -142.0,
        -2667.319580078125,
        918.5
      ],
      "bbox_max": [
        -138.0,
        -2663.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -168.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -142.0,
        -2663.0,
        920.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        -144.0,
        -2668.33349609375,
        918.5
      ],
      "bbox_max": [
        -144.0,
        -2663.0,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -168.0,
        -2663.0,
        885.0
      ],
      "bbox_max": [
        -138.0,
        -2660.849853515625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        -144.0,
        -2663.0,
        918.5
      ],
      "bbox_max": [
        -144.0,
        -2661.736083984375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2142.4599609375,
      "bbox_min": [
        -168.0,
        -2662.5,
        885.0
      ],
      "bbox_max": [
        -164.5,
        -2661.5,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -170.0,
        -2672.5,
        885.0
      ],
      "bbox_max": [
        -168.0,
        -2661.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -170.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -170.0,
        -2665.57666015625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -486.05755615234375,
      "bbox_min": [
        -169.5,
        -2665.534912109375,
        885.0
      ],
      "bbox_max": [
        -168.0,
        -2661.5,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2142.4599609375,
      "bbox_min": [
        -169.5,
        -2662.5,
        885.0
      ],
      "bbox_max": [
        -168.0,
        -2661.5,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5633555054664612,
        0.8184596300125122,
        0.11293553560972214
      ],
      "plane_d": 2242.135498046875,
      "bbox_min": [
        -280.0,
        -2675.23974609375,
        749.8496704101562
      ],
      "bbox_max": [
        -138.0,
        -2654.277587890625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -170.0,
        -2665.81396484375,
        904.0755615234375
      ],
      "bbox_max": [
        -138.0,
        -2655.5,
        920.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -170.0,
        -2665.81396484375,
        918.5
      ],
      "bbox_max": [
        -138.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        -170.0,
        -2661.973388671875,
        918.5
      ],
      "bbox_max": [
        -138.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2655.5,
      "bbox_min": [
        -144.0,
        -2655.5,
        918.5
      ],
      "bbox_max": [
        -138.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2655.5,
      "bbox_min": [
        -170.0,
        -2655.5,
        918.5
      ],
      "bbox_max": [
        -164.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -168.0,
      "bbox_min": [
        -168.0,
        -2665.0,
        904.0755615234375
      ],
      "bbox_max": [
        -166.0,
        -2663.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2663.0,
      "bbox_min": [
        -168.0,
        -2663.0,
        904.0755615234375
      ],
      "bbox_max": [
        -166.0,
        -2663.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5633555054664612,
        0.8184596300125122,
        0.11293553560972214
      ],
      "plane_d": 2242.135498046875,
      "bbox_min": [
        -280.0,
        -2657.304443359375,
        749.8496704101562
      ],
      "bbox_max": [
        -274.07421875,
        -2654.277587890625,
        801.344482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6797831654548645,
        0.7331898212432861,
        0.018096331506967545
      ],
      "plane_d": 2118.830810546875,
      "bbox_min": [
        -280.0,
        -2656.94873046875,
        0.0
      ],
      "bbox_max": [
        129.7200469970703,
        -2040.0,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5633555054664612,
        0.8184596300125122,
        0.11293553560972214
      ],
      "plane_d": 2242.135498046875,
      "bbox_min": [
        -280.0,
        -2656.94873046875,
        731.131591796875
      ],
      "bbox_max": [
        -274.07421875,
        -2648.321533203125,
        798.7672729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -280.0,
        -2654.277587890625,
        731.131591796875
      ],
      "bbox_max": [
        -274.07421875,
        -2648.321533203125,
        761.5028686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424458384513855,
        -0.8393089771270752,
        0.03623468056321144
      ],
      "plane_d": -2253.585693359375,
      "bbox_min": [
        -280.0,
        -2641.687744140625,
        0.0
      ],
      "bbox_max": [
        129.7200469970703,
        -2040.0,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430268257856369,
        -0.8978968262672424,
        0.09300856292247772
      ],
      "plane_d": -2403.1669921875,
      "bbox_min": [
        -280.0,
        -2597.9091796875,
        0.0
      ],
      "bbox_max": [
        129.7200469970703,
        -2040.0,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7759400010108948,
        0.4866269528865814,
        0.4013866186141968
      ],
      "plane_d": 605.982421875,
      "bbox_min": [
        -280.0,
        -2597.9091796875,
        0.0
      ],
      "bbox_max": [
        129.7200469970703,
        -2040.0,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7798405289649963,
        0.46382713317871094,
        0.42037254571914673
      ],
      "plane_d": 529.9271850585938,
      "bbox_min": [
        -280.0,
        -2597.9091796875,
        0.0
      ],
      "bbox_max": [
        129.7200469970703,
        -2040.0,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2366829514503479,
        0.9335814118385315,
        0.2690852880477905
      ],
      "plane_d": 1812.3699951171875,
      "bbox_min": [
        -280.0,
        -2597.9091796875,
        0.0
      ],
      "bbox_max": [
        129.7200469970703,
        -2040.0,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -280.0,
        -2597.9091796875,
        0.0
      ],
      "bbox_max": [
        119.41747283935547,
        -2124.32177734375,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.557774543762207,
        -0.8295528888702393,
        0.027008702978491783
      ],
      "plane_d": -2232.4296875,
      "bbox_min": [
        -280.0,
        -2581.8466796875,
        0.0
      ],
      "bbox_max": [
        -116.931396484375,
        -2208.415771484375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        -229.0,
        -2581.8466796875,
        0.0
      ],
      "bbox_max": [
        -116.931396484375,
        -2208.415771484375,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -145.0,
      "bbox_min": [
        -229.0,
        -2524.5,
        780.0
      ],
      "bbox_max": [
        -120.0,
        -2208.415771484375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -145.0,
        -2521.5,
        782.5
      ],
      "bbox_max": [
        -120.0,
        -2208.415771484375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -145.0,
        -2521.5,
        782.5
      ],
      "bbox_max": [
        -120.0,
        -2208.415771484375,
        819.3709106445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -423.849609375,
      "bbox_min": [
        -143.5,
        -2521.5,
        782.5
      ],
      "bbox_max": [
        -142.5,
        -2516.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -189.5,
      "bbox_min": [
        -229.0,
        -2513.32666015625,
        780.0
      ],
      "bbox_max": [
        -145.0,
        -2214.13623046875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -188.300048828125,
        -2513.32666015625,
        782.5
      ],
      "bbox_max": [
        -145.0,
        -2214.13623046875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -188.300048828125,
        -2513.32666015625,
        782.5
      ],
      "bbox_max": [
        -145.0,
        -2214.13623046875,
        819.024658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 816.0,
      "bbox_min": [
        -169.8990020751953,
        -2513.32666015625,
        816.0
      ],
      "bbox_max": [
        -164.0,
        -2510.5,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.042724609375,
      "bbox_min": [
        -188.300048828125,
        -2505.275634765625,
        782.5
      ],
      "bbox_max": [
        -188.042724609375,
        -2498.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.300048828125,
      "bbox_min": [
        -188.300048828125,
        -2504.73779296875,
        786.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2498.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2485.907958984375,
        780.0
      ],
      "bbox_max": [
        -226.5,
        -2461.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -226.5,
      "bbox_min": [
        -226.5,
        -2485.344970703125,
        797.0
      ],
      "bbox_max": [
        -226.5,
        -2461.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2770751714706421,
        0.8977282643318176,
        0.34251025319099426
      ],
      "plane_d": 2265.678955078125,
      "bbox_min": [
        -229.0,
        -2581.8466796875,
        0.0
      ],
      "bbox_max": [
        -116.931396484375,
        -2461.5,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -229.0,
        -2502.960693359375,
        748.5889282226562
      ],
      "bbox_max": [
        -189.5,
        -2461.5,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2486.063232421875,
        778.5
      ],
      "bbox_max": [
        -229.0,
        -2461.5,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15676754713058472,
        -0.9876355528831482
      ],
      "plane_d": 376.5713195800781,
      "bbox_min": [
        -224.5,
        -2500.185302734375,
        748.5889282226562
      ],
      "bbox_max": [
        -193.5,
        -2461.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845619797706604,
        -0.17503629624843597,
        0.0
      ],
      "plane_d": -651.885986328125,
      "bbox_min": [
        -224.5,
        -2499.52880859375,
        772.0
      ],
      "bbox_max": [
        -197.0,
        -2461.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2498.5,
      "bbox_min": [
        -201.0,
        -2499.52880859375,
        777.8729858398438
      ],
      "bbox_max": [
        -197.0,
        -2498.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -201.0,
      "bbox_min": [
        -201.0,
        -2499.52880859375,
        777.8729858398438
      ],
      "bbox_max": [
        -201.0,
        -2498.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -220.49998474121094,
      "bbox_min": [
        -220.5,
        -2500.185302734375,
        748.5889282226562
      ],
      "bbox_max": [
        -197.0,
        -2463.99072265625,
        778.0363159179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2498.5,
      "bbox_min": [
        -201.0,
        -2500.185302734375,
        774.0122680664062
      ],
      "bbox_max": [
        -197.0,
        -2498.5,
        778.0363159179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -200.5,
      "bbox_min": [
        -201.0,
        -2500.185302734375,
        774.0122680664062
      ],
      "bbox_max": [
        -197.5,
        -2498.5,
        778.0363159179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2499.0,
      "bbox_min": [
        -200.5,
        -2499.0,
        775.0
      ],
      "bbox_max": [
        -197.5,
        -2499.0,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -201.0,
      "bbox_min": [
        -201.0,
        -2499.73974609375,
        776.0
      ],
      "bbox_max": [
        -201.0,
        -2498.5,
        778.0363159179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5573205947875977,
        -0.7778975963592529,
        0.290291428565979
      ],
      "plane_d": -2111.4228515625,
      "bbox_min": [
        -280.0,
        -2523.504638671875,
        29.026920318603516
      ],
      "bbox_max": [
        -247.552978515625,
        -2501.824462890625,
        35.92359924316406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        63.3701171875,
        -2206.544921875,
        728.4032592773438
      ],
      "bbox_max": [
        119.41747283935547,
        -2124.32177734375,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642076253890991,
        0.49060776829719543,
        -0.11157596111297607
      ],
      "plane_d": 1246.207275390625,
      "bbox_min": [
        -187.47689819335938,
        -2303.484619140625,
        626.3668212890625
      ],
      "bbox_max": [
        129.7200469970703,
        -2040.0,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9042837023735046,
        0.4269319474697113,
        0.0
      ],
      "plane_d": 999.3490600585938,
      "bbox_min": [
        -187.47689819335938,
        -2233.716796875,
        626.3668212890625
      ],
      "bbox_max": [
        129.7200469970703,
        -2040.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        63.3701171875,
        -2206.544921875,
        739.994140625
      ],
      "bbox_max": [
        129.7200469970703,
        -2066.00927734375,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        76.70938873291016,
        -2044.892578125,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -2040.0,
        649.1409912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        107.26763916015625,
        -2044.892578125,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -2040.0,
        649.1409912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -187.47689819335938,
        -2233.716796875,
        626.3668212890625
      ],
      "bbox_max": [
        82.40275573730469,
        -2040.0,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -187.47689819335938,
        -2233.716796875,
        818.7000122070312
      ],
      "bbox_max": [
        -122.04180908203125,
        -2206.403564453125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -174.511474609375,
        -2233.716796875,
        861.0
      ],
      "bbox_max": [
        -125.63127136230469,
        -2214.045166015625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9814715385437012,
        0.1916080117225647
      ],
      "plane_d": -2147.4345703125,
      "bbox_min": [
        -184.58523559570312,
        -2219.521240234375,
        626.3668212890625
      ],
      "bbox_max": [
        82.40275573730469,
        -2040.0,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -172.86427307128906,
        -2064.75,
        631.1911010742188
      ],
      "bbox_max": [
        82.40275573730469,
        -2040.0,
        757.9679565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -113.6387939453125,
        -2059.573974609375,
        642.696533203125
      ],
      "bbox_max": [
        82.40275573730469,
        -2040.0,
        693.14501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -113.6387939453125,
        -2050.576416015625,
        648.947509765625
      ],
      "bbox_max": [
        -94.98645782470703,
        -2040.0,
        661.1878051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -113.6387939453125,
        -2049.560791015625,
        652.0034790039062
      ],
      "bbox_max": [
        -107.29669189453125,
        -2040.0,
        660.5897827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -104.91006469726562,
        -2059.573974609375,
        653.67919921875
      ],
      "bbox_max": [
        -97.62342834472656,
        -2040.0,
        693.14501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -172.86427307128906,
        -2064.75,
        631.1911010742188
      ],
      "bbox_max": [
        -108.52902221679688,
        -2040.0,
        658.9451293945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -184.58523559570312,
        -2219.521240234375,
        626.3668212890625
      ],
      "bbox_max": [
        -110.26805877685547,
        -2063.052490234375,
        865.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -165.60885620117188,
        -2219.521240234375,
        821.0
      ],
      "bbox_max": [
        -121.0,
        -2179.60009765625,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -141.76400756835938,
        -2181.5,
        861.0
      ],
      "bbox_max": [
        -123.87754821777344,
        -2179.60009765625,
        865.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -140.847412109375,
        -2180.03857421875,
        861.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -140.26210021972656,
        -2179.60009765625,
        861.5999755859375
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -162.45565795898438,
        -2187.44677734375,
        821.0
      ],
      "bbox_max": [
        -121.0,
        -2180.03857421875,
        861.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -147.56275939941406,
        -2187.44677734375,
        854.5
      ],
      "bbox_max": [
        -129.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 432.67938232421875,
      "bbox_min": [
        -131.5,
        -2187.44677734375,
        854.5
      ],
      "bbox_max": [
        -129.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -142.79855346679688,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2180.03857421875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -138.13999938964844,
        -2078.106689453125,
        626.3668212890625
      ],
      "bbox_max": [
        -110.26805877685547,
        -2063.052490234375,
        639.8867797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5552207231521606,
        0.3105274438858032,
        0.7715587019920349
      ],
      "plane_d": -146.06512451171875,
      "bbox_min": [
        -280.0,
        -2457.307861328125,
        637.6512451171875
      ],
      "bbox_max": [
        -139.53794860839844,
        -2040.0,
        1005.6622924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -280.0,
        -2239.39990234375,
        637.6512451171875
      ],
      "bbox_max": [
        -139.53794860839844,
        -2040.0,
        867.0999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -280.0,
        -2239.39990234375,
        790.450439453125
      ],
      "bbox_max": [
        -143.83319091796875,
        -2181.5,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -280.0,
        -2221.244384765625,
        861.0
      ],
      "bbox_max": [
        -268.0,
        -2181.5,
        867.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8180076479911804,
        0.18297654390335083,
        0.5453283786773682
      ],
      "plane_d": -291.77178955078125,
      "bbox_min": [
        -277.300048828125,
        -2219.5,
        862.0
      ],
      "bbox_max": [
        -268.0,
        -2181.5,
        867.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -280.0,
        -2221.244384765625,
        861.0
      ],
      "bbox_max": [
        -277.400146484375,
        -2218.526123046875,
        864.3377685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -280.0,
        -2219.5703125,
        790.450439453125
      ],
      "bbox_max": [
        -143.83319091796875,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -280.0,
        -2219.5703125,
        857.0
      ],
      "bbox_max": [
        -270.1224365234375,
        -2181.5,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -280.0,
        -2219.5703125,
        857.0
      ],
      "bbox_max": [
        -277.4501953125,
        -2216.561279296875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -280.0,
        -2219.5,
        790.450439453125
      ],
      "bbox_max": [
        -162.45565795898438,
        -2181.5,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -280.0,
        -2219.5,
        818.7000122070312
      ],
      "bbox_max": [
        -268.0,
        -2181.5,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -280.0,
        -2219.5,
        818.7000122070312
      ],
      "bbox_max": [
        -268.0,
        -2181.5,
        837.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -278.34173583984375,
        -2206.77099609375,
        820.0210571289062
      ],
      "bbox_max": [
        -270.515625,
        -2194.963623046875,
        837.0676879882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -280.0,
        -2217.564208984375,
        819.9862670898438
      ],
      "bbox_max": [
        -277.5511474609375,
        -2197.676025390625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -280.0,
        -2209.36181640625,
        819.9862670898438
      ],
      "bbox_max": [
        -278.05419921875,
        -2197.676025390625,
        840.6448364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -280.0,
        -2209.36181640625,
        833.1509399414062
      ],
      "bbox_max": [
        -278.05419921875,
        -2205.35400390625,
        840.6448364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36162224411964417,
        0.8005647659301758,
        0.4778340458869934
      ],
      "plane_d": 1267.4736328125,
      "bbox_min": [
        -280.0,
        -2198.250732421875,
        790.450439453125
      ],
      "bbox_max": [
        -245.962646484375,
        -2181.5,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -280.0,
        -2198.250732421875,
        804.6587524414062
      ],
      "bbox_max": [
        -245.962646484375,
        -2181.5,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -256.7187194824219,
        -2186.987548828125,
        808.6917114257812
      ],
      "bbox_max": [
        -245.962646484375,
        -2181.5,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -280.0,
        -2181.5,
        637.6512451171875
      ],
      "bbox_max": [
        -139.53794860839844,
        -2040.0,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -250.85545349121094,
        -2181.5,
        637.6512451171875
      ],
      "bbox_max": [
        -139.53794860839844,
        -2040.0,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -146.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -140.26210021972656,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -146.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -146.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -250.85545349121094,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -243.68463134765625,
        -2066.32080078125,
        645.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -250.85545349121094,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -246.357421875,
        -2068.887451171875,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -280.0,
        -2181.5,
        645.7384643554688
      ],
      "bbox_max": [
        -227.65122985839844,
        -2040.0,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -280.0,
        -2181.5,
        645.7384643554688
      ],
      "bbox_max": [
        -227.65122985839844,
        -2040.0,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36162224411964417,
        0.8005647659301758,
        0.4778340458869934
      ],
      "plane_d": 1267.4736328125,
      "bbox_min": [
        -280.0,
        -2181.5,
        783.0938720703125
      ],
      "bbox_max": [
        -249.0,
        -2177.109130859375,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -261.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -261.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        -229.0,
        -2527.5,
        765.3291015625
      ],
      "bbox_max": [
        -162.0,
        -2484.14697265625,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -168.0,
      "bbox_min": [
        -229.0,
        -2527.5,
        780.0
      ],
      "bbox_max": [
        -164.0,
        -2484.14697265625,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 816.0,
      "bbox_min": [
        -168.0,
        -2527.5,
        816.0
      ],
      "bbox_max": [
        -164.0,
        -2511.409912109375,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -189.5,
      "bbox_min": [
        -229.0,
        -2527.5,
        780.0
      ],
      "bbox_max": [
        -168.0,
        -2484.619873046875,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -188.5,
        -2527.5,
        782.5
      ],
      "bbox_max": [
        -168.0,
        -2504.68603515625,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 816.0,
      "bbox_min": [
        -170.0,
        -2527.5,
        816.0
      ],
      "bbox_max": [
        -168.0,
        -2510.5,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.042724609375,
      "bbox_min": [
        -188.5,
        -2523.5,
        782.5
      ],
      "bbox_max": [
        -187.60009765625,
        -2504.68603515625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -188.042724609375,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -187.60009765625,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.300048828125,
      "bbox_min": [
        -188.5,
        -2523.5,
        782.5
      ],
      "bbox_max": [
        -188.042724609375,
        -2504.68603515625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -188.300048828125,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -188.042724609375,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.5,
      "bbox_min": [
        -188.5,
        -2523.5,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -188.5,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 789.0,
      "bbox_min": [
        -229.0,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -199.0,
        -2484.619873046875,
        804.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1928.6337890625,
      "bbox_min": [
        -229.0,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -219.0,
        -2484.619873046875,
        804.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -226.5,
      "bbox_min": [
        -226.5,
        -2498.5,
        797.0
      ],
      "bbox_max": [
        -226.5,
        -2484.619873046875,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1928.6339111328125,
      "bbox_min": [
        -229.0,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -219.0,
        -2498.5,
        789.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -229.0,
        -2508.5,
        765.3291015625
      ],
      "bbox_max": [
        -193.73773193359375,
        -2485.907958984375,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1928.6339111328125,
      "bbox_min": [
        -229.0,
        -2508.5,
        778.5
      ],
      "bbox_max": [
        -219.0,
        -2485.907958984375,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2498.5,
        778.5
      ],
      "bbox_max": [
        -229.0,
        -2485.907958984375,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5639985799789429,
        -0.8257757425308228
      ],
      "plane_d": -773.2127075195312,
      "bbox_min": [
        -221.0,
        -2502.5,
        765.3291015625
      ],
      "bbox_max": [
        -197.5,
        -2490.7080078125,
        778.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -221.0,
      "bbox_min": [
        -221.0,
        -2502.5,
        765.3291015625
      ],
      "bbox_max": [
        -200.5,
        -2490.7080078125,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 775.9999389648438,
      "bbox_min": [
        -221.0,
        -2502.5,
        765.3291015625
      ],
      "bbox_max": [
        -200.5,
        -2490.7080078125,
        778.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2498.5,
      "bbox_min": [
        -221.0,
        -2502.5,
        776.0
      ],
      "bbox_max": [
        -201.0,
        -2490.7080078125,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -201.0,
      "bbox_min": [
        -201.0,
        -2502.5,
        776.0
      ],
      "bbox_max": [
        -201.0,
        -2499.480712890625,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15676754713058472,
        -0.9876355528831482
      ],
      "plane_d": 376.5713195800781,
      "bbox_min": [
        -219.30735778808594,
        -2493.0,
        776.6690673828125
      ],
      "bbox_max": [
        -214.84860229492188,
        -2490.7080078125,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845619797706604,
        -0.17503629624843597,
        0.0
      ],
      "plane_d": -651.885986328125,
      "bbox_min": [
        -219.30735778808594,
        -2493.0,
        776.6690673828125
      ],
      "bbox_max": [
        -218.89990234375,
        -2490.7080078125,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -220.49998474121094,
      "bbox_min": [
        -220.5,
        -2502.0,
        765.3291015625
      ],
      "bbox_max": [
        -200.5,
        -2491.060546875,
        776.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -200.5,
      "bbox_min": [
        -220.5,
        -2502.0,
        772.5
      ],
      "bbox_max": [
        -200.5,
        -2499.0,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2499.0,
      "bbox_min": [
        -220.5,
        -2499.0,
        775.0
      ],
      "bbox_max": [
        -217.5,
        -2499.0,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3544447720050812,
        0.9085077047348022,
        0.22132006287574768
      ],
      "plane_d": 2284.22607421875,
      "bbox_min": [
        -280.0,
        -2641.687744140625,
        0.0
      ],
      "bbox_max": [
        -125.29585266113281,
        -2476.800537109375,
        631.989990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2770751714706421,
        0.8977282643318176,
        0.34251025319099426
      ],
      "plane_d": 2265.678955078125,
      "bbox_min": [
        -280.0,
        -2641.687744140625,
        0.0
      ],
      "bbox_max": [
        -158.05810546875,
        -2476.800537109375,
        631.989990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5384513735771179,
        -0.8420933485031128,
        0.03080403432250023
      ],
      "plane_d": -2256.63623046875,
      "bbox_min": [
        -280.0,
        -2641.687744140625,
        0.0
      ],
      "bbox_max": [
        -246.677001953125,
        -2476.800537109375,
        631.989990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430268257856369,
        -0.8978968262672424,
        0.09300856292247772
      ],
      "plane_d": -2403.1669921875,
      "bbox_min": [
        -280.0,
        -2502.31689453125,
        539.8119506835938
      ],
      "bbox_max": [
        -246.677001953125,
        -2476.800537109375,
        631.989990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5485955476760864,
        0.7409572601318359,
        0.3873308598995209
      ],
      "plane_d": 2070.496826171875,
      "bbox_min": [
        -280.0,
        -2641.687744140625,
        0.0
      ],
      "bbox_max": [
        -247.552978515625,
        -2502.831787109375,
        90.5094223022461
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5573205947875977,
        -0.7778975963592529,
        0.290291428565979
      ],
      "plane_d": -2111.4228515625,
      "bbox_min": [
        -280.0,
        -2536.31884765625,
        0.0
      ],
      "bbox_max": [
        -247.552978515625,
        -2502.831787109375,
        35.92359924316406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.475697785615921,
        -0.7068511247634888,
        0.5235198140144348
      ],
      "plane_d": -1910.9530029296875,
      "bbox_min": [
        -280.0,
        -2536.31884765625,
        0.0
      ],
      "bbox_max": [
        -248.378662109375,
        -2512.26806640625,
        3.740133762359619
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1169.2957763671875,
        -2260.83544921875,
        0.0
      ],
      "bbox_max": [
        -279.99993896484375,
        -2040.0,
        1148.8271484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -860.804443359375,
        -2186.354736328125,
        0.0
      ],
      "bbox_max": [
        -809.9580688476562,
        -2163.21533203125,
        1148.8271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -860.804443359375,
        -2180.10693359375,
        1118.8780517578125
      ],
      "bbox_max": [
        -854.4132080078125,
        -2173.491455078125,
        1148.8271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -852.66796875,
        -2186.354736328125,
        0.0
      ],
      "bbox_max": [
        -809.9580688476562,
        -2163.21533203125,
        765.5958862304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -852.66796875,
        -2184.5048828125,
        296.2656555175781
      ],
      "bbox_max": [
        -823.1215209960938,
        -2165.90673828125,
        765.5958862304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429205179214478,
        0.6689924597740173,
        0.022761043161153793
      ],
      "plane_d": 2066.187744140625,
      "bbox_min": [
        -842.6279907226562,
        -2184.5048828125,
        296.2656555175781
      ],
      "bbox_max": [
        -823.1215209960938,
        -2165.90673828125,
        424.899169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -852.66796875,
        -2182.1826171875,
        707.8184814453125
      ],
      "bbox_max": [
        -839.6445922851562,
        -2168.956298828125,
        765.5958862304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -1036.3642578125,
        -2259.252685546875,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2040.0,
        888.99365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3755790889263153,
        0.9264931678771973,
        0.02346816658973694
      ],
      "plane_d": 2312.43115234375,
      "bbox_min": [
        -1036.3642578125,
        -2168.478759765625,
        0.0
      ],
      "bbox_max": [
        -835.00244140625,
        -2040.0,
        732.7373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -980.2942504882812,
        -2168.478759765625,
        301.9143371582031
      ],
      "bbox_max": [
        -845.19384765625,
        -2113.5029296875,
        732.7373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762436032295227,
        0.7347268462181091,
        0.053582221269607544
      ],
      "plane_d": 2184.045166015625,
      "bbox_min": [
        -974.577392578125,
        -2127.7587890625,
        507.709716796875
      ],
      "bbox_max": [
        -964.5498046875,
        -2120.9970703125,
        650.2186279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36377382278442383,
        0.930548906326294,
        0.04180183261632919
      ],
      "plane_d": 2304.13818359375,
      "bbox_min": [
        -980.2942504882812,
        -2163.067626953125,
        301.9143371582031
      ],
      "bbox_max": [
        -845.19384765625,
        -2113.5029296875,
        622.5990600585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6963309645652771,
        0.7165287137031555,
        0.04134921357035637
      ],
      "plane_d": 2171.017333984375,
      "bbox_min": [
        -980.2942504882812,
        -2121.847900390625,
        301.9143371582031
      ],
      "bbox_max": [
        -960.02001953125,
        -2113.5029296875,
        622.5990600585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762436032295227,
        0.7347268462181091,
        0.053582221269607544
      ],
      "plane_d": 2184.045166015625,
      "bbox_min": [
        -980.2942504882812,
        -2121.847900390625,
        487.23077392578125
      ],
      "bbox_max": [
        -964.5498046875,
        -2113.5029296875,
        622.5990600585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3834894299507141,
        0.9231441020965576,
        0.027221042662858963
      ],
      "plane_d": 2311.81103515625,
      "bbox_min": [
        -1036.3642578125,
        -2157.40576171875,
        0.0
      ],
      "bbox_max": [
        -835.00244140625,
        -2040.0,
        591.9867553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762436032295227,
        0.7347268462181091,
        0.053582221269607544
      ],
      "plane_d": 2184.045166015625,
      "bbox_min": [
        -1036.3642578125,
        -2114.774169921875,
        0.0
      ],
      "bbox_max": [
        -895.0585327148438,
        -2040.0,
        591.9867553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.703201413154602,
        0.7104752063751221,
        0.027071993798017502
      ],
      "plane_d": 2169.124267578125,
      "bbox_min": [
        -1034.701171875,
        -2114.774169921875,
        0.0
      ],
      "bbox_max": [
        -950.1731567382812,
        -2040.0,
        487.23077392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6963309645652771,
        0.7165287137031555,
        0.04134921357035637
      ],
      "plane_d": 2171.017333984375,
      "bbox_min": [
        -1034.701171875,
        -2114.774169921875,
        235.4507293701172
      ],
      "bbox_max": [
        -960.02001953125,
        -2040.0,
        487.23077392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7558661699295044,
        -0.4322206377983093,
        0.49178430438041687
      ],
      "plane_d": -188.6185302734375,
      "bbox_min": [
        -1030.2423095703125,
        -2107.35302734375,
        0.0
      ],
      "bbox_max": [
        -950.1731567382812,
        -2040.0,
        174.0879364013672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7558661699295044,
        -0.4322206377983093,
        0.49178430438041687
      ],
      "plane_d": -188.6185302734375,
      "bbox_min": [
        -1026.597900390625,
        -2098.053955078125,
        0.0
      ],
      "bbox_max": [
        -895.0585327148438,
        -2040.0,
        366.4222717285156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16410835087299347,
        -0.9725523591041565,
        0.16495563089847565
      ],
      "plane_d": -2175.37255859375,
      "bbox_min": [
        -1014.864501953125,
        -2087.986083984375,
        0.0
      ],
      "bbox_max": [
        -895.0585327148438,
        -2040.0,
        194.07044982910156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22133076190948486,
        -0.9681739807128906,
        0.11684101819992065
      ],
      "plane_d": -2216.021240234375,
      "bbox_min": [
        -1002.93603515625,
        -2087.986083984375,
        0.0
      ],
      "bbox_max": [
        -895.0585327148438,
        -2040.0,
        194.07044982910156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -938.8984375,
        -2087.986083984375,
        0.0
      ],
      "bbox_max": [
        -895.0585327148438,
        -2057.93994140625,
        157.1575164794922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21190190315246582,
        -0.9627490043640137,
        0.16796369850635529
      ],
      "plane_d": -2199.87109375,
      "bbox_min": [
        -938.8984375,
        -2087.986083984375,
        0.0
      ],
      "bbox_max": [
        -895.0585327148438,
        -2066.770263671875,
        77.95028686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2292175441980362,
        -0.9629797339439392,
        0.14187826216220856
      ],
      "plane_d": -2214.51904296875,
      "bbox_min": [
        -931.78857421875,
        -2074.339599609375,
        60.35429000854492
      ],
      "bbox_max": [
        -909.219970703125,
        -2066.770263671875,
        77.95028686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4714754819869995,
        -0.8809452652931213,
        0.040574923157691956
      ],
      "plane_d": -2225.99169921875,
      "bbox_min": [
        -948.3048706054688,
        -2259.252685546875,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2040.0,
        888.99365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7473034858703613,
        -0.6633269190788269,
        0.039178479462862015
      ],
      "plane_d": -1945.5296630859375,
      "bbox_min": [
        -793.6016235351562,
        -2259.252685546875,
        466.048828125
      ],
      "bbox_max": [
        -280.0,
        -2040.0,
        888.99365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -519.0640258789062,
        -2259.252685546875,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2040.0,
        888.99365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -408.99609375,
        -2259.252685546875,
        639.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2092.2255859375,
        888.99365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -398.73809814453125,
        -2259.252685546875,
        639.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2133.71728515625,
        888.99365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -398.73809814453125,
        -2259.252685546875,
        639.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2137.05517578125,
        888.99365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5552207231521606,
        0.3105274438858032,
        0.7715587019920349
      ],
      "plane_d": -146.06512451171875,
      "bbox_min": [
        -337.4930114746094,
        -2259.252685546875,
        667.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2137.05517578125,
        888.99365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -337.4930114746094,
        -2219.5,
        667.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2137.05517578125,
        841.750732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -280.60009765625,
        -2219.5,
        834.86962890625
      ],
      "bbox_max": [
        -280.0,
        -2216.49951171875,
        841.750732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -280.60009765625,
        -2219.5,
        834.86962890625
      ],
      "bbox_max": [
        -280.0,
        -2216.49951171875,
        836.9013061523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -355.803466796875,
        -2233.3134765625,
        667.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2133.71728515625,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -337.60186767578125,
        -2138.847412109375,
        667.9999389648438
      ],
      "bbox_max": [
        -336.4956359863281,
        -2136.859619140625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36162224411964417,
        0.8005647659301758,
        0.4778340458869934
      ],
      "plane_d": 1267.4736328125,
      "bbox_min": [
        -355.803466796875,
        -2233.3134765625,
        667.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2133.71728515625,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -338.6816101074219,
        -2138.659423828125,
        667.9999389648438
      ],
      "bbox_max": [
        -336.6002502441406,
        -2134.919677734375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -355.803466796875,
        -2233.3134765625,
        667.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2133.71728515625,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -338.9958801269531,
        -2136.82763671875,
        667.9999389648438
      ],
      "bbox_max": [
        -337.6197204589844,
        -2134.35498046875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -297.98779296875,
        -2233.3134765625,
        705.1061401367188
      ],
      "bbox_max": [
        -280.0,
        -2133.71728515625,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -297.98779296875,
        -2233.3134765625,
        840.6448364257812
      ],
      "bbox_max": [
        -280.0,
        -2209.36181640625,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3062765598297119,
        0.638495922088623,
        0.7060579061508179
      ],
      "plane_d": 782.314453125,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        639.9999389648438
      ],
      "bbox_max": [
        -294.1380310058594,
        -2092.2255859375,
        705.8507690429688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -342.2251281738281,
        -2136.17138671875,
        645.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2106.3486328125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -338.2642822265625,
        -2107.583984375,
        645.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2106.3486328125,
        648.5309448242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -361.6012878417969,
        -2150.153564453125,
        667.9999389648438
      ],
      "bbox_max": [
        -305.860595703125,
        -2121.553955078125,
        683.38916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -342.4285888671875,
        -2132.58642578125,
        667.9999389648438
      ],
      "bbox_max": [
        -339.98016357421875,
        -2128.187255859375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        661.1591796875
      ],
      "bbox_max": [
        -294.1380310058594,
        -2092.2255859375,
        705.8507690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -363.3562927246094,
        -2148.298828125,
        661.1591796875
      ],
      "bbox_max": [
        -294.1380310058594,
        -2092.2255859375,
        705.8507690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2629581093788147,
        0.5350224375724792,
        0.8028724193572998
      ],
      "plane_d": 510.412353515625,
      "bbox_min": [
        -363.3562927246094,
        -2140.843505859375,
        661.1591796875
      ],
      "bbox_max": [
        -294.1380310058594,
        -2092.2255859375,
        705.8507690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -343.9417419433594,
        -2131.678466796875,
        667.9999389648438
      ],
      "bbox_max": [
        -340.4855041503906,
        -2125.468505859375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -363.3562927246094,
        -2140.843505859375,
        668.1134033203125
      ],
      "bbox_max": [
        -341.3185729980469,
        -2130.181640625,
        676.5722045898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -344.1531677246094,
        -2134.03662109375,
        661.1591796875
      ],
      "bbox_max": [
        -294.1380310058594,
        -2092.2255859375,
        705.8507690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -344.1531677246094,
        -2134.03662109375,
        667.9999389648438
      ],
      "bbox_max": [
        -294.1380310058594,
        -2121.553955078125,
        705.8507690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -344.1531677246094,
        -2130.181640625,
        667.9999389648438
      ],
      "bbox_max": [
        -341.3185119628906,
        -2125.088623046875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -519.0640258789062,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2040.0,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -519.0640258789062,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2057.783203125,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3062775135040283,
        0.6384968161582947,
        0.7060566544532776
      ],
      "plane_d": 782.3170166015625,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        639.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2100.7158203125,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        639.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2102.835205078125,
        651.483642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        639.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2102.835205078125,
        651.483642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        639.9999389648438
      ],
      "bbox_max": [
        -404.5238342285156,
        -2127.01123046875,
        641.6473388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -406.736328125,
        -2153.543701171875,
        639.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2100.7158203125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        639.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2100.7158203125,
        652.8601684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        0.8660247921943665,
        1.291685862270242e-06
      ],
      "plane_d": 1640.2430419921875,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        639.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2100.7158203125,
        652.8601684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        639.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2100.7158203125,
        652.8601684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        639.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2100.7158203125,
        652.8601684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        639.9999389648438
      ],
      "bbox_max": [
        -359.4485778808594,
        -2101.52001953125,
        641.7142333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        639.9999389648438
      ],
      "bbox_max": [
        -359.4485778808594,
        -2101.52001953125,
        641.343017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -405.2586669921875,
        -2127.96875,
        639.9999389648438
      ],
      "bbox_max": [
        -359.25421142578125,
        -2100.88525390625,
        641.4992065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.4485778808594,
        -2101.52001953125,
        639.9999389648438
      ],
      "bbox_max": [
        -359.25421142578125,
        -2100.88525390625,
        640.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -405.2586669921875,
        -2127.96875,
        639.9999389648438
      ],
      "bbox_max": [
        -404.03619384765625,
        -2126.375732421875,
        640.7760620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -363.46234130859375,
        -2137.917236328125,
        639.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2057.783203125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -359.847412109375,
        -2107.583984375,
        639.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2057.783203125,
        657.2886962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.6785583496094,
        -2098.995361328125,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.98193359375,
        640.0137329101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -343.8673400878906,
        -2107.583984375,
        645.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2096.643798828125,
        657.2886962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -363.46234130859375,
        -2137.917236328125,
        652.6621704101562
      ],
      "bbox_max": [
        -337.551025390625,
        -2102.083251953125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31740716099739075,
        0.5046849250793457,
        0.8028361797332764
      ],
      "plane_d": 427.22772216796875,
      "bbox_min": [
        -363.46234130859375,
        -2137.917236328125,
        668.0
      ],
      "bbox_max": [
        -359.68548583984375,
        -2135.369873046875,
        668.1739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -363.46234130859375,
        -2137.917236328125,
        668.0
      ],
      "bbox_max": [
        -362.8344421386719,
        -2137.531005859375,
        668.1739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -519.0640258789062,
        -2202.210693359375,
        639.28125
      ],
      "bbox_max": [
        -481.86572265625,
        -2172.58935546875,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -513.1192626953125,
        -2191.465087890625,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2040.0,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -432.43115234375,
        -2180.35791015625,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2045.6334228515625,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35807520151138306,
        0.6098346710205078,
        0.7070246934890747
      ],
      "plane_d": 697.973388671875,
      "bbox_min": [
        -432.43115234375,
        -2180.35791015625,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2045.6334228515625,
        686.3023681640625
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2057.586181640625,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -406.736328125,
        -2140.915771484375,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2057.586181640625,
        653.4964599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        -406.736328125,
        -2134.3759765625,
        639.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2057.586181640625,
        646.655029296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        0.8660247921943665,
        1.291685862270242e-06
      ],
      "plane_d": 1640.2430419921875,
      "bbox_min": [
        -406.736328125,
        -2134.3759765625,
        639.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2057.586181640625,
        646.655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -406.736328125,
        -2134.3759765625,
        640.7760620117188
      ],
      "bbox_max": [
        -280.0,
        -2057.586181640625,
        646.655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2133.9990234375,
        640.7760620117188
      ],
      "bbox_max": [
        -359.4485168457031,
        -2101.52001953125,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        640.7760620117188
      ],
      "bbox_max": [
        -359.4485168457031,
        -2101.52001953125,
        643.6758422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        641.8824462890625
      ],
      "bbox_max": [
        -359.4485168457031,
        -2101.52001953125,
        643.6758422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -406.21026611328125,
        -2134.3759765625,
        645.7384643554688
      ],
      "bbox_max": [
        -343.5585632324219,
        -2096.48828125,
        646.655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -405.2587890625,
        -2127.96875,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2097.34765625,
        642.9303588867188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -405.2587890625,
        -2127.96875,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        642.9303588867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -376.2414855957031,
        -2110.781494140625,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        642.9303588867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -376.2414855957031,
        -2110.781494140625,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        642.598876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        641.4857177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -376.68212890625,
        -2108.90625,
        639.9999389648438
      ],
      "bbox_max": [
        -358.7217712402344,
        -2097.34765625,
        641.3223266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530882596969604,
        -0.49248817563056946,
        -0.17232513427734375
      ],
      "plane_d": -1249.125,
      "bbox_min": [
        -376.68212890625,
        -2108.90625,
        639.9999389648438
      ],
      "bbox_max": [
        -376.095947265625,
        -2107.806884765625,
        640.96044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        0.8660247921943665,
        1.291685862270242e-06
      ],
      "plane_d": 1640.2430419921875,
      "bbox_min": [
        -406.736328125,
        -2140.915771484375,
        639.28125
      ],
      "bbox_max": [
        -340.7268371582031,
        -2095.707763671875,
        653.4964599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -406.736328125,
        -2140.915771484375,
        641.983642578125
      ],
      "bbox_max": [
        -340.7268371582031,
        -2095.707763671875,
        653.4964599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -406.736328125,
        -2140.915771484375,
        641.983642578125
      ],
      "bbox_max": [
        -359.4485168457031,
        -2101.52001953125,
        653.4964599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        642.9303588867188
      ],
      "bbox_max": [
        -359.4485168457031,
        -2101.52001953125,
        644.3175659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -405.2587890625,
        -2127.96875,
        639.28125
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.297607421875,
        643.3959350585938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -405.2587890625,
        -2127.96875,
        640.4264526367188
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        643.3959350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -376.2871398925781,
        -2110.83935546875,
        640.9603881835938
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        643.3959350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -376.2871398925781,
        -2110.83935546875,
        640.9603881835938
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        643.2592163085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        641.3223266601562
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        641.6097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3261350691318512,
        0.5656665563583374,
        0.757401704788208
      ],
      "plane_d": 584.7686767578125,
      "bbox_min": [
        -393.1123962402344,
        -2117.34912109375,
        639.28125
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.297607421875,
        641.4099731445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.3460825104848482e-05,
        3.3786840504035354e-05,
        1.0
      ],
      "plane_d": -639.9375610351562,
      "bbox_min": [
        -380.5296936035156,
        -2110.094482421875,
        639.9999389648438
      ],
      "bbox_max": [
        -378.97265625,
        -2109.19677734375,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.3460825104848482e-05,
        3.3786840504035354e-05,
        1.0
      ],
      "plane_d": -639.9375610351562,
      "bbox_min": [
        -380.9677734375,
        -2110.094482421875,
        639.28125
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.297607421875,
        641.4099731445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726298213005066,
        0.536638617515564,
        0.7570772171020508
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -380.9677734375,
        -2110.094482421875,
        639.28125
      ],
      "bbox_max": [
        -379.2862243652344,
        -2109.23095703125,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.8332824707031,
        -2098.790771484375,
        640.9281616210938
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.297607421875,
        641.4099731445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        649.3043823242188
      ],
      "bbox_max": [
        -337.551025390625,
        -2099.849609375,
        686.3023681640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -405.9733581542969,
        -2137.482421875,
        649.3043823242188
      ],
      "bbox_max": [
        -405.737060546875,
        -2135.68798828125,
        650.9717407226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -397.22943115234375,
        -2151.965576171875,
        650.783447265625
      ],
      "bbox_max": [
        -337.551025390625,
        -2099.849609375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -397.22943115234375,
        -2151.965576171875,
        666.560302734375
      ],
      "bbox_max": [
        -396.3149719238281,
        -2150.559814453125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -406.736328125,
        -2151.767578125,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2045.6334228515625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -360.1973571777344,
        -2098.180908203125,
        639.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2045.6334228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -360.1973571777344,
        -2098.180908203125,
        639.9999389648438
      ],
      "bbox_max": [
        -332.9053955078125,
        -2077.535888671875,
        642.9036865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.1973571777344,
        -2098.180908203125,
        639.9999389648438
      ],
      "bbox_max": [
        -358.8597106933594,
        -2092.264892578125,
        640.9495239257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -338.8740234375,
        -2084.468994140625,
        642.3384399414062
      ],
      "bbox_max": [
        -332.9053955078125,
        -2077.535888671875,
        642.9036865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -406.736328125,
        -2151.767578125,
        639.28125
      ],
      "bbox_max": [
        -287.8267517089844,
        -2054.734375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -299.1072082519531,
        -2065.568603515625,
        645.7384643554688
      ],
      "bbox_max": [
        -287.8267517089844,
        -2054.734375,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -406.736328125,
        -2151.767578125,
        639.28125
      ],
      "bbox_max": [
        -297.43212890625,
        -2065.151123046875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726341724395752,
        0.5366532206535339,
        0.7570648193359375
      ],
      "plane_d": 506.0691223144531,
      "bbox_min": [
        -406.736328125,
        -2135.68798828125,
        639.28125
      ],
      "bbox_max": [
        -342.0165710449219,
        -2094.162109375,
        650.783447265625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        641.4099731445312
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.791015625,
        642.8890991210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.3460825104848482e-05,
        3.3786840504035354e-05,
        1.0
      ],
      "plane_d": -639.9375610351562,
      "bbox_min": [
        -379.2862243652344,
        -2109.23095703125,
        639.9999389648438
      ],
      "bbox_max": [
        -358.7217712402344,
        -2096.52099609375,
        642.7213745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -376.84039306640625,
        -2108.932861328125,
        639.9999389648438
      ],
      "bbox_max": [
        -358.7217712402344,
        -2096.52099609375,
        642.7213745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530882596969604,
        -0.49248817563056946,
        -0.17232513427734375
      ],
      "plane_d": -1249.125,
      "bbox_min": [
        -376.84039306640625,
        -2108.932861328125,
        639.9999389648438
      ],
      "bbox_max": [
        -376.28753662109375,
        -2107.53271484375,
        641.2645263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        0.8660247921943665,
        1.291685862270242e-06
      ],
      "plane_d": 1640.2430419921875,
      "bbox_min": [
        -406.736328125,
        -2135.68798828125,
        640.859619140625
      ],
      "bbox_max": [
        -358.675537109375,
        -2094.609130859375,
        649.3043823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2135.68798828125,
        643.008056640625
      ],
      "bbox_max": [
        -359.44854736328125,
        -2101.52001953125,
        649.3043823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        643.008056640625
      ],
      "bbox_max": [
        -359.44854736328125,
        -2101.52001953125,
        645.9818725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        644.2982788085938
      ],
      "bbox_max": [
        -359.44854736328125,
        -2101.52001953125,
        645.9818725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -405.2589111328125,
        -2127.96875,
        640.859619140625
      ],
      "bbox_max": [
        -358.675537109375,
        -2094.609130859375,
        645.3162231445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -376.6501770019531,
        -2111.001220703125,
        641.2615966796875
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        645.3162231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.4485778808594,
        -2101.52001953125,
        642.7213745117188
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        645.3162231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        642.7213745117188
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        644.0260620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -359.6673278808594,
        -2098.791015625,
        640.859619140625
      ],
      "bbox_max": [
        -358.7217712402344,
        -2094.609130859375,
        643.8809204101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -406.736328125,
        -2151.767578125,
        640.9122314453125
      ],
      "bbox_max": [
        -337.551025390625,
        -2091.995361328125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        640.9122314453125
      ],
      "bbox_max": [
        -337.551025390625,
        -2091.995361328125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        644.96728515625
      ],
      "bbox_max": [
        -344.00396728515625,
        -2101.52001953125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        644.96728515625
      ],
      "bbox_max": [
        -359.4485778808594,
        -2101.52001953125,
        648.9978637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        644.96728515625
      ],
      "bbox_max": [
        -405.7652893066406,
        -2128.628662109375,
        645.4821166992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -396.8337707519531,
        -2120.795166015625,
        640.9122314453125
      ],
      "bbox_max": [
        -358.675537109375,
        -2093.25439453125,
        648.1336059570312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -376.8392028808594,
        -2111.15625,
        643.6571044921875
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        646.8821411132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        643.8809204101562
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        646.4585571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -359.9736022949219,
        -2098.790771484375,
        640.9122314453125
      ],
      "bbox_max": [
        -358.7217712402344,
        -2093.25439453125,
        646.2623291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -513.1192626953125,
        -2191.465087890625,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2040.0,
        671.9999389648438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -416.1728515625,
        -2106.674072265625,
        639.28125
      ],
      "bbox_max": [
        -280.0,
        -2040.0,
        645.741943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -360.30859375,
        -2093.254638671875,
        639.9999389648438
      ],
      "bbox_max": [
        -280.0,
        -2040.0,
        645.741943359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2093.39599609375,
        640.9495849609375
      ],
      "bbox_max": [
        -357.18017578125,
        -2086.585205078125,
        641.4136962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.30859375,
        -2093.39599609375,
        640.9495849609375
      ],
      "bbox_max": [
        -359.9416198730469,
        -2091.77294921875,
        641.115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -460.35186767578125,
        -2150.557373046875,
        639.28125
      ],
      "bbox_max": [
        -287.59991455078125,
        -2040.0,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -425.5252685546875,
        -2150.557373046875,
        639.28125
      ],
      "bbox_max": [
        -287.59991455078125,
        -2040.0,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -425.5252685546875,
        -2150.557373046875,
        639.28125
      ],
      "bbox_max": [
        -287.59991455078125,
        -2040.0,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -303.6571044921875,
        -2058.383056640625,
        645.7384643554688
      ],
      "bbox_max": [
        -287.59991455078125,
        -2040.0,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -425.5252685546875,
        -2150.557373046875,
        639.28125
      ],
      "bbox_max": [
        -338.2374572753906,
        -2040.0,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        641.0853271484375
      ],
      "bbox_max": [
        -338.2374572753906,
        -2086.585205078125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -360.30859375,
        -2106.39501953125,
        641.0853271484375
      ],
      "bbox_max": [
        -338.2374572753906,
        -2086.585205078125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        641.0853271484375
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.585205078125,
        671.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6863763332366943,
        -0.7272465229034424,
        -0.0
      ],
      "plane_d": -1759.2607421875,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        641.0853271484375
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.585205078125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        641.0853271484375
      ],
      "bbox_max": [
        -351.3818359375,
        -2086.585205078125,
        671.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": -1352.66748046875,
      "bbox_min": [
        -357.70416259765625,
        -2087.4541015625,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 659.9999389648438,
      "bbox_min": [
        -357.70416259765625,
        -2087.4541015625,
        659.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 659.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        659.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8645933270454407,
        0.5024722814559937,
        0.0
      ],
      "plane_d": 740.5030517578125,
      "bbox_min": [
        -359.342529296875,
        -2092.0322265625,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49991971254348755,
        0.866071879863739,
        0.0
      ],
      "plane_d": 1638.5718994140625,
      "bbox_min": [
        -358.675537109375,
        -2098.995361328125,
        654.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2098.495361328125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        643.0117797851562
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        667.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        644.9042358398438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        644.9042358398438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -390.5455017089844,
        -2119.47412109375,
        644.9042358398438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        0.8660247921943665,
        1.291685862270242e-06
      ],
      "plane_d": 1640.2430419921875,
      "bbox_min": [
        -390.5455017089844,
        -2119.47412109375,
        644.9042358398438
      ],
      "bbox_max": [
        -376.1389465332031,
        -2109.25146484375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 655.9999389648438,
      "bbox_min": [
        -389.779052734375,
        -2118.4541015625,
        644.9042358398438
      ],
      "bbox_max": [
        -376.1389465332031,
        -2109.25146484375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -378.520751953125,
        -2111.9541015625,
        644.9042358398438
      ],
      "bbox_max": [
        -376.1389465332031,
        -2109.25146484375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -750.164306640625,
        -2232.937744140625,
        639.28125
      ],
      "bbox_max": [
        -404.1064758300781,
        -2040.0,
        836.1474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6731522679328918,
        -0.137336865067482,
        0.7266392707824707
      ],
      "plane_d": -1296.7210693359375,
      "bbox_min": [
        -750.164306640625,
        -2136.1591796875,
        639.28125
      ],
      "bbox_max": [
        -404.1064758300781,
        -2040.0,
        815.9224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -674.18994140625,
        -2136.1591796875,
        639.28125
      ],
      "bbox_max": [
        -404.1064758300781,
        -2040.0,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4396458864212036,
        -0.8734606504440308,
        0.20923222601413727
      ],
      "plane_d": -2314.2626953125,
      "bbox_min": [
        -674.18994140625,
        -2136.1591796875,
        743.8489379882812
      ],
      "bbox_max": [
        -665.9322509765625,
        -2128.6962890625,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -511.7373046875,
        -2133.08251953125,
        639.28125
      ],
      "bbox_max": [
        -404.1064758300781,
        -2040.0,
        699.1410522460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -511.7373046875,
        -2133.08251953125,
        639.28125
      ],
      "bbox_max": [
        -460.35186767578125,
        -2096.0830078125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -674.18994140625,
        -2232.937744140625,
        639.28125
      ],
      "bbox_max": [
        -463.440673828125,
        -2040.0,
        836.1474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36469170451164246,
        -0.3489462733268738,
        0.8632707595825195
      ],
      "plane_d": -1642.7313232421875,
      "bbox_min": [
        -674.18994140625,
        -2128.6962890625,
        757.6525268554688
      ],
      "bbox_max": [
        -573.24951171875,
        -2040.0,
        836.1474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -674.18994140625,
        -2232.937744140625,
        639.28125
      ],
      "bbox_max": [
        -463.440673828125,
        -2101.666259765625,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4396458864212036,
        -0.8734606504440308,
        0.20923222601413727
      ],
      "plane_d": -2314.2626953125,
      "bbox_min": [
        -674.18994140625,
        -2136.525634765625,
        743.73779296875
      ],
      "bbox_max": [
        -665.2572021484375,
        -2128.6962890625,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0939634194073733e-06,
        -5.392661819314526e-07,
        1.0
      ],
      "plane_d": -639.2818603515625,
      "bbox_min": [
        -583.7952880859375,
        -2232.937744140625,
        639.28125
      ],
      "bbox_max": [
        -463.440673828125,
        -2101.666259765625,
        695.9130249023438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -532.1075439453125,
        -2232.937744140625,
        639.28125
      ],
      "bbox_max": [
        -478.5008544921875,
        -2202.210693359375,
        695.9130249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -479.2474365234375,
        -2232.937744140625,
        695.3135375976562
      ],
      "bbox_max": [
        -478.5008544921875,
        -2232.79736328125,
        695.9130249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879413485527039,
        0.423933207988739,
        0.6889162063598633
      ],
      "plane_d": 185.86029052734375,
      "bbox_min": [
        -478.6838684082031,
        -2232.937744140625,
        695.7410278320312
      ],
      "bbox_max": [
        -478.5008544921875,
        -2232.79736328125,
        695.9130249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4271385669708252,
        -0.9028797149658203,
        0.04858982190489769
      ],
      "plane_d": -2246.743408203125,
      "bbox_min": [
        -793.6016235351562,
        -2143.28173828125,
        466.048828125
      ],
      "bbox_max": [
        -674.18994140625,
        -2046.3411865234375,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4538376033306122,
        -0.8906913995742798,
        0.026465820148587227
      ],
      "plane_d": -2228.372314453125,
      "bbox_min": [
        -948.3048706054688,
        -2230.6708984375,
        0.0
      ],
      "bbox_max": [
        -494.63037109375,
        -2042.9688720703125,
        744.58544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7473034858703613,
        -0.6633269190788269,
        0.039178479462862015
      ],
      "plane_d": -1945.5296630859375,
      "bbox_min": [
        -799.3662109375,
        -2194.3623046875,
        466.048828125
      ],
      "bbox_max": [
        -566.179443359375,
        -2071.79541015625,
        744.58544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -670.4060668945312,
        -2194.3623046875,
        639.2813110351562
      ],
      "bbox_max": [
        -566.179443359375,
        -2133.73095703125,
        744.58544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4396458864212036,
        -0.8734606504440308,
        0.20923222601413727
      ],
      "plane_d": -2314.2626953125,
      "bbox_min": [
        -670.4060668945312,
        -2148.140869140625,
        723.0947265625
      ],
      "bbox_max": [
        -652.0050659179688,
        -2133.73095703125,
        744.58544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0939634194073733e-06,
        -5.392661819314526e-07,
        1.0
      ],
      "plane_d": -639.2818603515625,
      "bbox_min": [
        -584.1630249023438,
        -2194.3623046875,
        639.2813110351562
      ],
      "bbox_max": [
        -566.179443359375,
        -2184.9345703125,
        639.2813110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4271385669708252,
        -0.9028797149658203,
        0.04858982190489769
      ],
      "plane_d": -2246.743408203125,
      "bbox_min": [
        -799.3662109375,
        -2143.28173828125,
        466.048828125
      ],
      "bbox_max": [
        -676.53125,
        -2071.79541015625,
        728.0035400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6731522679328918,
        -0.137336865067482,
        0.7266392707824707
      ],
      "plane_d": -1296.7210693359375,
      "bbox_min": [
        -799.3662109375,
        -2113.703857421875,
        651.8062744140625
      ],
      "bbox_max": [
        -709.2535400390625,
        -2071.79541015625,
        728.0035400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2615157663822174,
        -0.9648758172988892,
        0.024980084970593452
      ],
      "plane_d": -2227.614013671875,
      "bbox_min": [
        -948.3048706054688,
        -2230.6708984375,
        0.0
      ],
      "bbox_max": [
        -494.63037109375,
        -2042.9688720703125,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8758759498596191,
        -0.4812624454498291,
        0.035040486603975296
      ],
      "plane_d": -1640.369140625,
      "bbox_min": [
        -948.3048706054688,
        -2230.6708984375,
        0.0
      ],
      "bbox_max": [
        -494.63037109375,
        -2042.9688720703125,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7473034858703613,
        -0.6633269190788269,
        0.039178479462862015
      ],
      "plane_d": -1945.5296630859375,
      "bbox_min": [
        -676.53125,
        -2230.6708984375,
        395.9699401855469
      ],
      "bbox_max": [
        -494.63037109375,
        -2141.871337890625,
        723.4580688476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -652.0050659179688,
        -2230.6708984375,
        630.2252807617188
      ],
      "bbox_max": [
        -494.63037109375,
        -2148.140869140625,
        723.0947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -604.6768188476562,
        -2199.5419921875,
        630.2252807617188
      ],
      "bbox_max": [
        -594.0823974609375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -604.6768188476562,
        -2199.5419921875,
        630.2252807617188
      ],
      "bbox_max": [
        -594.0823974609375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -602.43359375,
        -2195.29052734375,
        639.2813110351562
      ],
      "bbox_max": [
        -598.218994140625,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -602.43359375,
        -2193.9814453125,
        641.6248779296875
      ],
      "bbox_max": [
        -599.2575073242188,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -599.7045288085938,
        -2230.6708984375,
        639.28125
      ],
      "bbox_max": [
        -494.63037109375,
        -2185.19921875,
        682.3578491210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0939634194073733e-06,
        -5.392661819314526e-07,
        1.0
      ],
      "plane_d": -639.2818603515625,
      "bbox_min": [
        -599.7045288085938,
        -2222.38232421875,
        639.28125
      ],
      "bbox_max": [
        -532.1075439453125,
        -2185.19921875,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -599.7045288085938,
        -2195.2744140625,
        639.3268432617188
      ],
      "bbox_max": [
        -598.2291870117188,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -599.7045288085938,
        -2194.46533203125,
        641.6248779296875
      ],
      "bbox_max": [
        -598.7432250976562,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7427215576171875,
        -0.6210522651672363,
        0.2503175735473633
      ],
      "plane_d": -1967.71533203125,
      "bbox_min": [
        -616.934326171875,
        -2225.050537109375,
        559.9291381835938
      ],
      "bbox_max": [
        -534.6232299804688,
        -2192.60791015625,
        648.6753540039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0939634194073733e-06,
        -5.392661819314526e-07,
        1.0
      ],
      "plane_d": -639.2818603515625,
      "bbox_min": [
        -600.3375854492188,
        -2225.050537109375,
        630.2252807617188
      ],
      "bbox_max": [
        -534.6232299804688,
        -2195.300048828125,
        648.6753540039062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -600.3375854492188,
        -2218.90576171875,
        630.2252807617188
      ],
      "bbox_max": [
        -578.3451538085938,
        -2196.3935546875,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -545.7772827148438,
        -2225.050537109375,
        639.28125
      ],
      "bbox_max": [
        -534.6232299804688,
        -2222.38232421875,
        648.6753540039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7754648327827454,
        -0.5560722351074219,
        0.2990618944168091
      ],
      "plane_d": -1871.9361572265625,
      "bbox_min": [
        -616.934326171875,
        -2218.885986328125,
        559.9291381835938
      ],
      "bbox_max": [
        -578.486328125,
        -2192.60791015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -615.72021484375,
        -2218.885986328125,
        630.2252807617188
      ],
      "bbox_max": [
        -578.486328125,
        -2192.60791015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -615.72021484375,
        -2218.401123046875,
        630.2252807617188
      ],
      "bbox_max": [
        -581.9351196289062,
        -2192.937255859375,
        639.2813110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -615.72021484375,
        -2202.09423828125,
        630.2252807617188
      ],
      "bbox_max": [
        -602.894775390625,
        -2192.937255859375,
        639.2813110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -615.4296875,
        -2205.430908203125,
        639.2813110351562
      ],
      "bbox_max": [
        -598.18994140625,
        -2192.60791015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -615.4296875,
        -2205.376953125,
        639.2813110351562
      ],
      "bbox_max": [
        -598.18994140625,
        -2192.60791015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -615.4296875,
        -2201.886962890625,
        639.2813110351562
      ],
      "bbox_max": [
        -598.18994140625,
        -2192.60791015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -598.7432250976562,
        -2195.333251953125,
        639.2813110351562
      ],
      "bbox_max": [
        -598.18994140625,
        -2194.46533203125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8123376965522766,
        -0.5648552179336548,
        0.14507277309894562
      ],
      "plane_d": -1827.8267822265625,
      "bbox_min": [
        -676.53125,
        -2215.376708984375,
        395.9699401855469
      ],
      "bbox_max": [
        -603.4556884765625,
        -2143.28173828125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8040702939033508,
        -0.5765846371650696,
        0.1449870765209198
      ],
      "plane_d": -1848.5401611328125,
      "bbox_min": [
        -627.8792724609375,
        -2214.751220703125,
        471.1322021484375
      ],
      "bbox_max": [
        -607.9061889648438,
        -2204.878662109375,
        564.9820556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7754648327827454,
        -0.5560722351074219,
        0.2990618944168091
      ],
      "plane_d": -1871.9361572265625,
      "bbox_min": [
        -616.934326171875,
        -2214.751220703125,
        559.9291381835938
      ],
      "bbox_max": [
        -607.9061889648438,
        -2204.878662109375,
        564.9820556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -629.2466430664062,
        -2215.376708984375,
        630.2252807617188
      ],
      "bbox_max": [
        -603.4556884765625,
        -2201.833251953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -629.2466430664062,
        -2215.376708984375,
        639.2813110351562
      ],
      "bbox_max": [
        -603.4556884765625,
        -2201.833251953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -622.4407958984375,
        -2212.70849609375,
        639.2813110351562
      ],
      "bbox_max": [
        -612.2088623046875,
        -2205.376953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -948.3048706054688,
        -2209.51220703125,
        0.0
      ],
      "bbox_max": [
        -645.1852416992188,
        -2042.9688720703125,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005043566226959,
        0.9524807333946228,
        0.04977479577064514
      ],
      "plane_d": 2285.599609375,
      "bbox_min": [
        -854.0363159179688,
        -2168.956298828125,
        730.94091796875
      ],
      "bbox_max": [
        -852.66796875,
        -2168.380126953125,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9412656426429749,
        -0.3293653726577759,
        0.07441509515047073
      ],
      "plane_d": -1360.3240966796875,
      "bbox_min": [
        -948.3048706054688,
        -2209.51220703125,
        0.0
      ],
      "bbox_max": [
        -645.1852416992188,
        -2042.9688720703125,
        403.0205383300781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24620355665683746,
        -0.9684427380561829,
        0.038763467222452164
      ],
      "plane_d": -2226.34130859375,
      "bbox_min": [
        -948.3048706054688,
        -2205.877197265625,
        0.0
      ],
      "bbox_max": [
        -671.0499267578125,
        -2042.9688720703125,
        403.0205383300781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25237345695495605,
        -0.9668518304824829,
        0.03879788890480995
      ],
      "plane_d": -2228.79150390625,
      "bbox_min": [
        -948.3048706054688,
        -2056.551025390625,
        170.03836059570312
      ],
      "bbox_max": [
        -922.985107421875,
        -2042.9688720703125,
        403.0205383300781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22133076190948486,
        -0.9681739807128906,
        0.11684101819992065
      ],
      "plane_d": -2216.021240234375,
      "bbox_min": [
        -929.723388671875,
        -2056.551025390625,
        170.03836059570312
      ],
      "bbox_max": [
        -926.461669921875,
        -2055.64697265625,
        171.35107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4426290988922119,
        -0.8944221138954163,
        0.06394129991531372
      ],
      "plane_d": -2236.98828125,
      "bbox_min": [
        -929.6712646484375,
        -2205.877197265625,
        0.0
      ],
      "bbox_max": [
        -671.0499267578125,
        -2055.694091796875,
        263.4397277832031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26263877749443054,
        -0.9629242420196533,
        0.061626359820365906
      ],
      "plane_d": -2234.106201171875,
      "bbox_min": [
        -929.6712646484375,
        -2205.877197265625,
        0.0
      ],
      "bbox_max": [
        -671.0499267578125,
        -2055.694091796875,
        263.4397277832031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47615304589271545,
        -0.8670215010643005,
        0.14680615067481995
      ],
      "plane_d": -2214.495849609375,
      "bbox_min": [
        -929.6712646484375,
        -2205.877197265625,
        0.0
      ],
      "bbox_max": [
        -671.0499267578125,
        -2055.694091796875,
        171.05938720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40625426173210144,
        -0.880420982837677,
        0.2445736974477768
      ],
      "plane_d": -2194.858154296875,
      "bbox_min": [
        -811.36181640625,
        -2171.264892578125,
        0.0
      ],
      "bbox_max": [
        -681.166015625,
        -2092.9150390625,
        92.37496948242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8602949976921082,
        -0.4507606625556946,
        0.238133043050766
      ],
      "plane_d": -1578.498046875,
      "bbox_min": [
        -697.17626953125,
        -2171.264892578125,
        0.0
      ],
      "bbox_max": [
        -681.166015625,
        -2157.045166015625,
        71.84719848632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -929.6712646484375,
        -2205.877197265625,
        0.0
      ],
      "bbox_max": [
        -671.0499267578125,
        -2055.694091796875,
        171.05938720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2292175441980362,
        -0.9629797339439392,
        0.14187826216220856
      ],
      "plane_d": -2214.51904296875,
      "bbox_min": [
        -929.6712646484375,
        -2205.877197265625,
        0.0
      ],
      "bbox_max": [
        -671.0499267578125,
        -2055.694091796875,
        171.05938720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21190190315246582,
        -0.9627490043640137,
        0.16796369850635529
      ],
      "plane_d": -2199.87109375,
      "bbox_min": [
        -929.6712646484375,
        -2205.877197265625,
        0.0
      ],
      "bbox_max": [
        -671.0499267578125,
        -2055.694091796875,
        171.05938720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8602949976921082,
        -0.4507606625556946,
        0.238133043050766
      ],
      "plane_d": -1578.498046875,
      "bbox_min": [
        -929.6712646484375,
        -2205.877197265625,
        0.0
      ],
      "bbox_max": [
        -671.0499267578125,
        -2055.694091796875,
        171.05938720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22133076190948486,
        -0.9681739807128906,
        0.11684101819992065
      ],
      "plane_d": -2216.021240234375,
      "bbox_min": [
        -929.6712646484375,
        -2057.93994140625,
        157.1575164794922
      ],
      "bbox_max": [
        -926.461669921875,
        -2055.694091796875,
        171.05938720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1131.7020263671875,
        -3173.53076171875,
        0.0
      ],
      "bbox_max": [
        -279.9999694824219,
        -2147.4443359375,
        1480.5965576171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1131.7020263671875,
      "bbox_min": [
        -3173.53076171875,
        0.0,
        -279.9999694824219
      ],
      "bbox_max": [
        -2147.4443359375,
        1480.5965576171875,
        2.802596928649634e-45
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7762428522109985,
        0.04481952264904976,
        0.6288387775421143
      ],
      "plane_d": 361.6246032714844,
      "bbox_min": [
        -954.8323364257812,
        -3071.92578125,
        812.885009765625
      ],
      "bbox_max": [
        -947.423095703125,
        -3063.33447265625,
        821.918701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -904.4310913085938,
        -2719.536865234375,
        0.0
      ],
      "bbox_max": [
        -491.5693359375,
        -2332.75390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -904.4310913085938,
        -2701.2490234375,
        639.6258544921875
      ],
      "bbox_max": [
        -525.963623046875,
        -2332.75390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -904.4310913085938,
        -2701.2490234375,
        639.6258544921875
      ],
      "bbox_max": [
        -525.963623046875,
        -2332.75390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9314306974411011,
        0.3556700348854065,
        0.0770426094532013
      ],
      "plane_d": 1355.5810546875,
      "bbox_min": [
        -904.4310913085938,
        -2693.9150390625,
        639.6258544921875
      ],
      "bbox_max": [
        -539.7568969726562,
        -2332.75390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -904.4310913085938,
        -2690.481689453125,
        639.6258544921875
      ],
      "bbox_max": [
        -546.2139282226562,
        -2332.75390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -904.4310913085938,
        -2690.481689453125,
        639.6258544921875
      ],
      "bbox_max": [
        -546.2139282226562,
        -2332.75390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -904.4310913085938,
        -2549.36376953125,
        639.6258544921875
      ],
      "bbox_max": [
        -594.252197265625,
        -2332.75390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -904.4310913085938,
        -2545.595458984375,
        639.6258544921875
      ],
      "bbox_max": [
        -594.252197265625,
        -2332.75390625,
        1406.9556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -904.4310913085938,
        -2545.595458984375,
        639.6258544921875
      ],
      "bbox_max": [
        -594.252197265625,
        -2332.75390625,
        1406.9556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7721387147903442,
        -0.5362740755081177,
        0.34089893102645874
      ],
      "plane_d": -867.376708984375,
      "bbox_min": [
        -904.4310913085938,
        -2545.595458984375,
        639.6258544921875
      ],
      "bbox_max": [
        -594.252197265625,
        -2332.75390625,
        1406.9556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7694186568260193,
        -0.5282776355743408,
        0.35905107855796814
      ],
      "plane_d": -862.0191650390625,
      "bbox_min": [
        -904.4310913085938,
        -2545.595458984375,
        639.6258544921875
      ],
      "bbox_max": [
        -594.252197265625,
        -2332.75390625,
        1406.9556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.675027072429657,
        -0.49037832021713257,
        -0.5512418150901794
      ],
      "plane_d": -246.33090209960938,
      "bbox_min": [
        -904.4310913085938,
        -2545.595458984375,
        639.6258544921875
      ],
      "bbox_max": [
        -594.252197265625,
        -2332.75390625,
        1406.9556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -837.259033203125,
        -2545.595458984375,
        663.75
      ],
      "bbox_max": [
        -594.252197265625,
        -2332.75390625,
        1406.9556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -780.5735473632812,
        -2332.75390625,
        674.7783813476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -782.8914794921875,
        -2332.75390625,
        671.9031982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -904.4310913085938,
        -2534.931640625,
        639.6258544921875
      ],
      "bbox_max": [
        -735.9410400390625,
        -2332.89013671875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -904.4310913085938,
        -2512.5654296875,
        665.9375
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        696.2402954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -904.4310913085938,
        -2512.5654296875,
        665.9375
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        696.2402954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -904.4310913085938,
        -2512.5654296875,
        665.9375
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        696.2402954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541924476624,
        -0.36512240767478943,
        0.30333849787712097
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -904.4310913085938,
        -2500.1484375,
        665.9375
      ],
      "bbox_max": [
        -898.0948486328125,
        -2487.185546875,
        668.8807983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016451746225357056,
        -0.023649385198950768,
        -0.999584972858429
      ],
      "plane_d": 616.3050537109375,
      "bbox_min": [
        -904.178466796875,
        -2534.931640625,
        639.6258544921875
      ],
      "bbox_max": [
        -735.9410400390625,
        -2332.89013671875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015236764214932919,
        -0.025140661746263504,
        -0.9995678067207336
      ],
      "plane_d": 613.6358642578125,
      "bbox_min": [
        -880.8256225585938,
        -2526.4794921875,
        684.7185668945312
      ],
      "bbox_max": [
        -746.6306762695312,
        -2342.465087890625,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -880.8256225585938,
        -2526.4501953125,
        684.7185668945312
      ],
      "bbox_max": [
        -746.6306762695312,
        -2342.465087890625,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20010554790496826,
        -0.33017414808273315,
        -0.9224656224250793
      ],
      "plane_d": -363.43182373046875,
      "bbox_min": [
        -880.8256225585938,
        -2526.4501953125,
        690.078125
      ],
      "bbox_max": [
        -851.7667236328125,
        -2496.873046875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -880.8256225585938,
        -2526.4501953125,
        690.078125
      ],
      "bbox_max": [
        -851.7667236328125,
        -2496.873046875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7571871280670166,
        0.14177244901657104,
        -0.6376270055770874
      ],
      "plane_d": 151.26864624023438,
      "bbox_min": [
        -858.8065795898438,
        -2526.4501953125,
        690.078125
      ],
      "bbox_max": [
        -851.7667236328125,
        -2512.498046875,
        695.8198852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -825.384033203125,
        -2430.9833984375,
        684.7185668945312
      ],
      "bbox_max": [
        -746.6306762695312,
        -2342.465087890625,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -825.384033203125,
        -2430.9833984375,
        684.7185668945312
      ],
      "bbox_max": [
        -746.6306762695312,
        -2342.465087890625,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6251323819160461,
        0.5020516514778137,
        -0.5976232290267944
      ],
      "plane_d": 1133.15673828125,
      "bbox_min": [
        -796.634033203125,
        -2430.9833984375,
        684.9544067382812
      ],
      "bbox_max": [
        -746.6306762695312,
        -2370.24951171875,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734040975570679,
        0.43424248695373535,
        -0.5982979536056519
      ],
      "plane_d": 930.3226318359375,
      "bbox_min": [
        -854.71240234375,
        -2526.4794921875,
        687.1875
      ],
      "bbox_max": [
        -796.634033203125,
        -2430.9833984375,
        690.4739990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7571871280670166,
        0.14177244901657104,
        -0.6376270055770874
      ],
      "plane_d": 151.26864624023438,
      "bbox_min": [
        -854.71240234375,
        -2526.4794921875,
        690.0169067382812
      ],
      "bbox_max": [
        -851.6050415039062,
        -2512.331787109375,
        690.4739990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6407753825187683,
        0.3764681816101074,
        -0.6690878868103027
      ],
      "plane_d": 861.8073120117188,
      "bbox_min": [
        -851.7667236328125,
        -2512.525634765625,
        690.0169067382812
      ],
      "bbox_max": [
        -851.6050415039062,
        -2512.331787109375,
        690.078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6407753825187683,
        0.3764681816101074,
        -0.6690878868103027
      ],
      "plane_d": 861.8073120117188,
      "bbox_min": [
        -904.178466796875,
        -2534.931640625,
        639.6258544921875
      ],
      "bbox_max": [
        -735.9410400390625,
        -2332.89013671875,
        690.40185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734040975570679,
        0.43424248695373535,
        -0.5982979536056519
      ],
      "plane_d": 930.3226318359375,
      "bbox_min": [
        -854.6571655273438,
        -2534.931640625,
        654.2742919921875
      ],
      "bbox_max": [
        -735.9410400390625,
        -2371.379638671875,
        690.40185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34332793951034546,
        0.3998381495475769,
        -0.8498560190200806
      ],
      "plane_d": 1271.518798828125,
      "bbox_min": [
        -854.6571655273438,
        -2534.931640625,
        663.75
      ],
      "bbox_max": [
        -735.9410400390625,
        -2374.304931640625,
        690.40185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7571871280670166,
        0.14177244901657104,
        -0.6376270055770874
      ],
      "plane_d": 151.26864624023438,
      "bbox_min": [
        -854.6571655273438,
        -2534.931640625,
        665.9375
      ],
      "bbox_max": [
        -833.7198486328125,
        -2512.525634765625,
        690.40185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188934922218323,
        0.49224644899368286,
        0.2951386272907257
      ],
      "plane_d": 363.49578857421875,
      "bbox_min": [
        -839.5821533203125,
        -2534.931640625,
        665.9375
      ],
      "bbox_max": [
        -833.7198486328125,
        -2524.685546875,
        669.04052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7599779963493347,
        0.5533286333084106,
        0.34097036719322205
      ],
      "plane_d": 529.8473510742188,
      "bbox_min": [
        -782.259033203125,
        -2440.9833984375,
        663.75
      ],
      "bbox_max": [
        -735.9410400390625,
        -2381.247314453125,
        672.4468994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7599779963493347,
        0.5533286333084106,
        0.34097036719322205
      ],
      "plane_d": 529.8473510742188,
      "bbox_min": [
        -782.259033203125,
        -2440.9833984375,
        656.7145385742188
      ],
      "bbox_max": [
        -737.33447265625,
        -2380.68603515625,
        666.9407348632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7599779963493347,
        0.5533286333084106,
        0.34097036719322205
      ],
      "plane_d": 529.8473510742188,
      "bbox_min": [
        -782.259033203125,
        -2440.9833984375,
        654.2742919921875
      ],
      "bbox_max": [
        -737.2938842773438,
        -2381.15087890625,
        663.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -749.5479736328125,
        -2393.28857421875,
        654.2742919921875
      ],
      "bbox_max": [
        -737.2938842773438,
        -2381.15087890625,
        660.59375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.794124960899353,
        0.5035092234611511,
        0.3403586447238922
      ],
      "plane_d": 381.9332275390625,
      "bbox_min": [
        -904.178466796875,
        -2534.494873046875,
        639.6258544921875
      ],
      "bbox_max": [
        -736.8543701171875,
        -2332.89013671875,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7906190752983093,
        0.49548137187957764,
        0.3597496747970581
      ],
      "plane_d": 352.2090148925781,
      "bbox_min": [
        -847.4234619140625,
        -2534.494873046875,
        639.6663818359375
      ],
      "bbox_max": [
        -736.8543701171875,
        -2370.225830078125,
        666.0324096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -847.32568359375,
        -2534.494873046875,
        639.6663818359375
      ],
      "bbox_max": [
        -736.8543701171875,
        -2370.225830078125,
        666.0324096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -847.32568359375,
        -2534.494873046875,
        639.6727294921875
      ],
      "bbox_max": [
        -736.8543701171875,
        -2379.129150390625,
        666.0324096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8071104884147644,
        0.4680122137069702,
        0.3599129617214203
      ],
      "plane_d": 269.00018310546875,
      "bbox_min": [
        -847.32568359375,
        -2534.494873046875,
        641.796875
      ],
      "bbox_max": [
        -833.7198486328125,
        -2519.998046875,
        666.0324096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -847.32568359375,
        -2534.494873046875,
        641.796875
      ],
      "bbox_max": [
        -833.7198486328125,
        -2519.998046875,
        666.0324096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188934922218323,
        0.49224644899368286,
        0.2951386272907257
      ],
      "plane_d": 363.49578857421875,
      "bbox_min": [
        -840.2496948242188,
        -2534.494873046875,
        663.588134765625
      ],
      "bbox_max": [
        -833.7198486328125,
        -2524.685546875,
        666.0324096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -789.134033203125,
        -2440.9833984375,
        640.3125
      ],
      "bbox_max": [
        -736.8543701171875,
        -2381.290283203125,
        663.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7599779963493347,
        0.5533286333084106,
        0.34097036719322205
      ],
      "plane_d": 529.8473510742188,
      "bbox_min": [
        -789.134033203125,
        -2440.9833984375,
        640.3125
      ],
      "bbox_max": [
        -749.5479736328125,
        -2393.28857421875,
        663.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -847.4234619140625,
        -2530.37744140625,
        641.796875
      ],
      "bbox_max": [
        -841.7667236328125,
        -2519.998046875,
        643.8764038085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -904.178466796875,
        -2530.325439453125,
        639.6258544921875
      ],
      "bbox_max": [
        -747.7177124023438,
        -2332.89013671875,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        639.6535034179688
      ],
      "bbox_max": [
        -747.7177124023438,
        -2352.15576171875,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -904.178466796875,
        -2530.325439453125,
        639.6258544921875
      ],
      "bbox_max": [
        -773.8707885742188,
        -2332.89013671875,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -904.178466796875,
        -2530.325439453125,
        639.6258544921875
      ],
      "bbox_max": [
        -773.8707885742188,
        -2332.89013671875,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -775.9280395507812,
        -2332.89013671875,
        680.2382202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -782.6444702148438,
        -2332.89013671875,
        669.7511596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -904.178466796875,
        -2530.325439453125,
        639.6258544921875
      ],
      "bbox_max": [
        -777.5018310546875,
        -2333.15234375,
        667.9860229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -904.178466796875,
        -2530.325439453125,
        639.6258544921875
      ],
      "bbox_max": [
        -777.5018310546875,
        -2335.879638671875,
        667.9860229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -904.178466796875,
        -2530.325439453125,
        641.796875
      ],
      "bbox_max": [
        -841.7667236328125,
        -2487.185546875,
        667.9860229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03805441036820412,
        0.1391364485025406,
        0.98954176902771
      ],
      "plane_d": -254.50424194335938,
      "bbox_min": [
        -896.3795776367188,
        -2509.9560546875,
        641.796875
      ],
      "bbox_max": [
        -885.7332153320312,
        -2491.873046875,
        644.2561645507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -896.3795776367188,
        -2504.37890625,
        641.796875
      ],
      "bbox_max": [
        -890.0479736328125,
        -2491.873046875,
        644.2561645507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -904.178466796875,
        -2504.29541015625,
        641.796875
      ],
      "bbox_max": [
        -890.0479736328125,
        -2487.185546875,
        667.9860229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541924476624,
        -0.36512240767478943,
        0.30333849787712097
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -904.178466796875,
        -2500.811279296875,
        663.5715942382812
      ],
      "bbox_max": [
        -898.0948486328125,
        -2487.185546875,
        667.9860229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296503663063049,
        0.3666344881057739,
        0.03646130487322807
      ],
      "plane_d": 1454.0635986328125,
      "bbox_min": [
        -574.3484497070312,
        -2719.536865234375,
        0.0
      ],
      "bbox_max": [
        -491.5693359375,
        -2554.2509765625,
        497.7949523925781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9315862059593201,
        0.3613213896751404,
        0.03992580994963646
      ],
      "plane_d": 1440.1312255859375,
      "bbox_min": [
        -574.3484497070312,
        -2715.982177734375,
        134.70785522460938
      ],
      "bbox_max": [
        -498.2544860839844,
        -2554.2509765625,
        497.7949523925781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -855.5603637695312,
        -2700.866943359375,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2179.94580078125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -567.82470703125,
        -2700.866943359375,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2372.154541015625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9434628486633301,
        -0.32140111923217773,
        0.08111273497343063
      ],
      "plane_d": -1258.9459228515625,
      "bbox_min": [
        -567.82470703125,
        -2700.866943359375,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2415.673583984375,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6797831654548645,
        0.7331898212432861,
        0.018096331506967545
      ],
      "plane_d": 2118.830810546875,
      "bbox_min": [
        -511.46240234375,
        -2700.866943359375,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2415.673583984375,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953548669815063,
        -0.4447094798088074,
        0.023941760882735252
      ],
      "plane_d": -1532.2132568359375,
      "bbox_min": [
        -511.46240234375,
        -2700.866943359375,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2415.673583984375,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5633555054664612,
        0.8184596300125122,
        0.11293553560972214
      ],
      "plane_d": 2242.135498046875,
      "bbox_min": [
        -343.02734375,
        -2668.909423828125,
        761.5028686523438
      ],
      "bbox_max": [
        -280.0,
        -2625.52685546875,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9115313291549683,
        -0.38201379776000977,
        0.1522369533777237
      ],
      "plane_d": -1389.03466796875,
      "bbox_min": [
        -511.46240234375,
        -2700.866943359375,
        0.0
      ],
      "bbox_max": [
        -376.275634765625,
        -2415.673583984375,
        146.20753479003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5485955476760864,
        0.7409572601318359,
        0.3873308598995209
      ],
      "plane_d": 2070.496826171875,
      "bbox_min": [
        -511.46240234375,
        -2632.418212890625,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2415.673583984375,
        86.79737091064453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296503663063049,
        0.3666344881057739,
        0.03646130487322807
      ],
      "plane_d": 1454.0635986328125,
      "bbox_min": [
        -567.82470703125,
        -2586.373046875,
        0.0
      ],
      "bbox_max": [
        -544.0863037109375,
        -2532.732666015625,
        121.99911499023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8202191591262817,
        0.571056604385376,
        0.033687908202409744
      ],
      "plane_d": 1912.07421875,
      "bbox_min": [
        -567.82470703125,
        -2541.47509765625,
        0.0
      ],
      "bbox_max": [
        -561.865234375,
        -2532.732666015625,
        29.808349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424458384513855,
        -0.8393089771270752,
        0.03623468056321144
      ],
      "plane_d": -2253.585693359375,
      "bbox_min": [
        -491.74896240234375,
        -2515.038330078125,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2372.154541015625,
        825.5303955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5395222306251526,
        -0.8415294885635376,
        0.027272434905171394
      ],
      "plane_d": -2254.31982421875,
      "bbox_min": [
        -481.1627197265625,
        -2502.831787109375,
        11.056449890136719
      ],
      "bbox_max": [
        -280.0,
        -2372.709716796875,
        825.5303955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430268257856369,
        -0.8978968262672424,
        0.09300856292247772
      ],
      "plane_d": -2403.1669921875,
      "bbox_min": [
        -393.79583740234375,
        -2476.800537109375,
        383.8636474609375
      ],
      "bbox_max": [
        -280.0,
        -2413.92529296875,
        825.5303955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994062423706055,
        -0.7998847365379333,
        0.029941599816083908
      ],
      "plane_d": -2178.19677734375,
      "bbox_min": [
        -392.693603515625,
        -2415.410400390625,
        388.24566650390625
      ],
      "bbox_max": [
        -391.22314453125,
        -2414.40576171875,
        393.3116455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5781846046447754,
        -0.8145887851715088,
        0.0463433600962162
      ],
      "plane_d": -2211.789794921875,
      "bbox_min": [
        -392.693603515625,
        -2415.410400390625,
        388.24566650390625
      ],
      "bbox_max": [
        -391.22314453125,
        -2414.40576171875,
        390.6929626464844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.557774543762207,
        -0.8295528888702393,
        0.027008702978491783
      ],
      "plane_d": -2232.4296875,
      "bbox_min": [
        -481.1627197265625,
        -2502.831787109375,
        11.056449890136719
      ],
      "bbox_max": [
        -280.0,
        -2372.709716796875,
        388.9328308105469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5573205947875977,
        -0.7778975963592529,
        0.290291428565979
      ],
      "plane_d": -2111.4228515625,
      "bbox_min": [
        -481.1627197265625,
        -2502.831787109375,
        11.056449890136719
      ],
      "bbox_max": [
        -280.0,
        -2372.709716796875,
        56.81050491333008
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.475697785615921,
        -0.7068511247634888,
        0.5235198140144348
      ],
      "plane_d": -1910.9530029296875,
      "bbox_min": [
        -393.83563232421875,
        -2454.134521484375,
        11.349940299987793
      ],
      "bbox_max": [
        -356.43310546875,
        -2426.31689453125,
        17.106475830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5384513735771179,
        -0.8420933485031128,
        0.03080403432250023
      ],
      "plane_d": -2256.63623046875,
      "bbox_min": [
        -491.74896240234375,
        -2515.038330078125,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2372.154541015625,
        717.7733764648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430268257856369,
        -0.8978968262672424,
        0.09300856292247772
      ],
      "plane_d": -2403.1669921875,
      "bbox_min": [
        -391.46820068359375,
        -2478.0947265625,
        388.9328308105469
      ],
      "bbox_max": [
        -280.0,
        -2415.062744140625,
        717.7733764648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994062423706055,
        -0.7998847365379333,
        0.029941599816083908
      ],
      "plane_d": -2178.19677734375,
      "bbox_min": [
        -391.46820068359375,
        -2415.410400390625,
        388.9328308105469
      ],
      "bbox_max": [
        -391.1797790527344,
        -2415.062744140625,
        394.5291748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.475697785615921,
        -0.7068511247634888,
        0.5235198140144348
      ],
      "plane_d": -1910.9530029296875,
      "bbox_min": [
        -491.74896240234375,
        -2515.038330078125,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2372.154541015625,
        31.58688735961914
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4636538028717041,
        -0.7131181955337524,
        0.5258208513259888
      ],
      "plane_d": -1921.4649658203125,
      "bbox_min": [
        -491.74896240234375,
        -2512.26806640625,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2372.154541015625,
        31.58688735961914
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5573205947875977,
        -0.7778975963592529,
        0.290291428565979
      ],
      "plane_d": -2111.4228515625,
      "bbox_min": [
        -488.6003723144531,
        -2512.26806640625,
        3.7401342391967773
      ],
      "bbox_max": [
        -280.0,
        -2372.154541015625,
        31.58688735961914
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4998539388179779,
        -0.8565889596939087,
        0.1280682235956192
      ],
      "plane_d": -2276.9931640625,
      "bbox_min": [
        -488.6003723144531,
        -2396.077880859375,
        6.27002477645874
      ],
      "bbox_max": [
        -446.3771057128906,
        -2372.154541015625,
        31.58688735961914
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -855.5603637695312,
        -2577.636962890625,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2179.94580078125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -855.5603637695312,
        -2577.636962890625,
        0.0
      ],
      "bbox_max": [
        -552.3164672851562,
        -2179.94580078125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -855.5603637695312,
        -2577.636962890625,
        97.04133605957031
      ],
      "bbox_max": [
        -552.3164672851562,
        -2179.94580078125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -855.5603637695312,
        -2577.636962890625,
        100.48339080810547
      ],
      "bbox_max": [
        -552.3164672851562,
        -2179.94580078125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296503663063049,
        0.3666344881057739,
        0.03646130487322807
      ],
      "plane_d": 1454.0635986328125,
      "bbox_min": [
        -783.0198974609375,
        -2577.636962890625,
        100.48339080810547
      ],
      "bbox_max": [
        -552.3164672851562,
        -2310.43701171875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9315862059593201,
        0.3613213896751404,
        0.03992580994963646
      ],
      "plane_d": 1440.1312255859375,
      "bbox_min": [
        -578.171875,
        -2556.2109375,
        421.2178649902344
      ],
      "bbox_max": [
        -572.501953125,
        -2544.010009765625,
        450.3244934082031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -578.171875,
        -2554.2509765625,
        443.0972900390625
      ],
      "bbox_max": [
        -574.3484497070312,
        -2544.010009765625,
        450.3244934082031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -777.5082397460938,
        -2338.611083984375,
        639.3778686523438
      ],
      "bbox_max": [
        -758.4019775390625,
        -2314.276123046875,
        639.6439208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -783.0198974609375,
        -2382.726318359375,
        639.3538208007812
      ],
      "bbox_max": [
        -711.3695678710938,
        -2310.43701171875,
        687.0174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34332793951034546,
        0.3998381495475769,
        -0.8498560190200806
      ],
      "plane_d": 1271.518798828125,
      "bbox_min": [
        -738.39111328125,
        -2382.726318359375,
        672.4468994140625
      ],
      "bbox_max": [
        -712.98974609375,
        -2353.859130859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34332793951034546,
        0.3998381495475769,
        -0.8498560190200806
      ],
      "plane_d": 1271.518798828125,
      "bbox_min": [
        -783.0198974609375,
        -2381.7568359375,
        639.3538208007812
      ],
      "bbox_max": [
        -711.3695678710938,
        -2310.43701171875,
        687.0174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6251323819160461,
        0.5020516514778137,
        -0.5976232290267944
      ],
      "plane_d": 1133.15673828125,
      "bbox_min": [
        -752.0667724609375,
        -2374.304931640625,
        679.6140747070312
      ],
      "bbox_max": [
        -726.142822265625,
        -2343.50244140625,
        687.0174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -752.0667724609375,
        -2370.24951171875,
        686.9425659179688
      ],
      "bbox_max": [
        -726.142822265625,
        -2343.50244140625,
        687.0174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -783.0198974609375,
        -2381.7568359375,
        639.3538208007812
      ],
      "bbox_max": [
        -711.3695678710938,
        -2310.43701171875,
        687.0145874023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -783.0198974609375,
        -2365.609375,
        639.3829345703125
      ],
      "bbox_max": [
        -726.142822265625,
        -2310.43701171875,
        687.0145874023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -783.0198974609375,
        -2365.609375,
        639.3829345703125
      ],
      "bbox_max": [
        -726.142822265625,
        -2310.43701171875,
        687.0145874023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -783.0198974609375,
        -2343.4765625,
        639.3829345703125
      ],
      "bbox_max": [
        -754.6053466796875,
        -2310.43701171875,
        686.7938232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -775.9280395507812,
        -2343.4765625,
        680.2382202148438
      ],
      "bbox_max": [
        -754.6053466796875,
        -2319.55615234375,
        686.7938232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -781.9783935546875,
        -2338.604248046875,
        639.3829345703125
      ],
      "bbox_max": [
        -758.4041137695312,
        -2310.982666015625,
        654.4479370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -781.9783935546875,
        -2335.879638671875,
        646.8973999023438
      ],
      "bbox_max": [
        -762.50537109375,
        -2310.982666015625,
        654.4479370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -697.61474609375,
        -2487.3388671875,
        1258.9176025390625
      ],
      "bbox_max": [
        -636.65966796875,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -697.61474609375,
        -2481.294677734375,
        1406.9556884765625
      ],
      "bbox_max": [
        -643.080078125,
        -2409.47900390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -637.385986328125,
        -2554.126708984375,
        443.0972900390625
      ],
      "bbox_max": [
        -574.4654541015625,
        -2481.19091796875,
        1383.0211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -637.385986328125,
        -2504.171630859375,
        1302.6832275390625
      ],
      "bbox_max": [
        -621.5278930664062,
        -2481.19091796875,
        1383.0211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -855.5603637695312,
        -2408.3671875,
        477.8255615234375
      ],
      "bbox_max": [
        -685.0712890625,
        -2179.94580078125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -770.8285522460938,
        -2408.3671875,
        639.3507080078125
      ],
      "bbox_max": [
        -685.0712890625,
        -2306.33251953125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -765.279052734375,
        -2323.63623046875,
        639.3507080078125
      ],
      "bbox_max": [
        -749.9871826171875,
        -2306.33251953125,
        686.7015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -754.6053466796875,
        -2320.1953125,
        686.6405639648438
      ],
      "bbox_max": [
        -752.467041015625,
        -2317.2001953125,
        686.6597900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -763.1380615234375,
        -2323.63623046875,
        639.3507080078125
      ],
      "bbox_max": [
        -749.9871826171875,
        -2307.621826171875,
        686.7015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -763.1380615234375,
        -2323.63623046875,
        639.3507080078125
      ],
      "bbox_max": [
        -749.9871826171875,
        -2307.621826171875,
        686.7015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -758.4019775390625,
        -2317.40283203125,
        639.3507080078125
      ],
      "bbox_max": [
        -753.7207641601562,
        -2311.613525390625,
        639.3803100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -763.1380615234375,
        -2311.39697265625,
        649.1970825195312
      ],
      "bbox_max": [
        -760.0313720703125,
        -2307.621826171875,
        651.2776489257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        639.3568115234375
      ],
      "bbox_max": [
        -685.0712890625,
        -2312.703125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -767.986572265625,
        -2343.50244140625,
        639.3568115234375
      ],
      "bbox_max": [
        -726.142822265625,
        -2315.81494140625,
        1420.7086181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -752.9869384765625,
        -2343.50244140625,
        639.3568115234375
      ],
      "bbox_max": [
        -726.142822265625,
        -2315.81494140625,
        686.9425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -752.9869384765625,
        -2333.996337890625,
        639.3568115234375
      ],
      "bbox_max": [
        -734.5928344726562,
        -2315.81494140625,
        686.6405639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -752.5239868164062,
        -2317.2001953125,
        686.5301513671875
      ],
      "bbox_max": [
        -752.123779296875,
        -2316.721435546875,
        686.6405639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -855.5603637695312,
        -2356.54248046875,
        630.2252807617188
      ],
      "bbox_max": [
        -724.2160034179688,
        -2179.94580078125,
        1427.1378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -774.5051879882812,
        -2356.54248046875,
        1051.602294921875
      ],
      "bbox_max": [
        -724.2160034179688,
        -2299.141845703125,
        1427.1378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -761.962646484375,
        -2356.54248046875,
        1051.602294921875
      ],
      "bbox_max": [
        -724.2160034179688,
        -2312.703125,
        1427.1378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -738.92578125,
        -2356.54248046875,
        1345.99072265625
      ],
      "bbox_max": [
        -724.2160034179688,
        -2338.639892578125,
        1427.1378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -738.92578125,
        -2352.36328125,
        1390.960205078125
      ],
      "bbox_max": [
        -729.0033569335938,
        -2339.8720703125,
        1427.1378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -855.5603637695312,
        -2338.1650390625,
        630.2252807617188
      ],
      "bbox_max": [
        -729.5591430664062,
        -2179.94580078125,
        1403.4530029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -855.5603637695312,
        -2338.1650390625,
        630.2252807617188
      ],
      "bbox_max": [
        -729.5591430664062,
        -2179.94580078125,
        1403.4530029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -855.5603637695312,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2179.94580078125,
        1402.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -770.0616455078125,
        -2316.208740234375,
        639.3263549804688
      ],
      "bbox_max": [
        -751.85205078125,
        -2280.2109375,
        836.8131713867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -762.0160522460938,
        -2308.695556640625,
        647.44970703125
      ],
      "bbox_max": [
        -756.6925048828125,
        -2303.34375,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -762.0160522460938,
        -2307.949462890625,
        649.5208740234375
      ],
      "bbox_max": [
        -756.8021240234375,
        -2303.34375,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -762.0160522460938,
        -2306.4140625,
        675.0604858398438
      ],
      "bbox_max": [
        -761.55126953125,
        -2305.747802734375,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -761.9382934570312,
        -2315.81494140625,
        675.13037109375
      ],
      "bbox_max": [
        -752.9869384765625,
        -2305.747802734375,
        685.6275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -759.273681640625,
        -2316.208740234375,
        639.3263549804688
      ],
      "bbox_max": [
        -751.85205078125,
        -2303.717529296875,
        649.4515380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -756.310791015625,
        -2316.208740234375,
        639.3263549804688
      ],
      "bbox_max": [
        -751.85205078125,
        -2309.22607421875,
        639.3568725585938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.74169921875,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2280.03857421875,
        1270.7828369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -768.7003173828125,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2282.0419921875,
        835.7605590820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -753.0465087890625,
        -2316.721435546875,
        685.5114135742188
      ],
      "bbox_max": [
        -752.123779296875,
        -2315.6474609375,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -768.2567138671875,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2282.130859375,
        816.547119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -757.1022338867188,
        -2303.717529296875,
        649.4515380859375
      ],
      "bbox_max": [
        -755.9295654296875,
        -2302.220703125,
        655.3712768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -756.84716796875,
        -2303.717529296875,
        649.4515380859375
      ],
      "bbox_max": [
        -755.9295654296875,
        -2302.23095703125,
        650.2191162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -756.84716796875,
        -2303.44970703125,
        649.943603515625
      ],
      "bbox_max": [
        -755.9295654296875,
        -2302.23095703125,
        650.2191162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -756.6925048828125,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2302.23388671875,
        650.0578002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -754.4367065429688,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2308.314453125,
        639.357421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -774.9254150390625,
        -2338.1650390625,
        630.2252807617188
      ],
      "bbox_max": [
        -729.5591430664062,
        -2287.4091796875,
        1403.4530029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -763.294189453125,
        -2338.1650390625,
        630.2252807617188
      ],
      "bbox_max": [
        -729.5591430664062,
        -2287.4091796875,
        760.8275146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -763.2392578125,
        -2302.23388671875,
        630.2252807617188
      ],
      "bbox_max": [
        -752.8037109375,
        -2287.467529296875,
        760.2110595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -755.9369506835938,
        -2302.23388671875,
        650.0578002929688
      ],
      "bbox_max": [
        -755.906494140625,
        -2302.20166015625,
        650.1961669921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -757.6132202148438,
        -2302.20166015625,
        630.2252807617188
      ],
      "bbox_max": [
        -752.8037109375,
        -2294.22802734375,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -753.873046875,
        -2301.795166015625,
        630.2252807617188
      ],
      "bbox_max": [
        -752.8037109375,
        -2300.530029296875,
        638.5557861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -753.873046875,
        -2301.795166015625,
        630.2252807617188
      ],
      "bbox_max": [
        -752.8037109375,
        -2300.53076171875,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -753.873046875,
        -2301.012451171875,
        636.9639892578125
      ],
      "bbox_max": [
        -753.5885620117188,
        -2300.52978515625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8128646016120911,
        -0.582452118396759,
        0.00089612090960145
      ],
      "plane_d": -1953.436279296875,
      "bbox_min": [
        -753.873046875,
        -2301.012451171875,
        639.2813110351562
      ],
      "bbox_max": [
        -753.6727294921875,
        -2300.702880859375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.871337890625,
        -2300.75,
        641.6248779296875
      ],
      "bbox_max": [
        -753.8310546875,
        -2300.702880859375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -755.9295654296875,
        -2338.1650390625,
        630.2252807617188
      ],
      "bbox_max": [
        -729.5591430664062,
        -2300.52978515625,
        650.060791015625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -753.7503662109375,
        -2304.79736328125,
        630.2252807617188
      ],
      "bbox_max": [
        -750.960693359375,
        -2300.94140625,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -752.82275390625,
        -2301.90966796875,
        630.2252807617188
      ],
      "bbox_max": [
        -752.7094116210938,
        -2301.761962890625,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -750.960693359375,
        -2305.024169921875,
        636.568603515625
      ],
      "bbox_max": [
        -750.7191162109375,
        -2304.75341796875,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -750.960693359375,
        -2305.024169921875,
        637.5436401367188
      ],
      "bbox_max": [
        -750.7191162109375,
        -2304.79736328125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -755.9295654296875,
        -2308.314453125,
        639.27490234375
      ],
      "bbox_max": [
        -750.8939819335938,
        -2300.52978515625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -755.9295654296875,
        -2308.314453125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2302.20166015625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8128646016120911,
        -0.582452118396759,
        0.00089612090960145
      ],
      "plane_d": -1953.436279296875,
      "bbox_min": [
        -753.8582153320312,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.8939819335938,
        -2300.52978515625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.8582153320312,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.8939819335938,
        -2300.52978515625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -753.8310546875,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.8939819335938,
        -2300.52978515625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -753.8310546875,
        -2300.702880859375,
        640.6307373046875
      ],
      "bbox_max": [
        -753.5884399414062,
        -2300.52978515625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -841.965576171875,
        -2190.76513671875,
        688.246337890625
      ],
      "bbox_max": [
        -834.5745849609375,
        -2181.8564453125,
        787.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -839.6445922851562,
        -2183.86328125,
        688.246337890625
      ],
      "bbox_max": [
        -837.9896850585938,
        -2182.1826171875,
        707.8184814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373378813266754,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -761.055908203125,
        -2350.402587890625,
        477.8255615234375
      ],
      "bbox_max": [
        -714.7828369140625,
        -2288.817626953125,
        699.5869750976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -761.055908203125,
        -2304.505859375,
        626.472900390625
      ],
      "bbox_max": [
        -751.0501708984375,
        -2288.817626953125,
        699.5869750976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -753.5899047851562,
        -2303.486083984375,
        630.2252807617188
      ],
      "bbox_max": [
        -751.1507568359375,
        -2299.74658203125,
        636.9641723632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -753.5899047851562,
        -2303.486083984375,
        630.2252807617188
      ],
      "bbox_max": [
        -751.1507568359375,
        -2299.74658203125,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -753.5890502929688,
        -2304.190673828125,
        630.8737182617188
      ],
      "bbox_max": [
        -751.250732421875,
        -2299.758056640625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.5884399414062,
        -2304.190673828125,
        641.6248779296875
      ],
      "bbox_max": [
        -751.250732421875,
        -2299.947021484375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -752.772216796875,
        -2350.402587890625,
        477.8255615234375
      ],
      "bbox_max": [
        -714.7828369140625,
        -2299.369873046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -750.6803588867188,
        -2350.402587890625,
        639.2813720703125
      ],
      "bbox_max": [
        -714.7828369140625,
        -2305.0849609375,
        639.3631591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -752.772216796875,
        -2316.24072265625,
        551.361083984375
      ],
      "bbox_max": [
        -739.7911987304688,
        -2299.369873046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -750.7191162109375,
        -2316.24072265625,
        639.28125
      ],
      "bbox_max": [
        -739.7911987304688,
        -2305.024169921875,
        639.2871704101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -752.772216796875,
        -2313.185302734375,
        630.2252807617188
      ],
      "bbox_max": [
        -742.0280151367188,
        -2299.369873046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -752.772216796875,
        -2313.185302734375,
        630.2252807617188
      ],
      "bbox_max": [
        -742.0280151367188,
        -2299.369873046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -752.772216796875,
        -2313.185302734375,
        639.28125
      ],
      "bbox_max": [
        -742.0280151367188,
        -2299.47509765625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -752.772216796875,
        -2304.749755859375,
        639.28125
      ],
      "bbox_max": [
        -749.1293334960938,
        -2299.47509765625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -750.894287109375,
        -2304.749755859375,
        639.28125
      ],
      "bbox_max": [
        -749.1293334960938,
        -2303.485107421875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296503663063049,
        0.3666344881057739,
        0.03646130487322807
      ],
      "plane_d": 1454.0635986328125,
      "bbox_min": [
        -673.747314453125,
        -2569.197265625,
        97.04133605957031
      ],
      "bbox_max": [
        -554.801025390625,
        -2404.270751953125,
        558.2156982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.834480881690979,
        0.550487756729126,
        0.024593127891421318
      ],
      "plane_d": 1872.022705078125,
      "bbox_min": [
        -673.747314453125,
        -2544.010009765625,
        421.6952819824219
      ],
      "bbox_max": [
        -577.6831665039062,
        -2404.270751953125,
        558.2156982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8202191591262817,
        0.571056604385376,
        0.033687908202409744
      ],
      "plane_d": 1912.07421875,
      "bbox_min": [
        -582.0225219726562,
        -2544.010009765625,
        421.6952819824219
      ],
      "bbox_max": [
        -577.6831665039062,
        -2537.216796875,
        443.0972900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373378813266754,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -838.8136596679688,
        -2407.66796875,
        0.0
      ],
      "bbox_max": [
        -673.747314453125,
        -2182.29931640625,
        1385.3797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -838.8136596679688,
        -2297.6806640625,
        0.0
      ],
      "bbox_max": [
        -753.1447143554688,
        -2182.29931640625,
        1364.9808349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -838.8136596679688,
        -2287.467529296875,
        132.6617889404297
      ],
      "bbox_max": [
        -763.2392578125,
        -2182.29931640625,
        1063.4324951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -775.706787109375,
        -2287.467529296875,
        760.2109985351562
      ],
      "bbox_max": [
        -763.2392578125,
        -2263.271728515625,
        944.0614013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.706787109375,
        -2285.833740234375,
        833.5809936523438
      ],
      "bbox_max": [
        -765.8814697265625,
        -2263.271728515625,
        944.0614013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -838.8136596679688,
        -2254.9462890625,
        132.6617889404297
      ],
      "bbox_max": [
        -781.328125,
        -2182.29931640625,
        946.2839965820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429205179214478,
        0.6689924597740173,
        0.022761043161153793
      ],
      "plane_d": 2066.187744140625,
      "bbox_min": [
        -823.192138671875,
        -2218.97607421875,
        132.6617889404297
      ],
      "bbox_max": [
        -794.0770874023438,
        -2184.494873046875,
        362.4170227050781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -823.1215209960938,
        -2210.4697265625,
        132.6617889404297
      ],
      "bbox_max": [
        -796.3873291015625,
        -2184.5048828125,
        296.2656555175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -838.8136596679688,
        -2227.4150390625,
        230.58316040039062
      ],
      "bbox_max": [
        -795.1062622070312,
        -2182.29931640625,
        704.5289916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429205179214478,
        0.6689924597740173,
        0.022761043161153793
      ],
      "plane_d": 2066.187744140625,
      "bbox_min": [
        -825.479736328125,
        -2202.36474609375,
        230.58316040039062
      ],
      "bbox_max": [
        -809.0655517578125,
        -2184.17333984375,
        363.49530029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -823.0145263671875,
        -2189.5185546875,
        230.58316040039062
      ],
      "bbox_max": [
        -816.2205200195312,
        -2184.52001953125,
        293.85711669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -775.4022827148438,
        -2297.6806640625,
        592.3736572265625
      ],
      "bbox_max": [
        -753.1447143554688,
        -2264.129638671875,
        1111.500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -775.0945434570312,
        -2286.757080078125,
        833.05029296875
      ],
      "bbox_max": [
        -765.195068359375,
        -2264.1533203125,
        1111.500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.0945434570312,
        -2286.757080078125,
        833.05029296875
      ],
      "bbox_max": [
        -765.195068359375,
        -2264.1533203125,
        942.94921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -762.060302734375,
        -2297.6806640625,
        592.3736572265625
      ],
      "bbox_max": [
        -753.1447143554688,
        -2273.45166015625,
        627.4076538085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -829.6610717773438,
        -2246.868408203125,
        0.0
      ],
      "bbox_max": [
        -784.2650756835938,
        -2183.585693359375,
        818.7529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -829.6610717773438,
        -2246.868408203125,
        361.432373046875
      ],
      "bbox_max": [
        -784.2650756835938,
        -2183.585693359375,
        818.7529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429205179214478,
        0.6689924597740173,
        0.022761043161153793
      ],
      "plane_d": 2066.187744140625,
      "bbox_min": [
        -827.633544921875,
        -2225.82861328125,
        362.4170227050781
      ],
      "bbox_max": [
        -792.2159423828125,
        -2183.87060546875,
        502.09661865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -788.6555786132812,
        -2407.66796875,
        97.15827941894531
      ],
      "bbox_max": [
        -673.747314453125,
        -2260.81689453125,
        1385.3797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -739.791259765625,
        -2407.66796875,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2316.24072265625,
        1314.4796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -710.0498657226562,
        -2407.66796875,
        1224.163330078125
      ],
      "bbox_max": [
        -685.0712890625,
        -2375.04443359375,
        1314.4796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9562264084815979,
        0.139556884765625,
        0.257205992937088
      ],
      "plane_d": 836.2110595703125,
      "bbox_min": [
        -739.791259765625,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2316.24072265625,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -714.501953125,
        -2355.322998046875,
        639.3294677734375
      ],
      "bbox_max": [
        -709.56298828125,
        -2348.62255859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -714.501953125,
        -2355.322998046875,
        639.3294677734375
      ],
      "bbox_max": [
        -709.56298828125,
        -2348.62255859375,
        649.135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -786.48876953125,
        -2375.35693359375,
        380.36639404296875
      ],
      "bbox_max": [
        -706.0453491210938,
        -2261.742919921875,
        1385.3797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -742.3391723632812,
        -2375.35693359375,
        1126.5186767578125
      ],
      "bbox_max": [
        -706.0453491210938,
        -2326.51611328125,
        1376.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -742.3391723632812,
        -2375.35693359375,
        1126.5186767578125
      ],
      "bbox_max": [
        -706.0453491210938,
        -2326.51611328125,
        1376.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -742.3391723632812,
        -2332.292724609375,
        1126.5186767578125
      ],
      "bbox_max": [
        -733.7012329101562,
        -2326.51611328125,
        1229.1416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -786.48876953125,
        -2280.03857421875,
        1270.7828369140625
      ],
      "bbox_max": [
        -778.74169921875,
        -2264.956787109375,
        1385.3797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -752.1113891601562,
        -2334.175537109375,
        380.36639404296875
      ],
      "bbox_max": [
        -722.285400390625,
        -2296.214111328125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -742.0280151367188,
        -2334.175537109375,
        630.2252807617188
      ],
      "bbox_max": [
        -722.285400390625,
        -2313.185302734375,
        639.29638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -739.8632202148438,
        -2330.087646484375,
        630.2252807617188
      ],
      "bbox_max": [
        -724.8484497070312,
        -2314.902099609375,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -752.1113891601562,
        -2327.564453125,
        630.2252807617188
      ],
      "bbox_max": [
        -726.7146606445312,
        -2296.214111328125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -752.0810546875,
        -2299.453369140625,
        630.2252807617188
      ],
      "bbox_max": [
        -747.5438842773438,
        -2296.214111328125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -752.1113891601562,
        -2303.507080078125,
        639.28125
      ],
      "bbox_max": [
        -744.8853759765625,
        -2296.298828125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -752.1113891601562,
        -2303.507080078125,
        639.28125
      ],
      "bbox_max": [
        -744.8853759765625,
        -2296.298828125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -749.1597900390625,
        -2303.507080078125,
        639.28125
      ],
      "bbox_max": [
        -744.8853759765625,
        -2300.444091796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085832595825195,
        0.02404039539396763
      ],
      "plane_d": 1733.21240234375,
      "bbox_min": [
        -805.3485717773438,
        -2567.84716796875,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2191.682861328125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281567931175232,
        0.37126728892326355,
        0.02618309296667576
      ],
      "plane_d": 1533.945556640625,
      "bbox_min": [
        -805.3485717773438,
        -2404.270751953125,
        0.0
      ],
      "bbox_max": [
        -673.747314453125,
        -2191.682861328125,
        1209.011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373378813266754,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -805.3485717773438,
        -2296.841796875,
        0.0
      ],
      "bbox_max": [
        -734.897216796875,
        -2191.682861328125,
        1062.6295166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429205179214478,
        0.6689924597740173,
        0.022761043161153793
      ],
      "plane_d": 2066.187744140625,
      "bbox_min": [
        -805.3485717773438,
        -2277.610107421875,
        0.0
      ],
      "bbox_max": [
        -750.751220703125,
        -2191.682861328125,
        1047.4464111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -792.2159423828125,
        -2277.610107421875,
        502.0966491699219
      ],
      "bbox_max": [
        -759.3041381835938,
        -2225.82861328125,
        1047.4464111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.3511352539062,
        -2264.1533203125,
        942.94921875
      ],
      "bbox_max": [
        -775.0945434570312,
        -2261.33837890625,
        956.3025512695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -775.8807983398438,
        -2277.610107421875,
        560.3877563476562
      ],
      "bbox_max": [
        -759.3041381835938,
        -2257.5107421875,
        957.9810180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -775.8807983398438,
        -2264.3046875,
        942.7584228515625
      ],
      "bbox_max": [
        -774.989501953125,
        -2262.30322265625,
        957.9810180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.8807983398438,
        -2264.3046875,
        942.7584228515625
      ],
      "bbox_max": [
        -774.989501953125,
        -2262.30322265625,
        952.2825927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -792.2159423828125,
        -2260.81689453125,
        502.0966491699219
      ],
      "bbox_max": [
        -765.472412109375,
        -2225.82861328125,
        1047.4464111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -781.328125,
        -2260.81689453125,
        946.2839965820312
      ],
      "bbox_max": [
        -776.7902221679688,
        -2254.9462890625,
        1047.4464111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -781.328125,
        -2260.416015625,
        946.2839965820312
      ],
      "bbox_max": [
        -776.7902221679688,
        -2254.9462890625,
        969.5377807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -805.3485717773438,
        -2254.792724609375,
        0.0
      ],
      "bbox_max": [
        -750.751220703125,
        -2191.682861328125,
        186.8227081298828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -779.3583374023438,
        -2296.841796875,
        0.0
      ],
      "bbox_max": [
        -734.897216796875,
        -2257.5107421875,
        1062.6295166015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2262.30322265625,
        952.2825927734375
      ],
      "bbox_max": [
        -775.8807983398438,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -778.8005981445312,
        -2296.841796875,
        0.0
      ],
      "bbox_max": [
        -734.897216796875,
        -2260.681396484375,
        1056.065673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.8005981445312,
        -2264.129638671875,
        950.8040161132812
      ],
      "bbox_max": [
        -775.4022827148438,
        -2260.681396484375,
        1056.065673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -776.570068359375,
        -2264.129638671875,
        950.8040161132812
      ],
      "bbox_max": [
        -775.4022827148438,
        -2260.681396484375,
        966.3346557617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2262.657958984375,
        950.8040161132812
      ],
      "bbox_max": [
        -775.7078247070312,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -779.3583374023438,
        -2261.899169921875,
        960.462158203125
      ],
      "bbox_max": [
        -776.570068359375,
        -2260.41552734375,
        1062.6295166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -779.3583374023438,
        -2261.742919921875,
        960.462158203125
      ],
      "bbox_max": [
        -776.570068359375,
        -2260.41552734375,
        1062.6295166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -747.693603515625,
        -2404.270751953125,
        0.0
      ],
      "bbox_max": [
        -673.747314453125,
        -2289.78173828125,
        1209.011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9562264084815979,
        0.139556884765625,
        0.257205992937088
      ],
      "plane_d": 836.2110595703125,
      "bbox_min": [
        -726.811279296875,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2327.158203125,
        1209.011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -726.811279296875,
        -2353.44921875,
        630.2252807617188
      ],
      "bbox_max": [
        -705.9177856445312,
        -2327.158203125,
        666.98779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -726.7146606445312,
        -2353.44921875,
        639.28125
      ],
      "bbox_max": [
        -706.224853515625,
        -2327.564453125,
        666.98779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -712.6063842773438,
        -2353.44921875,
        639.28125
      ],
      "bbox_max": [
        -706.224853515625,
        -2344.337158203125,
        666.98779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -712.6063842773438,
        -2353.44921875,
        639.28125
      ],
      "bbox_max": [
        -706.224853515625,
        -2344.337158203125,
        649.505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -721.0748901367188,
        -2362.74951171875,
        1168.2125244140625
      ],
      "bbox_max": [
        -713.7638549804688,
        -2351.30419921875,
        1209.011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -720.7378540039062,
        -2361.270751953125,
        1186.4080810546875
      ],
      "bbox_max": [
        -715.1890869140625,
        -2352.72265625,
        1209.011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -747.693603515625,
        -2352.895751953125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2289.78173828125,
        1199.8175048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -747.693603515625,
        -2352.895751953125,
        630.2252807617188
      ],
      "bbox_max": [
        -708.6976318359375,
        -2289.78173828125,
        1199.8175048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -747.693603515625,
        -2352.895751953125,
        630.2252807617188
      ],
      "bbox_max": [
        -708.852294921875,
        -2289.78173828125,
        1199.8175048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -747.662841796875,
        -2296.298828125,
        630.2252807617188
      ],
      "bbox_max": [
        -738.5347900390625,
        -2289.78173828125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -747.693603515625,
        -2352.895751953125,
        639.28125
      ],
      "bbox_max": [
        -720.0554809570312,
        -2289.9091796875,
        1199.8175048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.7510986328125,
        -2333.139892578125,
        1156.989013671875
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.134033203125,
        1178.7537841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.7510986328125,
        -2332.605712890625,
        1156.989013671875
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.134033203125,
        1165.0408935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -747.693603515625,
        -2300.46630859375,
        639.28125
      ],
      "bbox_max": [
        -736.3060913085938,
        -2289.9091796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -747.693603515625,
        -2300.46630859375,
        639.28125
      ],
      "bbox_max": [
        -736.3060913085938,
        -2289.9091796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -744.9161376953125,
        -2300.46630859375,
        639.28125
      ],
      "bbox_max": [
        -736.3060913085938,
        -2294.296875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8710070252418518,
        0.4906066656112671,
        0.025533335283398628
      ],
      "plane_d": 1752.1368408203125,
      "bbox_min": [
        -738.759521484375,
        -2567.84716796875,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2204.664794921875,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.834480881690979,
        0.550487756729126,
        0.024593127891421318
      ],
      "plane_d": 1872.022705078125,
      "bbox_min": [
        -738.759521484375,
        -2567.84716796875,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2204.664794921875,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9412656426429749,
        -0.3293653726577759,
        0.07441509515047073
      ],
      "plane_d": -1360.3240966796875,
      "bbox_min": [
        -679.6759643554688,
        -2456.75244140625,
        0.0
      ],
      "bbox_max": [
        -280.0,
        -2204.664794921875,
        970.539306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538359522819519,
        0.3617154061794281,
        0.6645753979682922
      ],
      "plane_d": 32.34027099609375,
      "bbox_min": [
        -650.1622924804688,
        -2456.75244140625,
        191.8474884033203
      ],
      "bbox_max": [
        -280.0,
        -2210.393798828125,
        970.539306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7415313124656677,
        -0.6696079969406128,
        0.04191046580672264
      ],
      "plane_d": -1963.6297607421875,
      "bbox_min": [
        -650.1622924804688,
        -2456.75244140625,
        191.8474884033203
      ],
      "bbox_max": [
        -280.0,
        -2210.393798828125,
        970.539306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9367828965187073,
        -0.20473380386829376,
        0.28376367688179016
      ],
      "plane_d": -1166.953125,
      "bbox_min": [
        -621.3937377929688,
        -2285.270751953125,
        503.47503662109375
      ],
      "bbox_max": [
        -547.3446655273438,
        -2212.855712890625,
        656.66552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8040702939033508,
        -0.5765846371650696,
        0.1449870765209198
      ],
      "plane_d": -1848.5401611328125,
      "bbox_min": [
        -621.3937377929688,
        -2250.447021484375,
        503.47503662109375
      ],
      "bbox_max": [
        -570.9049682617188,
        -2212.855712890625,
        610.0081787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7754648327827454,
        -0.5560722351074219,
        0.2990618944168091
      ],
      "plane_d": -1871.9361572265625,
      "bbox_min": [
        -608.0498046875,
        -2250.447021484375,
        559.9291381835938
      ],
      "bbox_max": [
        -570.9049682617188,
        -2217.2685546875,
        610.0081787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8221501111984253,
        -0.5637224912643433,
        0.07928481698036194
      ],
      "plane_d": -1806.1368408203125,
      "bbox_min": [
        -650.1622924804688,
        -2291.06005859375,
        191.8474884033203
      ],
      "bbox_max": [
        -556.5177612304688,
        -2210.393798828125,
        559.9291381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8139806389808655,
        -0.5609368085861206,
        0.15094897150993347
      ],
      "plane_d": -1822.4539794921875,
      "bbox_min": [
        -638.9112548828125,
        -2291.06005859375,
        385.76458740234375
      ],
      "bbox_max": [
        -556.5177612304688,
        -2210.393798828125,
        559.9291381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5089108347892761,
        -0.8510448932647705,
        0.1293530911207199
      ],
      "plane_d": -2284.995361328125,
      "bbox_min": [
        -598.3650512695312,
        -2291.06005859375,
        401.86346435546875
      ],
      "bbox_max": [
        -556.5177612304688,
        -2250.447021484375,
        559.9291381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8040702939033508,
        -0.5765846371650696,
        0.1449870765209198
      ],
      "plane_d": -1848.5401611328125,
      "bbox_min": [
        -638.9112548828125,
        -2250.447021484375,
        386.6965026855469
      ],
      "bbox_max": [
        -584.258056640625,
        -2210.393798828125,
        559.9291381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8123376965522766,
        -0.5648552179336548,
        0.14507277309894562
      ],
      "plane_d": -1827.8267822265625,
      "bbox_min": [
        -638.9112548828125,
        -2218.662841796875,
        386.6965026855469
      ],
      "bbox_max": [
        -627.8792724609375,
        -2210.393798828125,
        471.1322021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879413485527039,
        0.423933207988739,
        0.6889162063598633
      ],
      "plane_d": 185.86029052734375,
      "bbox_min": [
        -621.0487670898438,
        -2399.99365234375,
        555.4501953125
      ],
      "bbox_max": [
        -387.445068359375,
        -2212.904052734375,
        876.422607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9367828965187073,
        -0.20473380386829376,
        0.28376367688179016
      ],
      "plane_d": -1166.953125,
      "bbox_min": [
        -610.9713745117188,
        -2295.365234375,
        555.4501953125
      ],
      "bbox_max": [
        -536.644287109375,
        -2214.320556640625,
        684.7072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -563.072509765625,
        -2243.481689453125,
        630.2252807617188
      ],
      "bbox_max": [
        -560.1396484375,
        -2240.4169921875,
        631.389892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -563.072509765625,
        -2243.481689453125,
        630.2252807617188
      ],
      "bbox_max": [
        -560.1396484375,
        -2240.4169921875,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7754648327827454,
        -0.5560722351074219,
        0.2990618944168091
      ],
      "plane_d": -1871.9361572265625,
      "bbox_min": [
        -610.9713745117188,
        -2242.13525390625,
        555.4501953125
      ],
      "bbox_max": [
        -567.03173828125,
        -2214.320556640625,
        624.5343627929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -621.0487670898438,
        -2295.365234375,
        580.5648803710938
      ],
      "bbox_max": [
        -478.6838684082031,
        -2212.904052734375,
        695.7410278320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -601.2230224609375,
        -2295.365234375,
        580.5648803710938
      ],
      "bbox_max": [
        -479.2474365234375,
        -2215.6904296875,
        695.3135375976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9367828965187073,
        -0.20473380386829376,
        0.28376367688179016
      ],
      "plane_d": -1166.953125,
      "bbox_min": [
        -601.2230224609375,
        -2295.365234375,
        580.5648803710938
      ],
      "bbox_max": [
        -536.644287109375,
        -2215.6904296875,
        684.7072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -566.7360229492188,
        -2244.38427734375,
        630.2252807617188
      ],
      "bbox_max": [
        -560.1396484375,
        -2233.190185546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8059484362602234,
        0.5919858813285828,
        -0.0
      ],
      "plane_d": 1778.2655029296875,
      "bbox_min": [
        -563.099609375,
        -2242.1806640625,
        639.28125
      ],
      "bbox_max": [
        -560.1396484375,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -561.7347412109375,
        -2242.1806640625,
        641.6248779296875
      ],
      "bbox_max": [
        -560.1396484375,
        -2239.679443359375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7754648327827454,
        -0.5560722351074219,
        0.2990618944168091
      ],
      "plane_d": -1871.9361572265625,
      "bbox_min": [
        -601.2230224609375,
        -2260.451904296875,
        580.5648803710938
      ],
      "bbox_max": [
        -561.3180541992188,
        -2215.6904296875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -569.9207153320312,
        -2238.779541015625,
        630.2252807617188
      ],
      "bbox_max": [
        -565.5144653320312,
        -2231.3134765625,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7427215576171875,
        -0.6210522651672363,
        0.2503175735473633
      ],
      "plane_d": -1967.71533203125,
      "bbox_min": [
        -598.2819213867188,
        -2260.451904296875,
        587.4226684570312
      ],
      "bbox_max": [
        -561.3180541992188,
        -2216.103759765625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -569.9882202148438,
        -2233.5791015625,
        630.2252807617188
      ],
      "bbox_max": [
        -569.2437744140625,
        -2232.635009765625,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -589.819091796875,
        -2260.451904296875,
        630.2252807617188
      ],
      "bbox_max": [
        -561.3180541992188,
        -2232.688720703125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -564.7127075195312,
        -2244.697998046875,
        641.6248779296875
      ],
      "bbox_max": [
        -561.3180541992188,
        -2240.273681640625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7427215576171875,
        -0.6210522651672363,
        0.2503175735473633
      ],
      "plane_d": -1967.71533203125,
      "bbox_min": [
        -593.981689453125,
        -2237.995361328125,
        598.6825561523438
      ],
      "bbox_max": [
        -545.7772827148438,
        -2216.7080078125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -571.7012329101562,
        -2237.27685546875,
        630.2252807617188
      ],
      "bbox_max": [
        -545.7772827148438,
        -2222.450927734375,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -571.7012329101562,
        -2232.688720703125,
        630.2252807617188
      ],
      "bbox_max": [
        -568.2611694335938,
        -2228.693115234375,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -576.6520385742188,
        -2237.995361328125,
        630.2252807617188
      ],
      "bbox_max": [
        -569.9880981445312,
        -2230.64013671875,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -621.0487670898438,
        -2260.376220703125,
        612.2050170898438
      ],
      "bbox_max": [
        -553.1201782226562,
        -2212.904052734375,
        641.6248779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -621.0487670898438,
        -2260.376220703125,
        612.2050170898438
      ],
      "bbox_max": [
        -563.099609375,
        -2212.904052734375,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7427215576171875,
        -0.6210522651672363,
        0.2503175735473633
      ],
      "plane_d": -1967.71533203125,
      "bbox_min": [
        -585.8543090820312,
        -2260.376220703125,
        630.2252807617188
      ],
      "bbox_max": [
        -563.099609375,
        -2218.401123046875,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -585.8543090820312,
        -2260.376220703125,
        634.2875366210938
      ],
      "bbox_max": [
        -571.465576171875,
        -2249.705810546875,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7427215576171875,
        -0.6210522651672363,
        0.2503175735473633
      ],
      "plane_d": -1967.71533203125,
      "bbox_min": [
        -588.8173217773438,
        -2230.64013671875,
        612.2050170898438
      ],
      "bbox_max": [
        -571.7012329101562,
        -2217.433837890625,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5919927358627319,
        0.8059433102607727,
        0.0
      ],
      "plane_d": 1469.767333984375,
      "bbox_min": [
        -590.0313720703125,
        -2260.283203125,
        639.28125
      ],
      "bbox_max": [
        -561.3347778320312,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -589.9722900390625,
        -2260.283203125,
        639.28125
      ],
      "bbox_max": [
        -561.3347778320312,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -585.7289428710938,
        -2260.283203125,
        639.28125
      ],
      "bbox_max": [
        -561.3347778320312,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8059484362602234,
        0.5919858813285828,
        -0.0
      ],
      "plane_d": 1778.2655029296875,
      "bbox_min": [
        -563.099609375,
        -2239.679443359375,
        639.28125
      ],
      "bbox_max": [
        -561.3347778320312,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8758759498596191,
        -0.4812624454498291,
        0.035040486603975296
      ],
      "plane_d": -1640.369140625,
      "bbox_min": [
        -679.6759643554688,
        -2241.975341796875,
        0.0
      ],
      "bbox_max": [
        -610.1602172851562,
        -2204.664794921875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -642.7560424804688,
        -2241.975341796875,
        386.6965026855469
      ],
      "bbox_max": [
        -610.1602172851562,
        -2209.853515625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -631.4694213867188,
        -2241.975341796875,
        630.2252807617188
      ],
      "bbox_max": [
        -610.1602172851562,
        -2211.751953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -631.4694213867188,
        -2213.339111328125,
        630.2252807617188
      ],
      "bbox_max": [
        -629.2466430664062,
        -2211.751953125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -631.2091674804688,
        -2217.342041015625,
        639.28125
      ],
      "bbox_max": [
        -622.4407958984375,
        -2211.751953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -631.2091674804688,
        -2217.342041015625,
        639.28125
      ],
      "bbox_max": [
        -622.4407958984375,
        -2211.751953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -631.2091674804688,
        -2213.153076171875,
        639.28125
      ],
      "bbox_max": [
        -629.2466430664062,
        -2211.751953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8123376965522766,
        -0.5648552179336548,
        0.14507277309894562
      ],
      "plane_d": -1827.8267822265625,
      "bbox_min": [
        -642.7560424804688,
        -2218.662841796875,
        386.6965026855469
      ],
      "bbox_max": [
        -638.28662109375,
        -2209.853515625,
        415.3950500488281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8602949976921082,
        -0.4507606625556946,
        0.238133043050766
      ],
      "plane_d": -1578.498046875,
      "bbox_min": [
        -679.6759643554688,
        -2235.450439453125,
        0.0
      ],
      "bbox_max": [
        -619.0206298828125,
        -2204.664794921875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -640.35791015625,
        -2235.450439453125,
        630.2252807617188
      ],
      "bbox_max": [
        -619.0206298828125,
        -2213.10498046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -640.35791015625,
        -2235.335693359375,
        630.2252807617188
      ],
      "bbox_max": [
        -619.0206298828125,
        -2213.10498046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -640.35791015625,
        -2219.685302734375,
        630.2252807617188
      ],
      "bbox_max": [
        -631.2091674804688,
        -2213.153076171875,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -640.1262817382812,
        -2222.515869140625,
        639.28125
      ],
      "bbox_max": [
        -628.8401489257812,
        -2213.10498046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -640.0663452148438,
        -2222.515869140625,
        639.2813110351562
      ],
      "bbox_max": [
        -628.8401489257812,
        -2213.10498046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -636.1281127929688,
        -2222.515869140625,
        639.2813110351562
      ],
      "bbox_max": [
        -628.8401489257812,
        -2217.2939453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8202191591262817,
        0.571056604385376,
        0.033687908202409744
      ],
      "plane_d": 1912.07421875,
      "bbox_min": [
        -738.759521484375,
        -2557.679931640625,
        0.0
      ],
      "bbox_max": [
        -392.0885314941406,
        -2219.47705078125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296503663063049,
        0.3666344881057739,
        0.03646130487322807
      ],
      "plane_d": 1454.0635986328125,
      "bbox_min": [
        -577.6831665039062,
        -2557.679931640625,
        29.808334350585938
      ],
      "bbox_max": [
        -558.191650390625,
        -2541.47509765625,
        429.817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8397244811058044,
        -0.5365661978721619,
        0.08342374861240387
      ],
      "plane_d": -1756.9742431640625,
      "bbox_min": [
        -738.759521484375,
        -2414.696044921875,
        0.0
      ],
      "bbox_max": [
        -392.0885314941406,
        -2219.47705078125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5781846046447754,
        -0.8145887851715088,
        0.0463433600962162
      ],
      "plane_d": -2211.789794921875,
      "bbox_min": [
        -671.7844848632812,
        -2414.696044921875,
        0.0
      ],
      "bbox_max": [
        -392.0885314941406,
        -2219.72607421875,
        684.7072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7415313124656677,
        -0.6696079969406128,
        0.04191046580672264
      ],
      "plane_d": -1963.6297607421875,
      "bbox_min": [
        -671.7844848632812,
        -2413.0732421875,
        0.0
      ],
      "bbox_max": [
        -395.4713134765625,
        -2219.72607421875,
        684.7072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5395222306251526,
        -0.8415294885635376,
        0.027272434905171394
      ],
      "plane_d": -2254.31982421875,
      "bbox_min": [
        -504.2900390625,
        -2413.0732421875,
        37.8101692199707
      ],
      "bbox_max": [
        -395.4713134765625,
        -2353.19775390625,
        377.01031494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4998539388179779,
        -0.8565889596939087,
        0.1280682235956192
      ],
      "plane_d": -2276.9931640625,
      "bbox_min": [
        -504.2900390625,
        -2373.2626953125,
        37.8101692199707
      ],
      "bbox_max": [
        -473.75244140625,
        -2353.19775390625,
        71.826416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9412656426429749,
        -0.3293653726577759,
        0.07441509515047073
      ],
      "plane_d": -1360.3240966796875,
      "bbox_min": [
        -671.7844848632812,
        -2312.4736328125,
        0.0
      ],
      "bbox_max": [
        -541.8916015625,
        -2219.72607421875,
        457.1606140136719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5089108347892761,
        -0.8510448932647705,
        0.1293530911207199
      ],
      "plane_d": -2284.995361328125,
      "bbox_min": [
        -618.7315063476562,
        -2312.4736328125,
        318.5225830078125
      ],
      "bbox_max": [
        -541.8916015625,
        -2244.6787109375,
        457.1606140136719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8139806389808655,
        -0.5609368085861206,
        0.15094897150993347
      ],
      "plane_d": -1822.4539794921875,
      "bbox_min": [
        -618.7315063476562,
        -2261.97998046875,
        386.1427917480469
      ],
      "bbox_max": [
        -598.3650512695312,
        -2244.6787109375,
        457.1606140136719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8602949976921082,
        -0.4507606625556946,
        0.238133043050766
      ],
      "plane_d": -1578.498046875,
      "bbox_min": [
        -671.7844848632812,
        -2238.677001953125,
        0.0
      ],
      "bbox_max": [
        -661.85498046875,
        -2219.72607421875,
        13.382871627807617
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5192293524742126,
        -0.8514940738677979,
        0.07320254296064377
      ],
      "plane_d": -2270.671142578125,
      "bbox_min": [
        -636.28662109375,
        -2414.40576171875,
        0.0
      ],
      "bbox_max": [
        -392.693603515625,
        -2260.69091796875,
        394.9550476074219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5089108347892761,
        -0.8510448932647705,
        0.1293530911207199
      ],
      "plane_d": -2284.995361328125,
      "bbox_min": [
        -609.4266357421875,
        -2269.941162109375,
        382.904296875
      ],
      "bbox_max": [
        -596.65380859375,
        -2260.69091796875,
        394.9550476074219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8139806389808655,
        -0.5609368085861206,
        0.15094897150993347
      ],
      "plane_d": -1822.4539794921875,
      "bbox_min": [
        -609.4266357421875,
        -2262.677001953125,
        384.9858703613281
      ],
      "bbox_max": [
        -606.9039916992188,
        -2260.69091796875,
        394.9550476074219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5395222306251526,
        -0.8415294885635376,
        0.027272434905171394
      ],
      "plane_d": -2254.31982421875,
      "bbox_min": [
        -636.28662109375,
        -2414.40576171875,
        0.0
      ],
      "bbox_max": [
        -392.693603515625,
        -2262.677001953125,
        388.24566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.56119704246521,
        -0.8256406784057617,
        0.058097995817661285
      ],
      "plane_d": -2231.885986328125,
      "bbox_min": [
        -608.2724609375,
        -2328.025634765625,
        90.66432189941406
      ],
      "bbox_max": [
        -541.8916015625,
        -2262.677001953125,
        384.9858703613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5089108347892761,
        -0.8510448932647705,
        0.1293530911207199
      ],
      "plane_d": -2284.995361328125,
      "bbox_min": [
        -608.2724609375,
        -2312.4736328125,
        318.5225830078125
      ],
      "bbox_max": [
        -541.8916015625,
        -2262.677001953125,
        384.9858703613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5537408590316772,
        -0.8233800530433655,
        0.12416242808103561
      ],
      "plane_d": -2228.56689453125,
      "bbox_min": [
        -636.28662109375,
        -2374.730712890625,
        0.0
      ],
      "bbox_max": [
        -479.33441162109375,
        -2278.69140625,
        90.66432189941406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4998539388179779,
        -0.8565889596939087,
        0.1280682235956192
      ],
      "plane_d": -2276.9931640625,
      "bbox_min": [
        -543.9111328125,
        -2374.730712890625,
        0.0
      ],
      "bbox_max": [
        -479.33441162109375,
        -2328.025634765625,
        90.66432189941406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4636538028717041,
        -0.7131181955337524,
        0.5258208513259888
      ],
      "plane_d": -1921.4649658203125,
      "bbox_min": [
        -543.9111328125,
        -2374.730712890625,
        0.0
      ],
      "bbox_max": [
        -488.6003723144531,
        -2340.81591796875,
        6.270025253295898
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8221501111984253,
        -0.5637224912643433,
        0.07928481698036194
      ],
      "plane_d": -1806.1368408203125,
      "bbox_min": [
        -738.759521484375,
        -2407.66796875,
        0.0
      ],
      "bbox_max": [
        -585.6701049804688,
        -2219.47705078125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9412656426429749,
        -0.3293653726577759,
        0.07441509515047073
      ],
      "plane_d": -1360.3240966796875,
      "bbox_min": [
        -661.85498046875,
        -2262.677001953125,
        0.0
      ],
      "bbox_max": [
        -585.8739624023438,
        -2227.69970703125,
        633.505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8139806389808655,
        -0.5609368085861206,
        0.15094897150993347
      ],
      "plane_d": -1822.4539794921875,
      "bbox_min": [
        -621.9354248046875,
        -2262.677001953125,
        384.9858703613281
      ],
      "bbox_max": [
        -585.8739624023438,
        -2242.64111328125,
        633.505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -586.3511962890625,
        -2260.54638671875,
        630.2252807617188
      ],
      "bbox_max": [
        -585.8739624023438,
        -2260.156005859375,
        633.505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -586.3511962890625,
        -2260.54638671875,
        630.2252807617188
      ],
      "bbox_max": [
        -585.956298828125,
        -2260.156005859375,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -738.759521484375,
        -2407.66796875,
        630.2252807617188
      ],
      "bbox_max": [
        -585.6701049804688,
        -2219.47705078125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -738.759521484375,
        -2407.66796875,
        630.2252807617188
      ],
      "bbox_max": [
        -585.6701049804688,
        -2219.47705078125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -738.759521484375,
        -2349.337158203125,
        630.2252807617188
      ],
      "bbox_max": [
        -585.6701049804688,
        -2219.47705078125,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5919927358627319,
        0.8059433102607727,
        0.0
      ],
      "plane_d": 1469.767333984375,
      "bbox_min": [
        -738.759521484375,
        -2349.337158203125,
        630.2252807617188
      ],
      "bbox_max": [
        -589.9722900390625,
        -2219.47705078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8546817302703857,
        -0.5191524028778076,
        0.0
      ],
      "plane_d": -1822.911376953125,
      "bbox_min": [
        -708.852294921875,
        -2349.337158203125,
        630.2252807617188
      ],
      "bbox_max": [
        -705.815185546875,
        -2344.337158203125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -738.759521484375,
        -2344.337158203125,
        630.2252807617188
      ],
      "bbox_max": [
        -590.0313720703125,
        -2219.47705078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -738.7133178710938,
        -2289.9091796875,
        630.2252807617188
      ],
      "bbox_max": [
        -640.1262817382812,
        -2219.519775390625,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -738.759521484375,
        -2294.329833984375,
        639.28125
      ],
      "bbox_max": [
        -636.068115234375,
        -2219.47705078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -738.759521484375,
        -2289.942138671875,
        639.28125
      ],
      "bbox_max": [
        -640.0663452148438,
        -2219.47705078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -715.55029296875,
        -2407.66796875,
        1186.6314697265625
      ],
      "bbox_max": [
        -685.0712890625,
        -2359.94921875,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -715.55029296875,
        -2407.66796875,
        1195.7457275390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2359.94921875,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -941.46484375,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333296895027161,
        -0.5605107545852661,
        -0.5335925817489624
      ],
      "plane_d": -479.0086364746094,
      "bbox_min": [
        -941.46484375,
        -2576.886474609375,
        682.5
      ],
      "bbox_max": [
        -909.609375,
        -2559.375,
        726.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -918.32568359375,
        -2576.589599609375,
        717.738525390625
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.27099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -915.2291870117188,
        -2576.589599609375,
        719.03125
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.27099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -941.46484375,
        -2576.886474609375,
        682.5
      ],
      "bbox_max": [
        -909.609375,
        -2559.375,
        726.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -912.1072998046875,
        -2576.886474609375,
        719.03125
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03805441036820412,
        0.1391364485025406,
        0.98954176902771
      ],
      "plane_d": -254.50424194335938,
      "bbox_min": [
        -940.4493408203125,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -885.7332153320312,
        -2576.875,
        643.8728637695312
      ],
      "bbox_max": [
        -846.3800048828125,
        -2509.9560546875,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8071104884147644,
        0.4680122137069702,
        0.3599129617214203
      ],
      "plane_d": 269.00018310546875,
      "bbox_min": [
        -869.765625,
        -2576.875,
        643.8728637695312
      ],
      "bbox_max": [
        -846.3800048828125,
        -2530.56689453125,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -940.4493408203125,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -910.4232788085938,
        -2576.947509765625,
        719.03125
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.5377197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7724054455757141,
        0.19714896380901337,
        -0.6037565469741821
      ],
      "plane_d": 255.83349609375,
      "bbox_min": [
        -940.4493408203125,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.811839759349823,
        -0.18294356763362885,
        -0.5544798374176025
      ],
      "plane_d": -792.13720703125,
      "bbox_min": [
        -894.9523315429688,
        -2585.62548828125,
        682.1506958007812
      ],
      "bbox_max": [
        -860.625,
        -2571.875,
        726.3378295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622605800628662,
        -0.21425026655197144,
        -0.4589155912399292
      ],
      "plane_d": -986.1044921875,
      "bbox_min": [
        -890.2044067382812,
        -2581.53173828125,
        717.5496826171875
      ],
      "bbox_max": [
        -884.07763671875,
        -2571.875,
        726.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -890.2044067382812,
        -2580.69140625,
        719.03125
      ],
      "bbox_max": [
        -887.265625,
        -2571.875,
        726.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -894.9523315429688,
        -2585.62548828125,
        682.1506958007812
      ],
      "bbox_max": [
        -860.625,
        -2571.875,
        726.3378295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -861.900634765625,
        -2585.62548828125,
        682.1506958007812
      ],
      "bbox_max": [
        -860.625,
        -2579.375,
        684.910888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7571871280670166,
        0.14177244901657104,
        -0.6376270055770874
      ],
      "plane_d": 151.26864624023438,
      "bbox_min": [
        -940.4493408203125,
        -2585.442626953125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541924476624,
        -0.36512240767478943,
        0.30333849787712097
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -940.4493408203125,
        -2585.442626953125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -940.4493408203125,
        -2571.892578125,
        681.924560546875
      ],
      "bbox_max": [
        -933.75,
        -2559.375,
        684.4713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -938.7445068359375,
        -2585.442626953125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.811279296875,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -938.7445068359375,
        -2585.442626953125,
        645.6022338867188
      ],
      "bbox_max": [
        -838.7605590820312,
        -2510.893798828125,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -910.0775756835938,
        -2579.614501953125,
        719.03125
      ],
      "bbox_max": [
        -887.265625,
        -2566.875,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -910.0775756835938,
        -2577.3193359375,
        719.03125
      ],
      "bbox_max": [
        -907.9686279296875,
        -2566.875,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20010554790496826,
        -0.33017414808273315,
        -0.9224656224250793
      ],
      "plane_d": -363.43182373046875,
      "bbox_min": [
        -938.7445068359375,
        -2585.442626953125,
        645.6022338867188
      ],
      "bbox_max": [
        -838.7605590820312,
        -2513.1845703125,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188934922218323,
        0.49224644899368286,
        0.2951386272907257
      ],
      "plane_d": 363.49578857421875,
      "bbox_min": [
        -938.7445068359375,
        -2585.442626953125,
        645.6022338867188
      ],
      "bbox_max": [
        -838.7605590820312,
        -2530.88037109375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -873.16162109375,
        -2585.442626953125,
        652.96875
      ],
      "bbox_max": [
        -860.625,
        -2576.875,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -862.2821655273438,
        -2585.442626953125,
        681.1356811523438
      ],
      "bbox_max": [
        -860.625,
        -2579.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -873.16162109375,
        -2583.89208984375,
        652.96875
      ],
      "bbox_max": [
        -869.765625,
        -2576.875,
        654.5232543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8071104884147644,
        0.4680122137069702,
        0.3599129617214203
      ],
      "plane_d": 269.00018310546875,
      "bbox_min": [
        -938.7445068359375,
        -2583.45654296875,
        645.6022338867188
      ],
      "bbox_max": [
        -840.2496948242188,
        -2530.88037109375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -938.7445068359375,
        -2583.45654296875,
        652.96875
      ],
      "bbox_max": [
        -869.765625,
        -2559.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -929.7709350585938,
        -2575.733154296875,
        652.96875
      ],
      "bbox_max": [
        -916.9639282226562,
        -2561.875,
        655.6619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -929.7709350585938,
        -2573.511474609375,
        652.96875
      ],
      "bbox_max": [
        -924.609375,
        -2561.875,
        655.6619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -938.7445068359375,
        -2573.474853515625,
        652.96875
      ],
      "bbox_max": [
        -924.609375,
        -2559.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -938.7445068359375,
        -2572.086181640625,
        680.2847900390625
      ],
      "bbox_max": [
        -933.75,
        -2559.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2640.0,
      "bbox_min": [
        -1070.0,
        -2978.0,
        0.0
      ],
      "bbox_max": [
        -312.6351013183594,
        -2571.4130859375,
        1480.5965576171875
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        654.4735717773438
      ],
      "bbox_max": [
        -860.8630981445312,
        -2571.4130859375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333296895027161,
        -0.5605107545852661,
        -0.5335925817489624
      ],
      "plane_d": -479.0086364746094,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        673.092529296875
      ],
      "bbox_max": [
        -918.32568359375,
        -2571.4130859375,
        717.738525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        673.092529296875
      ],
      "bbox_max": [
        -935.3463134765625,
        -2571.4130859375,
        705.8635864257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -984.8797607421875,
        -2640.0,
        654.4735717773438
      ],
      "bbox_max": [
        -860.8630981445312,
        -2572.491943359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -916.9639282226562,
        -2640.0,
        654.4735717773438
      ],
      "bbox_max": [
        -869.9378662109375,
        -2575.733154296875,
        666.6993408203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -878.090576171875,
        -2640.0,
        654.4735717773438
      ],
      "bbox_max": [
        -869.9378662109375,
        -2583.89208984375,
        666.6993408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -984.8797607421875,
        -2640.0,
        655.013916015625
      ],
      "bbox_max": [
        -860.8630981445312,
        -2572.491943359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -984.8797607421875,
        -2640.0,
        655.013916015625
      ],
      "bbox_max": [
        -860.8630981445312,
        -2572.491943359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -898.75,
        -2640.0,
        742.6649169921875
      ],
      "bbox_max": [
        -882.9166870117188,
        -2636.0,
        770.9197387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -898.75,
        -2640.0,
        767.9290771484375
      ],
      "bbox_max": [
        -895.7581787109375,
        -2636.0,
        770.9197387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -863.10595703125,
        -2640.0,
        679.3844604492188
      ],
      "bbox_max": [
        -860.8630981445312,
        -2585.27783203125,
        705.8839111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -968.2777709960938,
        -2640.0,
        656.8616333007812
      ],
      "bbox_max": [
        -862.83447265625,
        -2577.3193359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -968.2777709960938,
        -2640.0,
        656.8616333007812
      ],
      "bbox_max": [
        -862.83447265625,
        -2584.02490234375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      "bbox_max": [
        -897.95458984375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -898.75,
        -2640.0,
        770.546875
      ],
      "bbox_max": [
        -897.95458984375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2859.5,
      "bbox_min": [
        -1070.0,
        -2930.0,
        0.0
      ],
      "bbox_max": [
        -312.6351013183594,
        -2640.0,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -985.7762451171875,
        -2930.0,
        0.0
      ],
      "bbox_max": [
        -312.6351013183594,
        -2859.5,
        1459.052734375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -966.0363159179688,
        -2930.0,
        0.0
      ],
      "bbox_max": [
        -312.6351013183594,
        -2859.5,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9094638824462891,
        0.4146226942539215,
        0.031041515991091728
      ],
      "plane_d": 1475.5181884765625,
      "bbox_min": [
        -966.0363159179688,
        -2930.0,
        324.57611083984375
      ],
      "bbox_max": [
        -319.76470947265625,
        -2859.5,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -966.0363159179688,
        -2930.0,
        769.9266357421875
      ],
      "bbox_max": [
        -877.9636840820312,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -939.1234741210938,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        790.5327758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7739577293395996,
        0.0,
        0.6332372426986694
      ],
      "plane_d": 226.98138427734375,
      "bbox_min": [
        -941.6363525390625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -904.2719116210938,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -940.416259765625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -904.2719116210938,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.0615234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -904.2719116210938,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -344.1455078125,
        -2887.054931640625,
        658.3660888671875
      ],
      "bbox_max": [
        -329.5851745605469,
        -2859.5,
        773.3578491210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -985.7762451171875,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -332.004638671875,
        -2859.5,
        1459.052734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -332.004638671875,
        -2859.5,
        1459.052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -337.2969055175781,
        -2859.5,
        1459.052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -346.7237243652344,
        -2859.5,
        1459.052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8156455159187317,
        -0.09158384799957275,
        -0.5712573528289795
      ],
      "plane_d": -519.972900390625,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -376.8299865722656,
        -2859.5,
        1459.052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -914.6135864257812,
        -2920.0,
        790.1911010742188
      ],
      "bbox_max": [
        -376.8299865722656,
        -2859.5,
        1459.052734375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -871.22314453125,
        -2863.125,
        790.1911010742188
      ],
      "bbox_max": [
        -376.8299865722656,
        -2859.5,
        1459.052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -871.22314453125,
        -2863.125,
        790.1911010742188
      ],
      "bbox_max": [
        -378.988037109375,
        -2859.5,
        1459.052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -381.02655029296875,
        -2860.219482421875,
        1457.741455078125
      ],
      "bbox_max": [
        -378.988037109375,
        -2859.5,
        1459.052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.906970739364624,
        0.3202887773513794,
        0.2735308110713959
      ],
      "plane_d": -89.20680236816406,
      "bbox_min": [
        -870.625,
        -2863.125,
        790.1911010742188
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920820951461792,
        0.2899842858314514,
        0.26076391339302063
      ],
      "plane_d": -177.9209442138672,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.4382934570312,
        -2930.0,
        784.3419189453125
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        820.7681884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -889.6334228515625,
        -2920.0,
        784.3419189453125
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        816.5783081054688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.906970739364624,
        0.3202887773513794,
        0.2735308110713959
      ],
      "plane_d": -89.20680236816406,
      "bbox_min": [
        -871.61669921875,
        -2863.125,
        784.3419189453125
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610851511359215,
        0.44841957092285156,
        0.8936687707901001
      ],
      "plane_d": 620.2235717773438,
      "bbox_min": [
        -891.4382934570312,
        -2930.0,
        790.2222290039062
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        820.7681884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -883.5030517578125,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        820.7681884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162712693214417,
        0.28804752230644226,
        0.27834436297416687
      ],
      "plane_d": -193.42657470703125,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.906970739364624,
        0.3202887773513794,
        0.2735308110713959
      ],
      "plane_d": -89.20680236816406,
      "bbox_min": [
        -889.6818237304688,
        -2920.0,
        761.111083984375
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.918883740901947,
        0.3240675926208496,
        0.22501780092716217
      ],
      "plane_d": -51.825592041015625,
      "bbox_min": [
        -889.6818237304688,
        -2920.0,
        761.111083984375
      ],
      "bbox_max": [
        -877.9344482421875,
        -2859.5,
        790.3518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2919.999755859375,
      "bbox_min": [
        -889.6818237304688,
        -2920.0,
        788.0
      ],
      "bbox_max": [
        -888.9674072265625,
        -2920.0,
        790.3518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7111465930938721,
        -0.03083941340446472,
        -0.7023670673370361
      ],
      "plane_d": -142.72918701171875,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -927.2113037109375,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2920.0,
        863.8005981445312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -883.5282592773438,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        820.9566040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        832.9804077148438
      ],
      "bbox_max": [
        -906.88134765625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        842.5675659179688
      ],
      "bbox_max": [
        -914.0,
        -2916.164306640625,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2920.0,
        842.5675659179688
      ],
      "bbox_max": [
        -914.0,
        -2916.164306640625,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -914.0,
        -2920.0,
        843.2164916992188
      ],
      "bbox_max": [
        -906.88134765625,
        -2920.0,
        850.4241333007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -932.0,
        -2930.0,
        838.0
      ],
      "bbox_max": [
        -914.0,
        -2920.0,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        838.0
      ],
      "bbox_max": [
        -914.0,
        -2920.0,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -914.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        843.2164916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -871.8587036132812,
        -2863.125,
        791.875
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -914.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -881.5404052734375,
        -2920.0,
        843.2164916992188
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -914.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -890.5786743164062,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610851511359215,
        0.44841957092285156,
        0.8936687707901001
      ],
      "plane_d": 620.2235717773438,
      "bbox_min": [
        -894.0,
        -2930.0,
        789.7291870117188
      ],
      "bbox_max": [
        -890.5786743164062,
        -2923.890625,
        792.794677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -903.77392578125,
        -2920.0,
        792.9763793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -914.0,
        -2930.0,
        838.0
      ],
      "bbox_max": [
        -906.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2916.164306640625,
        821.4066162109375
      ],
      "bbox_max": [
        -891.8325805664062,
        -2859.5,
        842.5675659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -932.0,
        -2863.125,
        832.5732421875
      ],
      "bbox_max": [
        -914.0,
        -2859.5,
        833.59375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -914.0,
        -2863.125,
        821.4066772460938
      ],
      "bbox_max": [
        -891.8325805664062,
        -2859.5,
        833.59375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -914.0,
        -2863.125,
        832.5732421875
      ],
      "bbox_max": [
        -899.6533813476562,
        -2859.5,
        833.59375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -361.046630859375,
        -2897.17431640625,
        1307.9615478515625
      ],
      "bbox_max": [
        -346.7237243652344,
        -2859.5,
        1362.815673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7959103584289551,
        0.01854807510972023,
        -0.6051303148269653
      ],
      "plane_d": 1315.767333984375,
      "bbox_min": [
        -985.7762451171875,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -985.7762451171875,
        -2920.0,
        790.23095703125
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -985.7762451171875,
        -2863.125,
        790.45849609375
      ],
      "bbox_max": [
        -984.375,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8746123313903809,
        0.4167838394641876,
        0.2476782649755478
      ],
      "plane_d": 1858.1204833984375,
      "bbox_min": [
        -985.7095336914062,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        859.0191040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -985.7095336914062,
        -2930.0,
        782.986328125
      ],
      "bbox_max": [
        -952.7792358398438,
        -2859.5,
        816.578369140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.019330371171236038,
        0.45839303731918335,
        0.8885393738746643
      ],
      "plane_d": 620.2068481445312,
      "bbox_min": [
        -954.5962524414062,
        -2930.0,
        790.2222290039062
      ],
      "bbox_max": [
        -952.7792358398438,
        -2925.0,
        792.8374633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -985.7095336914062,
        -2863.125,
        782.986328125
      ],
      "bbox_max": [
        -983.5852661132812,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8725059032440186,
        0.41551339626312256,
        0.25706446170806885
      ],
      "plane_d": 1844.976806640625,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        859.0191040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -984.375,
        -2920.0,
        761.111083984375
      ],
      "bbox_max": [
        -956.147705078125,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -956.8422241210938,
        -2920.0,
        788.0
      ],
      "bbox_max": [
        -956.147705078125,
        -2920.0,
        790.3572998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8552238941192627,
        0.42890995740890503,
        0.29090940952301025
      ],
      "plane_d": 1840.6619873046875,
      "bbox_min": [
        -977.84033203125,
        -2864.73291015625,
        761.111083984375
      ],
      "bbox_max": [
        -975.2305908203125,
        -2859.5,
        763.4368286132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7103961706161499,
        0.055301763117313385,
        -0.7016258835792542
      ],
      "plane_d": 1419.9700927734375,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        859.0191040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        850.0250854492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -938.7245483398438,
        -2920.0,
        843.216552734375
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        850.0250854492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -984.927490234375,
        -2863.125,
        791.2595825195312
      ],
      "bbox_max": [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -964.2676391601562,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        843.216552734375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        -954.4213256835938,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330371171236038,
        0.45839303731918335,
        0.8885393738746643
      ],
      "plane_d": 620.2068481445312,
      "bbox_min": [
        -954.4213256835938,
        -2930.0,
        789.6239013671875
      ],
      "bbox_max": [
        -950.0,
        -2923.65380859375,
        792.89794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330371171236038,
        0.45839303731918335,
        0.8885393738746643
      ],
      "plane_d": 620.2068481445312,
      "bbox_min": [
        -950.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        793.0687255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330371171236038,
        0.45839303731918335,
        0.8885393738746643
      ],
      "plane_d": 620.2068481445312,
      "bbox_min": [
        -942.1470947265625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -940.857421875,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        793.0968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -938.0,
        -2930.0,
        838.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -953.0294189453125,
        -2863.125,
        832.5732421875
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        833.59375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8908354640007019,
        0.4543260931968689
      ],
      "plane_d": 2074.13232421875,
      "bbox_min": [
        -1020.0,
        -2712.0,
        273.41998291015625
      ],
      "bbox_max": [
        -505.7439270019531,
        -2640.0,
        1480.5965576171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        -1020.0,
        -2712.0,
        273.41998291015625
      ],
      "bbox_max": [
        -505.7439270019531,
        -2670.0,
        752.3528442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1020.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -970.0,
        -2674.543212890625,
        752.3527221679688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -1007.907958984375,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -970.0,
        -2674.543212890625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9310928583145142,
        0.10939528048038483,
        0.34799253940582275
      ],
      "plane_d": 982.9365844726562,
      "bbox_min": [
        -1007.45263671875,
        -2710.0,
        694.6666870117188
      ],
      "bbox_max": [
        -996.9083251953125,
        -2700.84130859375,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -996.2919311523438,
        -2697.0,
        678.9081420898438
      ],
      "bbox_max": [
        -981.5535278320312,
        -2674.543212890625,
        694.1002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2710.0,
      "bbox_min": [
        -1020.0,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -971.9118041992188,
        -2695.500244140625,
        752.3527221679688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -980.0,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -971.9118041992188,
        -2710.0,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230917811393738,
        -0.23741567134857178,
        -0.6486693620681763
      ],
      "plane_d": 565.302490234375,
      "bbox_min": [
        -1012.0521240234375,
        -2710.0,
        720.0
      ],
      "bbox_max": [
        -1000.169921875,
        -2695.500244140625,
        748.4310913085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9310928583145142,
        0.10939528048038483,
        0.34799253940582275
      ],
      "plane_d": 982.9365844726562,
      "bbox_min": [
        -1012.0521240234375,
        -2710.0,
        720.0
      ],
      "bbox_max": [
        -1006.3765869140625,
        -2695.500244140625,
        735.1856079101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -1009.0059204101562,
        -2697.0,
        720.0
      ],
      "bbox_max": [
        -1007.4884643554688,
        -2695.500244140625,
        722.940673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -894.0,
        -2712.0,
        273.41998291015625
      ],
      "bbox_max": [
        -505.7439270019531,
        -2670.0,
        695.5555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9315862059593201,
        0.3613213896751404,
        0.03992580994963646
      ],
      "plane_d": 1440.1312255859375,
      "bbox_min": [
        -522.370361328125,
        -2712.0,
        273.41998291015625
      ],
      "bbox_max": [
        -505.7439270019531,
        -2703.15966796875,
        695.5555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -522.370361328125,
        -2712.0,
        497.7949523925781
      ],
      "bbox_max": [
        -515.4536743164062,
        -2703.15966796875,
        695.5555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -894.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -519.0872802734375,
        -2674.543212890625,
        752.3528442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -523.3565063476562,
        -2712.0,
        691.62646484375
      ],
      "bbox_max": [
        -519.0872802734375,
        -2702.63525390625,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -894.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -853.125,
        -2674.543212890625,
        752.3528442382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -870.4964599609375,
        -2697.0,
        678.9081420898438
      ],
      "bbox_max": [
        -856.3112182617188,
        -2674.543212890625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -870.4964599609375,
        -2697.0,
        678.9081420898438
      ],
      "bbox_max": [
        -864.9321899414062,
        -2674.543212890625,
        694.219482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2695.5,
        752.3528442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -868.5,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2695.5,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -868.5,
        -2700.0,
        720.0
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        728.8235473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -856.3504028320312,
        -2697.0,
        720.0
      ],
      "bbox_max": [
        -855.4293823242188,
        -2696.22900390625,
        722.940673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -856.40234375,
        -2696.355224609375,
        720.0
      ],
      "bbox_max": [
        -855.9296264648438,
        -2695.500244140625,
        721.4287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -1020.0,
        -2712.0,
        665.7777709960938
      ],
      "bbox_max": [
        -520.1425170898438,
        -2640.0,
        1480.5965576171875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -556.47802734375,
        -2712.0,
        733.9903564453125
      ],
      "bbox_max": [
        -520.1425170898438,
        -2685.024169921875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -556.47802734375,
        -2712.0,
        733.9903564453125
      ],
      "bbox_max": [
        -520.1425170898438,
        -2685.024169921875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -556.47802734375,
        -2712.0,
        1366.9058837890625
      ],
      "bbox_max": [
        -533.1121826171875,
        -2685.024169921875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9314306974411011,
        0.3556700348854065,
        0.0770426094532013
      ],
      "plane_d": 1355.5810546875,
      "bbox_min": [
        -546.2139282226562,
        -2712.0,
        1366.9058837890625
      ],
      "bbox_max": [
        -533.1121826171875,
        -2690.481689453125,
        1429.120361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -1020.0,
        -2712.0,
        665.7777709960938
      ],
      "bbox_max": [
        -853.0,
        -2640.0,
        860.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2641.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -858.5,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -757.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -858.5,
        -2641.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -932.0,
        -2650.0,
        665.7777709960938
      ],
      "bbox_max": [
        -862.1634521484375,
        -2641.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -878.75,
        -2645.0,
        666.7203369140625
      ],
      "bbox_max": [
        -878.1719360351562,
        -2641.0,
        667.578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": -1116.6708984375,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -875.6536865234375,
        -2647.400390625,
        668.4568481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -875.9871215820312,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -875.6536865234375,
        -2647.400390625,
        668.4568481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -932.0,
        -2650.0,
        666.8751220703125
      ],
      "bbox_max": [
        -862.1634521484375,
        -2641.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622605800628662,
        -0.21425026655197144,
        -0.4589155912399292
      ],
      "plane_d": -986.1044921875,
      "bbox_min": [
        -878.9583740234375,
        -2645.0,
        705.1217041015625
      ],
      "bbox_max": [
        -862.9725952148438,
        -2641.0,
        735.6944580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.811839759349823,
        -0.18294356763362885,
        -0.5544798374176025
      ],
      "plane_d": -792.13720703125,
      "bbox_min": [
        -864.4454956054688,
        -2645.0,
        705.9163208007812
      ],
      "bbox_max": [
        -862.9725952148438,
        -2641.0,
        708.4261474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -863.125,
        -2645.0,
        705.9163208007812
      ],
      "bbox_max": [
        -862.9725952148438,
        -2641.0,
        707.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -863.4183959960938,
        -2645.0,
        705.1217041015625
      ],
      "bbox_max": [
        -863.1098022460938,
        -2641.0,
        707.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -932.0,
        -2650.0,
        666.8751220703125
      ],
      "bbox_max": [
        -862.1634521484375,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -878.75,
        -2650.0,
        666.8751220703125
      ],
      "bbox_max": [
        -862.1634521484375,
        -2641.0,
        710.0059814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -878.75,
        -2645.0,
        666.8751220703125
      ],
      "bbox_max": [
        -877.6452026367188,
        -2641.0,
        668.4876708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 748.0,
      "bbox_min": [
        -932.0,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -876.0,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": -1116.6708984375,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.763513445854187,
        -0.0,
        -0.6457920074462891
      ],
      "plane_d": -200.36721801757812,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        725.420166015625
      ],
      "bbox_max": [
        -876.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -932.0,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -754.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        702.353759765625
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -914.0,
        -2660.0,
        702.353759765625
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2660.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2650.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -883.2678833007812,
        -2660.0,
        754.8399047851562
      ],
      "bbox_max": [
        -880.7991943359375,
        -2656.699462890625,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -932.0,
        -2660.0,
        757.0
      ],
      "bbox_max": [
        -882.3856201171875,
        -2641.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2642.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -927.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -921.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -921.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -915.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 909.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -909.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -927.0,
        -2660.0,
        757.0
      ],
      "bbox_max": [
        -882.3856201171875,
        -2641.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -927.0,
        -2656.699462890625,
        757.0
      ],
      "bbox_max": [
        -883.2678833007812,
        -2641.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -927.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -921.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2642.0,
      "bbox_min": [
        -927.0,
        -2642.0,
        757.0
      ],
      "bbox_max": [
        -921.0,
        -2642.0,
        772.6678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -915.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 909.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2642.0,
      "bbox_min": [
        -915.0,
        -2642.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        772.6678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -757.0,
      "bbox_min": [
        -932.0,
        -2641.0,
        666.505859375
      ],
      "bbox_max": [
        -858.5,
        -2640.0,
        772.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -881.5084838867188,
        -2641.0,
        666.505859375
      ],
      "bbox_max": [
        -878.0274047851562,
        -2640.0,
        666.8751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -878.2224731445312,
        -2641.0,
        666.505859375
      ],
      "bbox_max": [
        -878.0274047851562,
        -2640.0,
        666.8751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -932.0,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -878.1719360351562,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -877.3690185546875,
        -2640.0,
        668.7150268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -668.0,
      "bbox_min": [
        -932.0,
        -2641.0,
        668.0
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 748.0,
      "bbox_min": [
        -932.0,
        -2641.0,
        668.0
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -890.2030639648438,
        -2641.0,
        748.0
      ],
      "bbox_max": [
        -885.213134765625,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622605800628662,
        -0.21425026655197144,
        -0.4589155912399292
      ],
      "plane_d": -986.1044921875,
      "bbox_min": [
        -895.098388671875,
        -2641.0,
        668.0
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -885.6284790039062,
        -2641.0,
        705.8839111328125
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.811839759349823,
        -0.18294356763362885,
        -0.5544798374176025
      ],
      "plane_d": -792.13720703125,
      "bbox_min": [
        -864.775634765625,
        -2641.0,
        705.8839111328125
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        708.57958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -876.0,
      "bbox_min": [
        -895.098388671875,
        -2641.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": -1116.6708984375,
      "bbox_min": [
        -895.098388671875,
        -2641.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.763513445854187,
        -0.0,
        -0.6457920074462891
      ],
      "plane_d": -200.36721801757812,
      "bbox_min": [
        -895.098388671875,
        -2641.0,
        725.420166015625
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -932.0,
        -2641.0,
        757.0
      ],
      "bbox_max": [
        -889.7877807617188,
        -2640.0,
        772.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -898.71923828125,
        -2641.0,
        757.0
      ],
      "bbox_max": [
        -889.7877807617188,
        -2640.0,
        772.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -898.71923828125,
        -2641.0,
        767.2745971679688
      ],
      "bbox_max": [
        -895.01025390625,
        -2640.0,
        772.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        730.5896606445312
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        752.6513061523438
      ],
      "bbox_max": [
        -868.5,
        -2700.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        737.9435424804688
      ],
      "bbox_max": [
        -858.5,
        -2697.0,
        762.2891845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        752.6119384765625
      ],
      "bbox_max": [
        -868.5,
        -2700.0,
        762.2891845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -854.1096801757812,
        -2695.682861328125,
        730.1375122070312
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        731.486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -855.9295654296875,
        -2696.228759765625,
        720.0
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        729.67822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.5,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.5,
        -2660.0,
        766.3236694335938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        721.4291381835938
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        762.09228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -868.5,
        -2700.0,
        721.4291381835938
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        752.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -890.8987426757812,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2679.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2660.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484293580055237,
        -0.16308143734931946,
        -0.6428515315055847
      ],
      "plane_d": -602.921875,
      "bbox_min": [
        -898.28125,
        -2712.0,
        787.3197021484375
      ],
      "bbox_max": [
        -890.8987426757812,
        -2697.0,
        795.468505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2641.0,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -757.0,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2650.0,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        757.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        666.8751220703125
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -960.0,
        -2645.0,
        666.8751220703125
      ],
      "bbox_max": [
        -957.76513671875,
        -2641.0,
        668.2752075195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -960.0,
        -2645.0,
        666.8751220703125
      ],
      "bbox_max": [
        -958.2969970703125,
        -2641.0,
        668.2752075195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 972.0,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        666.8751220703125
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        705.541015625
      ],
      "bbox_max": [
        -972.3472290039062,
        -2641.0,
        735.4166259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333296895027161,
        -0.5605107545852661,
        -0.5335925817489624
      ],
      "plane_d": -479.0086364746094,
      "bbox_min": [
        -988.625,
        -2645.0,
        706.1533813476562
      ],
      "bbox_max": [
        -984.5794067382812,
        -2641.0,
        707.9124755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        705.541015625
      ],
      "bbox_max": [
        -988.625,
        -2645.0,
        709.5540771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": 342.6059265136719,
      "bbox_min": [
        -972.0,
        -2650.0,
        666.8751220703125
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.763513445854187,
        0.0,
        -0.6457920074462891
      ],
      "plane_d": 1210.605712890625,
      "bbox_min": [
        -972.0,
        -2650.0,
        666.8751220703125
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -668.0,
      "bbox_min": [
        -952.901611328125,
        -2650.0,
        666.8751220703125
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -952.5738525390625,
        -2645.0,
        666.8751220703125
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        667.578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 748.0,
      "bbox_min": [
        -952.901611328125,
        -2650.0,
        748.0
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -965.4456787109375,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        701.9979858398438
      ],
      "bbox_max": [
        -972.317626953125,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      "bbox_max": [
        -972.317626953125,
        -2656.699462890625,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -973.61962890625,
        -2660.0,
        757.0
      ],
      "bbox_max": [
        -932.0,
        -2641.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2642.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 934.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -934.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -972.317626953125,
        -2656.699462890625,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2641.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 934.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2642.0,
      "bbox_min": [
        -940.0,
        -2642.0,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        772.6678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -757.0,
      "bbox_min": [
        -991.0,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        772.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -958.7737426757812,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -957.2064208984375,
        -2640.0,
        668.449462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -958.2969970703125,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -957.2064208984375,
        -2640.0,
        666.8751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -986.0614624023438,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333296895027161,
        -0.5605107545852661,
        -0.5335925817489624
      ],
      "plane_d": -479.0086364746094,
      "bbox_min": [
        -986.0614624023438,
        -2641.0,
        705.8635864257812
      ],
      "bbox_max": [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 972.0,
      "bbox_min": [
        -972.3472290039062,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -972.3472290039062,
        -2641.0,
        735.4166259765625
      ],
      "bbox_max": [
        -972.0,
        -2640.914794921875,
        736.1331176757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": 342.6059265136719,
      "bbox_min": [
        -972.0,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -957.76513671875,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -951.8910522460938,
        -2640.0,
        666.8751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.763513445854187,
        0.0,
        -0.6457920074462891
      ],
      "plane_d": 1210.605712890625,
      "bbox_min": [
        -972.0,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -972.0,
        -2641.0,
        736.01611328125
      ],
      "bbox_max": [
        -961.2227783203125,
        -2640.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -952.0276489257812,
        -2641.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        666.8751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 748.0,
      "bbox_min": [
        -952.901611328125,
        -2641.0,
        748.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -961.88720703125,
        -2641.0,
        757.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        772.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -961.88720703125,
        -2641.0,
        757.0
      ],
      "bbox_max": [
        -952.3094482421875,
        -2640.0,
        772.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -956.9077758789062,
        -2641.0,
        767.2745971679688
      ],
      "bbox_max": [
        -952.3094482421875,
        -2640.0,
        772.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -1020.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2710.0,
      "bbox_min": [
        -1020.0,
        -2710.0,
        748.4310302734375
      ],
      "bbox_max": [
        -990.6512451171875,
        -2710.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2710.0,
      "bbox_min": [
        -1001.029541015625,
        -2710.0,
        748.4310302734375
      ],
      "bbox_max": [
        -989.7916870117188,
        -2710.0,
        760.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        722.940673828125
      ],
      "bbox_max": [
        -932.0,
        -2697.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2710.0,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        722.940673828125
      ],
      "bbox_max": [
        -956.71875,
        -2697.0,
        795.4685668945312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        -972.8922729492188,
        -2712.0,
        748.4310302734375
      ],
      "bbox_max": [
        -957.2279663085938,
        -2710.0,
        795.4685668945312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -972.8922729492188,
        -2712.0,
        748.4310302734375
      ],
      "bbox_max": [
        -970.0,
        -2710.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6743385195732117,
        -0.18642187118530273,
        -0.7145029306411743
      ],
      "plane_d": 708.3369750976562,
      "bbox_min": [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      "bbox_max": [
        -957.2279663085938,
        -2710.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6743385195732117,
        -0.18642187118530273,
        -0.7145029306411743
      ],
      "plane_d": 708.3369750976562,
      "bbox_min": [
        -1011.9400024414062,
        -2710.0,
        722.940673828125
      ],
      "bbox_max": [
        -956.71875,
        -2697.0,
        795.0206909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9311071038246155,
        0.11036209017038345,
        0.347648948431015
      ],
      "plane_d": 985.8095703125,
      "bbox_min": [
        -1011.9400024414062,
        -2701.77294921875,
        722.940673828125
      ],
      "bbox_max": [
        -1009.0059204101562,
        -2697.0,
        732.2994384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9310928583145142,
        0.10939528048038483,
        0.34799253940582275
      ],
      "plane_d": 982.9365844726562,
      "bbox_min": [
        -1011.9400024414062,
        -2701.77294921875,
        726.1282958984375
      ],
      "bbox_max": [
        -1010.0033569335938,
        -2697.0,
        732.2994384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -873.5,
      "bbox_min": [
        -1070.0,
        -2859.5,
        0.0
      ],
      "bbox_max": [
        -322.4647216796875,
        -2712.0,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2967163920402527,
        0.9547621607780457,
        0.01971287839114666
      ],
      "plane_d": 2806.599853515625,
      "bbox_min": [
        -519.5042724609375,
        -2859.5,
        0.0
      ],
      "bbox_max": [
        -322.4647216796875,
        -2712.0,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -349.8541259765625,
        -2859.5,
        0.0
      ],
      "bbox_max": [
        -322.4647216796875,
        -2835.491943359375,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9094638824462891,
        0.4146226942539215,
        0.031041515991091728
      ],
      "plane_d": 1475.5181884765625,
      "bbox_min": [
        -349.8541259765625,
        -2859.5,
        522.0913696289062
      ],
      "bbox_max": [
        -336.5840759277344,
        -2845.004150390625,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -349.8541259765625,
        -2845.801025390625,
        651.6136474609375
      ],
      "bbox_max": [
        -347.613525390625,
        -2845.004150390625,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -349.5162048339844,
        -2859.5,
        651.6136474609375
      ],
      "bbox_max": [
        -341.2353820800781,
        -2845.004150390625,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -349.05755615234375,
        -2859.5,
        651.6136474609375
      ],
      "bbox_max": [
        -341.2353820800781,
        -2845.004150390625,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32657477259635925,
        0.944736123085022,
        0.02867927961051464
      ],
      "plane_d": 2788.171630859375,
      "bbox_min": [
        -519.5042724609375,
        -2845.6787109375,
        0.0
      ],
      "bbox_max": [
        -334.930419921875,
        -2712.0,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9315862059593201,
        0.3613213896751404,
        0.03992580994963646
      ],
      "plane_d": 1440.1312255859375,
      "bbox_min": [
        -519.5042724609375,
        -2845.6787109375,
        0.0
      ],
      "bbox_max": [
        -347.613525390625,
        -2712.0,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296503663063049,
        0.3666344881057739,
        0.03646130487322807
      ],
      "plane_d": 1454.0635986328125,
      "bbox_min": [
        -498.2544860839844,
        -2791.1015625,
        0.0
      ],
      "bbox_max": [
        -463.345703125,
        -2715.982177734375,
        134.7078857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -519.5042724609375,
        -2845.6787109375,
        499.9759216308594
      ],
      "bbox_max": [
        -347.613525390625,
        -2712.0,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -485.8497314453125,
        -2802.19140625,
        529.9791259765625
      ],
      "bbox_max": [
        -482.3701171875,
        -2800.61376953125,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -485.264404296875,
        -2845.6787109375,
        529.9791259765625
      ],
      "bbox_max": [
        -347.613525390625,
        -2800.61376953125,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -361.2165222167969,
        -2845.6787109375,
        651.6136474609375
      ],
      "bbox_max": [
        -347.613525390625,
        -2841.567626953125,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -873.5,
        -2762.5,
        695.5555419921875
      ],
      "bbox_max": [
        -863.1127319335938,
        -2712.0,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -873.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -873.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -873.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        -0.3070027828216553,
        0.0
      ],
      "plane_d": -1683.250244140625,
      "bbox_min": [
        -873.5,
        -2859.5,
        783.3233032226562
      ],
      "bbox_max": [
        -871.5,
        -2775.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -873.5,
        -2859.5,
        792.8878784179688
      ],
      "bbox_max": [
        -871.8587036132812,
        -2854.677490234375,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        -0.3070027828216553,
        0.0
      ],
      "plane_d": -1683.250244140625,
      "bbox_min": [
        -873.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        786.5337524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -873.5,
        -2781.199951171875,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        783.045654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -872.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -872.5,
        -2714.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -873.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -872.5,
        -2712.400146484375,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.906970739364624,
        0.3202887773513794,
        0.2735308110713959
      ],
      "plane_d": -89.20680236816406,
      "bbox_min": [
        -873.5,
        -2859.5,
        748.3642578125
      ],
      "bbox_max": [
        -871.5,
        -2775.000244140625,
        786.5337524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.918883740901947,
        0.3240675926208496,
        0.22501780092716217
      ],
      "plane_d": -51.825592041015625,
      "bbox_min": [
        -873.5,
        -2846.85400390625,
        748.3642578125
      ],
      "bbox_max": [
        -871.5,
        -2830.819580078125,
        763.2899169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484293580055237,
        -0.16308143734931946,
        -0.6428515315055847
      ],
      "plane_d": -602.921875,
      "bbox_min": [
        -873.5,
        -2788.75,
        782.2899780273438
      ],
      "bbox_max": [
        -871.5,
        -2775.000244140625,
        786.5337524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -873.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -872.3709106445312,
        -2712.0,
        764.8575439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -873.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -872.3709106445312,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -546.9571533203125,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -342.9244384765625,
        -2712.0,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -514.8677978515625,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -342.9244384765625,
        -2802.919921875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -514.8211669921875,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -342.9244384765625,
        -2803.052001953125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -512.7351684570312,
        -2859.5,
        1263.345458984375
      ],
      "bbox_max": [
        -358.3706359863281,
        -2806.955322265625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -376.8299865722656,
        -2859.5,
        1263.345458984375
      ],
      "bbox_max": [
        -358.3706359863281,
        -2854.516357421875,
        1439.6474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -361.8818359375,
        -2859.5,
        1263.345458984375
      ],
      "bbox_max": [
        -358.3706359863281,
        -2854.516357421875,
        1307.5714111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -361.8818359375,
        -2859.5,
        1304.246337890625
      ],
      "bbox_max": [
        -359.81793212890625,
        -2854.516357421875,
        1314.0255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -361.8818359375,
        -2859.5,
        1304.246337890625
      ],
      "bbox_max": [
        -359.81793212890625,
        -2854.516357421875,
        1307.9615478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -512.7351684570312,
        -2813.591064453125,
        1386.6339111328125
      ],
      "bbox_max": [
        -498.223876953125,
        -2806.955322265625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -514.8211669921875,
        -2808.96240234375,
        1386.6339111328125
      ],
      "bbox_max": [
        -498.223876953125,
        -2803.052001953125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -514.8677978515625,
        -2806.955322265625,
        1386.6339111328125
      ],
      "bbox_max": [
        -498.223876953125,
        -2802.919921875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -546.9571533203125,
        -2806.955322265625,
        718.0
      ],
      "bbox_max": [
        -485.8497314453125,
        -2712.0,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -546.9571533203125,
        -2806.955322265625,
        718.0
      ],
      "bbox_max": [
        -498.223876953125,
        -2712.0,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -521.2469482421875,
        -2741.493896484375,
        718.0
      ],
      "bbox_max": [
        -508.307373046875,
        -2712.0,
        811.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -871.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        792.4702758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.906970739364624,
        0.3202887773513794,
        0.2735308110713959
      ],
      "plane_d": -89.20680236816406,
      "bbox_min": [
        -871.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        790.45849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -871.5,
        -2830.819580078125,
        727.904541015625
      ],
      "bbox_max": [
        -861.9823608398438,
        -2784.78515625,
        748.3642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -871.5,
        -2826.99072265625,
        718.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        784.2052612304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        -0.3070027828216553,
        0.0
      ],
      "plane_d": -1683.250244140625,
      "bbox_min": [
        -871.5,
        -2790.5,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        784.2052612304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484293580055237,
        -0.16308143734931946,
        -0.6428515315055847
      ],
      "plane_d": -602.921875,
      "bbox_min": [
        -871.5,
        -2788.75,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2712.0,
        782.2899780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -871.5,
        -2713.5,
        720.0
      ],
      "bbox_max": [
        -870.0,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484293580055237,
        -0.16308143734931946,
        -0.6428515315055847
      ],
      "plane_d": -602.921875,
      "bbox_min": [
        -871.5,
        -2788.75,
        781.3698120117188
      ],
      "bbox_max": [
        -869.0645141601562,
        -2781.199951171875,
        784.2052612304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        -1070.0,
        -2859.5,
        670.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        839.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        -1070.0,
        -2859.5,
        695.5555419921875
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.6743385195732117,
        -0.18642187118530273,
        -0.7145029306411743
      ],
      "plane_d": 708.3369750976562,
      "bbox_min": [
        -1070.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2774.0,
      "bbox_min": [
        -1070.0,
        -2774.0,
        728.8806762695312
      ],
      "bbox_max": [
        -1012.02734375,
        -2770.5,
        760.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.5,
      "bbox_min": [
        -1018.5,
        -2770.5,
        752.97802734375
      ],
      "bbox_max": [
        -1016.8873901367188,
        -2770.5,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230919003486633,
        -0.23741605877876282,
        -0.6486691832542419
      ],
      "plane_d": 565.3014526367188,
      "bbox_min": [
        -1045.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2774.0,
      "bbox_min": [
        -1045.0,
        -2774.0,
        721.8819580078125
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        760.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.5,
      "bbox_min": [
        -1018.5,
        -2770.5,
        750.14111328125
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2765.456298828125,
        759.475830078125
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -1045.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      "bbox_max": [
        -970.0,
        -2818.693115234375,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -1045.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        790.45849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2774.0,
      "bbox_min": [
        -1045.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1007.9630737304688,
        -2763.5,
        752.5339965820312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1020.0,
      "bbox_min": [
        -1025.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2770.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2771.5,
      "bbox_min": [
        -1025.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1020.0,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 1960.148193359375,
      "bbox_min": [
        -1025.0,
        -2774.0,
        736.0
      ],
      "bbox_max": [
        -1020.0,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1020.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2770.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2773.92626953125,
        720.1260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1444.9727783203125,
      "bbox_min": [
        -1020.0,
        -2770.5,
        720.0
      ],
      "bbox_max": [
        -1011.3297119140625,
        -2763.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1020.0,
        -2770.5,
        725.5
      ],
      "bbox_max": [
        -1011.3297119140625,
        -2769.0,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8552238941192627,
        0.42890995740890503,
        0.29090940952301025
      ],
      "plane_d": 1840.6619873046875,
      "bbox_min": [
        -1018.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        763.3938598632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.5,
      "bbox_min": [
        -1018.5,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1005.9593505859375,
        -2763.5,
        752.9193115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2774.0,
      "bbox_min": [
        -1017.502685546875,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1005.9593505859375,
        -2770.5,
        752.9193115234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1011.3297119140625,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2770.5,
        730.4086303710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1009.5,
      "bbox_min": [
        -1009.5,
        -2774.0,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2770.670654296875,
        730.4086303710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1444.9727783203125,
      "bbox_min": [
        -1013.224853515625,
        -2770.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1012.0814208984375,
        -2770.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2769.0,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2770.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2769.93115234375,
        720.8386840820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2774.0,
      "bbox_min": [
        -1008.0,
        -2776.0,
        720.0
      ],
      "bbox_max": [
        -978.9999389648438,
        -2766.99951171875,
        724.000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2771.196044921875,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2766.999755859375,
        721.864990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -1018.1138916015625,
        -2776.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2766.0,
      "bbox_min": [
        -1018.1138916015625,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2720.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2774.0,
      "bbox_min": [
        -1018.1138916015625,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -993.0,
        -2766.0,
        760.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1009.5,
        -2773.66162109375,
        725.5
      ],
      "bbox_max": [
        -1008.0,
        -2770.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1010.8219604492188,
        -2770.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2766.0,
        760.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1444.9727783203125,
      "bbox_min": [
        -1010.8219604492188,
        -2770.5,
        722.5
      ],
      "bbox_max": [
        -1008.0,
        -2766.0,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1010.3379516601562,
        -2770.5,
        725.5
      ],
      "bbox_max": [
        -1008.0,
        -2769.0,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        -1011.225341796875,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2720.0,
        760.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2762.0,
      "bbox_min": [
        -1011.225341796875,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2759.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1444.9727783203125,
      "bbox_min": [
        -1011.225341796875,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        722.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2766.0,
        757.5
      ],
      "bbox_max": [
        -1008.0,
        -2764.024169921875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2485.48046875,
      "bbox_min": [
        -993.0,
        -2762.0,
        753.0
      ],
      "bbox_max": [
        -990.0,
        -2759.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -990.0,
        -2767.0,
        695.5555419921875
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -970.0,
        -2859.5,
        670.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        839.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -960.0,
        -2820.0,
        670.0
      ],
      "bbox_max": [
        -880.5184326171875,
        -2712.0,
        729.6666259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        0.0,
        0.5144957900047302
      ],
      "plane_d": -1131.4620361328125,
      "bbox_min": [
        -887.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -885.3666381835938,
        -2766.999755859375,
        723.5556030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -970.0,
        -2859.5,
        695.5555419921875
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -894.0,
        -2854.677490234375,
        766.4002075195312
      ],
      "bbox_max": [
        -873.5,
        -2719.897216796875,
        811.0656127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -884.5225219726562,
        -2747.351318359375,
        766.4002075195312
      ],
      "bbox_max": [
        -873.5,
        -2719.897216796875,
        783.182861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -745.0,
      "bbox_min": [
        -894.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -878.5,
      "bbox_min": [
        -894.0,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        745.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -878.5,
        -2762.8076171875,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        745.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2715.5,
      "bbox_min": [
        -878.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2715.5,
        745.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -878.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2754.5,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -894.0,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2712.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.0,
        0.5144957900047302
      ],
      "plane_d": -1131.4619140625,
      "bbox_min": [
        -887.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2715.5,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -887.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2715.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2715.5,
      "bbox_min": [
        -887.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2715.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -890.8987426757812,
        -2859.5,
        752.0096435546875
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.918883740901947,
        0.3240675926208496,
        0.22501780092716217
      ],
      "plane_d": -51.825592041015625,
      "bbox_min": [
        -878.493408203125,
        -2859.5,
        752.0096435546875
      ],
      "bbox_max": [
        -873.5,
        -2839.021728515625,
        778.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.906970739364624,
        0.3202887773513794,
        0.2735308110713959
      ],
      "plane_d": -89.20680236816406,
      "bbox_min": [
        -877.9344482421875,
        -2859.5,
        763.2899169921875
      ],
      "bbox_max": [
        -873.5,
        -2846.85400390625,
        778.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -970.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -932.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -914.0,
        -2712.0,
        794.9854736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484293580055237,
        -0.16308143734931946,
        -0.6428515315055847
      ],
      "plane_d": -602.921875,
      "bbox_min": [
        -897.8980712890625,
        -2788.75,
        790.9302978515625
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -970.0,
        -2788.75,
        782.79443359375
      ],
      "bbox_max": [
        -932.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230919003486633,
        -0.23741605877876282,
        -0.6486691832542419
      ],
      "plane_d": 565.3014526367188,
      "bbox_min": [
        -970.0,
        -2718.603271484375,
        782.79443359375
      ],
      "bbox_max": [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -970.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -914.0,
        -2788.75,
        821.4066162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -932.0,
        -2859.5,
        810.4005737304688
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -895.9375,
        -2794.44287109375,
        810.4005737304688
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.4982432503529708e-06,
        -0.270979642868042,
        -0.9625850319862366
      ],
      "plane_d": 26.5576171875,
      "bbox_min": [
        -932.0,
        -2859.5,
        812.65625
      ],
      "bbox_max": [
        -895.9375,
        -2788.75,
        839.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 918.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -928.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -919.0,
        -2843.0,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -919.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        828.2097778320312
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 927.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        828.2097778320312
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        830.4618530273438
      ],
      "bbox_max": [
        -919.0,
        -2852.0,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 918.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -928.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2843.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 822.9999389648438,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.4618530273438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -919.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 927.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        823.0
      ],
      "bbox_max": [
        -927.0,
        -2844.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.996506378229242e-07,
        -0.2709798812866211,
        -0.9625849723815918
      ],
      "plane_d": 26.5545654296875,
      "bbox_min": [
        -970.0,
        -2859.5,
        803.5133056640625
      ],
      "bbox_max": [
        -932.0,
        -2788.75,
        832.5732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -970.0,
        -2859.5,
        803.5133056640625
      ],
      "bbox_max": [
        -953.0294189453125,
        -2788.75,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -970.0,
        -2818.693115234375,
        803.5133056640625
      ],
      "bbox_max": [
        -960.3125,
        -2788.75,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022194361314177513,
        0.23613107204437256,
        0.9714676737785339
      ],
      "plane_d": -96.8321533203125,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.24552778899669647,
        0.9693895578384399
      ],
      "plane_d": -46.93780517578125,
      "bbox_min": [
        -933.5289916992188,
        -2978.0,
        790.5328369140625
      ],
      "bbox_max": [
        -905.461181640625,
        -2930.0,
        802.8236694335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.3569946289062,
        -2978.0,
        790.5328369140625
      ],
      "bbox_max": [
        -905.461181640625,
        -2930.0,
        802.8236694335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330371171236038,
        0.45839303731918335,
        0.8885393738746643
      ],
      "plane_d": 620.2068481445312,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610851511359215,
        0.44841957092285156,
        0.8936687707901001
      ],
      "plane_d": 620.2235717773438,
      "bbox_min": [
        -954.572998046875,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -890.2422485351562,
        -2930.0,
        818.9483642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -954.572998046875,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -893.0887451171875,
        -2930.0,
        817.5613403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.232177734375,
        -2978.0,
        791.174072265625
      ],
      "bbox_max": [
        -893.0887451171875,
        -2930.0,
        816.8629150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.4109497070312,
        -2978.0,
        792.7325439453125
      ],
      "bbox_max": [
        -890.2422485351562,
        -2930.0,
        818.9483642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        794.19775390625
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        818.8846435546875
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -893.3917236328125,
        -2978.0,
        838.7080078125
      ],
      "bbox_max": [
        -892.9408569335938,
        -2976.87353515625,
        842.0806884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -893.3917236328125,
        -2978.0,
        841.642578125
      ],
      "bbox_max": [
        -893.0785522460938,
        -2976.87353515625,
        842.0806884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -893.377685546875,
        -2978.0,
        841.642578125
      ],
      "bbox_max": [
        -893.0785522460938,
        -2976.87353515625,
        842.0687866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        836.5609130859375
      ],
      "bbox_max": [
        -893.16796875,
        -2969.43994140625,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28555822372436523,
        0.010150653310120106,
        -0.9583075642585754
      ],
      "plane_d": 1120.8348388671875,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        836.5609130859375
      ],
      "bbox_max": [
        -934.7142944335938,
        -2970.04833984375,
        859.526611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968570470809937,
        -0.04264342784881592,
        0.06676524132490158
      ],
      "plane_d": 771.4093627929688,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        836.5609130859375
      ],
      "bbox_max": [
        -957.2632446289062,
        -2976.006103515625,
        841.4196166992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -962.9921875,
        -3076.67138671875,
        801.9602661132812
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -892.01171875,
        -2985.04052734375,
        816.8317260742188
      ],
      "bbox_max": [
        -890.463623046875,
        -2978.0,
        828.77734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -892.01171875,
        -2985.04052734375,
        816.8317260742188
      ],
      "bbox_max": [
        -890.463623046875,
        -2978.0,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610851511359215,
        0.44841957092285156,
        0.8936687707901001
      ],
      "plane_d": 620.2235717773438,
      "bbox_min": [
        -892.01171875,
        -2985.04052734375,
        816.8317260742188
      ],
      "bbox_max": [
        -891.4109497070312,
        -2978.0,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -962.9921875,
        -3076.67138671875,
        801.9602661132812
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -909.0305786132812,
        -2990.6005859375,
        802.6903076171875
      ],
      "bbox_max": [
        -891.8243408203125,
        -2978.0,
        818.189697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610851511359215,
        0.44841957092285156,
        0.8936687707901001
      ],
      "plane_d": 620.2235717773438,
      "bbox_min": [
        -893.0887451171875,
        -2980.69091796875,
        816.8428955078125
      ],
      "bbox_max": [
        -891.8243408203125,
        -2978.0,
        818.189697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.24552778899669647,
        0.9693895578384399
      ],
      "plane_d": -46.93780517578125,
      "bbox_min": [
        -909.0305786132812,
        -2990.6005859375,
        802.6903076171875
      ],
      "bbox_max": [
        -906.3569946289062,
        -2978.0,
        805.8817749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -962.9921875,
        -3064.909423828125,
        801.9602661132812
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -892.9408569335938,
        -2985.04052734375,
        820.3665161132812
      ],
      "bbox_max": [
        -891.521484375,
        -2978.0,
        838.7080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28555822372436523,
        0.010150653310120106,
        -0.9583075642585754
      ],
      "plane_d": 1120.8348388671875,
      "bbox_min": [
        -962.9921875,
        -3064.909423828125,
        801.9602661132812
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -962.9921875,
        -3064.909423828125,
        801.9602661132812
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -962.9921875,
        -3064.909423828125,
        801.9602661132812
      ],
      "bbox_max": [
        -891.521484375,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7762428522109985,
        0.04481952264904976,
        0.6288387775421143
      ],
      "plane_d": 361.6246032714844,
      "bbox_min": [
        -962.9921875,
        -3064.909423828125,
        801.9602661132812
      ],
      "bbox_max": [
        -891.521484375,
        -2978.0,
        851.0064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -956.2836303710938,
        -2990.9130859375,
        801.9602661132812
      ],
      "bbox_max": [
        -943.5988159179688,
        -2978.0,
        817.6448364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330371171236038,
        0.45839303731918335,
        0.8885393738746643
      ],
      "plane_d": 620.2068481445312,
      "bbox_min": [
        -956.2836303710938,
        -2978.23388671875,
        817.5243530273438
      ],
      "bbox_max": [
        -956.2008666992188,
        -2978.0,
        817.6448364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022194361314177513,
        0.23613107204437256,
        0.9714676737785339
      ],
      "plane_d": -96.8321533203125,
      "bbox_min": [
        -945.36328125,
        -2990.9130859375,
        801.9602661132812
      ],
      "bbox_max": [
        -943.5988159179688,
        -2978.0,
        805.068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8210588693618774,
        0.007935827597975731,
        0.5707883238792419
      ],
      "plane_d": 340.41064453125,
      "bbox_min": [
        -962.9921875,
        -3053.61669921875,
        801.969970703125
      ],
      "bbox_max": [
        -891.521484375,
        -2978.0,
        851.0064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -956.512939453125,
        -2990.9130859375,
        801.969970703125
      ],
      "bbox_max": [
        -943.3382568359375,
        -2978.0,
        821.0216064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330371171236038,
        0.45839303731918335,
        0.8885393738746643
      ],
      "plane_d": 620.2068481445312,
      "bbox_min": [
        -956.512939453125,
        -2984.7890625,
        817.5260009765625
      ],
      "bbox_max": [
        -954.572998046875,
        -2978.0,
        821.0216064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022194361314177513,
        0.23613107204437256,
        0.9714676737785339
      ],
      "plane_d": -96.8321533203125,
      "bbox_min": [
        -945.36328125,
        -2990.9130859375,
        801.969970703125
      ],
      "bbox_max": [
        -943.3382568359375,
        -2978.0,
        805.068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9939219355583191,
        -0.10033050924539566,
        -0.045308977365493774
      ],
      "plane_d": 688.4334716796875,
      "bbox_min": [
        -962.9921875,
        -3053.61669921875,
        801.9759521484375
      ],
      "bbox_max": [
        -891.521484375,
        -2978.0,
        851.0064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968570470809937,
        -0.04264342784881592,
        0.06676524132490158
      ],
      "plane_d": 771.4093627929688,
      "bbox_min": [
        -961.00341796875,
        -3042.81494140625,
        821.0216064453125
      ],
      "bbox_max": [
        -956.512939453125,
        -2978.0,
        851.0064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022194361314177513,
        0.23613107204437256,
        0.9714676737785339
      ],
      "plane_d": -96.8321533203125,
      "bbox_min": [
        -945.36328125,
        -2990.9130859375,
        801.9759521484375
      ],
      "bbox_max": [
        -891.521484375,
        -2978.0,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.24552778899669647,
        0.9693895578384399
      ],
      "plane_d": -46.93780517578125,
      "bbox_min": [
        -912.0682983398438,
        -2990.6005859375,
        802.6903076171875
      ],
      "bbox_max": [
        -906.4345703125,
        -2978.0,
        805.8817749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.4345703125,
        -2990.6005859375,
        805.8817749023438
      ],
      "bbox_max": [
        -891.521484375,
        -2978.058349609375,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610851511359215,
        0.44841957092285156,
        0.8936687707901001
      ],
      "plane_d": 620.2235717773438,
      "bbox_min": [
        -893.0757446289062,
        -2985.04052734375,
        816.8919677734375
      ],
      "bbox_max": [
        -891.521484375,
        -2978.058349609375,
        820.3665161132812
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}